import "./public.efeabce5.js";
import "./public.ac8af5d2.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire64a6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire64a6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");


var $7Yi7V = parcelRequire("7Yi7V");
const $7921bdd52deb8db9$export$240b20df485e8ed6 = {
    LANDING: "landing",
    AUTHOR: "author",
    SPEEDRUN: "speedrun",
    LABEL: "label",
    CREATIVE: "creative"
};
function $7921bdd52deb8db9$export$e97fefb967eddbb9() {
    const params = new URLSearchParams(window.location.search);
    const hasLabel = params.has("label");
    const hasAuthor = params.has("author");
    const labelValue = params.get("label");
    const authorValue = params.get("author");
    let marcId = (0, $7Yi7V.DEFAULT_MARC_ID);
    let mode = $7921bdd52deb8db9$export$240b20df485e8ed6.LANDING;
    if (hasLabel) {
        mode = $7921bdd52deb8db9$export$240b20df485e8ed6.LABEL;
        if (labelValue && labelValue.length > 0) marcId = labelValue;
    } else if (hasAuthor) {
        mode = $7921bdd52deb8db9$export$240b20df485e8ed6.AUTHOR;
        if (authorValue && authorValue.length > 0) marcId = authorValue;
    }
    // `?debug` reveals iteration UI (currently the scoring-tuner panel).
    // Independent of mode so we can debug-tune scoring inside speedrun
    // without flipping into author.
    const debug = params.has("debug");
    // `?marcs=001,003,007` pins the speedrun lineup for testing instead
    // of the random-from-manifest pick. Order is preserved. Debug-only
    // affordance — no UI links to it. Not validated against the
    // manifest; trust the URL.
    const marcsParam = params.get("marcs");
    const pinnedMarcs = marcsParam ? marcsParam.split(",").map((s)=>s.trim()).filter(Boolean) : [];
    return {
        marcId: marcId,
        mode: mode,
        debug: debug,
        pinnedMarcs: pinnedMarcs
    };
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $hwQVN = parcelRequire("hwQVN");

var $7Yi7V = parcelRequire("7Yi7V");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
// Sample-from-marc-photo gesture, lifted out of App so any palette UI
// can begin a pick without prop-drilling. ReferencePhoto's pointer
// listeners are wired at App level.
//
// The picker is "live" — popover stays open, hover updates onPreview
// repeatedly, click commits via onPick. The session ends on
// `endEyedropper()` (toggle off) or Escape (which fires the registered
// onCancel so the caller can reset its own UI state).
//
// Default value is a no-op so consumers never crash if the provider is
// missing (e.g. on the gallery/admin pages, where there's no marc photo
// to sample from). The Edit Color UI hides the eyedropper button when
// `available` is false.
const $7caa007c47a491c5$var$EyedropperContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    available: false,
    active: false,
    beginEyedropper: ()=>{},
    endEyedropper: ()=>{}
});
function $7caa007c47a491c5$export$1e92748507e26cde({ children: children, beginEyedropper: beginEyedropper, endEyedropper: endEyedropper, active: active = false }) {
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            available: true,
            active: active,
            beginEyedropper: beginEyedropper,
            endEyedropper: endEyedropper
        }), [
        active,
        beginEyedropper,
        endEyedropper
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7caa007c47a491c5$var$EyedropperContext.Provider, {
        value: value,
        children: children
    });
}
function $7caa007c47a491c5$export$968d3a33c108f1d4() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($7caa007c47a491c5$var$EyedropperContext);
}



var $e4LUm = parcelRequire("e4LUm");

var $4vfI7 = parcelRequire("4vfI7");

var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");
// Author → Label handoff via sessionStorage.
//
// The unlabeled reference doesn't live on disk; it's a transient artifact
// that flows from author straight into label mode. Author Save writes the
// just-built JSON here under a per-marc key, then navigates the page to
// `?label={marcId}`. LabelApp consumes the entry on mount (removing it as
// it goes). If there's no handoff (e.g. you reloaded the label tab),
// LabelApp falls back to using the committed reference-{marcId}.json on
// disk as the working copy.
//
// sessionStorage is per-tab and survives the navigation, so the data is
// scoped to "this iteration session" — refreshing the label tab consumes
// the handoff once and then it's gone.
const $54c1c6fbbb01e713$var$KEY_PREFIX = "egg-game:v1:handoff:reference-unlabeled:";
function $54c1c6fbbb01e713$export$b9580e21ee910689(marcId, json) {
    try {
        sessionStorage.setItem($54c1c6fbbb01e713$var$KEY_PREFIX + marcId, json);
        return true;
    } catch  {
        // Storage full / unavailable. Caller can decide whether to fall back to
        // a download — for now we just signal failure.
        return false;
    }
}
function $54c1c6fbbb01e713$export$fa7ee5447c2e5120(marcId) {
    try {
        const json = sessionStorage.getItem($54c1c6fbbb01e713$var$KEY_PREFIX + marcId);
        if (json != null) sessionStorage.removeItem($54c1c6fbbb01e713$var$KEY_PREFIX + marcId);
        return json;
    } catch  {
        return null;
    }
}



var $4e3Nb = parcelRequire("4e3Nb");

var $gDnUo = parcelRequire("gDnUo");

var $7Yi7V = parcelRequire("7Yi7V");
// Shared raster ops over palette-indexed canvases.
//
// Two consumers depend on the *exact* same algorithms here:
//   - saveReference.js quantizes + segments the author's traced drawing
//   - scoring.js quantizes + segments the player's drawing
// The match check is meaningful only if both sides snap colors and group
// pixels identically — diverging implementations would silently make
// scores depend on which code path quantized last. One source of truth.

var $gDnUo = parcelRequire("gDnUo");

var $7Yi7V = parcelRequire("7Yi7V");
const $e8508d5718da2544$export$6892fc71389c625c = 255;
function $e8508d5718da2544$export$36232b0c16c5edfc(r, g, b, paletteRgb) {
    let best = 0;
    let bestDist = Infinity;
    for(let i = 0; i < paletteRgb.length; i++){
        const p = paletteRgb[i];
        const dr = r - p.r;
        const dg = g - p.g;
        const db = b - p.b;
        const d = dr * dr + dg * dg + db * db;
        if (d < bestDist) {
            bestDist = d;
            best = i;
        }
    }
    return best;
}
function $e8508d5718da2544$export$74c7c8026075d9c4(imageData, paletteRgb) {
    const { data: data, width: width, height: height } = imageData;
    const indices = new Uint8Array(width * height);
    for(let i = 0, p = 0; i < data.length; i += 4, p++)if (data[i + 3] < (0, $7Yi7V.QUANTIZE_ALPHA_THRESHOLD)) indices[p] = $e8508d5718da2544$export$6892fc71389c625c;
    else indices[p] = $e8508d5718da2544$export$36232b0c16c5edfc(data[i], data[i + 1], data[i + 2], paletteRgb);
    return {
        indices: indices,
        width: width,
        height: height
    };
}
function $e8508d5718da2544$export$4ac79e59c9022a5e(canvas, palette) {
    const ctx = canvas.getContext("2d", {
        willReadFrequently: true
    });
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const paletteRgb = palette.map((0, $gDnUo.hexToRgb));
    return $e8508d5718da2544$export$74c7c8026075d9c4(imageData, paletteRgb);
}
function $e8508d5718da2544$export$4c2eb41cf5ea2f76(indices, width, height) {
    const visited = new Uint8Array(indices.length);
    const components = [];
    const stack = [];
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const seed = y * width + x;
        if (visited[seed]) continue;
        const color = indices[seed];
        if (color === $e8508d5718da2544$export$6892fc71389c625c) continue;
        stack.length = 0;
        stack.push(seed);
        let minX = x;
        let maxX = x;
        let minY = y;
        let maxY = y;
        const pixels = [];
        while(stack.length > 0){
            const i = stack.pop();
            if (visited[i]) continue;
            if (indices[i] !== color) continue;
            visited[i] = 1;
            pixels.push(i);
            const cx = i % width;
            const cy = (i - cx) / width;
            if (cx < minX) minX = cx;
            if (cx > maxX) maxX = cx;
            if (cy < minY) minY = cy;
            if (cy > maxY) maxY = cy;
            if (cx > 0) stack.push(i - 1);
            if (cx < width - 1) stack.push(i + 1);
            if (cy > 0) stack.push(i - width);
            if (cy < height - 1) stack.push(i + width);
        }
        components.push({
            colorIndex: color,
            pixels: pixels,
            bbox: {
                x: minX,
                y: minY,
                w: maxX - minX + 1,
                h: maxY - minY + 1
            }
        });
    }
    return components;
}


// Per-region pixel counts in each half of the bbox along the longer
// axis. Stored alongside pixelCount so scoring can apply a spatial
// "spread" check on large regions (drawing only the left half of a
// sweater shouldn't clear the threshold) with the right per-half
// threshold even when the mask is asymmetric. Without this stored
// info, scoring falls back to a 50/50 estimate which under-credits
// asymmetric masks.
function $16b21f3754b1f935$var$computeHalfPixels(pixels, bbox, canvasWidth) {
    const splitVertical = bbox.w >= bbox.h; // longer axis is x → split left/right
    const midX = bbox.x + bbox.w / 2;
    const midY = bbox.y + bbox.h / 2;
    let firstHalf = 0;
    let secondHalf = 0;
    for(let k = 0; k < pixels.length; k++){
        const gi = pixels[k];
        const gx = gi % canvasWidth;
        const gy = (gi - gx) / canvasWidth;
        if (splitVertical) {
            if (gx < midX) firstHalf++;
            else secondHalf++;
        } else if (gy < midY) firstHalf++;
        else secondHalf++;
    }
    return {
        axis: splitVertical ? 'x' : 'y',
        counts: [
            firstHalf,
            secondHalf
        ]
    };
}
function $16b21f3754b1f935$var$maskToPngDataUrl(pixels, bbox, canvasWidth) {
    const { x: ox, y: oy, w: w, h: h } = bbox;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    const imgData = ctx.createImageData(w, h);
    const data = imgData.data;
    for(let k = 0; k < pixels.length; k++){
        const gi = pixels[k];
        const gx = gi % canvasWidth;
        const gy = (gi - gx) / canvasWidth;
        const lx = gx - ox;
        const ly = gy - oy;
        const li = (ly * w + lx) * 4;
        data[li] = 255;
        data[li + 1] = 255;
        data[li + 2] = 255;
        data[li + 3] = 255;
    }
    ctx.putImageData(imgData, 0, 0);
    return canvas.toDataURL('image/png');
}
function $16b21f3754b1f935$var$quantizedImageDataUrl(indices, paletteRgb, width, height) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    const imgData = ctx.createImageData(width, height);
    const data = imgData.data;
    for(let i = 0; i < indices.length; i++){
        const ci = indices[i];
        const di = i * 4;
        if (ci === (0, $e8508d5718da2544$export$6892fc71389c625c)) data[di + 3] = 0;
        else {
            const p = paletteRgb[ci];
            data[di] = p.r;
            data[di + 1] = p.g;
            data[di + 2] = p.b;
            data[di + 3] = 255;
        }
    }
    ctx.putImageData(imgData, 0, 0);
    return canvas.toDataURL('image/png');
}
// Object-fit: contain algorithm. Returns the rect (in frame coords) where
// a natW×natH image actually lands inside a frameW×frameH box when rendered
// with object-fit: contain and centered. This is the image's "display box"
// *before* any CSS transform (scaleX/rotation/translate) is applied on top.
function $16b21f3754b1f935$var$containRect(frameW, frameH, natW, natH) {
    if (natW <= 0 || natH <= 0) return {
        x: 0,
        y: 0,
        w: 0,
        h: 0
    };
    const imgAR = natW / natH;
    const frameAR = frameW / frameH;
    let w;
    let h;
    if (imgAR > frameAR) {
        w = frameW;
        h = frameW / imgAR;
    } else {
        h = frameH;
        w = frameH * imgAR;
    }
    return {
        x: (frameW - w) / 2,
        y: (frameH - h) / 2,
        w: w,
        h: h
    };
}
function $16b21f3754b1f935$var$loadNaturalSize(src) {
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        img.onerror = ()=>resolve({
                width: 0,
                height: 0
            });
        img.src = src;
    });
}
function $16b21f3754b1f935$export$c0500e6838f5afdc({ canvas: canvas, palette: palette, marcId: marcId, eggId: eggId, marcTransform: marcTransform, eggTransform: eggTransform, eggLights: eggLights, eggWarmth: eggWarmth, eggRedshift: eggRedshift, eggNaturalSize: eggNaturalSize, marcNaturalSize: marcNaturalSize }) {
    const ctx = canvas.getContext('2d', {
        willReadFrequently: true
    });
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const paletteRgb = palette.map((0, $gDnUo.hexToRgb));
    const { indices: indices, width: width, height: height } = (0, $e8508d5718da2544$export$74c7c8026075d9c4)(imgData, paletteRgb);
    const rawRegions = (0, $e8508d5718da2544$export$4c2eb41cf5ea2f76)(indices, width, height);
    const regions = rawRegions.filter((r)=>r.pixels.length >= (0, $7Yi7V.MIN_REGION_PIXELS))// Sort by area descending so the bigger features (sweater, hair) land
    // first in the file. Makes relabel-pass UI more natural.
    .sort((a, b)=>b.pixels.length - a.pixels.length).map((r, i)=>({
            id: `r-${String(i + 1).padStart(3, '0')}`,
            colorIndex: r.colorIndex,
            color: palette[r.colorIndex],
            bbox: r.bbox,
            pixelCount: r.pixels.length,
            halfPixels: $16b21f3754b1f935$var$computeHalfPixels(r.pixels, r.bbox, canvas.width),
            mask: $16b21f3754b1f935$var$maskToPngDataUrl(r.pixels, r.bbox, canvas.width),
            label: ''
        }));
    const image = $16b21f3754b1f935$var$quantizedImageDataUrl(indices, paletteRgb, canvas.width, canvas.height);
    const eggDisplayBox = $16b21f3754b1f935$var$containRect(canvas.width, canvas.height, eggNaturalSize.width, eggNaturalSize.height);
    const marcDisplayBox = $16b21f3754b1f935$var$containRect(canvas.width, canvas.height, marcNaturalSize.width, marcNaturalSize.height);
    return {
        version: (0, $7Yi7V.REFERENCE_VERSION),
        createdAt: new Date().toISOString(),
        canvas: {
            width: canvas.width,
            height: canvas.height
        },
        egg: {
            id: eggId,
            naturalSize: eggNaturalSize,
            displayBox: eggDisplayBox,
            transform: eggTransform ?? (0, $7Yi7V.DEFAULT_EGG_TRANSFORM),
            lights: eggLights,
            warmth: eggWarmth,
            redshift: eggRedshift
        },
        marc: {
            id: marcId,
            naturalSize: marcNaturalSize,
            displayBox: marcDisplayBox,
            transform: marcTransform
        },
        palette: palette,
        drawing: {
            image: image,
            regions: regions
        }
    };
}
async function $16b21f3754b1f935$export$2e2bcd8739ae039(opts) {
    const [eggNaturalSize, marcNaturalSize] = await Promise.all([
        $16b21f3754b1f935$var$loadNaturalSize(opts.eggSrc),
        $16b21f3754b1f935$var$loadNaturalSize(opts.marcSrc)
    ]);
    const reference = $16b21f3754b1f935$export$c0500e6838f5afdc({
        ...opts,
        eggNaturalSize: eggNaturalSize,
        marcNaturalSize: marcNaturalSize
    });
    const json = JSON.stringify(reference, null, 2);
    return {
        reference: reference,
        json: json,
        regionCount: reference.drawing.regions.length,
        bytes: new Blob([
            json
        ]).size
    };
}




var $acw62 = parcelRequire("acw62");
function $8c77a2f882a1085d$var$matches(event, spec) {
    if (typeof spec === 'string') {
        // Bare key shortcuts implicitly require no modifier keys — otherwise
        // `useKey('1')` would fire on ctrl+1 and collide with modifier-scoped
        // shortcuts.
        if (event.ctrlKey || event.metaKey || event.altKey) return false;
        return event.key.toLowerCase() === spec.toLowerCase();
    }
    if (spec && typeof spec === 'object') {
        if (spec.key && event.key.toLowerCase() !== spec.key.toLowerCase()) return false;
        if (spec.shift != null && event.shiftKey !== spec.shift) return false;
        if (spec.meta != null && event.metaKey !== spec.meta) return false;
        if (spec.ctrl != null && event.ctrlKey !== spec.ctrl) return false;
        if (spec.alt != null && event.altKey !== spec.alt) return false;
        // `mod: true/false` matches ctrl OR cmd — the platform-neutral way to
        // express "with modifier" for Mac + Windows/Linux together.
        if (spec.mod != null) {
            const hasMod = event.ctrlKey || event.metaKey;
            if (hasMod !== spec.mod) return false;
        }
        return true;
    }
    return false;
}
function $8c77a2f882a1085d$var$isEditableTarget(target) {
    if (!target) return false;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (target.isContentEditable) return true;
    return false;
}
function $8c77a2f882a1085d$export$2e2bcd8739ae039(spec, handler, options = {}) {
    const handlerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(handler);
    handlerRef.current = handler;
    const specKey = typeof spec === 'string' ? spec : JSON.stringify(spec);
    const allowInInputs = !!options.allowInInputs;
    const preventDefault = !!options.preventDefault;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        function onKeyDown(event) {
            if (!allowInInputs && $8c77a2f882a1085d$var$isEditableTarget(event.target)) return;
            if (!$8c77a2f882a1085d$var$matches(event, spec)) return;
            if (preventDefault) event.preventDefault();
            handlerRef.current(event);
        }
        window.addEventListener('keydown', onKeyDown);
        return ()=>window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        specKey,
        allowInInputs,
        preventDefault
    ]);
}



var $acw62 = parcelRequire("acw62");
function $6b137a2b7afbc892$export$2e2bcd8739ae039(key, defaultValue) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>{
        try {
            const raw = window.localStorage.getItem(key);
            if (raw != null) return JSON.parse(raw);
        } catch  {
        // fall through to default
        }
        return defaultValue;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        } catch  {
        // Storage full / unavailable — silently drop. The in-memory state
        // still works; persistence just fails this round.
        }
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}


function $30e7b6ad4a686810$export$2e2bcd8739ae039({ urlState: urlState, mode: mode, canvasRef: canvasRef }) {
    const authorMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).AUTHOR;
    const key = (suffix)=>`egg-game:v1:marc:${urlState.marcId}:${suffix}`;
    // ── Persisted per-marc state ──────────────────────────────────────
    const [palette, setPalette] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("palette"), (0, $7Yi7V.DEFAULT_PALETTE));
    const [marcTransform, setMarcTransform] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("marcTransform"), (0, $7Yi7V.DEFAULT_MARC_TRANSFORM));
    const [eggTransform, setEggTransform] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("eggTransform"), (0, $7Yi7V.DEFAULT_EGG_TRANSFORM));
    const [eggLights, setEggLights] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("eggLights"), (0, $7Yi7V.DEFAULT_EGG_LIGHTS));
    // Defensive palette reset: if DEFAULT_PALETTE's slot count changes
    // between versions, a stored palette from the old shape won't map.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (palette.length !== (0, $7Yi7V.DEFAULT_PALETTE).length) setPalette((0, $7Yi7V.DEFAULT_PALETTE));
    }, [
        palette.length,
        setPalette
    ]);
    // ── Transient editing UI ──────────────────────────────────────────
    const [marcVisible, setMarcVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(authorMode);
    const [marcOpacity, setMarcOpacity] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7Yi7V.ONION_OPACITY));
    // Mutually-exclusive transform modes: marc and egg both want pointer
    // events on the canvas, so enabling one disables the other.
    const [marcTransformMode, _setMarcTransformMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [eggTransformMode, _setEggTransformMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const setMarcTransformMode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        _setMarcTransformMode((cur)=>{
            const next = typeof value === "function" ? value(cur) : value;
            if (next) _setEggTransformMode(false);
            return next;
        });
    }, []);
    const setEggTransformMode = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((value)=>{
        _setEggTransformMode((cur)=>{
            const next = typeof value === "function" ? value(cur) : value;
            if (next) _setMarcTransformMode(false);
            return next;
        });
    }, []);
    // Author A/B toggle: temporarily flip lighting off to compare.
    const [lightingEnabled, setLightingEnabled] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    // Egg warmth: per-marc, persisted. Different marcs need different warmth
    // settings (varies with skin tone / lighting in the source photo), so the
    // author's tuned value rides along with the rest of the marc state into
    // localStorage and into the saved reference.
    const [eggWarmth, setEggWarmth] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("eggWarmth"), (0, $7Yi7V.DEFAULT_EGG_WARMTH));
    // Redshift mirrors warmth: per-marc, persisted, biases the tint toward red.
    const [eggRedshift, setEggRedshift] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(key("eggRedshift"), (0, $7Yi7V.DEFAULT_EGG_REDSHIFT));
    const setPaletteSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((index, hex)=>{
        setPalette((prev)=>{
            const next = [
                ...prev
            ];
            next[index] = hex;
            return next;
        });
    }, [
        setPalette
    ]);
    // ── Hotkeys ───────────────────────────────────────────────────────
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("m", ()=>{
        if (authorMode) setMarcVisible((v)=>!v);
    });
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("l", ()=>{
        if (authorMode) setLightingEnabled((v)=>!v);
    });
    // ── Derived ───────────────────────────────────────────────────────
    // The marc reference photo doubles as the onion overlay in the drawing
    // pane during author mode. The easel/ReferencePhoto always shows it; the
    // onion is author-only, so we hand back null otherwise.
    const marcOnionSrc = authorMode ? (0, $4e3Nb.marcImageUrl)(urlState.marcId) : null;
    // "Save" no longer means "download a file." It builds the unlabeled JSON,
    // stashes it in sessionStorage under a handoff key, and navigates to
    // ?label={marcId}. LabelApp picks the handoff up on mount — so the
    // author never has to drop a file on disk before labeling. The labeled
    // reference.json is the only artifact that gets downloaded (from label
    // mode), and that's the only file that's actually committed to the repo.
    const save = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        // Default eggLights is one light with intensity=0, shadow=0 (no
        // relight applied). If the author never opened the lighting
        // controls, that's what gets saved — the egg renders flat in
        // play mode and the marc looks plastic. Cheap guard: warn before
        // committing a trace that has no light tuned at all. Author can
        // confirm-through if they really meant it.
        const isUnlit = !eggLights || eggLights.length === 0 || eggLights.every((l)=>(l?.intensity ?? 0) === 0 && (l?.shadow ?? 0) === 0);
        if (isUnlit) {
            const ok = window.confirm("No lighting configured for this marc \u2014 the egg will render flat. Save anyway?");
            if (!ok) return;
        }
        const result = await (0, $16b21f3754b1f935$export$2e2bcd8739ae039)({
            canvas: canvas,
            palette: palette,
            marcId: urlState.marcId,
            eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
            marcSrc: (0, $4e3Nb.marcImageUrl)(urlState.marcId),
            eggSrc: (0, $4e3Nb.eggImageUrl)((0, $7Yi7V.DEFAULT_EGG_ID)),
            marcTransform: marcTransform,
            eggTransform: eggTransform,
            eggLights: eggLights,
            eggWarmth: eggWarmth,
            eggRedshift: eggRedshift
        });
        (0, $54c1c6fbbb01e713$export$b9580e21ee910689)(urlState.marcId, result.json);
        // eslint-disable-next-line no-console
        console.log(`Built reference-unlabeled (marc ${urlState.marcId}) \u{2014} ${result.regionCount} regions, ${(result.bytes / 1024).toFixed(1)}KB. Handing off to label mode.`);
        window.location.search = `?label=${urlState.marcId}`;
    }, [
        palette,
        marcTransform,
        eggTransform,
        eggLights,
        eggWarmth,
        eggRedshift,
        urlState.marcId,
        canvasRef
    ]);
    return {
        palette: // Persisted
        palette,
        setPalette: setPalette,
        setPaletteSlot: setPaletteSlot,
        marcTransform: marcTransform,
        setMarcTransform: setMarcTransform,
        eggTransform: eggTransform,
        setEggTransform: setEggTransform,
        eggLights: eggLights,
        setEggLights: setEggLights,
        marcVisible: // Transient
        marcVisible,
        setMarcVisible: setMarcVisible,
        marcOpacity: marcOpacity,
        setMarcOpacity: setMarcOpacity,
        marcTransformMode: marcTransformMode,
        setMarcTransformMode: setMarcTransformMode,
        eggTransformMode: eggTransformMode,
        setEggTransformMode: setEggTransformMode,
        lightingEnabled: lightingEnabled,
        setLightingEnabled: setLightingEnabled,
        eggWarmth: eggWarmth,
        setEggWarmth: setEggWarmth,
        eggRedshift: eggRedshift,
        setEggRedshift: setEggRedshift,
        // Resets
        resetMarcTransform: ()=>setMarcTransform((0, $7Yi7V.DEFAULT_MARC_TRANSFORM)),
        resetEggTransform: ()=>setEggTransform((0, $7Yi7V.DEFAULT_EGG_TRANSFORM)),
        resetEggLights: ()=>setEggLights((0, $7Yi7V.DEFAULT_EGG_LIGHTS)),
        marcOnionSrc: // Derived
        marcOnionSrc,
        save: save
    };
}



var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");
// Creative mode session state. No persistence — every entry into
// creative starts fresh, and switching marcs reseeds the per-marc
// values from the new reference.
//
// Marc swap is a cross-fade. Two marc IDs flow through:
//
//   selectedMarcId  — the user's pick. Drives the egg side (so the egg
//                     pose tween + reference fetch begin as soon as the
//                     user clicks).
//   displayedMarcId — what the easel + onion currently SHOW. Lags
//                     selectedMarcId by FADE_OUT_MS during a swap, so
//                     the marcId/transform snap on the photo + onion
//                     happens under cover of opacity 0. First pick
//                     (no prior marc) and same-marc re-pick skip the
//                     transition entirely.
//
// transitionPhase drives the opacity dampening on both surfaces:
//   'idle' — opacity follows the user (or 1 for the easel)
//   'out'  — easel photoVisible=false, onion opacity=0; CSS transition
//            fades both out over FADE_OUT_MS
//   'in'   — easel photoVisible=true, onion opacity=user; CSS transition
//            fades back in over FADE_IN_MS, after which we return to
//            'idle' (drops the onion's CSS transition so the slider
//            stays snappy outside the swap window).
const $3699cbcb67a7e0a1$var$DEFAULT_ONION_OPACITY = 0.25;
const $3699cbcb67a7e0a1$var$FADE_OUT_MS = (0, $7Yi7V.LANDING_PHOTO_FADE_OUT_MS);
const $3699cbcb67a7e0a1$var$FADE_IN_MS = (0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS);
function $3699cbcb67a7e0a1$export$2e2bcd8739ae039({ active: active }) {
    const [selectedMarcId, setSelectedMarcId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [displayedMarcId, setDisplayedMarcId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [transitionPhase, setTransitionPhase] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("idle");
    const [pickerOpen, setPickerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [onionOpacity, setOnionOpacity] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState($3699cbcb67a7e0a1$var$DEFAULT_ONION_OPACITY);
    const [warmth, setWarmth] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7Yi7V.DEFAULT_EGG_WARMTH));
    const [redshift, setRedshift] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7Yi7V.DEFAULT_EGG_REDSHIFT));
    const [eggLights, setEggLights] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7Yi7V.DEFAULT_EGG_LIGHTS));
    const [palette, setPalette] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $7Yi7V.DEFAULT_PALETTE));
    const setPaletteSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((index, hex)=>{
        setPalette((prev)=>{
            if (prev[index] === hex) return prev;
            const next = prev.slice();
            next[index] = hex;
            return next;
        });
    }, []);
    const fadeOutTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const fadeInTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const clearTimers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (fadeOutTimerRef.current != null) {
            clearTimeout(fadeOutTimerRef.current);
            fadeOutTimerRef.current = null;
        }
        if (fadeInTimerRef.current != null) {
            clearTimeout(fadeInTimerRef.current);
            fadeInTimerRef.current = null;
        }
    }, []);
    // Reset on creative exit. Picker is NOT auto-opened on entry — the
    // Landing button opens the picker directly while still in landing
    // mode, and picking a marc is what triggers the landing → creative
    // transition (App handles the setMode + pickMarc call). By the time
    // we're "active" here, the user has already picked, so an auto-open
    // would just re-pop the picker. Reseeding warmth/redshift/lights to
    // per-marc author values lives in useDisplayedSurfaces.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active) return;
        clearTimers();
        setSelectedMarcId(null);
        setDisplayedMarcId(null);
        setTransitionPhase("idle");
        setPickerOpen(false);
        setOnionOpacity($3699cbcb67a7e0a1$var$DEFAULT_ONION_OPACITY);
        setPalette((0, $7Yi7V.DEFAULT_PALETTE));
    }, [
        active,
        clearTimers
    ]);
    // `fadeFromHint` is what the easel/onion are currently rendering at
    // pick time — pre-pick that's whatever ambient marc was on screen
    // (landing's last marc, in the common landing → creative path). The
    // hint becomes the fade-out source when displayedMarcId is still
    // null, so the very first pick after creative entry cross-fades
    // from the ambient marc instead of snapping. Without it, the first
    // pick would always take the snap path (prev==null).
    const pickMarc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((id, fadeFromHint = null)=>{
        setSelectedMarcId(id);
        setPickerOpen(false);
        setDisplayedMarcId((prev)=>{
            const fadeFrom = prev ?? fadeFromHint;
            // No fade source (somehow neither displayed nor ambient) or
            // same-marc re-pick: snap.
            if (fadeFrom == null || fadeFrom === id) {
                clearTimers();
                setTransitionPhase("idle");
                return id;
            }
            // Cancel any in-flight transition so a rapid second pick
            // doesn't race the prior swap.
            clearTimers();
            setTransitionPhase("out");
            fadeOutTimerRef.current = setTimeout(()=>{
                fadeOutTimerRef.current = null;
                setDisplayedMarcId(id);
                setTransitionPhase("in");
                fadeInTimerRef.current = setTimeout(()=>{
                    fadeInTimerRef.current = null;
                    setTransitionPhase("idle");
                }, $3699cbcb67a7e0a1$var$FADE_IN_MS);
            }, $3699cbcb67a7e0a1$var$FADE_OUT_MS);
            // Park displayedMarcId on the fade-out source so the easel +
            // onion render that marc through the fade-out window.
            return fadeFrom;
        });
    }, [
        clearTimers
    ]);
    return {
        selectedMarcId: selectedMarcId,
        displayedMarcId: displayedMarcId,
        setDisplayedMarcId: // Exposed so App can seed it on creative entry to whatever marc is
        // currently on screen (landing's last). Seeding lets useReferenceJson
        // fetch the ambient reference before the user clicks, so the fade-
        // out's first frame already has the correct marc transform — without
        // it, displayedEff briefly resolves to DEFAULT_MARC_TRANSFORM during
        // the React commit between marcId-set and fetch-resolve.
        setDisplayedMarcId,
        transitionPhase: transitionPhase,
        pickMarc: pickMarc,
        pickerOpen: pickerOpen,
        openPicker: ()=>setPickerOpen(true),
        closePicker: ()=>setPickerOpen(false),
        onionOpacity: onionOpacity,
        setOnionOpacity: setOnionOpacity,
        warmth: warmth,
        setWarmth: setWarmth,
        redshift: redshift,
        setRedshift: setRedshift,
        eggLights: eggLights,
        setEggLights: setEggLights,
        palette: palette,
        setPalette: setPalette,
        setPaletteSlot: setPaletteSlot
    };
}



var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");


var $7Yi7V = parcelRequire("7Yi7V");
function $400b8d69e3376440$export$2e2bcd8739ae039({ authorMode: authorMode, reference: reference, author: author }) {
    if (authorMode) return {
        palette: author.palette,
        eggTransform: author.eggTransform,
        eggLights: author.eggLights,
        eggWarmth: author.eggWarmth,
        eggRedshift: author.eggRedshift,
        marcTransform: author.marcTransform
    };
    const palette = reference?.palette?.length === (0, $7Yi7V.DEFAULT_PALETTE).length ? reference.palette : (0, $7Yi7V.DEFAULT_PALETTE);
    const eggTransform = reference?.egg?.transform ?? (0, $7Yi7V.DEFAULT_EGG_TRANSFORM);
    const eggLights = reference?.egg?.lights ?? (0, $7Yi7V.DEFAULT_EGG_LIGHTS);
    const eggWarmth = reference?.egg?.warmth ?? (0, $7Yi7V.DEFAULT_EGG_WARMTH);
    const eggRedshift = reference?.egg?.redshift ?? (0, $7Yi7V.DEFAULT_EGG_REDSHIFT);
    const marcTransform = reference?.marc?.transform ?? (0, $7Yi7V.DEFAULT_MARC_TRANSFORM);
    return {
        palette: palette,
        eggTransform: eggTransform,
        eggLights: eggLights,
        eggWarmth: eggWarmth,
        eggRedshift: eggRedshift,
        marcTransform: marcTransform
    };
}



var $8Qhlh = parcelRequire("8Qhlh");

var $acw62 = parcelRequire("acw62");
// Smoothly animates an eggTransform bag (tx, ty, scale, scaleX,
// rotation) toward a target whenever the target changes. Active in
// any mode where the marc changes via state (landing/speedrun/creative)
// — author/label set `active=false` so slider/drag updates aren't
// fought by the tween.
//
// Why JS rAF and not a CSS transition: the egg is rendered to a
// canvas with the transform baked in (drawEggTransformed +
// applyLighting both consume eggTransform). Animating via CSS would
// require reworking the rendering pipeline so the egg renders at
// identity and the wrapper handles position; that's invasive and
// changes lighting semantics in subtle ways. Tweening the bag in
// React state is one extra rAF loop; the per-frame canvas re-light
// is fast enough at this canvas size for a one-second slide.
//
// Lighting is NOT tweened — eff.eggLights snaps at the moment the
// marcId changes (start of the move). This is intentional: trying to
// interpolate lights between marcs with potentially different array
// lengths gets messy fast, and the snap happens while drawing+photo
// are invisible (or the modal is dismissing, in creative mode) and
// the egg is in motion, so it reads as part of the transition rather
// than as a flash.
//
// Returns { current, tweening, tweeningRef }:
//   current     — the interpolated transform (or the target itself when
//                 inactive — no rAF, no animation, just passthrough).
//   tweening    — React state, true while a tween is in progress.
//                 Speedrun gates player input on this so the round
//                 doesn't start mid-flight. Useful as a render dep
//                 since it triggers re-renders on transitions.
//   tweeningRef — the SAME tweening info but mutated synchronously
//                 inside the hook's effect, so consumers reading it
//                 from another effect in the same commit cycle see
//                 the up-to-date value (whereas `tweening` from React
//                 state is still the prior render's). Speedrun's
//                 markStarted gate reads this — without it, the
//                 markStarted effect would race the tween's
//                 setTweening(true) and fire markStarted ~16ms
//                 before the slide actually begins, then the timer
//                 would count through the entire tween.
function $855add3c185591bb$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $855add3c185591bb$var$lerpTransform(a, b, t) {
    return {
        tx: a.tx + (b.tx - a.tx) * t,
        ty: a.ty + (b.ty - a.ty) * t,
        scale: a.scale + (b.scale - a.scale) * t,
        scaleX: a.scaleX + (b.scaleX - a.scaleX) * t,
        rotation: a.rotation + (b.rotation - a.rotation) * t
    };
}
function $855add3c185591bb$var$transformsEqual(a, b) {
    return a.tx === b.tx && a.ty === b.ty && a.scale === b.scale && a.scaleX === b.scaleX && a.rotation === b.rotation;
}
function $855add3c185591bb$export$2e2bcd8739ae039({ target: target, durationMs: durationMs, active: active }) {
    const [current, setCurrent] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(target);
    const [tweening, setTweening] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // currentRef mirrors `current` synchronously so the next tween's
    // effect can read the latest value as its `from` without waiting
    // for a render cycle.
    const currentRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(target);
    // tweeningRef mirrors `tweening` synchronously — same purpose, but
    // for consumers that need the up-to-date value within the SAME
    // commit cycle that the tween starts/ends. See header comment for
    // the markStarted ordering issue this avoids.
    const tweeningRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) {
            // Snap to target on deactivate — no animation, no rAF loop.
            currentRef.current = target;
            tweeningRef.current = false;
            setCurrent(target);
            setTweening(false);
            return;
        }
        if ($855add3c185591bb$var$transformsEqual(currentRef.current, target)) return;
        const from = currentRef.current;
        const start = performance.now();
        tweeningRef.current = true;
        setTweening(true);
        let raf;
        const tick = (now)=>{
            const elapsed = now - start;
            const t = Math.min(1, elapsed / durationMs);
            const eased = $855add3c185591bb$var$easeInOutCubic(t);
            const next = $855add3c185591bb$var$lerpTransform(from, target, eased);
            currentRef.current = next;
            setCurrent(next);
            if (t < 1) raf = requestAnimationFrame(tick);
            else {
                tweeningRef.current = false;
                setTweening(false);
            }
        };
        raf = requestAnimationFrame(tick);
        // Only cancel the rAF on cleanup; don't clear `tweening` here.
        // If the effect re-fires because `target` changed mid-tween, the
        // next run will start a new tween and re-set tweening=true. If it
        // re-fires because `active` flipped false, the inactive branch
        // above clears tweening. In neither case do we want a flicker
        // false→true between frames.
        return ()=>cancelAnimationFrame(raf);
    }, [
        target,
        durationMs,
        active
    ]);
    return {
        current: active ? current : target,
        tweening: active && tweening,
        tweeningRef: tweeningRef
    };
}


function $6bed9cd88f4a851e$export$2e2bcd8739ae039({ urlState: urlState, mode: mode, authoring: authoring, speedrun: speedrun, landing: landing, creative: creative, lastDisplayMarcIdRef: lastDisplayMarcIdRef }) {
    const authorMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).AUTHOR;
    const speedrunMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN;
    const landingMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING;
    const creativeMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE;
    // The "logical" current marc — what the user has explicitly chosen
    // (or null in transitional states: speedrun pre-engine-start,
    // creative pre-pick).
    let logicalMarcId;
    if (speedrunMode) logicalMarcId = speedrun.snapshot.currentMarcId;
    else if (landingMode) logicalMarcId = landing.currentId;
    else if (creativeMode) logicalMarcId = creative.selectedMarcId;
    else logicalMarcId = urlState.marcId;
    // Hold the previous logical marc when in a transitional state. Lets
    // the photo + trace + scoring keep showing the marc the user was just
    // looking at instead of snapping to urlState.marcId — most visible
    // win is creative entry: picker opens and the egg/photo/trace stay
    // anchored to whatever landing was showing until the user picks.
    // Updated via useEffect (not during render) so the ref stays
    // consistent with React's commit cycle.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (logicalMarcId != null) lastDisplayMarcIdRef.current = logicalMarcId;
    }, [
        logicalMarcId,
        lastDisplayMarcIdRef
    ]);
    const effectiveMarcId = logicalMarcId ?? lastDisplayMarcIdRef.current ?? urlState.marcId;
    const { reference: reference } = (0, $8Qhlh.default)(effectiveMarcId, authorMode);
    const eff = (0, $400b8d69e3376440$export$2e2bcd8739ae039)({
        authorMode: authorMode,
        reference: reference,
        author: authoring
    });
    // Reseed creative's tweakables (warmth/redshift/lights/palette) to
    // whatever the marc's author tuned, every time the user picks a new
    // marc. The user's edits then deviate from those starting points
    // until the next marc swap. Palette reseed doesn't recolor existing
    // strokes — DrawingEngine's freezeStrokeColor mode bakes color at
    // commit-time, so a swatch swap only affects future strokes.
    const creativeMarcId = creativeMode ? creative.selectedMarcId : null;
    const setCreativeWarmth = creative.setWarmth;
    const setCreativeRedshift = creative.setRedshift;
    const setCreativeEggLights = creative.setEggLights;
    const setCreativePalette = creative.setPalette;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!creativeMode) return;
        if (!reference) return;
        if (!creativeMarcId) return;
        setCreativeWarmth(reference.egg?.warmth ?? 30);
        setCreativeRedshift(reference.egg?.redshift ?? 30);
        setCreativeEggLights(reference.egg?.lights ?? []);
        if (reference.palette?.length === 6) setCreativePalette(reference.palette);
    }, [
        creativeMode,
        creativeMarcId,
        reference,
        setCreativeWarmth,
        setCreativeRedshift,
        setCreativeEggLights,
        setCreativePalette
    ]);
    // Creative cross-fade: easel + onion lag selectedMarcId by FADE_OUT_MS
    // so the marcId/transform jump on those surfaces happens under cover
    // of opacity 0. Egg side still tracks selectedMarcId immediately (so
    // the egg pose tween begins on click) — only the marc photo + onion
    // lag.
    //
    // We fetch displayedReference whenever creative.displayedMarcId is
    // non-null, INCLUDING from landing mode (when the picker is open
    // and the seed effect below has primed displayedMarcId to the
    // currently-visible marc). This is what lets the fetch resolve
    // BEFORE the user picks, so the first creative render after pick
    // already has displayedReference loaded for the OLD marc — without
    // it the photo briefly snaps to DEFAULT_MARC_TRANSFORM during the
    // first render of the fade-out.
    const { reference: displayedReference } = (0, $8Qhlh.default)(creative.displayedMarcId, authorMode);
    const displayedEff = (0, $400b8d69e3376440$export$2e2bcd8739ae039)({
        authorMode: authorMode,
        reference: displayedReference,
        author: authoring
    });
    // Keep creative.displayedMarcId in sync with whatever's currently on
    // screen WHILE THE PICKER IS OPEN — including from landing mode,
    // before the user has picked. Two reasons:
    //   1. Lets useReferenceJson(creative.displayedMarcId) start fetching
    //      the ambient reference *before* the user picks, so the first
    //      pick's fade-out doesn't briefly read DEFAULT_MARC_TRANSFORM
    //      while displayedReference is mid-resolve. This is load-bearing
    //      now that picker opens BEFORE mode flips to creative — the old
    //      "seed on creative entry" effect ran too late, since pickMarc
    //      and setMode(CREATIVE) batch into one render and useReferenceJson
    //      hasn't resolved its first fetch yet.
    //   2. Re-syncs if the user dismisses the picker, the landing reel
    //      cycles to a new marc, then the user re-opens the picker —
    //      otherwise displayedMarcId would still point at the marc the
    //      first picker-open captured, and pickMarc would fade FROM the
    //      wrong marc.
    // Outside the picker, displayedMarcId is owned by useCreative (the
    // pickMarc cross-fade flips it from FROM-marc to TO-marc mid-fade).
    // Skip mid-cross-fade — if the user opens "Change Marc" mid-fade,
    // displayedMarcId is the FROM/TO marc of the in-flight fade and
    // forcibly snapping it to effectiveMarcId (= selectedMarcId, the
    // TO-marc) would break the fade. pickMarc will reset things if the
    // user picks a new marc anyway.
    const setCreativeDisplayedMarcId = creative.setDisplayedMarcId;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!creative.pickerOpen) return;
        if (creative.transitionPhase !== "idle") return;
        if (!effectiveMarcId) return;
        if (creative.displayedMarcId === effectiveMarcId) return;
        setCreativeDisplayedMarcId(effectiveMarcId);
    }, [
        creative.pickerOpen,
        creative.transitionPhase,
        creative.displayedMarcId,
        effectiveMarcId,
        setCreativeDisplayedMarcId
    ]);
    // Pre-pick (creative.displayedMarcId == null) we fall back to the
    // hold-previous effectiveMarcId so the easel keeps showing whatever
    // landing was rendering until the user picks. After the first pick,
    // displayedMarcId is the source of truth for the easel + onion.
    const usingCreativeDisplayed = creativeMode && creative.displayedMarcId != null;
    const displayedMarcId = usingCreativeDisplayed ? creative.displayedMarcId : effectiveMarcId;
    // displayedMarcTransform follows displayedEff ONLY during fade-out —
    // that's when displayedMarcId points to the OLD marc (lagged) and we
    // genuinely need the OLD reference's transform to keep the photo
    // aligned at its prior pose while it fades to opacity 0.
    //
    // During fade-in (and idle), displayedMarcId has already swapped to
    // the new marc; we read from `eff` (which has been fetching the new
    // reference since the pick fired, so it's resolved by the time the
    // 600ms fade-out finishes) instead of `displayedEff`. Otherwise the
    // displayedReference fetch is a microtask behind the marcId swap and
    // the photo fades in at the OLD transform for one render before the
    // new transform pops into place — the user-reported "transform
    // applies after fade-in" artifact.
    const displayedMarcTransform = creativeMode && creative.transitionPhase === "out" ? displayedEff.marcTransform : eff.marcTransform;
    // Creative mode photo + onion opacity dampening, derived from the
    // useCreative state machine. During 'out' the easel hides its photo
    // (its CSS opacity transition fades it to 0) and the onion is forced
    // to 0; during 'in' the onion's CSS transition fades it back up to
    // the user's slider value. Outside 'out'/'in' the onion has its
    // transition disabled so the slider stays responsive.
    const creativePhotoVisible = !creativeMode || creative.transitionPhase !== "out";
    const creativeOnionOpacity = creativeMode && creative.transitionPhase === "out" ? 0 : creative.onionOpacity;
    const creativeOnionTransitionMs = creative.transitionPhase === "out" ? (0, $7Yi7V.LANDING_PHOTO_FADE_OUT_MS) : creative.transitionPhase === "in" ? (0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS) : 0;
    // The egg side (pose + lighting + tints) tracks `effectiveMarcId`
    // everywhere except landing — which staggers it via `landing.eggMarcId`
    // (lagged by PHOTO_FADE_IN_MS) so the photo fades in first while the
    // egg holds the old marc's pose, then slides over. The hold-previous
    // semantic in `effectiveMarcId` already handles the no-pick states
    // (speedrun pre-start, creative pre-pick) so eggMarcId stays pinned
    // to the prior marc's id and the tween doesn't fire a stray hop.
    const eggMarcId = landingMode ? landing.eggMarcId : effectiveMarcId;
    const { reference: eggReference, loadedForMarcId: eggReferenceLoadedForMarcId } = (0, $8Qhlh.default)(eggMarcId, authorMode);
    const eggSide = (0, $400b8d69e3376440$export$2e2bcd8739ae039)({
        authorMode: authorMode,
        reference: eggReference,
        author: authoring
    });
    // Tween the egg transform on marc change. Active in modes where the
    // marc swaps via state (landing reel, speedrun lineup advance,
    // creative pick); not in author/label, where the transform is driven
    // by sliders/drag and a tween would fight every input. `tween.tweening`
    // gates speedrun input + scoring so the player can't draw onto a
    // moving egg or score against a marc that's still flying in.
    const tweenActive = landingMode || speedrunMode || creativeMode;
    const tween = (0, $855add3c185591bb$export$2e2bcd8739ae039)({
        target: eggSide.eggTransform,
        durationMs: (0, $7Yi7V.LANDING_EGG_MOVE_MS),
        active: tweenActive
    });
    // Trace overlay shown on the egg canvas in landing (cycle-driven
    // fade in/out) and creative (mounted at opacity 0 so the post-pick
    // fade-out animates smoothly from whatever opacity it was at). Hidden
    // in speedrun/author. Returns a finished {src, visible}|null so JSX
    // consumers don't have to rebuild the conditional.
    //
    // Source ref (`drawingRef`) is the LAGGED `displayedReference` in
    // creative so the trace src stays pinned to the OLD marc through the
    // pick cross-fade — matches the photo's `displayedMarcTransform`
    // lag. Without lag, the trace's src would flip to the picked marc
    // the instant the new fetch resolves, which mid-fade-out would
    // flash the picked marc's drawing at high opacity before the fade
    // completes. In landing the cycle owns marcId timing directly, so
    // plain `reference` is correct.
    const drawingRef = creativeMode ? displayedReference : reference;
    const landingDrawing = drawingRef?.drawing?.image && (landingMode || creativeMode) ? {
        src: drawingRef.drawing.image,
        visible: landingMode ? landing.drawingShown : !creative.selectedMarcId
    } : null;
    // Creative mode overrides lights/warmth/redshift with session
    // tweakables (LightingEditor + sliders); reference values flow
    // through unchanged in every other mode.
    const eggDisplay = {
        eggTransform: tween.current,
        eggLights: creativeMode ? creative.eggLights : eggSide.eggLights,
        eggWarmth: creativeMode ? creative.warmth : eggSide.eggWarmth,
        eggRedshift: creativeMode ? creative.redshift : eggSide.eggRedshift
    };
    // Creative owns its own palette (seeded from reference, edited via
    // double-click swatches). Other modes pass through the reference's
    // palette as `eff` already resolves it.
    const effOut = creativeMode ? {
        ...eff,
        palette: creative.palette
    } : eff;
    return {
        effectiveMarcId: effectiveMarcId,
        displayedMarcId: displayedMarcId,
        displayedMarcTransform: displayedMarcTransform,
        reference: reference,
        eff: effOut,
        landingDrawing: landingDrawing,
        eggDisplay: eggDisplay,
        eggReferenceLoadedForMarcId: eggReferenceLoadedForMarcId,
        tween: tween,
        creativePhotoVisible: creativePhotoVisible,
        creativeOnionOpacity: creativeOnionOpacity,
        creativeOnionTransitionMs: creativeOnionTransitionMs
    };
}



var $acw62 = parcelRequire("acw62");
// Imperative drawing engine. Owns the stroke + redo lists, the active
// stroke during a pointer drag, the lastTool / lastActionAt activity
// signals, and the canvas-painting work. Lives outside React; the hook
// (useDrawing) handles the React-side glue.
//
// Inputs that React owns (tool, palette, colorIndex, size) flow in via
// setInputs() — the engine reads its own copy when handlers fire so a
// mid-stroke palette change behaves consistently. The canvas reference
// is passed at construction; the engine reads .current on demand so the
// element doesn't have to exist at construction time.
//
// Snapshot is event-frequency: emits on stroke commit / undo / redo /
// clear. The hook subscribes and pushes the snapshot into React state
// for things downstream (DrawingToolbar's enable/disable, scoring's
// strokes input, the speedrun activity signals).

var $47gLI = parcelRequire("47gLI");
const $6b9b3bfe84dfc7d2$var$MIN_SIZE = 2;
const $6b9b3bfe84dfc7d2$var$MAX_SIZE = 80;
const $6b9b3bfe84dfc7d2$var$FILL_TOLERANCE = 24; // squared Euclidean RGB+alpha distance
function $6b9b3bfe84dfc7d2$var$clampSize(n) {
    return Math.max($6b9b3bfe84dfc7d2$var$MIN_SIZE, Math.min($6b9b3bfe84dfc7d2$var$MAX_SIZE, n));
}
function $6b9b3bfe84dfc7d2$var$canvasPointFromEvent(canvas, event) {
    // rect.width/height include CSS transforms (like FitContainer's scale),
    // which offsetWidth/offsetHeight do not. The visual size is what we need
    // to map viewport-pixel deltas back to canvas-buffer pixels. The drawing
    // canvas is always axis-aligned regardless of egg rotation, so a
    // straight screen→virtual map suffices.
    const rect = canvas.getBoundingClientRect();
    const displayedW = rect.width || canvas.offsetWidth;
    const displayedH = rect.height || canvas.offsetHeight;
    return {
        x: (event.clientX - rect.left) * canvas.width / displayedW,
        y: (event.clientY - rect.top) * canvas.height / displayedH,
        pressure: event.pressure > 0 && event.pressure !== 0.5 ? event.pressure : null
    };
}
function $6b9b3bfe84dfc7d2$var$floodFillMask(imgData, startX, startY, width, height, silhouette) {
    const { data: data } = imgData;
    const startIdx = (startY * width + startX) * 4;
    const t0 = data[startIdx];
    const t1 = data[startIdx + 1];
    const t2 = data[startIdx + 2];
    const t3 = data[startIdx + 3];
    // Egg silhouette acts as a wall: a fill seeded outside the egg can only
    // grow into other off-egg pixels, and likewise inside-egg fills stay
    // inside. Lets the player draw two strokes to the egg's left and right
    // edges and have the fill bridge across as if the egg were a closed
    // boundary.
    const seedOnEgg = silhouette ? silhouette[startY * width + startX] : 0;
    const tol2 = $6b9b3bfe84dfc7d2$var$FILL_TOLERANCE * $6b9b3bfe84dfc7d2$var$FILL_TOLERANCE;
    const mask = new Uint8Array(width * height);
    const stack = [
        startX | 0,
        startY | 0
    ];
    while(stack.length > 0){
        const y = stack.pop();
        const x = stack.pop();
        if (x < 0 || x >= width || y < 0 || y >= height) continue;
        const mi = y * width + x;
        if (mask[mi]) continue;
        if (silhouette && silhouette[mi] !== seedOnEgg) continue;
        const pi = mi * 4;
        const dr = data[pi] - t0;
        const dg = data[pi + 1] - t1;
        const db = data[pi + 2] - t2;
        const da = data[pi + 3] - t3;
        if (dr * dr + dg * dg + db * db + da * da > tol2) continue;
        mask[mi] = 1;
        stack.push(x + 1, y, x - 1, y, x, y + 1, x, y - 1);
    }
    return mask;
}
function $6b9b3bfe84dfc7d2$var$dilateMask(mask, width, height, iterations = 1) {
    let cur = mask;
    for(let k = 0; k < iterations; k++){
        const next = new Uint8Array(cur.length);
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const i = y * width + x;
            if (cur[i]) {
                next[i] = 1;
                if (x > 0) next[i - 1] = 1;
                if (x < width - 1) next[i + 1] = 1;
                if (y > 0) next[i - width] = 1;
                if (y < height - 1) next[i + width] = 1;
            }
        }
        cur = next;
    }
    return cur;
}
function $6b9b3bfe84dfc7d2$var$cropMaskToBbox(mask, width, height) {
    let minX = width, minY = height, maxX = -1, maxY = -1;
    for(let y = 0; y < height; y++){
        for(let x = 0; x < width; x++)if (mask[y * width + x]) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
        }
    }
    if (maxX < 0) return {
        bbox: {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        },
        mask: new Uint8Array(0)
    };
    const w = maxX - minX + 1;
    const h = maxY - minY + 1;
    const cropped = new Uint8Array(w * h);
    for(let y = 0; y < h; y++)for(let x = 0; x < w; x++)cropped[y * w + x] = mask[(y + minY) * width + (x + minX)];
    return {
        bbox: {
            x: minX,
            y: minY,
            w: w,
            h: h
        },
        mask: cropped
    };
}
class $6b9b3bfe84dfc7d2$export$2e2bcd8739ae039 {
    constructor({ canvasRef: canvasRef, eggSilhouetteRef: eggSilhouetteRef }){
        this.canvasRef = canvasRef;
        this.eggSilhouetteRef = eggSilhouetteRef;
        this.strokes = [];
        this.redoStack = [];
        this.activeStroke = null;
        this.activePointerId = null;
        this.lastTool = null;
        this.lastActionAt = 0;
        // Inputs from React, refreshed via setInputs.
        this.tool = "pen";
        this.palette = [];
        this.colorIndex = 0;
        this.size = 16;
        // When true, committed strokes have colorIndex nulled so palette
        // slot edits no longer recolor them — creative mode wants new
        // strokes frozen at draw-time. Default false matches author/speedrun.
        this.freezeStrokeColor = false;
        this.listeners = new Set();
    }
    setInputs({ tool: tool, palette: palette, colorIndex: colorIndex, size: size, freezeStrokeColor: freezeStrokeColor }) {
        const paletteChanged = palette !== this.palette;
        this.tool = tool;
        this.palette = palette;
        this.colorIndex = colorIndex;
        this.size = size;
        this.freezeStrokeColor = !!freezeStrokeColor;
        if (paletteChanged) this._redrawAll();
    }
    onPointerDown(event) {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        if (event.button !== 0 && event.pointerType === "mouse") return;
        const point = $6b9b3bfe84dfc7d2$var$canvasPointFromEvent(canvas, event);
        if (this.tool === "fill") {
            this._applyFillAt(point.x, point.y);
            return;
        }
        canvas.setPointerCapture(event.pointerId);
        this.activePointerId = event.pointerId;
        const stroke = {
            tool: this.tool,
            colorIndex: this.tool === "eraser" ? null : this.colorIndex,
            color: this.tool === "eraser" ? null : this.palette[this.colorIndex],
            size: $6b9b3bfe84dfc7d2$var$clampSize(this.size),
            points: [
                point
            ]
        };
        this.activeStroke = stroke;
        const ctx = canvas.getContext("2d");
        (0, $47gLI.renderPenStroke)(ctx, stroke, this.palette);
    }
    onPointerMove(event) {
        if (this.activePointerId !== event.pointerId) return;
        const stroke = this.activeStroke;
        if (!stroke) return;
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const point = $6b9b3bfe84dfc7d2$var$canvasPointFromEvent(canvas, event);
        const prev = stroke.points[stroke.points.length - 1];
        const dx = point.x - prev.x;
        const dy = point.y - prev.y;
        if (dx * dx + dy * dy < 0.5) return;
        stroke.points.push(point);
        const ctx = canvas.getContext("2d");
        (0, $47gLI.renderPenStroke)(ctx, {
            ...stroke,
            points: [
                prev,
                point
            ]
        }, this.palette);
    }
    onPointerUp(event) {
        if (this.activePointerId !== event.pointerId) return;
        const stroke = this.activeStroke;
        this.activeStroke = null;
        this.activePointerId = null;
        if (!stroke) return;
        this._commit(stroke);
    }
    undo() {
        if (this.strokes.length === 0) return;
        const popped = this.strokes[this.strokes.length - 1];
        this.strokes = this.strokes.slice(0, -1);
        this.redoStack = [
            ...this.redoStack,
            popped
        ];
        this._redrawAll();
        this._emit();
    }
    redo() {
        if (this.redoStack.length === 0) return;
        const popped = this.redoStack[this.redoStack.length - 1];
        this.redoStack = this.redoStack.slice(0, -1);
        this.strokes = [
            ...this.strokes,
            popped
        ];
        this._redrawAll();
        this._emit();
    }
    // Wipe all strokes + redo history and repaint. Used between marcs in
    // a speedrun round. Does not touch tool/palette/size inputs — those
    // belong to React.
    clear() {
        if (this.strokes.length === 0 && this.redoStack.length === 0) return;
        this.strokes = [];
        this.redoStack = [];
        this._redrawAll();
        this._emit();
    }
    getSnapshot() {
        return {
            strokes: this.strokes,
            canUndo: this.strokes.length > 0,
            canRedo: this.redoStack.length > 0,
            lastTool: this.lastTool,
            lastActionAt: this.lastActionAt
        };
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return ()=>this.listeners.delete(listener);
    }
    dispose() {
        this.listeners.clear();
        this.activeStroke = null;
        this.activePointerId = null;
    }
    _commit(stroke) {
        if (this.freezeStrokeColor && stroke.colorIndex != null) stroke.colorIndex = null;
        this.strokes = [
            ...this.strokes,
            stroke
        ];
        this.redoStack = [];
        this.lastTool = stroke.tool;
        this.lastActionAt = Date.now();
        this._emit();
    }
    _applyFillAt(canvasX, canvasY) {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const x = Math.max(0, Math.min(canvas.width - 1, Math.round(canvasX)));
        const y = Math.max(0, Math.min(canvas.height - 1, Math.round(canvasY)));
        const silhouette = this.eggSilhouetteRef?.current?.data ?? null;
        const rawMask = $6b9b3bfe84dfc7d2$var$floodFillMask(imgData, x, y, canvas.width, canvas.height, silhouette);
        // Dilate by 2px to cover anti-aliased stroke edges — without this
        // the fill stops one pixel short of opaque stroke cores and leaves
        // a halo.
        const mask = $6b9b3bfe84dfc7d2$var$dilateMask(rawMask, canvas.width, canvas.height, 2);
        // Dilation doesn't know about the silhouette wall, so it can extend
        // the fill up to 2px across the egg boundary. Clip back to the
        // seed's silhouette state.
        if (silhouette) {
            const seedOnEgg = silhouette[y * canvas.width + x];
            for(let i = 0; i < mask.length; i++)if (mask[i] && silhouette[i] !== seedOnEgg) mask[i] = 0;
        }
        const { bbox: bbox, mask: cropped } = $6b9b3bfe84dfc7d2$var$cropMaskToBbox(mask, canvas.width, canvas.height);
        if (cropped.length === 0) return;
        const fill = {
            tool: "fill",
            colorIndex: this.colorIndex,
            color: this.palette[this.colorIndex],
            bbox: bbox,
            mask: cropped
        };
        // Render the fill to canvas immediately so subsequent fills see
        // updated pixels (otherwise the next fill's flood would seed off
        // the pre-fill canvas state).
        this._commit(fill);
        this._redrawAll();
    }
    _redrawAll() {
        const canvas = this.canvasRef?.current;
        if (!canvas) return;
        (0, $47gLI.redraw)(canvas, this.strokes, this.palette);
    }
    _emit() {
        for (const l of this.listeners)l();
    }
}


function $b678971e312560c2$export$2e2bcd8739ae039({ canvasRef: canvasRef, tool: tool, palette: palette, colorIndex: colorIndex, size: size, eggSilhouetteRef: eggSilhouetteRef, freezeStrokeColor: freezeStrokeColor = false }) {
    const engineRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (engineRef.current == null) engineRef.current = new (0, $6b9b3bfe84dfc7d2$export$2e2bcd8739ae039)({
        canvasRef: canvasRef,
        eggSilhouetteRef: eggSilhouetteRef
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        engineRef.current.setInputs({
            tool: tool,
            palette: palette,
            colorIndex: colorIndex,
            size: size,
            freezeStrokeColor: freezeStrokeColor
        });
    }, [
        tool,
        palette,
        colorIndex,
        size,
        freezeStrokeColor
    ]);
    const [snapshot, setSnapshot] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>engineRef.current.getSnapshot());
    const recompute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setSnapshot(engineRef.current.getSnapshot());
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const engine = engineRef.current;
        const unsub = engine.subscribe(recompute);
        return ()=>{
            unsub();
            engine.dispose();
        };
    }, [
        recompute
    ]);
    // Stable handlers — delegate to the engine. Methods on the class read
    // .canvasRef.current internally, so the closure doesn't need to
    // capture the canvas.
    const canvasHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            onPointerDown: (e)=>engineRef.current.onPointerDown(e),
            onPointerMove: (e)=>engineRef.current.onPointerMove(e),
            onPointerUp: (e)=>engineRef.current.onPointerUp(e),
            onPointerCancel: (e)=>engineRef.current.onPointerUp(e)
        }), []);
    const undo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>engineRef.current.undo(), []);
    const redo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>engineRef.current.redo(), []);
    const clear = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>engineRef.current.clear(), []);
    return {
        canvasHandlers: canvasHandlers,
        undo: undo,
        redo: redo,
        clear: clear,
        strokes: snapshot.strokes,
        canUndo: snapshot.canUndo,
        canRedo: snapshot.canRedo,
        lastTool: snapshot.lastTool,
        lastActionAt: snapshot.lastActionAt
    };
}




var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");
function $c4b469c0eb5e80de$export$2e2bcd8739ae039({ ids: ids, active: active, entryFromMarcId: entryFromMarcId }) {
    const [index, setIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    // eggIndex lags currentIndex by PHOTO_FADE_IN_MS within each cycle.
    // Equal to currentIndex outside the lag window.
    const [eggIndex, setEggIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [drawingShown, setDrawingShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [photoShown, setPhotoShown] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Held FROM marc during an entry-from-other-mode transition. Two
    // separate holds because the photo's src and the egg's pose lift
    // at different times in the entry timeline:
    //   - entryPhotoHold lifts after PHOTO_FADE_OUT (photo reaches
    //     opacity 0; src can swap under cover).
    //   - entryEggHold lifts after PHOTO_FADE_OUT + PHOTO_FADE_IN
    //     (photo fully visible at NEW src; egg starts tweening).
    // Both null outside the entry window.
    const [entryPhotoHold, setEntryPhotoHold] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [entryEggHold, setEntryEggHold] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const isFirstCycleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    // Snapshot at activation so a stale prop doesn't disturb a
    // mid-cycle re-render.
    const entryFromAtActivationRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) {
            setIndex(0);
            setEggIndex(0);
            setDrawingShown(false);
            setPhotoShown(false);
            setEntryPhotoHold(null);
            setEntryEggHold(null);
            isFirstCycleRef.current = true;
            entryFromAtActivationRef.current = null;
        }
    }, [
        active
    ]);
    // Snapshot the FROM marc and seed entry state synchronously on
    // first activation. useLayoutEffect (not useEffect) so seeded
    // state is in place before the browser paints the first landing
    // frame — otherwise the photo briefly snaps to ids[0] at high
    // opacity before any fade can hide it.
    //
    // Two seeded paths, depending on whether the FROM marc differs
    // from ids[0]:
    //
    //   FROM != ids[0]  — set entryPhotoHold/entryEggHold so the
    //                     photo's src and the egg's pose stay pinned
    //                     to FROM through the fade-out / fade-in /
    //                     egg-move beats (driven by the cycle effect).
    //   FROM == ids[0]  — the photo is already showing the right marc
    //                     at opacity 1 (we came from a mode that was
    //                     rendering ids[0] in the background). Pre-set
    //                     photoShown=true and drawingShown=true so the
    //                     first landing render commits at opacity 1 —
    //                     no CSS transition fires (Frame K → Frame K'
    //                     happens via the synchronous re-render from
    //                     this effect, no paint between, browser sees
    //                     opacity stayed at 1 from the prior mode's
    //                     paint). The cycle effect's cold-boot path
    //                     still runs but its setPhotoShown(true) at
    //                     SETTLE_MS and setDrawingShown(true) at
    //                     fade-in time become no-ops, leaving us in a
    //                     "fully visible, waiting for hold to expire"
    //                     state until the cycle naturally fades out
    //                     and advances.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(()=>{
        if (!active) return;
        if (!isFirstCycleRef.current) return;
        if (ids.length === 0) return;
        entryFromAtActivationRef.current = entryFromMarcId ?? null;
        if (entryFromMarcId == null) return;
        if (entryFromMarcId === ids[0]) {
            setPhotoShown(true);
            setDrawingShown(true);
        } else {
            setEntryPhotoHold(entryFromMarcId);
            setEntryEggHold(entryFromMarcId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        active
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) return;
        if (ids.length === 0) return;
        const timers = [];
        const at = (delay, fn)=>timers.push(setTimeout(fn, delay));
        const isFirst = isFirstCycleRef.current;
        isFirstCycleRef.current = false;
        const fromMarcId = entryFromAtActivationRef.current;
        const useEntry = isFirst && fromMarcId != null && fromMarcId !== ids[0];
        let drawingFadeInAt;
        if (useEntry) {
            // Entering from creative/speedrun: the photo currently shows
            // FROM marc at opacity 1 with the egg in FROM pose. Fade out
            // the FROM photo (entryPhotoHold keeps src/transform pinned),
            // swap to ids[0] under cover of opacity 0, fade back in over
            // the still-OLD egg pose, then move the egg, then fade in the
            // drawing.
            const photoFadedOutAt = (0, $7Yi7V.LANDING_PHOTO_FADE_OUT_MS);
            at(photoFadedOutAt, ()=>{
                setEntryPhotoHold(null);
                setPhotoShown(true);
            });
            const eggMoveAt = photoFadedOutAt + (0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS);
            at(eggMoveAt, ()=>{
                setEntryEggHold(null);
            });
            drawingFadeInAt = eggMoveAt + (0, $7Yi7V.LANDING_EGG_MOVE_MS);
        } else if (isFirst) {
            // First marc has no prior egg pose to move from — settle, fade
            // in photo, fade in drawing.
            at((0, $7Yi7V.LANDING_INITIAL_SETTLE_MS), ()=>setPhotoShown(true));
            drawingFadeInAt = (0, $7Yi7V.LANDING_INITIAL_SETTLE_MS) + (0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS);
        // eggIndex stays at 0 (== index); no egg move on first cycle.
        } else {
            // Subsequent marcs: photo fades in first against the still-old
            // egg pose, then the egg slides over to the new pose, then the
            // drawing fades in.
            at(0, ()=>setPhotoShown(true));
            at((0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS), ()=>setEggIndex(index));
            drawingFadeInAt = (0, $7Yi7V.LANDING_PHOTO_FADE_IN_MS) + (0, $7Yi7V.LANDING_EGG_MOVE_MS);
        }
        at(drawingFadeInAt, ()=>setDrawingShown(true));
        if (ids.length <= 1) return ()=>timers.forEach(clearTimeout);
        const drawingFadeInDoneAt = drawingFadeInAt + (0, $7Yi7V.LANDING_DRAWING_FADE_IN_MS);
        const fadeOutStartsAt = drawingFadeInDoneAt + (0, $7Yi7V.LANDING_HOLD_MS);
        const advanceAt = fadeOutStartsAt + (0, $7Yi7V.LANDING_DRAWING_FADE_OUT_MS);
        at(fadeOutStartsAt, ()=>{
            setDrawingShown(false);
            setPhotoShown(false);
        });
        at(advanceAt, ()=>{
            setIndex((i)=>(i + 1) % ids.length);
        });
        return ()=>timers.forEach(clearTimeout);
    }, [
        active,
        index,
        ids.length
    ]);
    const currentId = entryPhotoHold ?? (ids.length > 0 ? ids[index % ids.length] : null);
    const eggMarcId = entryEggHold ?? (ids.length > 0 ? ids[eggIndex % ids.length] : null);
    return {
        currentId: currentId,
        eggMarcId: eggMarcId,
        drawingShown: drawingShown,
        photoShown: photoShown
    };
}



var $acw62 = parcelRequire("acw62");
// Per-marc state machine + animator. Owns a DetectionGate (private
// member) plus the celebration timer and shown target picker — this is
// the engine that drives one marc's play through to allDone. The outer
// SpeedrunEngine sits above and owns the multi-marc round (lineup,
// currentIndex). Lives outside React; the binding hook (useMarcEngine)
// handles the React-side glue.
//
// State machine (all owned here, none in React):
//   regions       — latest scoring output, fed in via update()
//   shownId       — which region the panel is asking the player to draw
//   celebrating   — true during the post-completion animation window
//   celebrationTimer — clears on dispose / reset
//
// Target picker rules:
//   - prefer regions that have never been committed
//   - then deficient regions (committed but raw fell back below threshold)
//   - else null (allDone)
//
// Transitions:
//   - update() pushes new score result into the gate, then calls
//     _maybeAdvanceShown which either kicks celebration (if the current
//     shown just satisfied) or syncs shownId to the picker's choice.
//   - When the gate emits a transition, the same _maybeAdvanceShown
//     fires.
//   - Celebration timer resolution: clears celebrating, advances shown,
//     emits.
//
// Side-effect callbacks (onTargetChange, onCelebrationStart,
// onCelebrationEnd) fire at the exact moments those events
// conceptually happen — when shownId swaps, when the celebration
// timer kicks off, or when it resolves. The hook passes setters at
// construction time; the engine still doesn't import React, it just
// invokes plain functions. Snapshot subscribers are for things React
// renders (panel chrome); event callbacks are for things React mutates
// (palette / tool state) or out-of-band side effects (sound).
// Imperative state machine + animator for the speedrun progress bar. Lives
// outside React: owns its own rAF loop, writes clip-path directly to the
// bar element, and only notifies subscribers when commit/deficient state
// transitions actually flip. SpeedrunEngine wraps the gate and adds the
// celebration state machine on top; the React-side binding lives in
// useSpeedrunEngine.
//
// State per region:
//   displayed — animated 0..1, chases raw score at a tool-dependent rate.
//   committed — sticky once displayed reached 1.0. Never clears.
//   deficient — flips true when a committed region's raw score drops below
//               DETECTION_DEFICIENT_THRESHOLD, false again at raw >= 1.
//
// satisfied = committed && !deficient. The next-target picker prefers
// !committed first, then !satisfied, so heavy undos re-queue the region
// without yanking the player off their current target mid-stroke.
//
// Down direction: instant snap. If raw drops, displayed matches
// immediately so a stale-high bar can't commit through the player's
// correction.

var $7Yi7V = parcelRequire("7Yi7V");
const $355c436525546c11$var$COMMIT_EPSILON = 0.001;
function $355c436525546c11$var$clamp01(v) {
    return Math.max(0, Math.min(1, v));
}
class $355c436525546c11$export$2e2bcd8739ae039 {
    constructor(){
        this._displayed = new Map();
        this._committed = new Map();
        this._deficient = new Map();
        this._regions = [];
        this._lastTool = "pen";
        this._fillMs = 250;
        this._strokeMs = 1100;
        this._barEl = null;
        this._barRegionId = null;
        this._listeners = new Set();
        this._raf = null;
        this._lastFrame = 0;
        this._step = this._step.bind(this);
    }
    // Called from React when scoring recomputes (or rates / tool change).
    // Synchronous: snaps displayed downward, runs deficiency, updates the
    // bar, kicks the rAF loop if anything still needs to animate up.
    update({ regions: regions, lastTool: lastTool, fillMs: fillMs, strokeMs: strokeMs }) {
        this._regions = regions;
        this._lastTool = lastTool;
        this._fillMs = fillMs;
        this._strokeMs = strokeMs;
        let transitionsChanged = false;
        let needsLoop = false;
        for (const r of regions){
            const target = $355c436525546c11$var$clamp01(r.score ?? 0);
            const cur = this._displayed.get(r.id) ?? 0;
            if (cur > target) this._displayed.set(r.id, target);
            else if (cur < target) needsLoop = true;
            const next = this._displayed.get(r.id) ?? 0;
            if (this._maybeCommit(r.id, target, next)) transitionsChanged = true;
            if (this._updateDeficiency(r.id, target)) transitionsChanged = true;
        }
        this._writeBar();
        if (transitionsChanged) this._emit();
        if (needsLoop) this._startLoop();
    }
    // Called by ScorePanel whenever the bar element or the region it
    // displays changes. Idempotent — no-op when nothing changed.
    bindBar(el, regionId) {
        if (this._barEl === el && this._barRegionId === regionId) return;
        this._barEl = el;
        this._barRegionId = regionId;
        this._writeBar();
    }
    // For the panel's pip row + next-target selector. Reads-only snapshot.
    getRegionState(id) {
        const committed = !!this._committed.get(id);
        const deficient = !!this._deficient.get(id);
        return {
            committed: committed,
            deficient: deficient,
            satisfied: committed && !deficient
        };
    }
    subscribe(listener) {
        this._listeners.add(listener);
        return ()=>{
            this._listeners.delete(listener);
        };
    }
    // Clears all per-region state but keeps the bar binding + listeners
    // so the gate can be reused for a fresh speedrun without rebinding.
    reset() {
        if (this._raf != null) cancelAnimationFrame(this._raf);
        this._raf = null;
        this._lastFrame = 0;
        this._displayed.clear();
        this._committed.clear();
        this._deficient.clear();
        this._regions = [];
        this._writeBar();
    }
    dispose() {
        if (this._raf != null) cancelAnimationFrame(this._raf);
        this._raf = null;
        this._listeners.clear();
        this._barEl = null;
    }
    _step(now) {
        this._raf = null;
        const dt = this._lastFrame ? now - this._lastFrame : 16;
        this._lastFrame = now;
        const rateMs = this._lastTool === "fill" ? this._fillMs : this._strokeMs;
        const ratePerMs = 1 / Math.max(1, rateMs);
        let transitionsChanged = false;
        let needsMore = false;
        for (const r of this._regions){
            const target = $355c436525546c11$var$clamp01(r.score ?? 0);
            const cur = this._displayed.get(r.id) ?? 0;
            if (cur >= target) continue;
            const next = Math.min(target, cur + ratePerMs * dt);
            this._displayed.set(r.id, next);
            if (next < target) needsMore = true;
            if (this._maybeCommit(r.id, target, next)) transitionsChanged = true;
        }
        this._writeBar();
        if (transitionsChanged) this._emit();
        if (needsMore) this._raf = requestAnimationFrame(this._step);
        else this._lastFrame = 0;
    }
    _startLoop() {
        if (this._raf != null) return;
        this._lastFrame = 0;
        this._raf = requestAnimationFrame(this._step);
    }
    _maybeCommit(id, target, displayed) {
        if (target < 1 - $355c436525546c11$var$COMMIT_EPSILON) return false;
        if (displayed < 1 - $355c436525546c11$var$COMMIT_EPSILON) return false;
        if (!this._committed.get(id)) {
            this._committed.set(id, true);
            this._deficient.set(id, false);
            return true;
        }
        if (this._deficient.get(id)) {
            this._deficient.set(id, false);
            return true;
        }
        return false;
    }
    _updateDeficiency(id, target) {
        if (!this._committed.get(id)) return false;
        const wasDeficient = !!this._deficient.get(id);
        let next = wasDeficient;
        if (!wasDeficient && target < (0, $7Yi7V.DETECTION_DEFICIENT_THRESHOLD)) next = true;
        else if (wasDeficient && target >= 1 - $355c436525546c11$var$COMMIT_EPSILON) next = false;
        if (next !== wasDeficient) {
            this._deficient.set(id, next);
            return true;
        }
        return false;
    }
    _writeBar() {
        const el = this._barEl;
        if (!el) return;
        const id = this._barRegionId;
        if (id == null) return;
        const committed = !!this._committed.get(id);
        const deficient = !!this._deficient.get(id);
        const satisfied = committed && !deficient;
        const region = this._regions.find((r)=>r.id === id);
        const overdrawn = !!region?.overdrawn;
        // Overdraw shows full bar (red, via CSS keyed on data-overdrawn)
        // even though raw score is low, so the player gets an unmistakable
        // "too much!" signal. Commit logic is unaffected — _maybeCommit
        // gates on the real target (region.score), which is well below 1
        // when overdrawn, so the gate won't false-commit through this.
        const displayed = overdrawn || satisfied ? 1 : this._displayed.get(id) ?? 0;
        const insetRight = (1 - displayed) * 100;
        el.style.clipPath = `inset(0 ${insetRight}% 0 0)`;
        // Stripes pause while the bar is still climbing toward raw target;
        // resume on stable / satisfied.
        const rawTarget = region ? $355c436525546c11$var$clamp01(region.score ?? 0) : 0;
        const growing = !overdrawn && !satisfied && displayed < rawTarget - $355c436525546c11$var$COMMIT_EPSILON;
        const flag = growing ? "1" : "0";
        if (el.dataset.growing !== flag) el.dataset.growing = flag;
        const overdrawFlag = overdrawn ? "1" : "0";
        if (el.dataset.overdrawn !== overdrawFlag) el.dataset.overdrawn = overdrawFlag;
    }
    _emit() {
        for (const l of this._listeners)l();
    }
}


const $ac74d23f8ba09367$var$NOOP = ()=>{};
class $ac74d23f8ba09367$export$2e2bcd8739ae039 {
    constructor({ celebrationMs: celebrationMs, onTargetChange: onTargetChange, onCelebrationStart: onCelebrationStart, onCelebrationEnd: onCelebrationEnd }){
        this.gate = new (0, $355c436525546c11$export$2e2bcd8739ae039)();
        this.celebrationMs = celebrationMs;
        this.onTargetChange = onTargetChange ?? $ac74d23f8ba09367$var$NOOP;
        this.onCelebrationStart = onCelebrationStart ?? $ac74d23f8ba09367$var$NOOP;
        this.onCelebrationEnd = onCelebrationEnd ?? $ac74d23f8ba09367$var$NOOP;
        this.regions = [];
        this.shownId = null;
        this.celebrating = false;
        this.celebrationTimer = null;
        this.barEl = null;
        this.listeners = new Set();
        this._unsubGate = this.gate.subscribe(()=>this._onGateTransition());
    }
    update({ regions: regions, lastTool: lastTool, fillMs: fillMs, strokeMs: strokeMs, celebrationMs: celebrationMs }) {
        this.regions = regions;
        if (celebrationMs != null) this.celebrationMs = celebrationMs;
        this.gate.update({
            regions: regions,
            lastTool: lastTool,
            fillMs: fillMs,
            strokeMs: strokeMs
        });
        this._maybeAdvanceShown();
        this._emit();
    }
    bindBar(el) {
        this.barEl = el;
        this.gate.bindBar(el, this.shownId);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return ()=>this.listeners.delete(listener);
    }
    // Read-only snapshot for the panel. Builds a fresh object each call —
    // callers either store it in React state on emit or read it on demand.
    getSnapshot() {
        const shown = this.shownId != null ? this.regions.find((r)=>r.id === this.shownId) : null;
        const realNext = this._pickNext();
        return {
            shownId: this.shownId,
            shownLabel: shown?.label ?? null,
            shownColorIndex: shown?.colorIndex ?? null,
            // ScorePanel reads this to swap title copy + bar color when the
            // current target is overdrawn. Sourced directly from scoring's
            // group-level overdraw flag.
            shownOverdrawn: !!shown?.overdrawn,
            // Full region from scoring (or null) — DebugScoringPanel and the
            // canvas mask overlay consume this. Includes pixelCount, hits,
            // required, score, assignedSize, overdrawAllowed, mode, and a
            // subRegions breakdown.
            shown: shown ?? null,
            incomingLabel: this.celebrating && realNext ? realNext.label : null,
            celebrating: this.celebrating,
            hasLabeled: this.regions.length > 0,
            allDone: this.regions.length > 0 && realNext === null && !this.celebrating,
            regions: this.regions.map((r)=>{
                const s = this.gate.getRegionState(r.id);
                return {
                    id: r.id,
                    label: r.label,
                    detected: s.satisfied,
                    committed: s.committed,
                    deficient: s.deficient
                };
            })
        };
    }
    // Clears all per-marc state for a fresh marc. Keeps listeners + bar
    // binding so the engine can be re-fed without rebinding.
    reset() {
        if (this.celebrationTimer != null) clearTimeout(this.celebrationTimer);
        this.celebrationTimer = null;
        this.celebrating = false;
        this.shownId = null;
        this.regions = [];
        this.gate.reset();
        this._emit();
    }
    dispose() {
        if (this.celebrationTimer != null) clearTimeout(this.celebrationTimer);
        this.celebrationTimer = null;
        this._unsubGate();
        this.gate.dispose();
        this.listeners.clear();
        this.barEl = null;
    }
    _pickNext() {
        return this.regions.find((r)=>!this.gate.getRegionState(r.id).committed) ?? this.regions.find((r)=>!this.gate.getRegionState(r.id).satisfied) ?? null;
    }
    _maybeAdvanceShown() {
        if (this.celebrating) return;
        const realNext = this._pickNext();
        const realNextId = realNext?.id ?? null;
        if (this.shownId === realNextId) return;
        if (this.shownId != null) {
            const shownState = this.gate.getRegionState(this.shownId);
            if (shownState.satisfied) {
                this._startCelebration();
                return;
            }
        }
        this._setShown(realNextId);
    }
    _setShown(id) {
        if (this.shownId === id) return;
        this.shownId = id;
        // Re-bind gate to the new region so the bar tracks it. Idempotent
        // when nothing actually changed.
        this.gate.bindBar(this.barEl, this.shownId);
        const region = id != null ? this.regions.find((r)=>r.id === id) ?? null : null;
        this.onTargetChange(region);
    }
    _startCelebration() {
        this.celebrating = true;
        this.onCelebrationStart();
        this.celebrationTimer = setTimeout(()=>{
            this.celebrationTimer = null;
            this.celebrating = false;
            const next = this._pickNext();
            this._setShown(next?.id ?? null);
            this._emit();
            this.onCelebrationEnd();
        }, this.celebrationMs);
    }
    _onGateTransition() {
        this._maybeAdvanceShown();
        this._emit();
    }
    _emit() {
        for (const l of this.listeners)l();
    }
}



var $7Yi7V = parcelRequire("7Yi7V");

var $e4LUm = parcelRequire("e4LUm");

var $4vfI7 = parcelRequire("4vfI7");

var $7Yi7V = parcelRequire("7Yi7V");


var $47gLI = parcelRequire("47gLI");
const $c1e9a979fb38f5e6$var$CANONICAL_RANK = new Map((0, $7Yi7V.CANONICAL_LABELS).map((label, i)=>[
        label.toLowerCase(),
        i
    ]));
// Module-singleton offscreen canvas for rasterizing strokes during
// scoring. Reused across calls — score recomputes once per stroke
// commit, so allocating a fresh canvas each time would be wasteful.
// Sized to the reference's canvas dims on demand.
let $c1e9a979fb38f5e6$var$_scoringCanvas = null;
function $c1e9a979fb38f5e6$var$getScoringCanvas(width, height) {
    if ($c1e9a979fb38f5e6$var$_scoringCanvas == null) $c1e9a979fb38f5e6$var$_scoringCanvas = document.createElement("canvas");
    if ($c1e9a979fb38f5e6$var$_scoringCanvas.width !== width) $c1e9a979fb38f5e6$var$_scoringCanvas.width = width;
    if ($c1e9a979fb38f5e6$var$_scoringCanvas.height !== height) $c1e9a979fb38f5e6$var$_scoringCanvas.height = height;
    return $c1e9a979fb38f5e6$var$_scoringCanvas;
}
// Linear interp on `pixelCount` between SMALL_REGION_PIXELS and
// LARGE_REGION_PIXELS, clamped at the endpoints. Both the search-radius
// curve (small region → big radius) and the mass-fraction curve (small
// region → lenient fraction) live on this axis, so they stay coherent.
function $c1e9a979fb38f5e6$var$interpRegionSize(pixelCount, valAtSmall, valAtLarge) {
    if (pixelCount <= (0, $7Yi7V.SMALL_REGION_PIXELS)) return valAtSmall;
    if (pixelCount >= (0, $7Yi7V.LARGE_REGION_PIXELS)) return valAtLarge;
    const t = (pixelCount - (0, $7Yi7V.SMALL_REGION_PIXELS)) / ((0, $7Yi7V.LARGE_REGION_PIXELS) - (0, $7Yi7V.SMALL_REGION_PIXELS));
    return valAtSmall + (valAtLarge - valAtSmall) * t;
}
// Inverse-size curve: small regions get big search boxes, big regions get
// small ones. See constants.js for the rationale. `scale` multiplies the
// final radius (per-region overrides included) so debug tuning can fan the
// whole curve in/out at once. Pass effectivePixelCount when a label
// downrank applies (LABEL_DEFAULTS.sizeFactor) — neck consults the curve
// at its scaled-down size, getting a more generous search radius
// alongside the more lenient mass fraction.
function $c1e9a979fb38f5e6$var$searchRadiusFor(region, scale, effectivePixelCount) {
    const base = typeof region.searchRadius === "number" ? region.searchRadius : $c1e9a979fb38f5e6$var$interpRegionSize(effectivePixelCount ?? region.pixelCount ?? 0, (0, $7Yi7V.MAX_SEARCH_RADIUS_PX), (0, $7Yi7V.MIN_SEARCH_RADIUS_PX));
    return base * scale;
}
function $c1e9a979fb38f5e6$var$massFractionFor(pixelCount, smallFraction, largeFraction) {
    return $c1e9a979fb38f5e6$var$interpRegionSize(pixelCount, smallFraction, largeFraction);
}
// Region IDs in reference.json are positional (`r-001` = biggest region
// in that marc, `r-002` = second biggest, …) and so they collide across
// marcs — every marc has its own `r-001`. That bites the speedrun
// runtime: MarcEngine and DetectionGate key state by id, and during the
// brief render window where the engine has been fed the previous marc's
// regions before the new marc's reference loads, shownId can latch onto
// an id that the *next* marc happens to reuse. The follow-up update with
// the new marc's regions then early-returns ("id matches, no-op"),
// `onTargetChange` doesn't fire, and `setActiveColorIndex` skips — so
// the brush stays on the prior marc's color but in the new marc's
// palette. Background-tab timer throttling makes the race much wider
// and was how this got noticed.
//
// Fix: the on-disk ids stay positional (saveReference is unchanged, no
// migration), but every id that leaves scoreDrawing is namespaced with
// the marc id, so A's `001::r-001` is a different string than B's
// `004::r-001`. Engines, gates, and the panel still treat ids as
// opaque keys; they just see longer strings.
function $c1e9a979fb38f5e6$var$namespacedRegionId(reference, regionId) {
    return `${reference.marc.id}::${regionId}`;
}
// Same shape as the mass-fraction and search-radius curves: small
// regions get a much more generous overdraw multiplier (a tiny
// reference mass swamps any normal pen stroke at a flat 3×, but the
// flood-fill failure mode being detected is enormous in absolute
// pixels and trips at any reasonable ratio). Large regions stay at
// the strict 3× — a sweater + accidental whole-canvas fill is still
// many multiples of the reference mass.
function $c1e9a979fb38f5e6$var$maxOverdrawRatioFor(pixelCount, smallRatio, largeRatio) {
    return $c1e9a979fb38f5e6$var$interpRegionSize(pixelCount, smallRatio, largeRatio);
}
const $c1e9a979fb38f5e6$export$6de33833799c3d24 = {
    largeMassFraction: (0, $7Yi7V.DEFAULT_LARGE_MASS_FRACTION),
    smallMassFraction: (0, $7Yi7V.DEFAULT_SMALL_MASS_FRACTION),
    smallMaxOverdrawRatio: (0, $7Yi7V.DEFAULT_SMALL_MAX_OVERDRAW_RATIO),
    largeMaxOverdrawRatio: (0, $7Yi7V.DEFAULT_LARGE_MAX_OVERDRAW_RATIO),
    searchRadiusScale: 1,
    distanceSoftener: (0, $7Yi7V.ASSIGNMENT_DISTANCE_SOFTENER_PX),
    // Detection gate (consumed by SpeedrunEngine, not scoreDrawing). Lives
    // here so the debug panel surfaces all play-loop knobs in one place.
    detectionFillMs: (0, $7Yi7V.DETECTION_FILL_MS),
    detectionStrokeMs: (0, $7Yi7V.DETECTION_STROKE_MS)
};
function $c1e9a979fb38f5e6$var$normalizeLabel(label) {
    return (label ?? "").trim().toLowerCase();
}
const $c1e9a979fb38f5e6$var$DEFAULT_ALL_OF_SET = new Set((0, $7Yi7V.DEFAULT_ALL_OF_LABELS).map((s)=>s.toLowerCase()));
// Groups (regions sharing a label) score in one of two modes:
//   "all" — each subregion must individually clear its own threshold.
//           Group score = average of subregion scores (so two-of-eyes is
//           50% when one eye is fully drawn). Group detected = every
//           subregion detected.
//   "any" — hits pool across subregions; threshold is the largest
//           subregion's threshold, so filling one subregion alone clears
//           the group, AND a single stroke spanning multiple subregions
//           clears the group via summed hits.
//
// Resolution order: explicit `reference.labelGroups[label]` wins, then the
// hard-coded DEFAULT_ALL_OF_LABELS list (eyes/eyebrows/pupils), else "any".
function $c1e9a979fb38f5e6$var$resolveGroupMode(labelKey, labelGroups) {
    const explicit = labelGroups?.[labelKey];
    if (explicit === "all" || explicit === "any") return explicit;
    return $c1e9a979fb38f5e6$var$DEFAULT_ALL_OF_SET.has(labelKey) ? "all" : "any";
}
function $c1e9a979fb38f5e6$var$isColorAgnostic(region, agnosticSet) {
    if (region.matchAnyColor === true) return true;
    return agnosticSet.has($c1e9a979fb38f5e6$var$normalizeLabel(region.label));
}
function $c1e9a979fb38f5e6$var$bboxesIntersect(a, b) {
    return !(a.x + a.w <= b.x0 || a.x >= b.x1 || a.y + a.h <= b.y0 || a.y >= b.y1);
}
function $c1e9a979fb38f5e6$export$aa6d056303e2cea2({ strokes: strokes, palette: palette, reference: reference, overrides: overrides }) {
    if (!reference) return {
        regions: [],
        overall: 0,
        labeledCount: 0,
        detectedCount: 0
    };
    const largeMassFraction = overrides?.largeMassFraction ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.largeMassFraction;
    const smallMassFraction = overrides?.smallMassFraction ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.smallMassFraction;
    const smallMaxOverdrawRatio = overrides?.smallMaxOverdrawRatio ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.smallMaxOverdrawRatio;
    const largeMaxOverdrawRatio = overrides?.largeMaxOverdrawRatio ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.largeMaxOverdrawRatio;
    const radiusScale = overrides?.searchRadiusScale ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.searchRadiusScale;
    const distanceSoftener = overrides?.distanceSoftener ?? $c1e9a979fb38f5e6$export$6de33833799c3d24.distanceSoftener;
    const labelGroups = reference.labelGroups ?? null;
    // Rasterize strokes to the scoring canvas. Same redraw() the on-screen
    // canvas uses, so the pixel result is byte-identical to what the player
    // sees — quantize/connected-components downstream stay consistent
    // between scoring and the saved reference's region extraction.
    const canvasW = reference.canvas.width;
    const canvasH = reference.canvas.height;
    const canvas = $c1e9a979fb38f5e6$var$getScoringCanvas(canvasW, canvasH);
    (0, $47gLI.redraw)(canvas, strokes ?? [], palette);
    const { indices: indices, width: width, height: height } = (0, $e8508d5718da2544$export$4ac79e59c9022a5e)(canvas, palette);
    const agnosticSet = new Set((0, $7Yi7V.COLOR_AGNOSTIC_LABELS).map((s)=>s.toLowerCase()));
    const labeled = reference.drawing.regions.filter((r)=>$c1e9a979fb38f5e6$var$normalizeLabel(r.label).length > 0);
    // Precompute each labeled region's dilated search box + per-region settings.
    // `assignedHits` accumulates as we credit components during the match loop.
    const subs = labeled.map((r)=>{
        // Per-label difficulty downrank — see LABEL_DEFAULTS in
        // constants.js. effectivePixelCount is what the curve sees for
        // both mass fraction (later, in score computation) and search
        // radius (here). pixelCount itself is unchanged for everything
        // else (display, overdraw budget, halfPixels).
        const sizeFactor = (0, $7Yi7V.LABEL_DEFAULTS)[$c1e9a979fb38f5e6$var$normalizeLabel(r.label)]?.sizeFactor ?? 1;
        const effectivePixelCount = r.pixelCount * sizeFactor;
        const radius = $c1e9a979fb38f5e6$var$searchRadiusFor(r, radiusScale, effectivePixelCount);
        // Spread split: subregions above SPREAD_REGION_PIXELS get an
        // automatic left/right (or top/bottom) split along the longer
        // axis. Each half has its own threshold (proportional to the
        // mask's pixelCount in that half, from saved halfPixels — falls
        // back to 50/50 if missing) and is independently capped at
        // contribution time. This forces "draw across the whole region"
        // without requiring a multi-subregion JSON layout.
        const useSpread = r.pixelCount > (0, $7Yi7V.SPREAD_REGION_PIXELS);
        const splitAxis = useSpread ? r.bbox.w >= r.bbox.h ? "x" : "y" : null;
        const splitMid = useSpread ? splitAxis === "x" ? r.bbox.x + r.bbox.w / 2 : r.bbox.y + r.bbox.h / 2 : null;
        const halfPixelCounts = useSpread ? r.halfPixels?.counts ?? [
            r.pixelCount / 2,
            r.pixelCount / 2
        ] : null;
        return {
            region: r,
            x0: Math.max(0, Math.floor(r.bbox.x - radius)),
            y0: Math.max(0, Math.floor(r.bbox.y - radius)),
            x1: Math.min(width, Math.ceil(r.bbox.x + r.bbox.w + radius)),
            y1: Math.min(height, Math.ceil(r.bbox.y + r.bbox.h + radius)),
            cx: r.bbox.x + r.bbox.w / 2,
            cy: r.bbox.y + r.bbox.h / 2,
            matchAnyColor: $c1e9a979fb38f5e6$var$isColorAgnostic(r, agnosticSet),
            assignedHits: 0,
            // Total size of player components attributed to this subregion
            // (full component pixel counts, not bbox-clipped overlap). Used
            // for overdraw detection — see maxOverdrawRatioFor curve. A
            // single big spilled component blows this up even if only part
            // of it lands in the bbox.
            assignedSize: 0,
            splitAxis: // Spread-split state. splitAxis null = single-cap mode.
            splitAxis,
            splitMid: splitMid,
            halfPixelCounts: halfPixelCounts,
            halfHits: useSpread ? [
                0,
                0
            ] : null,
            sizeFactor: // Label downrank — passed through to mass fraction calc below.
            sizeFactor,
            effectivePixelCount: effectivePixelCount
        };
    });
    // Regions with the same label merge into one scoring group. Useful when a
    // single semantic thing (e.g. a jacket visible on both sides of Marc's
    // chest) was traced as two disconnected regions. Subregions keep their
    // own dilated bboxes so position-sensitivity is preserved per-piece; mode
    // (all-of vs any-of, see resolveGroupMode) decides how subregion hits
    // combine into the group's score.
    const groupMap = new Map();
    for (const s of subs){
        const key = $c1e9a979fb38f5e6$var$normalizeLabel(s.region.label);
        if (!groupMap.has(key)) groupMap.set(key, {
            label: s.region.label.trim(),
            labelKey: key,
            mode: $c1e9a979fb38f5e6$var$resolveGroupMode(key, labelGroups),
            subregions: [],
            totalPixelCount: 0,
            // Sum of comp.pixels.length over each component for which this
            // group was bestGroup. Counted ONCE per component (not once per
            // overlapping subregion), so any-of mode evaluates overdraw
            // against the group's pooled mass instead of the smallest
            // subregion's mass — see "any-of overdraw" below.
            groupAssignedSize: 0
        });
        const g = groupMap.get(key);
        g.subregions.push(s);
        g.totalPixelCount += s.region.pixelCount;
    }
    // Sort groups by canonical-label order first (so the player draws
    // foundational regions before details — see CANONICAL_LABELS in
    // constants.js), then by pixel count for anything unlisted. labelKey
    // is already lowercased by normalizeLabel.
    const groups = Array.from(groupMap.values()).sort((a, b)=>{
        const ra = $c1e9a979fb38f5e6$var$CANONICAL_RANK.get(a.labelKey) ?? Infinity;
        const rb = $c1e9a979fb38f5e6$var$CANONICAL_RANK.get(b.labelKey) ?? Infinity;
        if (ra !== rb) return ra - rb;
        return b.totalPixelCount - a.totalPixelCount;
    });
    const components = (0, $e8508d5718da2544$export$4c2eb41cf5ea2f76)(indices, width, height);
    // For each player component, pick the single best-matching group, then
    // credit subregions within that group. Crediting differs by mode:
    //   all-of → only the single best-matching subregion, because dilated
    //            bboxes of small features (eyes, eyebrows) overlap heavily,
    //            and crediting all of them would let one eyebrow stroke
    //            satisfy both eyebrow subregions.
    //   any-of → every overlapping subregion (current behavior). One stroke
    //            spanning both halves of a sweater is desirable here; minor
    //            double-counting on overlapping bboxes is tolerable and is
    //            tuned out via thresholds, not credit shape.
    //
    // Future tweak for any-of if the leniency feels off: gate multi-subregion
    // credit on the stroke actually *touching* each subregion's bbox (e.g.
    // require ≥N pixels overlap with each), so dilated-bbox-overlap alone
    // doesn't fan out credit. Single stroke spanning both halves still works,
    // but a stroke wholly inside one half stops accidentally crediting its
    // neighbor.
    for (const comp of components){
        const compCx = comp.bbox.x + comp.bbox.w / 2;
        const compCy = comp.bbox.y + comp.bbox.h / 2;
        let bestGroup = null;
        let bestGroupScore = 0;
        let bestGroupOverlaps = null;
        for (const g of groups){
            let gScore = 0;
            const overlaps = [];
            for (const s of g.subregions){
                if (!s.matchAnyColor && s.region.colorIndex !== comp.colorIndex) continue;
                if (!$c1e9a979fb38f5e6$var$bboxesIntersect(comp.bbox, s)) continue;
                let overlap = 0;
                // Per-half overlap accumulators when this sub uses spread
                // split. Null otherwise — keeps the hot-loop branch-free for
                // the common case.
                const halfOverlap = s.splitAxis ? [
                    0,
                    0
                ] : null;
                for(let k = 0; k < comp.pixels.length; k++){
                    const i = comp.pixels[k];
                    const px = i % width;
                    const py = (i - px) / width;
                    if (px >= s.x0 && px < s.x1 && py >= s.y0 && py < s.y1) {
                        overlap++;
                        if (halfOverlap) {
                            const pos = s.splitAxis === "x" ? px : py;
                            halfOverlap[pos < s.splitMid ? 0 : 1]++;
                        }
                    }
                }
                if (overlap === 0) continue;
                const dx = compCx - s.cx;
                const dy = compCy - s.cy;
                const dist = Math.sqrt(dx * dx + dy * dy);
                const sScore = overlap / (1 + dist / distanceSoftener);
                overlaps.push({
                    s: s,
                    overlap: overlap,
                    halfOverlap: halfOverlap,
                    sScore: sScore
                });
                if (sScore > gScore) gScore = sScore;
            }
            if (gScore > bestGroupScore) {
                bestGroupScore = gScore;
                bestGroup = g;
                bestGroupOverlaps = overlaps;
            }
        }
        if (bestGroup && bestGroupOverlaps.length > 0) {
            const compSize = comp.pixels.length;
            bestGroup.groupAssignedSize += compSize;
            if (bestGroup.mode === "all") {
                let pick = bestGroupOverlaps[0];
                for(let i = 1; i < bestGroupOverlaps.length; i++)if (bestGroupOverlaps[i].sScore > pick.sScore) pick = bestGroupOverlaps[i];
                pick.s.assignedHits += pick.overlap;
                pick.s.assignedSize += compSize;
                if (pick.s.halfHits && pick.halfOverlap) {
                    pick.s.halfHits[0] += pick.halfOverlap[0];
                    pick.s.halfHits[1] += pick.halfOverlap[1];
                }
            } else for (const { s: s, overlap: overlap, halfOverlap: halfOverlap } of bestGroupOverlaps){
                s.assignedHits += overlap;
                s.assignedSize += compSize;
                if (s.halfHits && halfOverlap) {
                    s.halfHits[0] += halfOverlap[0];
                    s.halfHits[1] += halfOverlap[1];
                }
            }
        }
    }
    const regions = groups.map((g)=>{
        // Per-subregion threshold from the curve, keyed on the subregion's own
        // pixelCount so a tiny eye gets the lenient small-region fraction even
        // when paired with a bigger sibling. Per-region `minMassFraction`
        // overrides still win via Math.min.
        //
        // Per-subregion `overdrawn` is only consulted in all-of mode, where
        // each subregion stands alone. Any-of evaluates overdraw at the
        // group level (see below) so a small subregion in a multi-region
        // group doesn't dictate the cap for the whole thing.
        const subResults = g.subregions.map((s)=>{
            // Curve consults the EFFECTIVE pixelCount so a label downrank
            // (LABEL_DEFAULTS.sizeFactor) gets the smaller-region's lenient
            // mass fraction. Threshold then uses effectivePixelCount × that
            // fraction — so a 25K neck with sizeFactor=0.4 grades as a 10K
            // region (lower fraction × smaller mass = much smaller required
            // ink). HalfPixelCounts are also scaled by sizeFactor for
            // spread-split subregions, keeping the half thresholds
            // consistent with the whole.
            const curveFraction = $c1e9a979fb38f5e6$var$massFractionFor(s.effectivePixelCount, smallMassFraction, largeMassFraction);
            const fraction = typeof s.region.minMassFraction === "number" ? Math.min(curveFraction, s.region.minMassFraction) : curveFraction;
            const threshold = Math.max(1, s.effectivePixelCount * fraction);
            // cappedHits: how much of this sub's threshold the player has
            // earned. For small/medium subs, just capped at threshold.
            // For spread-split subs, sum of per-half capped contributions
            // — drawing only one half can't earn more than that half's
            // share even if the player overpaints heavily.
            let cappedHits;
            let halfThresholds = null;
            if (s.splitAxis && s.halfHits) {
                const lt = Math.max(1, s.halfPixelCounts[0] * s.sizeFactor * fraction);
                const rt = Math.max(1, s.halfPixelCounts[1] * s.sizeFactor * fraction);
                halfThresholds = [
                    lt,
                    rt
                ];
                cappedHits = Math.min(s.halfHits[0], lt) + Math.min(s.halfHits[1], rt);
            } else cappedHits = Math.min(s.assignedHits, threshold);
            const baseScore = Math.min(1, cappedHits / threshold);
            // Curve consults pixelCount (NOT effectivePixelCount): label
            // downrank widens threshold/radius for alignment slack but does
            // not change "did the player accidentally flood-fill?" — the
            // overdraw budget tracks the actual ink mass on the canvas.
            const overdrawRatio = typeof s.region.maxOverdrawRatio === "number" ? s.region.maxOverdrawRatio : $c1e9a979fb38f5e6$var$maxOverdrawRatioFor(s.region.pixelCount, smallMaxOverdrawRatio, largeMaxOverdrawRatio);
            const overdrawAllowed = s.region.pixelCount * overdrawRatio;
            const subOverdrawn = s.assignedSize > overdrawAllowed;
            const score = subOverdrawn ? Math.max(0, baseScore - (s.assignedSize - overdrawAllowed) / overdrawAllowed) : baseScore;
            return {
                sub: s,
                hits: s.assignedHits,
                cappedHits: cappedHits,
                threshold: threshold,
                score: score,
                detected: !subOverdrawn && cappedHits >= threshold,
                overdrawn: subOverdrawn,
                // Debug-only info; ignored by core scoring.
                halfHits: s.halfHits,
                halfThresholds: halfThresholds,
                splitAxis: s.splitAxis
            };
        });
        let hits;
        let required;
        let score;
        let detected;
        let overdrawn;
        if (g.mode === "all") {
            // All-of: each subregion stands on its own. Display hits/required as
            // sums for tooltip continuity, but the user-visible progress is the
            // average of subregion scores so two-of-eyes reads 50% when one is
            // fully drawn. Detection requires every subregion individually clear.
            hits = subResults.reduce((acc, sr)=>acc + sr.cappedHits, 0);
            required = subResults.reduce((acc, sr)=>acc + sr.threshold, 0);
            score = subResults.length > 0 ? subResults.reduce((acc, sr)=>acc + sr.score, 0) / subResults.length : 0;
            detected = subResults.every((sr)=>sr.detected);
            overdrawn = subResults.some((sr)=>sr.overdrawn);
        } else {
            // Any-of: subregions are facets of one logical region. Each
            // subregion contributes up to its OWN threshold to the pooled
            // score — past that, drawing more in one part doesn't keep
            // pumping the bar. This is what enforces "every part must be
            // touched" without a binary spread gate: reaching 100% requires
            // every subregion at its threshold, and the bar climbs
            // smoothly as the player covers each part.
            //
            // Why per-sub cap instead of all-of: credit still goes to ALL
            // overlapping subregions per component (see the credit loop),
            // so one stroke that genuinely spans both halves of a split
            // jacket gets credit on both. All-of's "best subregion only"
            // credit would lose that property.
            //
            // Required pools for sum-threshold semantics. Overdraw uses
            // groupAssignedSize / totalPixelCount, summed once per
            // attributed component (not per overlapping subregion).
            hits = subResults.reduce((acc, sr)=>acc + sr.cappedHits, 0);
            required = subResults.reduce((acc, sr)=>acc + sr.threshold, 0);
            const groupOverdrawRatio = $c1e9a979fb38f5e6$var$maxOverdrawRatioFor(g.totalPixelCount, smallMaxOverdrawRatio, largeMaxOverdrawRatio);
            const overdrawAllowed = g.totalPixelCount * groupOverdrawRatio;
            overdrawn = g.groupAssignedSize > overdrawAllowed;
            const baseScore = Math.min(1, hits / required);
            score = overdrawn ? Math.max(0, baseScore - (g.groupAssignedSize - overdrawAllowed) / overdrawAllowed) : baseScore;
            detected = !overdrawn && hits >= required;
        }
        const first = g.subregions[0].region;
        const anyAgnostic = g.subregions.some((s)=>s.matchAnyColor);
        // Per-subregion debug breakdown — only used by DebugScoringPanel
        // to make per-region tuning intelligible. Cheap to compute, doesn't
        // change scoring behavior.
        const subRegions = g.subregions.map((s, i)=>{
            const sr = subResults[i];
            return {
                id: $c1e9a979fb38f5e6$var$namespacedRegionId(reference, s.region.id),
                pixelCount: s.region.pixelCount,
                bbox: s.region.bbox,
                searchBbox: {
                    x: s.x0,
                    y: s.y0,
                    w: s.x1 - s.x0,
                    h: s.y1 - s.y0
                },
                hits: s.assignedHits,
                cappedHits: sr.cappedHits,
                assignedSize: s.assignedSize,
                colorIndex: s.region.colorIndex,
                // Spread-split debug, null when not applicable.
                splitAxis: s.splitAxis,
                halfHits: s.halfHits,
                halfPixelCounts: s.halfPixelCounts,
                halfThresholds: sr.halfThresholds
            };
        });
        const overdrawAllowed = Math.round(g.totalPixelCount * $c1e9a979fb38f5e6$var$maxOverdrawRatioFor(g.totalPixelCount, smallMaxOverdrawRatio, largeMaxOverdrawRatio));
        return {
            id: $c1e9a979fb38f5e6$var$namespacedRegionId(reference, g.subregions.map((s)=>s.region.id).join("+")),
            label: g.label,
            color: first.color,
            colorIndex: first.colorIndex,
            pixelCount: g.totalPixelCount,
            hits: hits,
            required: Math.round(required),
            score: score,
            detected: detected,
            overdrawn: overdrawn,
            matchAnyColor: anyAgnostic,
            subCount: g.subregions.length,
            mode: g.mode,
            // Debug fields. assignedSize is group-level for any-of, sum of
            // subregion sizes for all-of (where the group-level pool isn't
            // the threshold for overdraw, but it's still informative).
            assignedSize: g.mode === "all" ? subRegions.reduce((acc, s)=>acc + s.assignedSize, 0) : g.groupAssignedSize,
            overdrawAllowed: overdrawAllowed,
            subRegions: subRegions
        };
    });
    const detectedCount = regions.filter((r)=>r.detected).length;
    const overall = regions.length > 0 ? detectedCount / regions.length : 0;
    return {
        regions: regions,
        overall: overall,
        labeledCount: regions.length,
        detectedCount: detectedCount
    };
}


// WebAudio-synth sound effects + mute state. No assets — every sound is
// generated from a triangle oscillator with a quick attack/decay
// envelope. Three sounds today:
//
//   playCountInBeat   — 3 / 2 / 1 ticks during the speedrun count-in.
//   playCountInGo     — GO tick. Higher pitch, slightly louder; the
//                       "round started" cue.
//   playCommit        — region-committed chime. Two-note up-arpeggio,
//                       fires at the start of MarcEngine's celebration
//                       window so it lands with the bar going full.
//
// Mute state lives here (not in React) so engine code can check it
// synchronously without prop-drilling. localStorage backed; subscribers
// (React hooks, in practice) get notified on change.
const $cd49d00d6f1363b1$var$STORAGE_KEY = "egg-game:v1:sound-muted";
let $cd49d00d6f1363b1$var$muted = $cd49d00d6f1363b1$var$readMuted();
const $cd49d00d6f1363b1$var$muteListeners = new Set();
function $cd49d00d6f1363b1$var$readMuted() {
    try {
        return JSON.parse(localStorage.getItem($cd49d00d6f1363b1$var$STORAGE_KEY) ?? "false") === true;
    } catch  {
        return false;
    }
}
function $cd49d00d6f1363b1$export$daf3ed797ed8a980() {
    return $cd49d00d6f1363b1$var$muted;
}
function $cd49d00d6f1363b1$export$a1680ba91cc9be33(next) {
    const v = !!next;
    if (v === $cd49d00d6f1363b1$var$muted) return;
    $cd49d00d6f1363b1$var$muted = v;
    try {
        localStorage.setItem($cd49d00d6f1363b1$var$STORAGE_KEY, JSON.stringify(v));
    } catch  {
    // localStorage can throw in private mode / quota — fail open, the
    // in-memory flag still drives playback for the session.
    }
    for (const l of $cd49d00d6f1363b1$var$muteListeners)l(v);
}
function $cd49d00d6f1363b1$export$22ff19d9bef9b9a9(listener) {
    $cd49d00d6f1363b1$var$muteListeners.add(listener);
    return ()=>$cd49d00d6f1363b1$var$muteListeners.delete(listener);
}
// Lazy singleton AudioContext. Browsers gate AudioContext creation on a
// user gesture; the first play call after a click (e.g., the Speedrun
// button) is inside that gesture chain, so creation succeeds. resume()
// is defensive in case the context boots suspended (some browsers do
// this even mid-gesture if the page has been backgrounded).
let $cd49d00d6f1363b1$var$ctx = null;
function $cd49d00d6f1363b1$var$getCtx() {
    if ($cd49d00d6f1363b1$var$ctx == null) {
        const Ctor = window.AudioContext || window.webkitAudioContext;
        if (!Ctor) return null;
        $cd49d00d6f1363b1$var$ctx = new Ctor();
    }
    if ($cd49d00d6f1363b1$var$ctx.state === "suspended") $cd49d00d6f1363b1$var$ctx.resume().catch(()=>{});
    return $cd49d00d6f1363b1$var$ctx;
}
// Play a single triangle-wave tone with linear attack + exponential
// decay. The exponential decay reads as a more natural percussive
// envelope than linear — the tail trails off cleanly instead of
// cutting at a hard zero. attackMs is short by design (ramps from 0
// to peak in a handful of ms) so the tone reads as struck rather
// than swelled.
function $cd49d00d6f1363b1$var$playTone({ freq: freq, durationMs: durationMs, peakGain: peakGain, attackMs: attackMs = 4, type: type = "triangle" }) {
    if ($cd49d00d6f1363b1$var$muted) return;
    const c = $cd49d00d6f1363b1$var$getCtx();
    if (!c) return;
    const now = c.currentTime;
    const dur = durationMs / 1000;
    const attack = attackMs / 1000;
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, now);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(peakGain, now + attack);
    // exponentialRampToValueAtTime can't reach 0 — clamp to a small
    // floor and stop the oscillator at the end so it cleans up.
    gain.gain.exponentialRampToValueAtTime(0.0001, now + dur);
    osc.connect(gain).connect(c.destination);
    osc.start(now);
    osc.stop(now + dur + 0.02);
}
function $cd49d00d6f1363b1$export$655b052f6e42c8ce() {
    $cd49d00d6f1363b1$var$playTone({
        freq: 440,
        durationMs: 120,
        peakGain: 0.18
    });
}
function $cd49d00d6f1363b1$export$bf11a81b6fb1584e() {
    $cd49d00d6f1363b1$var$playTone({
        freq: 660,
        durationMs: 200,
        peakGain: 0.24
    });
}
function $cd49d00d6f1363b1$export$583da8e3d3f46bfb() {
    if ($cd49d00d6f1363b1$var$muted) return;
    $cd49d00d6f1363b1$var$playTone({
        freq: 659.25,
        durationMs: 140,
        peakGain: 0.08
    });
    // Slight delay before the second note. setTimeout is fine here —
    // we're not trying to be sample-accurate, and scheduling the second
    // tone via the AudioContext clock would complicate the early-out
    // path on mute toggle mid-chime.
    setTimeout(()=>$cd49d00d6f1363b1$var$playTone({
            freq: 880,
            durationMs: 180,
            peakGain: 0.12
        }), 70);
}


function $f02e9dd8be437860$export$2e2bcd8739ae039({ active: active, marcId: marcId, strokes: strokes, palette: palette, reference: reference, scoreOverrides: scoreOverrides, lastTool: lastTool, lastActionAt: lastActionAt }) {
    const { setTool: setTool } = (0, $4vfI7.useTool)();
    const { setActiveColorIndex: setActiveColorIndex } = (0, $e4LUm.usePalette)();
    const engineRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (engineRef.current == null) // setActiveColorIndex / setTool are useState setters (stable
    // identity for the provider's lifetime) so capturing them at
    // construction is safe — they don't go stale across renders.
    engineRef.current = new (0, $ac74d23f8ba09367$export$2e2bcd8739ae039)({
        celebrationMs: (0, $7Yi7V.CELEBRATION_MS),
        onTargetChange: (region)=>{
            if (region?.colorIndex != null) setActiveColorIndex(region.colorIndex);
        },
        onCelebrationStart: ()=>(0, $cd49d00d6f1363b1$export$583da8e3d3f46bfb)(),
        onCelebrationEnd: ()=>setTool("pen")
    });
    // Score is a pure derivation over committed strokes. Only meaningful
    // when active + reference loaded; empty otherwise.
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!active || !reference) return {
            regions: [],
            overall: 0,
            labeledCount: 0,
            detectedCount: 0
        };
        return (0, $c1e9a979fb38f5e6$export$aa6d056303e2cea2)({
            strokes: strokes,
            palette: palette,
            reference: reference,
            overrides: scoreOverrides
        });
    }, [
        active,
        strokes,
        palette,
        reference,
        scoreOverrides
    ]);
    const [snapshot, setSnapshot] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>engineRef.current.getSnapshot());
    const recompute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setSnapshot(engineRef.current.getSnapshot());
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const engine = engineRef.current;
        const unsub = engine.subscribe(recompute);
        return ()=>{
            unsub();
            engine.dispose();
        };
    }, [
        recompute
    ]);
    // Reset on inactive (mode switch out) or marcId change (round
    // advance, or debug arrow-key cycle).
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        engineRef.current.reset();
    }, [
        active,
        marcId
    ]);
    // Push React-side inputs into the engine. Skip while inactive so
    // stroke/score churn during author mode doesn't drive the state
    // machine.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) return;
        engineRef.current.update({
            regions: result.regions,
            lastTool: lastTool,
            fillMs: scoreOverrides.detectionFillMs,
            strokeMs: scoreOverrides.detectionStrokeMs,
            celebrationMs: (0, $7Yi7V.CELEBRATION_MS)
        });
    }, [
        active,
        result.regions,
        lastTool,
        lastActionAt,
        scoreOverrides.detectionFillMs,
        scoreOverrides.detectionStrokeMs
    ]);
    const bindBar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((el)=>{
        engineRef.current.bindBar(el);
    }, []);
    return {
        snapshot: snapshot,
        bindBar: bindBar
    };
}



var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");

var $4e3Nb = parcelRequire("4e3Nb");
function $c47171705eb25d33$export$2e2bcd8739ae039({ active: active, allDone: allDone, advanceMarc: advanceMarc, effectiveMarcId: effectiveMarcId, eff: eff, strokes: strokes, canvasRef: canvasRef, speedrunLineup: speedrunLineup, speedrunStartedAt: speedrunStartedAt, onMarcCaptured: onMarcCaptured }) {
    const [showcasing, setShowcasing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [showcaseMarcSnapshot, setShowcaseMarcSnapshot] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [roundDrawings, setRoundDrawings] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({});
    const [debugEndScreenOpen, setDebugEndScreenOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Synchronous mirror of roundDrawings. Triggershowcase needs the
    // previous marc's finishedAt to compute the current marc's duration,
    // and it needs to read it on the same tick it writes the new entry —
    // setRoundDrawings updaters don't run inline when the fiber has
    // pending lanes (e.g., the setShowcaseMarcSnapshot above dirties
    // them), so reading state-via-prev-in-updater can't be trusted to
    // run before our synchronous onMarcCaptured call.
    const roundDrawingsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const showcaseAdvanceTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const showcaseEndTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Showcase trigger as a callback so both the natural allDone effect
    // and the debug `v` hotkey can fire it. Self-guards against re-entry
    // while a showcase is already in flight.
    const effMarcTransform = eff.marcTransform;
    const effPalette = eff.palette;
    const effEggTransform = eff.eggTransform;
    const effEggLights = eff.eggLights;
    const effEggWarmth = eff.eggWarmth;
    const effEggRedshift = eff.eggRedshift;
    const triggerShowcase = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (showcaseAdvanceTimerRef.current != null || showcaseEndTimerRef.current != null) return;
        setShowcaseMarcSnapshot({
            src: (0, $4e3Nb.marcImageUrl)(effectiveMarcId),
            marcTransform: effMarcTransform
        });
        // toDataURL reads the canvas synchronously — must run BEFORE the
        // marcId-keyed drawing.clear() effect fires (which it will, in
        // the tail of this render's commit, when advanceMarc is called
        // below). Capturing right here is safely "as of allDone time."
        const drawingSrc = canvasRef.current?.toDataURL("image/png") ?? null;
        const finishedAt = Date.now();
        // Per-marc duration: time from when the player STARTED this
        // marc to when they finished. For marc N>0 the start is the
        // previous marc's finishedAt; for the first marc it's the
        // round-level startedAt (markStarted timestamp).
        const idx = speedrunLineup.indexOf(effectiveMarcId);
        const prevMarcId = idx > 0 ? speedrunLineup[idx - 1] : null;
        const prevFinishedAt = prevMarcId ? roundDrawingsRef.current[prevMarcId]?.finishedAt ?? null : speedrunStartedAt;
        const duration = prevFinishedAt != null ? finishedAt - prevFinishedAt : null;
        const captured = {
            drawingSrc: drawingSrc,
            strokes: strokes,
            palette: effPalette,
            eggTransform: effEggTransform,
            // Saved so the end-screen can reposition the marc photo
            // identically to play — guarantees marc's head sits where
            // the egg's head sits in the drawn portrait next to it.
            marcTransform: effMarcTransform,
            // Lights/warmth/redshift ride along so the per-marc Download
            // button on the end-screen can render a composite that matches
            // what the player saw, not the canonical reference defaults.
            eggLights: effEggLights,
            eggWarmth: effEggWarmth,
            eggRedshift: effEggRedshift,
            finishedAt: finishedAt,
            duration: duration
        };
        const next = {
            ...roundDrawingsRef.current,
            [effectiveMarcId]: captured
        };
        roundDrawingsRef.current = next;
        setRoundDrawings(next);
        if (onMarcCaptured) onMarcCaptured(effectiveMarcId, captured);
        setShowcasing(true);
        showcaseAdvanceTimerRef.current = setTimeout(()=>{
            showcaseAdvanceTimerRef.current = null;
            advanceMarc();
        }, (0, $7Yi7V.SHOWCASE_FADE_IN_MS) + (0, $7Yi7V.SHOWCASE_HOLD_MS));
        showcaseEndTimerRef.current = setTimeout(()=>{
            showcaseEndTimerRef.current = null;
            setShowcasing(false);
            setShowcaseMarcSnapshot(null);
        }, (0, $7Yi7V.SHOWCASE_MS));
    }, [
        advanceMarc,
        effectiveMarcId,
        effMarcTransform,
        effPalette,
        effEggTransform,
        strokes,
        canvasRef,
        speedrunLineup,
        speedrunStartedAt,
        onMarcCaptured
    ]);
    // Auto-fire on allDone while active. Depends on the stable
    // advanceMarc callback (not the speedrun object) — the object's
    // identity changes every render, which double-fired this effect
    // and skipped a marc per round.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) return;
        if (!allDone) return;
        triggerShowcase();
    }, [
        active,
        allDone,
        triggerShowcase
    ]);
    // Reset on inactive (mode flips out of speedrun mid-showcase, e.g.,
    // back to landing). Clears both pending timers so the easel/canvas
    // don't stay stuck mid-fade and we don't fire a stale advanceMarc.
    // Also drops captured per-marc drawings + the debug end-screen flag
    // — end-screen state is round-scoped, leaving speedrun resets it.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active) return;
        if (showcaseAdvanceTimerRef.current != null) {
            clearTimeout(showcaseAdvanceTimerRef.current);
            showcaseAdvanceTimerRef.current = null;
        }
        if (showcaseEndTimerRef.current != null) {
            clearTimeout(showcaseEndTimerRef.current);
            showcaseEndTimerRef.current = null;
        }
        setShowcasing(false);
        setShowcaseMarcSnapshot(null);
        roundDrawingsRef.current = {};
        setRoundDrawings({});
        setDebugEndScreenOpen(false);
    }, [
        active
    ]);
    // Debug-only: `n` hotkey populates fake roundDrawings and forces the
    // end-screen open so we can iterate on the modal without playing
    // through. Strokes/palette aren't populated (no real play); modal
    // renders from drawingSrc only.
    const triggerDebugEndScreen = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((fakeDrawings)=>{
        roundDrawingsRef.current = fakeDrawings;
        setRoundDrawings(fakeDrawings);
        setDebugEndScreenOpen(true);
    }, []);
    // Merged showcaseMarc — JSX gets a finished {src, marcTransform} or
    // null, instead of having to gate on (active && showcasing && snapshot).
    const showcaseMarc = active && showcasing && showcaseMarcSnapshot ? showcaseMarcSnapshot : null;
    return {
        showcasing: showcasing,
        showcaseMarc: showcaseMarc,
        roundDrawings: roundDrawings,
        triggerShowcase: triggerShowcase,
        debugEndScreenOpen: debugEndScreenOpen,
        triggerDebugEndScreen: triggerDebugEndScreen
    };
}



var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");

function $44735938ea086b83$export$2e2bcd8739ae039({ active: active, currentMarcId: currentMarcId, eggReferenceLoadedForMarcId: eggReferenceLoadedForMarcId, tween: tween, markStarted: markStarted, debug: debug }) {
    const tweeningRef = tween.tweeningRef;
    const tweening = tween.tweening;
    const firedRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const [countIn, setCountIn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        numeral: null,
        exiting: false
    });
    const timersRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef([]);
    const clearTimers = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        for (const t of timersRef.current)clearTimeout(t);
        timersRef.current = [];
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!active) {
            firedRef.current = false;
            clearTimers();
            setCountIn({
                numeral: null,
                exiting: false
            });
            return;
        }
        if (firedRef.current) return;
        if (currentMarcId == null) return;
        if (eggReferenceLoadedForMarcId !== currentMarcId) return;
        if (tweeningRef.current) return;
        firedRef.current = true;
        if (debug) {
            markStarted();
            return;
        }
        // 3 / 2 / 1 each hold for COUNT_IN_BEAT_MS; GO holds for the
        // shorter COUNT_IN_GO_MS (linger less, get into the round). The
        // first numeral renders synchronously on the first commit after
        // the effect fires; subsequent beats are queued via setTimeout.
        setCountIn({
            numeral: (0, $7Yi7V.COUNT_IN_BEATS)[0],
            exiting: false
        });
        (0, $cd49d00d6f1363b1$export$655b052f6e42c8ce)();
        let elapsed = 0;
        for(let i = 1; i < (0, $7Yi7V.COUNT_IN_BEATS).length; i++){
            elapsed += (0, $7Yi7V.COUNT_IN_BEAT_MS);
            const isGo = i === (0, $7Yi7V.COUNT_IN_BEATS).length - 1;
            const t = setTimeout(()=>{
                setCountIn({
                    numeral: (0, $7Yi7V.COUNT_IN_BEATS)[i],
                    exiting: false
                });
                if (isGo) (0, $cd49d00d6f1363b1$export$bf11a81b6fb1584e)();
                else (0, $cd49d00d6f1363b1$export$655b052f6e42c8ce)();
            }, elapsed);
            timersRef.current.push(t);
        }
        // GO beat ends → fire markStarted (timer starts, input unlocks),
        // start the exit fade, then clear count-in state once the fade
        // settles.
        const goEnd = elapsed + (0, $7Yi7V.COUNT_IN_GO_MS);
        const tStart = setTimeout(()=>{
            markStarted();
            setCountIn((c)=>({
                    numeral: c.numeral,
                    exiting: true
                }));
        }, goEnd);
        timersRef.current.push(tStart);
        const tClear = setTimeout(()=>{
            setCountIn({
                numeral: null,
                exiting: false
            });
        }, goEnd + (0, $7Yi7V.COUNT_IN_EXIT_MS));
        timersRef.current.push(tClear);
    }, [
        active,
        currentMarcId,
        eggReferenceLoadedForMarcId,
        tweening,
        markStarted,
        tweeningRef,
        debug,
        clearTimers
    ]);
    return countIn;
}



var $acw62 = parcelRequire("acw62");
// Multi-marc round state. Owns the lineup + currentIndex + complete
// flag; nothing else. Per-marc play state (target picker, detection,
// celebration) lives in MarcEngine. Lives outside React; the binding
// hook (useSpeedrunEngine) handles the React-side glue.
//
// Inputs:
//   start({ lineup, available }) — begin a round with this marc list,
//     and remember the full available list so cycleMarc can walk it.
//     Does NOT stamp startedAt — the timer is deferred until the egg
//     is actually in position (App calls markStarted() on first tween-
//     end).
//   markStarted()                — first time the egg has settled at
//     the round's first marc. Stamps startedAt. Idempotent.
//   advanceMarc()                — current marc just hit allDone.
//   cycleMarc(delta)             — debug-only: replace the current
//     entry in the lineup with the next/prev marc from `available`.
//     Preserves round shape (lineup length stays the same).
//   reset()                      — drop all state.
//
// Snapshot: { currentMarcId, currentIndex, total, complete }. Listeners
// observe snapshots; downstream side effects (clearing the canvas
// between marcs) ride on the snapshot's currentMarcId via a React
// useEffect rather than an imperative callback from here.
class $f17124731a101cfc$export$2e2bcd8739ae039 {
    constructor(){
        this.lineup = [];
        this.available = [];
        this.currentIndex = 0;
        this.complete = false;
        // Round timer is count-UP — final score is total elapsed time. Both
        // millisecond timestamps from Date.now(); startedAt is stamped by
        // markStarted() (called by App when the first tween settles), and
        // endedAt is stamped exactly once when the round flips to complete
        // (so the displayed time freezes at the moment the last marc is
        // finished, not whenever the ScorePanel happens to render next).
        this.startedAt = null;
        this.endedAt = null;
        this.listeners = new Set();
    }
    start({ lineup: lineup, available: available }) {
        this.lineup = [
            ...lineup
        ];
        this.available = [
            ...available ?? lineup
        ];
        this.currentIndex = 0;
        this.complete = this.lineup.length === 0;
        // startedAt stays null until markStarted(); the round's "is the
        // timer running yet?" signal is the snapshot's startedAt being
        // non-null. ScorePanel's RoundTimer already shows 0:00.0 in that
        // case.
        this.startedAt = null;
        this.endedAt = null;
        this._emit();
    }
    // Idempotent: called by App when the first tween-end transition
    // fires in a fresh round. Subsequent invocations no-op so we don't
    // accidentally re-stamp startedAt mid-round (e.g., on a marc-to-
    // marc tween-end).
    markStarted() {
        if (this.startedAt != null) return;
        if (this.complete) return;
        if (this.lineup.length === 0) return;
        this.startedAt = Date.now();
        this._emit();
    }
    advanceMarc() {
        if (this.complete) return;
        if (this.currentIndex + 1 >= this.lineup.length) {
            this.complete = true;
            this.endedAt = Date.now();
        } else this.currentIndex += 1;
        this._emit();
    }
    // Debug-only: replace the current lineup slot with the next/prev marc
    // from `available`. If the candidate is the same as the current id
    // (lineup of 1 with only one available), no-ops. Lineup is replaced
    // with a new array (immutable update) rather than spliced in place so
    // snapshot consumers can compare identities to detect real changes.
    cycleMarc(delta) {
        if (this.available.length === 0 || this.lineup.length === 0) return;
        const current = this.lineup[this.currentIndex];
        const i = this.available.indexOf(current);
        const len = this.available.length;
        // If current isn't in `available` (e.g. pinned via ?marcs= to an id
        // not in manifest), fall back to index 0 so cycling still works.
        const base = i === -1 ? 0 : i;
        const next = this.available[(base + delta + len) % len];
        if (next === current) return;
        this.lineup = this.lineup.map((id, idx)=>idx === this.currentIndex ? next : id);
        this._emit();
    }
    reset() {
        this.lineup = [];
        this.available = [];
        this.currentIndex = 0;
        this.complete = false;
        this.startedAt = null;
        this.endedAt = null;
        this._emit();
    }
    subscribe(listener) {
        this.listeners.add(listener);
        return ()=>this.listeners.delete(listener);
    }
    dispose() {
        this.listeners.clear();
    }
    getSnapshot() {
        // In complete state we still expose the last marc as currentMarcId
        // so the reference photo + canvas don't flicker back to a default
        // while the round-complete UI catches up. Goes null only when the
        // engine is fully reset (lineup empty).
        //
        // `lineup` is exposed by reference. All mutations (start, cycleMarc,
        // reset) replace this.lineup with a new array, so consumers can
        // compare identities to detect real round-shape changes — useful
        // for memoization downstream (the end-screen modal recomputes
        // podium order off this).
        return {
            currentMarcId: this.lineup.length > 0 ? this.lineup[this.currentIndex] : null,
            currentIndex: this.currentIndex,
            lineup: this.lineup,
            total: this.lineup.length,
            complete: this.complete,
            startedAt: this.startedAt,
            endedAt: this.endedAt
        };
    }
    _emit() {
        for (const l of this.listeners)l();
    }
}


// Binding hook for SpeedrunEngine (multi-marc round). Constructs the
// engine, picks a fresh lineup when `active` flips true, and exposes a
// snapshot + advance/cycle methods to App. Resets on inactive so the
// next entry into speedrun re-rolls.
//
// Lineup picker:
//   - If `pinnedLineup` is non-empty (debug ?marcs=), use it as-is.
//   - Else shuffle `available` and take `roundSize`.
function $e47285a9ce27f4b2$var$shuffle(arr) {
    const a = [
        ...arr
    ];
    for(let i = a.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [
            a[j],
            a[i]
        ];
    }
    return a;
}
function $e47285a9ce27f4b2$var$pickLineup({ available: available, pinnedLineup: pinnedLineup, roundSize: roundSize }) {
    if (pinnedLineup && pinnedLineup.length > 0) return [
        ...pinnedLineup
    ];
    return $e47285a9ce27f4b2$var$shuffle(available).slice(0, roundSize);
}
function $e47285a9ce27f4b2$export$2e2bcd8739ae039({ active: active, available: available, pinnedLineup: pinnedLineup, roundSize: roundSize }) {
    const engineRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    if (engineRef.current == null) engineRef.current = new (0, $f17124731a101cfc$export$2e2bcd8739ae039)();
    const [snapshot, setSnapshot] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>engineRef.current.getSnapshot());
    const recompute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        setSnapshot(engineRef.current.getSnapshot());
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const engine = engineRef.current;
        const unsub = engine.subscribe(recompute);
        return ()=>{
            unsub();
            engine.dispose();
        };
    }, [
        recompute
    ]);
    // Roll a fresh lineup on activation; reset on deactivation. Available
    // / pinned changes after start are intentionally ignored — the round
    // shape is locked at start time.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (active) {
            const lineup = $e47285a9ce27f4b2$var$pickLineup({
                available: available,
                pinnedLineup: pinnedLineup,
                roundSize: roundSize
            });
            engineRef.current.start({
                lineup: lineup,
                available: available
            });
        } else engineRef.current.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        active
    ]);
    const advanceMarc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        engineRef.current.advanceMarc();
    }, []);
    const cycleMarc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((delta)=>{
        engineRef.current.cycleMarc(delta);
    }, []);
    const markStarted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        engineRef.current.markStarted();
    }, []);
    // Roll a fresh lineup without leaving speedrun mode. Used by the
    // end-screen "Play Again" button — same path as the active=true
    // effect, just driven by an explicit user action.
    const restart = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const lineup = $e47285a9ce27f4b2$var$pickLineup({
            available: available,
            pinnedLineup: pinnedLineup,
            roundSize: roundSize
        });
        engineRef.current.start({
            lineup: lineup,
            available: available
        });
    }, [
        available,
        pinnedLineup,
        roundSize
    ]);
    return {
        snapshot: snapshot,
        advanceMarc: advanceMarc,
        cycleMarc: cycleMarc,
        markStarted: markStarted,
        restart: restart
    };
}


// Pool of marcs shown on the landing-page cycling preview. Today this is
// exactly the set of marcs that have committed reference drawings —
// effectively the same as AVAILABLE_MARC_IDS. The split exists because
// the two pools will diverge: speedrun needs marcs that are tractable
// in 60s on a per-region basis, but the landing reel is happy to show
// off heavy detail traces as eye candy. When that distinction starts
// to matter, the simplest extension is a `landingOnly: true` flag in
// reference.json that gen-manifest emits as a second array.
// Auto-generated by scripts/gen-manifest.js. Do not edit by hand —
// re-run `npm run gen-manifest` after adding/removing references.
const $558b48ff778d5bc1$export$abd6720e30c85521 = [
    "001",
    "002",
    "003",
    "004",
    "006",
    "007",
    "008",
    "009",
    "010",
    "011",
    "012",
    "013",
    "014",
    "015",
    "016",
    "017",
    "018",
    "019",
    "020"
];


const $68890285b5e31cfc$export$1e0018afdce14cd3 = (0, $558b48ff778d5bc1$export$abd6720e30c85521);




var $gLxJv = parcelRequire("gLxJv");

var $4e3Nb = parcelRequire("4e3Nb");

var $7vZux = parcelRequire("7vZux");



var $4cvDM = parcelRequire("4cvDM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $baa6D = parcelRequire("baa6D");
// Standard themed button. Knobs:
//   variant: 'internal' (boring surface, used inside dense panels) |
//            'default'  (warm chrome, has presence — landing CTAs, modal
//                       primary actions) |
//            'primary'  (warn-orange CTA — the highest-emphasis action)
//   size:    'small' | 'medium' | 'large'
//   $active: selected state, swaps bg/fg to selected-* tokens
//
// Visual values are exposed as CSS custom properties (--background,
// --text-color, --border-color, --padding, --font-size). Variant + size
// just set those; the style rules consume them. To tweak a single instance,
// set the var via inline style (`style={{ '--background': 'red' }}`) or
// extend with `styled(Button)\`--padding: 14px 28px;\``.
//
// `noFocusOnMouseDown` is built in so callers don't need to remember it.
function $3d26c75613118b87$var$Button({ variant: variant = "default", size: size = "medium", $active: $active = false, children: children, ...rest }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3d26c75613118b87$var$Root, {
        $variant: variant,
        $size: size,
        $active: $active,
        ...rest,
        children: children
    });
}
const $3d26c75613118b87$var$SIZES = {
    small: `
    --padding: 6px 12px;
    --font-size: 13px;
  `,
    medium: `
    --padding: 8px 16px;
    --font-size: 1rem;
  `,
    large: `
    --padding: 0.5rem 1rem;
    --font-size: 1.125rem;
  `
};
const $3d26c75613118b87$var$VARIANTS = {
    internal: `
    --background: var(--color-surface);
    --text-color: var(--color-text);
    --border-color: var(--color-border);
    --hover-background: var(--color-surface-hover);
  `,
    default: `
    --background: var(--color-chrome);
    --text-color: var(--color-text);
    --border-color: var(--color-stone-500);
    --hover-background: var(--color-orange-300);
  `,
    primary: `
    --background: var(--color-warn);
    --text-color: var(--color-selected-fg);
    --border-color: var(--color-warn);
    --hover-background: var(--color-warn-hover);
  `
};
const $3d26c75613118b87$var$ACTIVE = `
  --background: var(--color-selected-bg);
  --text-color: var(--color-selected-fg);
`;
const $3d26c75613118b87$var$Root = (0, $lmFrL.default).button.attrs({
    onMouseDown: (0, $baa6D.noFocusOnMouseDown)
})`
  ${(p)=>$3d26c75613118b87$var$SIZES[p.$size] ?? $3d26c75613118b87$var$SIZES.medium}
  ${(p)=>$3d26c75613118b87$var$VARIANTS[p.$variant] ?? $3d26c75613118b87$var$VARIANTS.default}
  ${(p)=>p.$active && $3d26c75613118b87$var$ACTIVE}

  padding: var(--padding);
  font-size: var(--font-size);
  background: var(--background);
  color: var(--text-color);
  border: 1px solid var(--color-border-subtle);
  box-shadow: var(--surface-box-shadow);

  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 120ms ease-out,
    color 120ms ease-out;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  :has(:hover) &:hover {
    background-color: var(--hover-background);
  }

  &:focus-visible {
    outline: 2px solid var(--color-text);
    outline-offset: 2px;
  }
`;
var $3d26c75613118b87$export$2e2bcd8739ae039 = $3d26c75613118b87$var$Button;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
// packages/core/number/src/number.ts
function $b488a2b318a95c87$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}



var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $88UcQ = parcelRequire("88UcQ");
// packages/react/direction/src/direction.tsx

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
var $f9ad7d2f57cc5bec$var$DirectionContext = $acw62.createContext(void 0);
var $f9ad7d2f57cc5bec$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $ayMG0.jsx)($f9ad7d2f57cc5bec$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $f9ad7d2f57cc5bec$export$b39126d51d94e6f3(localDir) {
    const globalDir = $acw62.useContext($f9ad7d2f57cc5bec$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $f9ad7d2f57cc5bec$export$2881499e37b75b9a = $f9ad7d2f57cc5bec$export$c760c09fdd558351;


// packages/react/use-previous/src/use-previous.tsx

var $acw62 = parcelRequire("acw62");
function $44b714300f6a50aa$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        previous: value
    });
    return $acw62.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}



var $8727j = parcelRequire("8727j");

var $kFbxc = parcelRequire("kFbxc");

var $acw62 = parcelRequire("acw62");

var $jnK0n = parcelRequire("jnK0n");

var $htT6J = parcelRequire("htT6J");

var $9UeUh = parcelRequire("9UeUh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
function $a9634733d4b9bce9$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $9UeUh.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $9UeUh.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
// src/ordered-dictionary.ts
var $a9634733d4b9bce9$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $a9634733d4b9bce9$var$OrderedDict = class _OrderedDict extends Map {
    #keys;
    constructor(entries){
        super(entries);
        this.#keys = [
            ...super.keys()
        ];
        $a9634733d4b9bce9$var$__instanciated.set(this, true);
    }
    set(key, value) {
        if ($a9634733d4b9bce9$var$__instanciated.get(this)) {
            if (this.has(key)) this.#keys[this.#keys.indexOf(key)] = key;
            else this.#keys.push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = this.#keys.length;
        const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...this.#keys
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = this.#keys.indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = this.#keys.indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = this.#keys.indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        this.#keys = [];
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) this.#keys.splice(this.#keys.indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $a9634733d4b9bce9$var$at(this.#keys, index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return this.#keys.indexOf(key);
    }
    keyAt(index) {
        return $a9634733d4b9bce9$var$at(this.#keys, index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue ?? this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue ?? this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
};
function $a9634733d4b9bce9$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $a9634733d4b9bce9$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
function $a9634733d4b9bce9$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $a9634733d4b9bce9$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
function $a9634733d4b9bce9$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
function $a9634733d4b9bce9$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $jnK0n.createContextScope)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $a9634733d4b9bce9$var$OrderedDict(),
        setItemMap: ()=>void 0
    });
    const CollectionProvider = ({ state: state, ...props })=>{
        return state ? /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionInit, {
            ...props
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = (props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionProviderImpl, {
            ...props,
            state: state
        });
    };
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = (props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [collectionElement, setCollectionElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composeRefs = (0, $htT6J.useComposedRefs)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            if (!collectionElement) return;
            const observer = $a9634733d4b9bce9$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    };
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $9UeUh.createSlot)(COLLECTION_SLOT_NAME);
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $9UeUh.createSlot)(ITEM_SLOT_NAME);
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
        const [element, setElement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
        const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(itemData);
        if (!$a9634733d4b9bce9$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, {
                        ...itemData2,
                        element: element
                    });
                    return map.toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
                }
                return map.set(element, {
                    ...itemData2,
                    element: element
                }).toSorted($a9634733d4b9bce9$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $a9634733d4b9bce9$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $ayMG0.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(new $a9634733d4b9bce9$var$OrderedDict());
    }
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
function $a9634733d4b9bce9$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a9634733d4b9bce9$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
function $a9634733d4b9bce9$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $a9634733d4b9bce9$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
function $a9634733d4b9bce9$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}



var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2aa948012ed37c30$var$PAGE_KEYS = [
    "PageUp",
    "PageDown"
];
var $2aa948012ed37c30$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $2aa948012ed37c30$var$BACK_KEYS = {
    "from-left": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-right": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowRight"
    ],
    "from-bottom": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-top": [
        "Home",
        "PageDown",
        "ArrowUp",
        "ArrowLeft"
    ]
};
var $2aa948012ed37c30$var$SLIDER_NAME = "Slider";
var [$2aa948012ed37c30$var$Collection, $2aa948012ed37c30$var$useCollection, $2aa948012ed37c30$var$createCollectionScope] = (0, $a9634733d4b9bce9$export$c74125a8e3af6bb2)($2aa948012ed37c30$var$SLIDER_NAME);
var [$2aa948012ed37c30$var$createSliderContext, $2aa948012ed37c30$export$ef72632d7b901f97] = (0, $jnK0n.createContextScope)($2aa948012ed37c30$var$SLIDER_NAME, [
    $2aa948012ed37c30$var$createCollectionScope
]);
var [$2aa948012ed37c30$var$SliderProvider, $2aa948012ed37c30$var$useSliderContext] = $2aa948012ed37c30$var$createSliderContext($2aa948012ed37c30$var$SLIDER_NAME);
var $2aa948012ed37c30$export$472062a354075cee = $acw62.forwardRef((props, forwardedRef)=>{
    const { name: name, min: min = 0, max: max = 100, step: step = 1, orientation: orientation = "horizontal", disabled: disabled = false, minStepsBetweenThumbs: minStepsBetweenThumbs = 0, defaultValue: defaultValue = [
        min
    ], value: value, onValueChange: onValueChange = ()=>{}, onValueCommit: onValueCommit = ()=>{}, inverted: inverted = false, form: form, ...sliderProps } = props;
    const thumbRefs = $acw62.useRef(/* @__PURE__ */ new Set());
    const valueIndexToChangeRef = $acw62.useRef(0);
    const isHorizontal = orientation === "horizontal";
    const SliderOrientation = isHorizontal ? $2aa948012ed37c30$var$SliderHorizontal : $2aa948012ed37c30$var$SliderVertical;
    const [values = [], setValues] = (0, $88UcQ.useControllableState)({
        prop: value,
        defaultProp: defaultValue,
        onChange: (value2)=>{
            const thumbs = [
                ...thumbRefs.current
            ];
            thumbs[valueIndexToChangeRef.current]?.focus();
            onValueChange(value2);
        }
    });
    const valuesBeforeSlideStartRef = $acw62.useRef(values);
    function handleSlideStart(value2) {
        const closestIndex = $2aa948012ed37c30$var$getClosestValueIndex(values, value2);
        updateValues(value2, closestIndex);
    }
    function handleSlideMove(value2) {
        updateValues(value2, valueIndexToChangeRef.current);
    }
    function handleSlideEnd() {
        const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
        const nextValue = values[valueIndexToChangeRef.current];
        const hasChanged = nextValue !== prevValue;
        if (hasChanged) onValueCommit(values);
    }
    function updateValues(value2, atIndex, { commit: commit } = {
        commit: false
    }) {
        const decimalCount = $2aa948012ed37c30$var$getDecimalCount(step);
        const snapToStep = $2aa948012ed37c30$var$roundValue(Math.round((value2 - min) / step) * step + min, decimalCount);
        const nextValue = (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(snapToStep, [
            min,
            max
        ]);
        setValues((prevValues = [])=>{
            const nextValues = $2aa948012ed37c30$var$getNextSortedValues(prevValues, nextValue, atIndex);
            if ($2aa948012ed37c30$var$hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
                valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
                const hasChanged = String(nextValues) !== String(prevValues);
                if (hasChanged && commit) onValueCommit(nextValues);
                return hasChanged ? nextValues : prevValues;
            } else return prevValues;
        });
    }
    return /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderProvider, {
        scope: props.__scopeSlider,
        name: name,
        disabled: disabled,
        min: min,
        max: max,
        valueIndexToChangeRef: valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values: values,
        orientation: orientation,
        form: form,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$Collection.Provider, {
            scope: props.__scopeSlider,
            children: /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$Collection.Slot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)(SliderOrientation, {
                    "aria-disabled": disabled,
                    "data-disabled": disabled ? "" : void 0,
                    ...sliderProps,
                    ref: forwardedRef,
                    onPointerDown: (0, $2IwC4.composeEventHandlers)(sliderProps.onPointerDown, ()=>{
                        if (!disabled) valuesBeforeSlideStartRef.current = values;
                    }),
                    min: min,
                    max: max,
                    inverted: inverted,
                    onSlideStart: disabled ? void 0 : handleSlideStart,
                    onSlideMove: disabled ? void 0 : handleSlideMove,
                    onSlideEnd: disabled ? void 0 : handleSlideEnd,
                    onHomeKeyDown: ()=>!disabled && updateValues(min, 0, {
                            commit: true
                        }),
                    onEndKeyDown: ()=>!disabled && updateValues(max, values.length - 1, {
                            commit: true
                        }),
                    onStepKeyDown: ({ event: event, direction: stepDirection })=>{
                        if (!disabled) {
                            const isPageKey = $2aa948012ed37c30$var$PAGE_KEYS.includes(event.key);
                            const isSkipKey = isPageKey || event.shiftKey && $2aa948012ed37c30$var$ARROW_KEYS.includes(event.key);
                            const multiplier = isSkipKey ? 10 : 1;
                            const atIndex = valueIndexToChangeRef.current;
                            const value2 = values[atIndex];
                            const stepInDirection = step * multiplier * stepDirection;
                            updateValues(value2 + stepInDirection, atIndex, {
                                commit: true
                            });
                        }
                    }
                })
            })
        })
    });
});
$2aa948012ed37c30$export$472062a354075cee.displayName = $2aa948012ed37c30$var$SLIDER_NAME;
var [$2aa948012ed37c30$var$SliderOrientationProvider, $2aa948012ed37c30$var$useSliderOrientationContext] = $2aa948012ed37c30$var$createSliderContext($2aa948012ed37c30$var$SLIDER_NAME, {
    startEdge: "left",
    endEdge: "right",
    size: "width",
    direction: 1
});
var $2aa948012ed37c30$var$SliderHorizontal = $acw62.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, dir: dir, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const [slider, setSlider] = $acw62.useState(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setSlider(node));
    const rectRef = $acw62.useRef(void 0);
    const direction = (0, $f9ad7d2f57cc5bec$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || slider.getBoundingClientRect();
        const input = [
            0,
            rect.width
        ];
        const output = isSlidingFromLeft ? [
            min,
            max
        ] : [
            max,
            min
        ];
        const value = $2aa948012ed37c30$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.left);
    }
    return /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromLeft ? "left" : "right",
        endEdge: isSlidingFromLeft ? "right" : "left",
        direction: isSlidingFromLeft ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderImpl, {
            dir: direction,
            "data-orientation": "horizontal",
            ...sliderProps,
            ref: composedRefs,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideStart?.(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideMove?.(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd?.();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
                const isBackKey = $2aa948012ed37c30$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown?.({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $2aa948012ed37c30$var$SliderVertical = $acw62.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const sliderRef = $acw62.useRef(null);
    const ref = (0, $htT6J.useComposedRefs)(forwardedRef, sliderRef);
    const rectRef = $acw62.useRef(void 0);
    const isSlidingFromBottom = !inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
        const input = [
            0,
            rect.height
        ];
        const output = isSlidingFromBottom ? [
            max,
            min
        ] : [
            min,
            max
        ];
        const value = $2aa948012ed37c30$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.top);
    }
    return /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromBottom ? "bottom" : "top",
        endEdge: isSlidingFromBottom ? "top" : "bottom",
        size: "height",
        direction: isSlidingFromBottom ? 1 : -1,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderImpl, {
            "data-orientation": "vertical",
            ...sliderProps,
            ref: ref,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideStart?.(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideMove?.(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd?.();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
                const isBackKey = $2aa948012ed37c30$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown?.({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $2aa948012ed37c30$var$SliderImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onHomeKeyDown: onHomeKeyDown, onEndKeyDown: onEndKeyDown, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const context = $2aa948012ed37c30$var$useSliderContext($2aa948012ed37c30$var$SLIDER_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
        ...sliderProps,
        ref: forwardedRef,
        onKeyDown: (0, $2IwC4.composeEventHandlers)(props.onKeyDown, (event)=>{
            if (event.key === "Home") {
                onHomeKeyDown(event);
                event.preventDefault();
            } else if (event.key === "End") {
                onEndKeyDown(event);
                event.preventDefault();
            } else if ($2aa948012ed37c30$var$PAGE_KEYS.concat($2aa948012ed37c30$var$ARROW_KEYS).includes(event.key)) {
                onStepKeyDown(event);
                event.preventDefault();
            }
        }),
        onPointerDown: (0, $2IwC4.composeEventHandlers)(props.onPointerDown, (event)=>{
            const target = event.target;
            target.setPointerCapture(event.pointerId);
            event.preventDefault();
            if (context.thumbs.has(target)) target.focus();
            else onSlideStart(event);
        }),
        onPointerMove: (0, $2IwC4.composeEventHandlers)(props.onPointerMove, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) onSlideMove(event);
        }),
        onPointerUp: (0, $2IwC4.composeEventHandlers)(props.onPointerUp, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) {
                target.releasePointerCapture(event.pointerId);
                onSlideEnd(event);
            }
        })
    });
});
var $2aa948012ed37c30$var$TRACK_NAME = "SliderTrack";
var $2aa948012ed37c30$export$105594979f116971 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...trackProps } = props;
    const context = $2aa948012ed37c30$var$useSliderContext($2aa948012ed37c30$var$TRACK_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
        "data-disabled": context.disabled ? "" : void 0,
        "data-orientation": context.orientation,
        ...trackProps,
        ref: forwardedRef
    });
});
$2aa948012ed37c30$export$105594979f116971.displayName = $2aa948012ed37c30$var$TRACK_NAME;
var $2aa948012ed37c30$var$RANGE_NAME = "SliderRange";
var $2aa948012ed37c30$export$a5cf38a7a000fe77 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...rangeProps } = props;
    const context = $2aa948012ed37c30$var$useSliderContext($2aa948012ed37c30$var$RANGE_NAME, __scopeSlider);
    const orientation = $2aa948012ed37c30$var$useSliderOrientationContext($2aa948012ed37c30$var$RANGE_NAME, __scopeSlider);
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map((value)=>$2aa948012ed37c30$var$convertValueToPercentage(value, context.min, context.max));
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        ...rangeProps,
        ref: composedRefs,
        style: {
            ...props.style,
            [orientation.startEdge]: offsetStart + "%",
            [orientation.endEdge]: offsetEnd + "%"
        }
    });
});
$2aa948012ed37c30$export$a5cf38a7a000fe77.displayName = $2aa948012ed37c30$var$RANGE_NAME;
var $2aa948012ed37c30$var$THUMB_NAME = "SliderThumb";
var $2aa948012ed37c30$export$2c1b491743890dec = $acw62.forwardRef((props, forwardedRef)=>{
    const getItems = $2aa948012ed37c30$var$useCollection(props.__scopeSlider);
    const [thumb, setThumb] = $acw62.useState(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setThumb(node));
    const index = $acw62.useMemo(()=>thumb ? getItems().findIndex((item)=>item.ref.current === thumb) : -1, [
        getItems,
        thumb
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderThumbImpl, {
        ...props,
        ref: composedRefs,
        index: index
    });
});
var $2aa948012ed37c30$var$SliderThumbImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, index: index, name: name, ...thumbProps } = props;
    const context = $2aa948012ed37c30$var$useSliderContext($2aa948012ed37c30$var$THUMB_NAME, __scopeSlider);
    const orientation = $2aa948012ed37c30$var$useSliderOrientationContext($2aa948012ed37c30$var$THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = $acw62.useState(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, (node)=>setThumb(node));
    const isFormControl = thumb ? context.form || !!thumb.closest("form") : true;
    const size = (0, $8727j.useSize)(thumb);
    const value = context.values[index];
    const percent = value === void 0 ? 0 : $2aa948012ed37c30$var$convertValueToPercentage(value, context.min, context.max);
    const label = $2aa948012ed37c30$var$getLabel(index, context.values.length);
    const orientationSize = size?.[orientation.size];
    const thumbInBoundsOffset = orientationSize ? $2aa948012ed37c30$var$getThumbInBoundsOffset(orientationSize, percent, orientation.direction) : 0;
    $acw62.useEffect(()=>{
        if (thumb) {
            context.thumbs.add(thumb);
            return ()=>{
                context.thumbs.delete(thumb);
            };
        }
    }, [
        thumb,
        context.thumbs
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("span", {
        style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [orientation.startEdge]: `calc(${percent}% + ${thumbInBoundsOffset}px)`
        },
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$Collection.ItemSlot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).span, {
                    role: "slider",
                    "aria-label": props["aria-label"] || label,
                    "aria-valuemin": context.min,
                    "aria-valuenow": value,
                    "aria-valuemax": context.max,
                    "aria-orientation": context.orientation,
                    "data-orientation": context.orientation,
                    "data-disabled": context.disabled ? "" : void 0,
                    tabIndex: context.disabled ? void 0 : 0,
                    ...thumbProps,
                    ref: composedRefs,
                    style: value === void 0 ? {
                        display: "none"
                    } : props.style,
                    onFocus: (0, $2IwC4.composeEventHandlers)(props.onFocus, ()=>{
                        context.valueIndexToChangeRef.current = index;
                    })
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $ayMG0.jsx)($2aa948012ed37c30$var$SliderBubbleInput, {
                name: name ?? (context.name ? context.name + (context.values.length > 1 ? "[]" : "") : void 0),
                form: context.form,
                value: value
            }, index)
        ]
    });
});
$2aa948012ed37c30$export$2c1b491743890dec.displayName = $2aa948012ed37c30$var$THUMB_NAME;
var $2aa948012ed37c30$var$BUBBLE_INPUT_NAME = "RadioBubbleInput";
var $2aa948012ed37c30$var$SliderBubbleInput = $acw62.forwardRef(({ __scopeSlider: __scopeSlider, value: value, ...props }, forwardedRef)=>{
    const ref = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(ref, forwardedRef);
    const prevValue = (0, $44b714300f6a50aa$export$5cae361ad82dce8b)(value);
    $acw62.useEffect(()=>{
        const input = ref.current;
        if (!input) return;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("input", {
                bubbles: true
            });
            setValue.call(input, value);
            input.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).input, {
        style: {
            display: "none"
        },
        ...props,
        ref: composedRefs,
        defaultValue: value
    });
});
$2aa948012ed37c30$var$SliderBubbleInput.displayName = $2aa948012ed37c30$var$BUBBLE_INPUT_NAME;
function $2aa948012ed37c30$var$getNextSortedValues(prevValues = [], nextValue, atIndex) {
    const nextValues = [
        ...prevValues
    ];
    nextValues[atIndex] = nextValue;
    return nextValues.sort((a, b)=>a - b);
}
function $2aa948012ed37c30$var$convertValueToPercentage(value, min, max) {
    const maxSteps = max - min;
    const percentPerStep = 100 / maxSteps;
    const percentage = percentPerStep * (value - min);
    return (0, $b488a2b318a95c87$export$7d15b64cf5a3a4c4)(percentage, [
        0,
        100
    ]);
}
function $2aa948012ed37c30$var$getLabel(index, totalValues) {
    if (totalValues > 2) return `Value ${index + 1} of ${totalValues}`;
    else if (totalValues === 2) return [
        "Minimum",
        "Maximum"
    ][index];
    else return void 0;
}
function $2aa948012ed37c30$var$getClosestValueIndex(values, nextValue) {
    if (values.length === 1) return 0;
    const distances = values.map((value)=>Math.abs(value - nextValue));
    const closestDistance = Math.min(...distances);
    return distances.indexOf(closestDistance);
}
function $2aa948012ed37c30$var$getThumbInBoundsOffset(width, left, direction) {
    const halfWidth = width / 2;
    const halfPercent = 50;
    const offset = $2aa948012ed37c30$var$linearScale([
        0,
        halfPercent
    ], [
        0,
        halfWidth
    ]);
    return (halfWidth - offset(left) * direction) * direction;
}
function $2aa948012ed37c30$var$getStepsBetweenValues(values) {
    return values.slice(0, -1).map((value, index)=>values[index + 1] - value);
}
function $2aa948012ed37c30$var$hasMinStepsBetweenValues(values, minStepsBetweenValues) {
    if (minStepsBetweenValues > 0) {
        const stepsBetweenValues = $2aa948012ed37c30$var$getStepsBetweenValues(values);
        const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
        return actualMinStepsBetweenValues >= minStepsBetweenValues;
    }
    return true;
}
function $2aa948012ed37c30$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $2aa948012ed37c30$var$getDecimalCount(value) {
    return (String(value).split(".")[1] || "").length;
}
function $2aa948012ed37c30$var$roundValue(value, decimalCount) {
    const rounder = Math.pow(10, decimalCount);
    return Math.round(value * rounder) / rounder;
}
var $2aa948012ed37c30$export$be92b6f5f03c0fe9 = $2aa948012ed37c30$export$472062a354075cee;
var $2aa948012ed37c30$export$13921ac0cc260818 = $2aa948012ed37c30$export$105594979f116971;
var $2aa948012ed37c30$export$9a58ef0d7ad3278c = $2aa948012ed37c30$export$a5cf38a7a000fe77;
var $2aa948012ed37c30$export$6521433ed15a34db = $2aa948012ed37c30$export$2c1b491743890dec;



var $lmFrL = parcelRequire("lmFrL");
// Single-thumb slider over Radix primitives. Radix's value/onValueChange are
// array-shaped (multi-thumb support); this wrapper hides that for the common
// single-value case so call sites read like the native input did.
function $7ffaeb3a0df79d49$var$ToolSlider({ min: min, max: max, step: step = 1, value: value, onValueChange: onValueChange, ariaLabel: ariaLabel }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7ffaeb3a0df79d49$var$Root, {
        min: min,
        max: max,
        step: step,
        value: [
            value
        ],
        onValueChange: (arr)=>onValueChange(arr[0]),
        "aria-label": ariaLabel,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($7ffaeb3a0df79d49$var$Track, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($7ffaeb3a0df79d49$var$Range, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($7ffaeb3a0df79d49$var$Thumb, {})
        ]
    });
}
const $7ffaeb3a0df79d49$var$Root = (0, $lmFrL.default)($2aa948012ed37c30$export$be92b6f5f03c0fe9)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
  height: 20px;
`;
const $7ffaeb3a0df79d49$var$Track = (0, $lmFrL.default)($2aa948012ed37c30$export$13921ac0cc260818)`
  position: relative;
  flex-grow: 1;
  background: var(--color-chrome);
  border-radius: 999px;
  height: 4px;
`;
const $7ffaeb3a0df79d49$var$Range = (0, $lmFrL.default)($2aa948012ed37c30$export$9a58ef0d7ad3278c)`
  position: absolute;
  background: var(--color-chrome-active);
  border-radius: 999px;
  height: 100%;
`;
const $7ffaeb3a0df79d49$var$Thumb = (0, $lmFrL.default)($2aa948012ed37c30$export$6521433ed15a34db)`
  display: block;
  width: 16px;
  height: 16px;
  background: var(--color-surface);
  border: 1.5px solid var(--color-chrome-active);
  border-radius: 50%;
  cursor: grab;

  &:hover {
    background: var(--color-chrome-hover);
  }

  /* Inverted fill on focus: hollow thumb (surface bg + active border)
     becomes filled (active bg + text border). Avoids stacking another
     active-color ring on top of the active-color border + range, which
     read as visual noise rather than a focus state. */
  &:focus-visible {
    background: var(--color-chrome-active);
    border-color: var(--color-text);
    outline: none;
  }

  &[data-state="active"] {
    cursor: grabbing;
  }
`;
var $7ffaeb3a0df79d49$export$2e2bcd8739ae039 = $7ffaeb3a0df79d49$var$ToolSlider;




// Multi-light direction + intensity + shadow + size editor.
// Drop-in popover-body for any panel that wants the full lighting
// pipeline exposed (author + creative). Owns its own activeLight
// index (resets when the lights array shrinks below the index).
//
// Lights array shape (matching the saved-reference format):
//   [{ direction: { x, y, z }, intensity, shadow, size }]
// `setLights(next)` is called with a new array on every edit; the
// caller decides where the array lives (author state, creative state,
// etc).
//
// `onResetAll` is optional — when supplied, a "Reset all" button is
// shown alongside Remove. Author wires this to the per-marc-default
// reset; creative leaves it unset (the marc swap reseeds anyway).
function $85900dfd3a8d68a9$var$LightingEditor({ lights: lights, setLights: setLights, onResetAll: onResetAll }) {
    const [activeLightIndex, setActiveLightIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const safeLights = Array.isArray(lights) ? lights : [];
    const safeLightIndex = Math.min(Math.max(0, activeLightIndex), Math.max(0, safeLights.length - 1));
    const activeLight = safeLights[safeLightIndex] ?? (0, $7Yi7V.DEFAULT_EGG_LIGHT);
    const updateActive = (patch)=>{
        setLights(safeLights.map((L, i)=>i === safeLightIndex ? {
                ...L ?? {},
                ...patch
            } : L));
    };
    const atMaxLights = safeLights.length >= (0, $7Yi7V.MAX_EGG_LIGHTS);
    const addLight = ()=>{
        if (atMaxLights) return;
        const next = [
            ...safeLights,
            {
                ...(0, $7Yi7V.DEFAULT_EGG_LIGHT)
            }
        ];
        setLights(next);
        setActiveLightIndex(next.length - 1);
    };
    const removeActive = ()=>{
        if (safeLights.length === 0) return;
        const next = safeLights.filter((_, i)=>i !== safeLightIndex);
        setLights(next);
        setActiveLightIndex(Math.min(safeLightIndex, Math.max(0, next.length - 1)));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$PopLabel, {
                children: [
                    "Light ",
                    safeLightIndex + 1,
                    " of ",
                    safeLights.length
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$Tabs, {
                children: [
                    safeLights.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$TabButton, {
                            type: "button",
                            $active: i === safeLightIndex,
                            onClick: ()=>setActiveLightIndex(i),
                            "aria-label": `Edit light ${i + 1}`,
                            children: i + 1
                        }, i)),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$TabButton, {
                        type: "button",
                        onClick: addLight,
                        disabled: atMaxLights,
                        "aria-label": "Add light",
                        title: atMaxLights ? `Max ${0, $7Yi7V.MAX_EGG_LIGHTS} lights` : "Add a new light",
                        children: "+"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$PopLabel, {
                children: "Direction"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$LightPad, {
                lights: safeLights,
                activeIndex: safeLightIndex,
                onSelectLight: setActiveLightIndex,
                onChangeActive: (direction)=>updateActive({
                        direction: direction
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$PopLabel, {
                children: [
                    "Intensity \xb7 ",
                    Math.round((activeLight?.intensity ?? 0) * 100)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                min: 0,
                max: 100,
                value: Math.round((activeLight?.intensity ?? 0) * 100),
                onValueChange: (v)=>updateActive({
                        intensity: v / 100
                    }),
                ariaLabel: "Light intensity"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$PopLabel, {
                children: [
                    "Shadow \xb7 ",
                    Math.round((activeLight?.shadow ?? 0) * 100)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                min: 0,
                max: 100,
                value: Math.round((activeLight?.shadow ?? 0) * 100),
                onValueChange: (v)=>updateActive({
                        shadow: v / 100
                    }),
                ariaLabel: "Light shadow"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$PopLabel, {
                children: [
                    "Size \xb7 ",
                    Math.round((activeLight?.size ?? 1) * 100)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                min: 0,
                max: 100,
                value: Math.round((activeLight?.size ?? 1) * 100),
                onValueChange: (v)=>updateActive({
                        size: v / 100
                    }),
                ariaLabel: "Light size"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$Row, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$MiniButton, {
                        type: "button",
                        onClick: removeActive,
                        disabled: safeLights.length <= 1,
                        title: safeLights.length <= 1 ? "Need at least one light" : "Remove this light",
                        children: "Remove"
                    }),
                    onResetAll && /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$MiniButton, {
                        type: "button",
                        onClick: onResetAll,
                        children: "Reset all"
                    })
                ]
            })
        ]
    });
}
// Drag-a-dot pad for the light source position. Rectangle is sized to the
// canvas aspect so the author can place the light spatially relative to
// where the egg lives. Mapping: pad position → 2D direction in [-1, 1]²,
// then clamped to the unit disk so the result lies on the upper
// hemisphere; z is derived as sqrt(1 - x² - y²). Center = head-on,
// rectangle edges = pure side light.
//
// Multi-light: every light renders as a dot. Active is the warn color
// and on top; inactive lights are muted and behind. Pointer-down on a
// non-active dot selects that light (and starts dragging it); pointer-
// down anywhere else drags the active dot to that point.
const $85900dfd3a8d68a9$var$PAD_DOT_HIT_RADIUS = 12;
function $85900dfd3a8d68a9$var$LightPad({ lights: lights, activeIndex: activeIndex, onSelectLight: onSelectLight, onChangeActive: onChangeActive }) {
    const padRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const dragRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const aspect = (0, $7Yi7V.CANVAS_WIDTH) / (0, $7Yi7V.CANVAS_HEIGHT);
    const padHeight = 140;
    const padWidth = padHeight * aspect;
    const halfW = padWidth / 2;
    const halfH = padHeight / 2;
    const dotPos = (L)=>{
        const dx = L?.direction?.x ?? 0;
        const dy = L?.direction?.y ?? 0;
        return {
            x: halfW + dx * halfW,
            y: halfH + dy * halfH
        };
    };
    const setFromPointer = (event)=>{
        const pad = padRef.current;
        if (!pad) return;
        const rect = pad.getBoundingClientRect();
        let x = (event.clientX - rect.left - halfW) / halfW;
        let y = (event.clientY - rect.top - halfH) / halfH;
        const r = Math.sqrt(x * x + y * y);
        if (r > 1) {
            x /= r;
            y /= r;
        }
        const z = Math.sqrt(Math.max(0, 1 - x * x - y * y));
        onChangeActive({
            x: x,
            y: y,
            z: z
        });
    };
    const handleDown = (event)=>{
        event.preventDefault();
        event.currentTarget.setPointerCapture(event.pointerId);
        dragRef.current = true;
        const pad = padRef.current;
        if (pad) {
            const rect = pad.getBoundingClientRect();
            const px = event.clientX - rect.left;
            const py = event.clientY - rect.top;
            let bestI = -1;
            let bestD2 = $85900dfd3a8d68a9$var$PAD_DOT_HIT_RADIUS * $85900dfd3a8d68a9$var$PAD_DOT_HIT_RADIUS;
            for(let i = 0; i < lights.length; i++){
                if (i === activeIndex) continue;
                const { x: x, y: y } = dotPos(lights[i]);
                const d2 = (x - px) * (x - px) + (y - py) * (y - py);
                if (d2 < bestD2) {
                    bestD2 = d2;
                    bestI = i;
                }
            }
            if (bestI >= 0) {
                onSelectLight(bestI);
                return;
            }
        }
        setFromPointer(event);
    };
    const handleMove = (event)=>{
        if (!dragRef.current) return;
        setFromPointer(event);
    };
    const handleUp = (event)=>{
        dragRef.current = false;
        try {
            event.currentTarget.releasePointerCapture(event.pointerId);
        } catch  {
        // ignore — pointer may have already been released
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($85900dfd3a8d68a9$var$Pad, {
        ref: padRef,
        onPointerDown: handleDown,
        onPointerMove: handleMove,
        onPointerUp: handleUp,
        onPointerCancel: handleUp,
        style: {
            width: padWidth,
            height: padHeight
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$PadEgg, {}),
            lights.map((L, i)=>{
                if (i === activeIndex) return null;
                const { x: x, y: y } = dotPos(L);
                return /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$PadDot, {
                    $inactive: true,
                    style: {
                        left: x,
                        top: y
                    },
                    "aria-label": `Light ${i + 1}`,
                    children: i + 1
                }, i);
            }),
            lights[activeIndex] && /*#__PURE__*/ (0, $ayMG0.jsx)($85900dfd3a8d68a9$var$PadDot, {
                style: {
                    left: dotPos(lights[activeIndex]).x,
                    top: dotPos(lights[activeIndex]).y
                },
                "aria-label": `Light ${activeIndex + 1} (active)`,
                children: activeIndex + 1
            })
        ]
    });
}
const $85900dfd3a8d68a9$var$PopLabel = (0, $lmFrL.default).div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
`;
const $85900dfd3a8d68a9$var$Row = (0, $lmFrL.default).div`
  display: flex;
  gap: 6px;
`;
const $85900dfd3a8d68a9$var$Tabs = (0, $lmFrL.default).div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;
const $85900dfd3a8d68a9$var$TabButton = (0, $lmFrL.default).button`
  min-width: 24px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid
    ${(p)=>p.$active ? "var(--color-warn)" : "var(--color-border)"};
  background: ${(p)=>p.$active ? "var(--color-warn)" : "var(--color-surface)"};
  color: ${(p)=>p.$active ? "var(--color-text)" : "inherit"};
  font-size: 11px;
  font-weight: ${(p)=>p.$active ? "700" : "400"};
  cursor: pointer;
  font-variant-numeric: tabular-nums;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
const $85900dfd3a8d68a9$var$Pad = (0, $lmFrL.default).div`
  position: relative;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background: var(--color-surface);
  cursor: crosshair;
  touch-action: none;
  user-select: none;
`;
const $85900dfd3a8d68a9$var$PadEgg = (0, $lmFrL.default).div`
  position: absolute;
  left: 15%;
  right: 15%;
  top: 15%;
  bottom: 15%;
  border-radius: 50%;
  background: var(--color-border-subtle);
  pointer-events: none;
`;
const $85900dfd3a8d68a9$var$PadDot = (0, $lmFrL.default).div`
  position: absolute;
  width: 16px;
  height: 16px;
  margin-left: -8px;
  margin-top: -8px;
  border-radius: 50%;
  background: ${(p)=>p.$inactive ? "var(--color-text-muted, #999)" : "var(--color-warn)"};
  border: 2px solid var(--color-text);
  opacity: ${(p)=>p.$inactive ? 0.6 : 1};
  z-index: ${(p)=>p.$inactive ? 1 : 2};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
  pointer-events: none;
`;
const $85900dfd3a8d68a9$var$MiniButton = (0, $lmFrL.default).button`
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  font-size: 11px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var $85900dfd3a8d68a9$export$2e2bcd8739ae039 = $85900dfd3a8d68a9$var$LightingEditor;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");
const $5507f8043745c309$var$PANEL_MAX_WIDTH = 420;
// Shared card shell for in-app UI surfaces. Below TABLET the floating
// chrome dissolves into a full-width strip with a single border-top.
function $5507f8043745c309$var$Panel({ children: children, className: className, style: style }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5507f8043745c309$var$Wrapper, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5507f8043745c309$var$Interior, {
            className: className,
            style: style,
            children: children
        })
    });
}
const $5507f8043745c309$var$Interior = (0, $lmFrL.default).div`
  position: relative;
  background-color: var(--color-orange-100);
  border-radius: 6px;
  border: 1px solid var(--color-orange-300);
  width: 380px;
  height: 200px;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    width: 100%;
    max-width: ${$5507f8043745c309$var$PANEL_MAX_WIDTH}px;
    height: 200px;
    border: none;
    /* border-right: 1px solid var(--color-orange-300); */
    border-radius: 0;
    padding: 12px 0;
  }

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    height: 160px;
    padding: 4px 0;
  }
`;
// At and below TABLET the cream chrome stays edge-to-edge (continuous
// with the toolbar's cream backdrop in col 1) while the Interior is
// constrained and centered.
const $5507f8043745c309$var$Wrapper = (0, $lmFrL.default).div`
  padding: 8px;
  box-shadow: var(--surface-box-shadow-strong);
  background-color: var(--color-orange-100);
  border-radius: 8px;
  position: relative;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    width: 100%;
    padding: 0;
    box-shadow: none;
    border-radius: 0;
    border-top: 1px solid var(--color-orange-300);
    display: flex;
    justify-content: center;
  }
`;
var $5507f8043745c309$export$2e2bcd8739ae039 = $5507f8043745c309$var$Panel;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6Qnxw = parcelRequire("6Qnxw");

var $lmFrL = parcelRequire("lmFrL");
// Anchor (not Trigger) so callers keep full control of their button's onClick:
// pen-click selects-tool-or-opens-popover, Marc-click toggles-visibility-or-
// opens-opacity, etc. Trigger would call onOpenChange on every click and
// double-toggle our externally-controlled state. Open state is therefore fully
// owned by the caller; Radix only ever calls onOpenChange(false) (Escape,
// click-outside).
function $0439259ca7ccea8d$var$ToolPopover({ open: open, onOpenChange: onOpenChange, trigger: trigger, side: side = "top", align: align = "start", sideOffset: sideOffset = 8, autoFocusOnOpen: autoFocusOnOpen = false, lockOpen: // While true, swallow outside-pointerdown so the popover doesn't
// close. Used by ColorEditor's eyedropper session — clicking the marc
// photo to pick a color must commit AND keep the editor open.
lockOpen = false, children: children }) {
    // Ref the trigger DOM node so the outside-pointer-down handler can detect
    // clicks on our own anchor and skip closing — otherwise Radix closes on
    // pointerdown and the anchor's onClick reopens on the same gesture.
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const triggerWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(trigger, {
        ref: anchorRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($6Qnxw.Root, {
        open: open,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6Qnxw.Anchor, {
                asChild: true,
                children: triggerWithRef
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6Qnxw.Portal, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($0439259ca7ccea8d$var$Content, {
                    side: side,
                    align: align,
                    sideOffset: sideOffset,
                    onOpenAutoFocus: (e)=>{
                        // Default: don't steal focus on open — popovers are usually opened
                        // from a click on the canvas-adjacent toolbar and the user wants
                        // their pointer/typing focus to stay where it was. Hotkey-opened
                        // popovers opt in so the slider thumb gets focus and arrow keys
                        // can drive it without an extra click.
                        if (!autoFocusOnOpen) e.preventDefault();
                    },
                    onPointerDownOutside: (e)=>{
                        const target = e.detail.originalEvent.target;
                        if (anchorRef.current && anchorRef.current.contains(target)) {
                            e.preventDefault();
                            return;
                        }
                        if (lockOpen) e.preventDefault();
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($0439259ca7ccea8d$var$ContentInner, {
                        children: children
                    })
                })
            })
        ]
    });
}
// onOpenAutoFocus prevented: tool hotkeys (q/w/e/1-6/m) are global and would
// be eaten by an auto-focused range input inside the popover.
const $0439259ca7ccea8d$var$Content = (0, $lmFrL.default)($6Qnxw.Content)`
  min-width: 220px;
  padding: 4px;
  background: var(--color-surface);
  /* border: 1px solid var(--color-border); */
  border-radius: 6px;
  box-shadow: var(--surface-box-shadow-strong);
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 20;
`;
const $0439259ca7ccea8d$var$ContentInner = (0, $lmFrL.default).div`
  border: 1px solid var(--color-orange-300);
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
var $0439259ca7ccea8d$export$2e2bcd8739ae039 = $0439259ca7ccea8d$var$ToolPopover;





// Author panel buttons are uniformly small + internal. Local wrapper so call
// sites don't have to repeat the props seven times. Spread order means
// callers can still override (e.g. Save → variant="primary").
const $d41632e1035022ac$var$AuthorButton = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
        size: "small",
        variant: "internal",
        ...props
    });
function $d41632e1035022ac$var$AuthorToolbar({ authoring: authoring, saveDisabled: saveDisabled }) {
    const { marcVisible: marcVisible, setMarcVisible: setMarcVisible, marcOpacity: marcOpacity, setMarcOpacity: setMarcOpacity, marcTransformMode: marcTransformMode, setMarcTransformMode: setMarcTransformMode, eggTransform: eggTransform, setEggTransform: setEggTransform, eggTransformMode: eggTransformMode, setEggTransformMode: setEggTransformMode, resetMarcTransform: resetMarcTransform, eggLights: eggLights, setEggLights: setEggLights, resetEggLights: resetEggLights, eggWarmth: eggWarmth, setEggWarmth: onEggWarmthChange, eggRedshift: eggRedshift, setEggRedshift: onEggRedshiftChange, save: onSave } = authoring;
    const onToggleMarc = ()=>setMarcVisible((v)=>!v);
    const onToggleMarcTransform = ()=>setMarcTransformMode((v)=>!v);
    const onToggleEggTransform = ()=>setEggTransformMode((v)=>!v);
    // Single-field updates: keeps the other eggTransform fields intact while
    // a slider drives one of them.
    const updateEgg = (field, value)=>setEggTransform({
            ...eggTransform,
            [field]: value
        });
    const resetEggField = (field)=>setEggTransform({
            ...eggTransform,
            [field]: (0, $7Yi7V.DEFAULT_EGG_TRANSFORM)[field]
        });
    const resetEggPosition = ()=>setEggTransform({
            ...eggTransform,
            tx: (0, $7Yi7V.DEFAULT_EGG_TRANSFORM).tx,
            ty: (0, $7Yi7V.DEFAULT_EGG_TRANSFORM).ty
        });
    const [openPopover, setOpenPopover] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Trigger button label: total intensity across all lights, so two lights
    // at 30 + 70 reads "Lights 100" (matches the visual brightness budget the
    // author is composing). The popover body itself is the shared
    // LightingEditor — it owns its own activeLight state.
    const totalIntensityPct = Math.round((Array.isArray(eggLights) ? eggLights : []).reduce((sum, L)=>sum + (L?.intensity ?? 0), 0) * 100);
    const togglePopover = (key)=>{
        setOpenPopover((p)=>p === key ? null : key);
    };
    // Radix only calls this with `false` (Escape, click-outside) since we drive
    // open via Anchor + caller state, not Trigger.
    const closeIfRequested = (open)=>{
        if (!open) setOpenPopover(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5507f8043745c309$export$2e2bcd8739ae039), {
        style: {
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            padding: "10px 16px",
            gap: "6px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Label, {
                children: "Author Mode"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$MiniRow, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "marc-opacity",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: marcVisible,
                            onClick: ()=>{
                                if (marcVisible) togglePopover("marc-opacity");
                                else {
                                    onToggleMarc();
                                    setOpenPopover(null);
                                }
                            },
                            title: "Toggle Marc onion (m) \xb7 click again to set opacity",
                            children: marcVisible ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "Marc ",
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$Num, {
                                        children: [
                                            Math.round(marcOpacity * 100),
                                            "%"
                                        ]
                                    })
                                ]
                            }) : "Show Marc"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Opacity \xb7 ",
                                    Math.round(marcOpacity * 100),
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 0,
                                max: 100,
                                value: Math.round(marcOpacity * 100),
                                onValueChange: (v)=>setMarcOpacity(v / 100),
                                ariaLabel: "Marc opacity"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniRow, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                    type: "button",
                                    onClick: onToggleMarc,
                                    children: "Hide Marc (m)"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$AuthorButton, {
                        type: "button",
                        $active: marcTransformMode,
                        onClick: onToggleMarcTransform,
                        disabled: !marcVisible,
                        title: "Enable drag/rotate/scale on Marc",
                        children: "Transform"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$AuthorButton, {
                        type: "button",
                        $active: eggTransformMode,
                        onClick: onToggleEggTransform,
                        title: "Drag the egg to reposition it",
                        children: "Move Egg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$MiniRow, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-rot",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-rot",
                            onClick: ()=>togglePopover("egg-rot"),
                            title: "Rotate egg",
                            children: [
                                "Rot ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: $d41632e1035022ac$var$formatDeg(eggTransform.rotation)
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Rotation \xb7 ",
                                    $d41632e1035022ac$var$formatDeg(eggTransform.rotation)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: -90,
                                max: 90,
                                value: eggTransform.rotation,
                                onValueChange: (v)=>updateEgg("rotation", v),
                                ariaLabel: "Egg rotation"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$MiniRow, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                        type: "button",
                                        onClick: ()=>resetEggField("rotation"),
                                        children: "Reset"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                        type: "button",
                                        onClick: resetEggPosition,
                                        children: "Reset Position"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                        type: "button",
                                        onClick: resetMarcTransform,
                                        children: "Reset Marc"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-scale",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-scale",
                            onClick: ()=>togglePopover("egg-scale"),
                            title: "Scale egg",
                            children: [
                                "Scale ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: $d41632e1035022ac$var$formatPct(eggTransform.scale)
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Scale \xb7 ",
                                    $d41632e1035022ac$var$formatPct(eggTransform.scale)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 50,
                                max: 200,
                                value: Math.round((eggTransform.scale ?? 1) * 100),
                                onValueChange: (v)=>updateEgg("scale", v / 100),
                                ariaLabel: "Egg scale"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniRow, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                    type: "button",
                                    onClick: ()=>resetEggField("scale"),
                                    children: "Reset"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-scalex",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-scalex",
                            onClick: ()=>togglePopover("egg-scalex"),
                            title: "Horizontal squish \u2014 makes the egg read more head-shaped",
                            children: [
                                "Width ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: $d41632e1035022ac$var$formatPct(eggTransform.scaleX)
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Width \xb7 ",
                                    $d41632e1035022ac$var$formatPct(eggTransform.scaleX)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 50,
                                max: 150,
                                value: Math.round((eggTransform.scaleX ?? 1) * 100),
                                onValueChange: (v)=>updateEgg("scaleX", v / 100),
                                ariaLabel: "Egg width"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniRow, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                    type: "button",
                                    onClick: ()=>resetEggField("scaleX"),
                                    children: "Reset"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$MiniRow, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-warmth",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-warmth",
                            onClick: ()=>togglePopover("egg-warmth"),
                            title: "Warm tint applied to the egg photo (global, persisted to localStorage)",
                            children: [
                                "Warmth ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: eggWarmth
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Warmth \xb7 ",
                                    eggWarmth
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 0,
                                max: 100,
                                value: eggWarmth,
                                onValueChange: onEggWarmthChange,
                                ariaLabel: "Egg warmth"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniRow, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                    type: "button",
                                    onClick: ()=>onEggWarmthChange(0),
                                    children: "Reset"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-redshift",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-redshift",
                            onClick: ()=>togglePopover("egg-redshift"),
                            title: "Red bias on top of warmth \u2014 for marcs whose face reads flushed/red",
                            children: [
                                "Red ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: eggRedshift
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$PopLabel, {
                                children: [
                                    "Redshift \xb7 ",
                                    eggRedshift
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 0,
                                max: 100,
                                value: eggRedshift,
                                onValueChange: onEggRedshiftChange,
                                ariaLabel: "Egg redshift"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniRow, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$MiniButton, {
                                    type: "button",
                                    onClick: ()=>onEggRedshiftChange(0),
                                    children: "Reset"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "egg-light",
                        onOpenChange: closeIfRequested,
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($d41632e1035022ac$var$AuthorButton, {
                            type: "button",
                            $active: openPopover === "egg-light",
                            onClick: ()=>togglePopover("egg-light"),
                            title: "Per-marc lighting \u2014 stack multiple lights (key + fill, etc.). Each tab edits one light independently.",
                            children: [
                                "Lights ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d41632e1035022ac$var$Num, {
                                    children: totalIntensityPct
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85900dfd3a8d68a9$export$2e2bcd8739ae039), {
                            lights: Array.isArray(eggLights) ? eggLights : [],
                            setLights: setEggLights,
                            onResetAll: resetEggLights
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
                type: "button",
                size: "small",
                variant: "primary",
                onClick: onSave,
                disabled: saveDisabled,
                children: "Save"
            })
        ]
    });
}
function $d41632e1035022ac$var$formatDeg(n) {
    return `${Math.round(n)}\xb0`;
}
function $d41632e1035022ac$var$formatPct(n) {
    return `${Math.round((n ?? 1) * 100)}%`;
}
const $d41632e1035022ac$var$Label = (0, $lmFrL.default).span`
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-warn);
`;
const $d41632e1035022ac$var$Num = (0, $lmFrL.default).span`
  display: inline-block;
  min-width: 40px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  opacity: 0.85;
`;
const $d41632e1035022ac$var$PopLabel = (0, $lmFrL.default).div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
`;
const $d41632e1035022ac$var$MiniRow = (0, $lmFrL.default).div`
  display: flex;
  gap: 6px;
`;
const $d41632e1035022ac$var$MiniButton = (0, $lmFrL.default).button`
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  font-size: 11px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
var $d41632e1035022ac$export$2e2bcd8739ae039 = $d41632e1035022ac$var$AuthorToolbar;





var $5Ykzn = parcelRequire("5Ykzn");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $8edc56e88ba0e3ae$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M228,48V96a12,12,0,0,1-12,12H168a12,12,0,0,1,0-24h19l-7.8-7.8a75.55,75.55,0,0,0-53.32-22.26h-.43A75.49,75.49,0,0,0,72.39,75.57,12,12,0,1,1,55.61,58.41a99.38,99.38,0,0,1,69.87-28.47H126A99.42,99.42,0,0,1,196.2,59.23L204,67V48a12,12,0,0,1,24,0ZM183.61,180.43a75.49,75.49,0,0,1-53.09,21.63h-.43A75.55,75.55,0,0,1,76.77,179.8L69,172H88a12,12,0,0,0,0-24H40a12,12,0,0,0-12,12v48a12,12,0,0,0,24,0V189l7.8,7.8A99.42,99.42,0,0,0,130,226.06h.56a99.38,99.38,0,0,0,69.87-28.47,12,12,0,0,0-16.78-17.16Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,48V96a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h28.69L182.06,73.37a79.56,79.56,0,0,0-56.13-23.43h-.45A79.52,79.52,0,0,0,69.59,72.71,8,8,0,0,1,58.41,61.27a96,96,0,0,1,135,.79L208,76.69V48a8,8,0,0,1,16,0ZM186.41,183.29a80,80,0,0,1-112.47-.66L59.31,168H88a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V179.31l14.63,14.63A95.43,95.43,0,0,0,130,222.06h.53a95.36,95.36,0,0,0,67.07-27.33,8,8,0,0,0-11.18-11.44Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,48V96a8,8,0,0,1-8,8H168a8,8,0,0,1-5.66-13.66L180.65,72a79.48,79.48,0,0,0-54.72-22.09h-.45A79.52,79.52,0,0,0,69.59,72.71,8,8,0,0,1,58.41,61.27,96,96,0,0,1,192,60.7l18.36-18.36A8,8,0,0,1,224,48ZM186.41,183.29A80,80,0,0,1,75.35,184l18.31-18.31A8,8,0,0,0,88,152H40a8,8,0,0,0-8,8v48a8,8,0,0,0,13.66,5.66L64,195.3a95.42,95.42,0,0,0,66,26.76h.53a95.36,95.36,0,0,0,67.07-27.33,8,8,0,0,0-11.18-11.44Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M222,48V96a6,6,0,0,1-6,6H168a6,6,0,0,1,0-12h33.52L183.47,72a81.51,81.51,0,0,0-57.53-24h-.46A81.5,81.5,0,0,0,68.19,71.28a6,6,0,1,1-8.38-8.58,93.38,93.38,0,0,1,65.67-26.76H126a93.45,93.45,0,0,1,66,27.53l18,18V48a6,6,0,0,1,12,0ZM187.81,184.72a81.5,81.5,0,0,1-57.29,23.34h-.46a81.51,81.51,0,0,1-57.53-24L54.48,166H88a6,6,0,0,0,0-12H40a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V174.48l18,18.05a93.45,93.45,0,0,0,66,27.53h.52a93.38,93.38,0,0,0,65.67-26.76,6,6,0,1,0-8.38-8.58Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,48V96a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h28.69L182.06,73.37a79.56,79.56,0,0,0-56.13-23.43h-.45A79.52,79.52,0,0,0,69.59,72.71,8,8,0,0,1,58.41,61.27a96,96,0,0,1,135,.79L208,76.69V48a8,8,0,0,1,16,0ZM186.41,183.29a80,80,0,0,1-112.47-.66L59.31,168H88a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V179.31l14.63,14.63A95.43,95.43,0,0,0,130,222.06h.53a95.36,95.36,0,0,0,67.07-27.33,8,8,0,0,0-11.18-11.44Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M220,48V96a4,4,0,0,1-4,4H168a4,4,0,0,1,0-8h38.34L184.89,70.54A84,84,0,0,0,66.8,69.85a4,4,0,1,1-5.6-5.72,92,92,0,0,1,129.34.76L212,86.34V48a4,4,0,0,1,8,0ZM189.2,186.15a83.44,83.44,0,0,1-58.68,23.91h-.47a83.52,83.52,0,0,1-58.94-24.6L49.66,164H88a4,4,0,0,0,0-8H40a4,4,0,0,0-4,4v48a4,4,0,0,0,8,0V169.66l21.46,21.45A91.43,91.43,0,0,0,130,218.06h.51a91.45,91.45,0,0,0,64.28-26.19,4,4,0,1,0-5.6-5.72Z"
        }))
    ]
]);


const $fffcb848af99c7fe$export$3fd18ba16eaf26dd = $acw62.forwardRef((e, s)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: s,
        ...e,
        weights: (0, $8edc56e88ba0e3ae$export$2e2bcd8739ae039)
    }));
$fffcb848af99c7fe$export$3fd18ba16eaf26dd.displayName = "ArrowsClockwiseIcon";
const $fffcb848af99c7fe$export$e23b03e3f30df91f = $fffcb848af99c7fe$export$3fd18ba16eaf26dd;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $3181a191aed49e63$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M180,232a12,12,0,0,1-12,12H88a12,12,0,0,1,0-24h80A12,12,0,0,1,180,232Zm40-128a91.51,91.51,0,0,1-35.17,72.35A12.26,12.26,0,0,0,180,186v2a20,20,0,0,1-20,20H96a20,20,0,0,1-20-20v-2a12,12,0,0,0-4.7-9.51A91.57,91.57,0,0,1,36,104.52C35.73,54.69,76,13.2,125.79,12A92,92,0,0,1,220,104Zm-24,0a68,68,0,0,0-69.65-68C89.56,36.88,59.8,67.55,60,104.38a67.71,67.71,0,0,0,26.1,53.19A35.87,35.87,0,0,1,100,184h56.1A36.13,36.13,0,0,1,170,157.49,67.68,67.68,0,0,0,196,104Zm-20.07-5.32a48.5,48.5,0,0,0-31.91-40,12,12,0,0,0-8,22.62,24.31,24.31,0,0,1,16.09,20,12,12,0,0,0,23.86-2.64Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M208,104a79.86,79.86,0,0,1-30.59,62.92A24.29,24.29,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6a24.11,24.11,0,0,0-9.3-19A79.87,79.87,0,0,1,48,104.45C47.76,61.09,82.72,25,126.07,24A80,80,0,0,1,208,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-32.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M174,232a6,6,0,0,1-6,6H88a6,6,0,0,1,0-12h80A6,6,0,0,1,174,232Zm40-128a85.56,85.56,0,0,1-32.88,67.64A18.23,18.23,0,0,0,174,186v6a14,14,0,0,1-14,14H96a14,14,0,0,1-14-14v-6a18,18,0,0,0-7-14.23h0a85.59,85.59,0,0,1-33-67.24C41.74,57.91,79.39,19.12,125.93,18A86,86,0,0,1,214,104Zm-12,0a74,74,0,0,0-75.79-74C86.17,31,53.78,64.34,54,104.42a73.67,73.67,0,0,0,28.4,57.87A29.92,29.92,0,0,1,94,186v6a2,2,0,0,0,2,2h64a2,2,0,0,0,2-2v-6a30.18,30.18,0,0,1,11.7-23.78A73.59,73.59,0,0,0,202,104Zm-20.08-9A55.58,55.58,0,0,0,137,50.08a6,6,0,1,0-2,11.84C152.38,64.84,167.13,79.6,170.08,97a6,6,0,0,0,5.91,5,6.87,6.87,0,0,0,1-.08A6,6,0,0,0,181.92,95Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M172,232a4,4,0,0,1-4,4H88a4,4,0,0,1,0-8h80A4,4,0,0,1,172,232Zm40-128a83.59,83.59,0,0,1-32.11,66.06A20.2,20.2,0,0,0,172,186v6a12,12,0,0,1-12,12H96a12,12,0,0,1-12-12v-6a20,20,0,0,0-7.76-15.81A83.58,83.58,0,0,1,44,104.47C43.75,59,80.52,21.09,126,20a84,84,0,0,1,86,84Zm-8,0a76,76,0,0,0-77.83-76C85,29,51.77,63.27,52,104.43a75.62,75.62,0,0,0,29.17,59.43A28,28,0,0,1,92,186v6a4,4,0,0,0,4,4h64a4,4,0,0,0,4-4v-6a28.14,28.14,0,0,1,10.94-22.2A75.62,75.62,0,0,0,204,104ZM136.66,52.06a4,4,0,0,0-1.32,7.88C153.53,63,169,78.45,172.06,96.67A4,4,0,0,0,176,100a3.88,3.88,0,0,0,.67-.06,4,4,0,0,0,3.27-4.61A53.51,53.51,0,0,0,136.66,52.06Z"
        }))
    ]
]);


const $7d102ee67d39f7c9$export$7ceaccb4ac404f2d = $acw62.forwardRef((e, r)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: r,
        ...e,
        weights: (0, $3181a191aed49e63$export$2e2bcd8739ae039)
    }));
$7d102ee67d39f7c9$export$7ceaccb4ac404f2d.displayName = "LightbulbIcon";
const $7d102ee67d39f7c9$export$3d88f82d313e52c = $7d102ee67d39f7c9$export$7ceaccb4ac404f2d;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $f46dfb5b1ef5acc0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,156a43.78,43.78,0,0,0-29.09,11L106.1,140.8a44.07,44.07,0,0,0,0-25.6L146.91,89a43.83,43.83,0,1,0-13-20.17L93.09,95a44,44,0,1,0,0,65.94L133.9,187.2A44,44,0,1,0,176,156Zm0-120a20,20,0,1,1-20,20A20,20,0,0,1,176,36ZM64,148a20,20,0,1,1,20-20A20,20,0,0,1,64,148Zm112,72a20,20,0,1,1,20-20A20,20,0,0,1,176,220Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M208,200a32,32,0,1,1-32-32A32,32,0,0,1,208,200ZM176,88a32,32,0,1,0-32-32A32,32,0,0,0,176,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,160a39.89,39.89,0,0,0-28.62,12.09l-46.1-29.63a39.8,39.8,0,0,0,0-28.92l46.1-29.63a40,40,0,1,0-8.66-13.45l-46.1,29.63a40,40,0,1,0,0,55.82l46.1,29.63A40,40,0,1,0,176,160Zm0-128a24,24,0,1,1-24,24A24,24,0,0,1,176,32ZM64,152a24,24,0,1,1,24-24A24,24,0,0,1,64,152Zm112,72a24,24,0,1,1,24-24A24,24,0,0,1,176,224Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M212,200a36,36,0,1,1-69.85-12.25l-53-34.05a36,36,0,1,1,0-51.4l53-34a36.09,36.09,0,1,1,8.67,13.45l-53,34.05a36,36,0,0,1,0,24.5l53,34.05A36,36,0,0,1,212,200Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,162a37.91,37.91,0,0,0-28.3,12.67L98.8,143.24a37.89,37.89,0,0,0,0-30.48l48.9-31.43a38,38,0,1,0-6.5-10.09L92.3,102.67a38,38,0,1,0,0,50.66l48.9,31.43A38,38,0,1,0,176,162Zm0-132a26,26,0,1,1-26,26A26,26,0,0,1,176,30ZM64,154a26,26,0,1,1,26-26A26,26,0,0,1,64,154Zm112,72a26,26,0,1,1,26-26A26,26,0,0,1,176,226Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,160a39.89,39.89,0,0,0-28.62,12.09l-46.1-29.63a39.8,39.8,0,0,0,0-28.92l46.1-29.63a40,40,0,1,0-8.66-13.45l-46.1,29.63a40,40,0,1,0,0,55.82l46.1,29.63A40,40,0,1,0,176,160Zm0-128a24,24,0,1,1-24,24A24,24,0,0,1,176,32ZM64,152a24,24,0,1,1,24-24A24,24,0,0,1,64,152Zm112,72a24,24,0,1,1,24-24A24,24,0,0,1,176,224Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M176,164a36,36,0,0,0-27.92,13.3L96.25,144a35.92,35.92,0,0,0,0-32L148.08,78.7A35.93,35.93,0,1,0,143.75,72L91.92,105.3a36,36,0,1,0,0,45.4L143.75,184A36,36,0,1,0,176,164Zm0-136a28,28,0,1,1-28,28A28,28,0,0,1,176,28ZM64,156a28,28,0,1,1,28-28A28,28,0,0,1,64,156Zm112,72a28,28,0,1,1,28-28A28,28,0,0,1,176,228Z"
        }))
    ]
]);


const $358642fbc699ef49$export$4e6df255ea06b543 = $acw62.forwardRef((r, t)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: t,
        ...r,
        weights: (0, $f46dfb5b1ef5acc0$export$2e2bcd8739ae039)
    }));
$358642fbc699ef49$export$4e6df255ea06b543.displayName = "ShareNetworkIcon";
const $358642fbc699ef49$export$ee62305a5b7a42eb = $358642fbc699ef49$export$4e6df255ea06b543;




var $e4LUm = parcelRequire("e4LUm");

var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");
function $eb158f4d61a7e273$export$2e2bcd8739ae039() {
    const query = `(max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px)`;
    const [match, setMatch] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>typeof window !== "undefined" ? window.matchMedia(query).matches : false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const mql = window.matchMedia(query);
        const onChange = ()=>setMatch(mql.matches);
        onChange();
        mql.addEventListener("change", onChange);
        return ()=>mql.removeEventListener("change", onChange);
    }, [
        query
    ]);
    return match;
}



var $4cvDM = parcelRequire("4cvDM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $498ba2dab0ae91e7$var$u() {
    return ($498ba2dab0ae91e7$var$u = Object.assign || function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }).apply(this, arguments);
}
function $498ba2dab0ae91e7$var$c(e, r) {
    if (null == e) return {};
    var t, n, o = {}, a = Object.keys(e);
    for(n = 0; n < a.length; n++)r.indexOf(t = a[n]) >= 0 || (o[t] = e[t]);
    return o;
}
function $498ba2dab0ae91e7$var$i(e) {
    var t = (0, $acw62.useRef)(e), n = (0, $acw62.useRef)(function(e) {
        t.current && t.current(e);
    });
    return t.current = e, n.current;
}
var $498ba2dab0ae91e7$var$s = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = 1), e > t ? t : e < r ? r : e;
}, $498ba2dab0ae91e7$var$f = function(e) {
    return "touches" in e;
}, $498ba2dab0ae91e7$var$v = function(e) {
    return e && e.ownerDocument.defaultView || self;
}, $498ba2dab0ae91e7$var$d = function(e, r, t) {
    var n = e.getBoundingClientRect(), o = $498ba2dab0ae91e7$var$f(r) ? function(e, r) {
        for(var t = 0; t < e.length; t++)if (e[t].identifier === r) return e[t];
        return e[0];
    }(r.touches, t) : r;
    return {
        left: $498ba2dab0ae91e7$var$s((o.pageX - (n.left + $498ba2dab0ae91e7$var$v(e).pageXOffset)) / n.width),
        top: $498ba2dab0ae91e7$var$s((o.pageY - (n.top + $498ba2dab0ae91e7$var$v(e).pageYOffset)) / n.height)
    };
}, $498ba2dab0ae91e7$var$h = function(e) {
    !$498ba2dab0ae91e7$var$f(e) && e.preventDefault();
}, $498ba2dab0ae91e7$var$m = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(o) {
    var a = o.onMove, l = o.onKey, s = $498ba2dab0ae91e7$var$c(o, [
        "onMove",
        "onKey"
    ]), m = (0, $acw62.useRef)(null), g = $498ba2dab0ae91e7$var$i(a), p = $498ba2dab0ae91e7$var$i(l), b = (0, $acw62.useRef)(null), _ = (0, $acw62.useRef)(!1), x = (0, $acw62.useMemo)(function() {
        var e = function(e) {
            $498ba2dab0ae91e7$var$h(e), ($498ba2dab0ae91e7$var$f(e) ? e.touches.length > 0 : e.buttons > 0) && m.current ? g($498ba2dab0ae91e7$var$d(m.current, e, b.current)) : t(!1);
        }, r = function() {
            return t(!1);
        };
        function t(t) {
            var n = _.current, o = $498ba2dab0ae91e7$var$v(m.current), a = t ? o.addEventListener : o.removeEventListener;
            a(n ? "touchmove" : "mousemove", e), a(n ? "touchend" : "mouseup", r);
        }
        return [
            function(e) {
                var r = e.nativeEvent, n = m.current;
                if (n && ($498ba2dab0ae91e7$var$h(r), !function(e, r) {
                    return r && !$498ba2dab0ae91e7$var$f(e);
                }(r, _.current) && n)) {
                    if ($498ba2dab0ae91e7$var$f(r)) {
                        _.current = !0;
                        var o = r.changedTouches || [];
                        o.length && (b.current = o[0].identifier);
                    }
                    n.focus(), g($498ba2dab0ae91e7$var$d(n, r, b.current)), t(!0);
                }
            },
            function(e) {
                var r = e.which || e.keyCode;
                r < 37 || r > 40 || (e.preventDefault(), p({
                    left: 39 === r ? .05 : 37 === r ? -0.05 : 0,
                    top: 40 === r ? .05 : 38 === r ? -0.05 : 0
                }));
            },
            t
        ];
    }, [
        p,
        g
    ]), C = x[0], E = x[1], H = x[2];
    return (0, $acw62.useEffect)(function() {
        return H;
    }, [
        H
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        onTouchStart: C,
        onMouseDown: C,
        className: "react-colorful__interactive",
        ref: m,
        onKeyDown: E,
        tabIndex: 0,
        role: "slider"
    }));
}), $498ba2dab0ae91e7$var$g = function(e) {
    return e.filter(Boolean).join(" ");
}, $498ba2dab0ae91e7$var$p = function(r) {
    var t = r.color, n = r.left, o = r.top, a = void 0 === o ? .5 : o, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__pointer",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l,
        style: {
            top: 100 * a + "%",
            left: 100 * n + "%"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__pointer-fill",
        style: {
            backgroundColor: t
        }
    }));
}, $498ba2dab0ae91e7$var$b = function(e, r, t) {
    return void 0 === r && (r = 0), void 0 === t && (t = Math.pow(10, r)), Math.round(t * e) / t;
}, $498ba2dab0ae91e7$var$_ = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $498ba2dab0ae91e7$var$x = function(e) {
    return $498ba2dab0ae91e7$var$L($498ba2dab0ae91e7$var$C(e));
}, $498ba2dab0ae91e7$var$C = function(e) {
    return "#" === e[0] && (e = e.substring(1)), e.length < 6 ? {
        r: parseInt(e[0] + e[0], 16),
        g: parseInt(e[1] + e[1], 16),
        b: parseInt(e[2] + e[2], 16),
        a: 4 === e.length ? $498ba2dab0ae91e7$var$b(parseInt(e[3] + e[3], 16) / 255, 2) : 1
    } : {
        r: parseInt(e.substring(0, 2), 16),
        g: parseInt(e.substring(2, 4), 16),
        b: parseInt(e.substring(4, 6), 16),
        a: 8 === e.length ? $498ba2dab0ae91e7$var$b(parseInt(e.substring(6, 8), 16) / 255, 2) : 1
    };
}, $498ba2dab0ae91e7$var$E = function(e, r) {
    return void 0 === r && (r = "deg"), Number(e) * ($498ba2dab0ae91e7$var$_[r] || 1);
}, $498ba2dab0ae91e7$var$H = function(e) {
    var r = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$N({
        h: $498ba2dab0ae91e7$var$E(r[1], r[2]),
        s: Number(r[3]),
        l: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$M = $498ba2dab0ae91e7$var$H, $498ba2dab0ae91e7$var$N = function(e) {
    var r = e.s, t = e.l;
    return {
        h: e.h,
        s: (r *= (t < 50 ? t : 100 - t) / 100) > 0 ? 2 * r / (t + r) * 100 : 0,
        v: t + r,
        a: e.a
    };
}, $498ba2dab0ae91e7$var$w = function(e) {
    return $498ba2dab0ae91e7$var$K($498ba2dab0ae91e7$var$I(e));
}, $498ba2dab0ae91e7$var$y = function(e) {
    var r = e.s, t = e.v, n = e.a, o = (200 - r) * t / 100;
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(o > 0 && o < 200 ? r * t / 100 / (o <= 100 ? o : 200 - o) * 100 : 0),
        l: $498ba2dab0ae91e7$var$b(o / 2),
        a: $498ba2dab0ae91e7$var$b(n, 2)
    };
}, $498ba2dab0ae91e7$var$q = function(e) {
    var r = $498ba2dab0ae91e7$var$y(e);
    return "hsl(" + r.h + ", " + r.s + "%, " + r.l + "%)";
}, $498ba2dab0ae91e7$var$k = function(e) {
    var r = $498ba2dab0ae91e7$var$y(e);
    return "hsla(" + r.h + ", " + r.s + "%, " + r.l + "%, " + r.a + ")";
}, $498ba2dab0ae91e7$var$I = function(e) {
    var r = e.h, t = e.s, n = e.v, o = e.a;
    r = r / 360 * 6, t /= 100, n /= 100;
    var a = Math.floor(r), l = n * (1 - t), u = n * (1 - (r - a) * t), c = n * (1 - (1 - r + a) * t), i = a % 6;
    return {
        r: $498ba2dab0ae91e7$var$b(255 * [
            n,
            u,
            l,
            l,
            c,
            n
        ][i]),
        g: $498ba2dab0ae91e7$var$b(255 * [
            c,
            n,
            n,
            u,
            l,
            l
        ][i]),
        b: $498ba2dab0ae91e7$var$b(255 * [
            l,
            l,
            c,
            n,
            n,
            u
        ][i]),
        a: $498ba2dab0ae91e7$var$b(o, 2)
    };
}, $498ba2dab0ae91e7$var$O = function(e) {
    var r = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$A({
        h: $498ba2dab0ae91e7$var$E(r[1], r[2]),
        s: Number(r[3]),
        v: Number(r[4]),
        a: void 0 === r[5] ? 1 : Number(r[5]) / (r[6] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$j = $498ba2dab0ae91e7$var$O, $498ba2dab0ae91e7$var$z = function(e) {
    var r = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i.exec(e);
    return r ? $498ba2dab0ae91e7$var$L({
        r: Number(r[1]) / (r[2] ? 100 / 255 : 1),
        g: Number(r[3]) / (r[4] ? 100 / 255 : 1),
        b: Number(r[5]) / (r[6] ? 100 / 255 : 1),
        a: void 0 === r[7] ? 1 : Number(r[7]) / (r[8] ? 100 : 1)
    }) : {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    };
}, $498ba2dab0ae91e7$var$B = $498ba2dab0ae91e7$var$z, $498ba2dab0ae91e7$var$D = function(e) {
    var r = e.toString(16);
    return r.length < 2 ? "0" + r : r;
}, $498ba2dab0ae91e7$var$K = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = o < 1 ? $498ba2dab0ae91e7$var$D($498ba2dab0ae91e7$var$b(255 * o)) : "";
    return "#" + $498ba2dab0ae91e7$var$D(r) + $498ba2dab0ae91e7$var$D(t) + $498ba2dab0ae91e7$var$D(n) + a;
}, $498ba2dab0ae91e7$var$L = function(e) {
    var r = e.r, t = e.g, n = e.b, o = e.a, a = Math.max(r, t, n), l = a - Math.min(r, t, n), u = l ? a === r ? (t - n) / l : a === t ? 2 + (n - r) / l : 4 + (r - t) / l : 0;
    return {
        h: $498ba2dab0ae91e7$var$b(60 * (u < 0 ? u + 6 : u)),
        s: $498ba2dab0ae91e7$var$b(a ? l / a * 100 : 0),
        v: $498ba2dab0ae91e7$var$b(a / 255 * 100),
        a: o
    };
}, $498ba2dab0ae91e7$var$A = function(e) {
    return {
        h: $498ba2dab0ae91e7$var$b(e.h),
        s: $498ba2dab0ae91e7$var$b(e.s),
        v: $498ba2dab0ae91e7$var$b(e.v),
        a: $498ba2dab0ae91e7$var$b(e.a, 2)
    };
}, $498ba2dab0ae91e7$var$S = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hue, n = r.onChange, o = $498ba2dab0ae91e7$var$g([
        "react-colorful__hue",
        r.className
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                h: 360 * e.left
            });
        },
        onKey: function(e) {
            n({
                h: $498ba2dab0ae91e7$var$s(t + 360 * e.left, 0, 360)
            });
        },
        "aria-label": "Hue",
        "aria-valuenow": $498ba2dab0ae91e7$var$b(t),
        "aria-valuemax": "360",
        "aria-valuemin": "0"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__hue-pointer",
        left: t / 360,
        color: $498ba2dab0ae91e7$var$q({
            h: t,
            s: 100,
            v: 100,
            a: 1
        })
    })));
}), $498ba2dab0ae91e7$var$T = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(r) {
    var t = r.hsva, n = r.onChange, o = {
        backgroundColor: $498ba2dab0ae91e7$var$q({
            h: t.h,
            s: 100,
            v: 100,
            a: 1
        })
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__saturation",
        style: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            n({
                s: 100 * e.left,
                v: 100 - 100 * e.top
            });
        },
        onKey: function(e) {
            n({
                s: $498ba2dab0ae91e7$var$s(t.s + 100 * e.left, 0, 100),
                v: $498ba2dab0ae91e7$var$s(t.v - 100 * e.top, 0, 100)
            });
        },
        "aria-label": "Color",
        "aria-valuetext": "Saturation " + $498ba2dab0ae91e7$var$b(t.s) + "%, Brightness " + $498ba2dab0ae91e7$var$b(t.v) + "%"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__saturation-pointer",
        top: 1 - t.v / 100,
        left: t.s / 100,
        color: $498ba2dab0ae91e7$var$q(t)
    })));
}), $498ba2dab0ae91e7$var$F = function(e, r) {
    if (e === r) return !0;
    for(var t in e)if (e[t] !== r[t]) return !1;
    return !0;
}, $498ba2dab0ae91e7$var$P = function(e, r) {
    return e.replace(/\s/g, "") === r.replace(/\s/g, "");
}, $498ba2dab0ae91e7$var$X = function(e, r) {
    return e.toLowerCase() === r.toLowerCase() || $498ba2dab0ae91e7$var$F($498ba2dab0ae91e7$var$C(e), $498ba2dab0ae91e7$var$C(r));
};
function $498ba2dab0ae91e7$var$Y(e, t, l) {
    var u = $498ba2dab0ae91e7$var$i(l), c = (0, $acw62.useState)(function() {
        return e.toHsva(t);
    }), s = c[0], f = c[1], v = (0, $acw62.useRef)({
        color: t,
        hsva: s
    });
    (0, $acw62.useEffect)(function() {
        if (!e.equal(t, v.current.color)) {
            var r = e.toHsva(t);
            v.current = {
                hsva: r,
                color: t
            }, f(r);
        }
    }, [
        t,
        e
    ]), (0, $acw62.useEffect)(function() {
        var r;
        $498ba2dab0ae91e7$var$F(s, v.current.hsva) || e.equal(r = e.fromHsva(s), v.current.color) || (v.current = {
            hsva: s,
            color: r
        }, u(r));
    }, [
        s,
        e,
        u
    ]);
    var d = (0, $acw62.useCallback)(function(e) {
        f(function(r) {
            return Object.assign({}, r, e);
        });
    }, []);
    return [
        s,
        d
    ];
}
var $498ba2dab0ae91e7$var$R, $498ba2dab0ae91e7$var$V = "undefined" != typeof window ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect), $498ba2dab0ae91e7$var$$ = function() {
    return $498ba2dab0ae91e7$var$R || ("undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : void 0);
}, $498ba2dab0ae91e7$export$c5f670b24c0ae95a = function(e) {
    $498ba2dab0ae91e7$var$R = e;
}, $498ba2dab0ae91e7$var$J = new Map, $498ba2dab0ae91e7$var$Q = function(e) {
    $498ba2dab0ae91e7$var$V(function() {
        var r = e.current ? e.current.ownerDocument : document;
        if (void 0 !== r && !$498ba2dab0ae91e7$var$J.has(r)) {
            var t = r.createElement("style");
            t.innerHTML = '.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url(\'data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>\')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}', $498ba2dab0ae91e7$var$J.set(r, t);
            var n = $498ba2dab0ae91e7$var$$();
            n && t.setAttribute("nonce", n), r.head.appendChild(t);
        }
    }, []);
}, $498ba2dab0ae91e7$var$U = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$Q(f);
    var v = $498ba2dab0ae91e7$var$Y(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$S, {
        hue: d.h,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$W = {
    defaultColor: "000",
    toHsva: $498ba2dab0ae91e7$var$x,
    fromHsva: function(e) {
        return $498ba2dab0ae91e7$var$w({
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        });
    },
    equal: $498ba2dab0ae91e7$var$X
}, $498ba2dab0ae91e7$export$a3bc3c32746e9f3a = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$W
    }));
}, $498ba2dab0ae91e7$var$ee = function(r) {
    var t = r.className, n = r.hsva, o = r.onChange, a = {
        backgroundImage: "linear-gradient(90deg, " + $498ba2dab0ae91e7$var$k(Object.assign({}, n, {
            a: 0
        })) + ", " + $498ba2dab0ae91e7$var$k(Object.assign({}, n, {
            a: 1
        })) + ")"
    }, l = $498ba2dab0ae91e7$var$g([
        "react-colorful__alpha",
        t
    ]), u = $498ba2dab0ae91e7$var$b(100 * n.a);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "react-colorful__alpha-gradient",
        style: a
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$m, {
        onMove: function(e) {
            o({
                a: e.left
            });
        },
        onKey: function(e) {
            o({
                a: $498ba2dab0ae91e7$var$s(n.a + e.left)
            });
        },
        "aria-label": "Alpha",
        "aria-valuetext": u + "%",
        "aria-valuenow": u,
        "aria-valuemin": "0",
        "aria-valuemax": "100"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$p, {
        className: "react-colorful__alpha-pointer",
        left: n.a,
        color: $498ba2dab0ae91e7$var$k(n)
    })));
}, $498ba2dab0ae91e7$var$re = function(t) {
    var n = t.className, o = t.colorModel, a = t.color, l = void 0 === a ? o.defaultColor : a, i = t.onChange, s = $498ba2dab0ae91e7$var$c(t, [
        "className",
        "colorModel",
        "color",
        "onChange"
    ]), f = (0, $acw62.useRef)(null);
    $498ba2dab0ae91e7$var$Q(f);
    var v = $498ba2dab0ae91e7$var$Y(o, l, i), d = v[0], h = v[1], m = $498ba2dab0ae91e7$var$g([
        "react-colorful",
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $498ba2dab0ae91e7$var$u({}, s, {
        ref: f,
        className: m
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$T, {
        hsva: d,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$S, {
        hue: d.h,
        onChange: h
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$ee, {
        hsva: d,
        onChange: h,
        className: "react-colorful__last-control"
    }));
}, $498ba2dab0ae91e7$var$te = {
    defaultColor: "0001",
    toHsva: $498ba2dab0ae91e7$var$x,
    fromHsva: $498ba2dab0ae91e7$var$w,
    equal: $498ba2dab0ae91e7$var$X
}, $498ba2dab0ae91e7$export$ac2f77823341da45 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$te
    }));
}, $498ba2dab0ae91e7$var$oe = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$N,
    fromHsva: $498ba2dab0ae91e7$var$y,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$ee0b0fc8d408da1d = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$oe
    }));
}, $498ba2dab0ae91e7$var$le = {
    defaultColor: "hsla(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$H,
    fromHsva: $498ba2dab0ae91e7$var$k,
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$989f0248ad966033 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$le
    }));
}, $498ba2dab0ae91e7$var$ce = {
    defaultColor: {
        h: 0,
        s: 0,
        l: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$N({
            h: e.h,
            s: e.s,
            l: e.l,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            h: (r = $498ba2dab0ae91e7$var$y(e)).h,
            s: r.s,
            l: r.l
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$c737d6c85aab3af7 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ce
    }));
}, $498ba2dab0ae91e7$var$se = {
    defaultColor: "hsl(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$M,
    fromHsva: $498ba2dab0ae91e7$var$q,
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$f4f988c96ece960 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$se
    }));
}, $498ba2dab0ae91e7$var$ve = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0,
        a: 1
    },
    toHsva: function(e) {
        return e;
    },
    fromHsva: $498ba2dab0ae91e7$var$A,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$a2298f22bee4c5fd = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ve
    }));
}, $498ba2dab0ae91e7$var$he = {
    defaultColor: "hsva(0, 0%, 0%, 1)",
    toHsva: $498ba2dab0ae91e7$var$O,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return "hsva(" + r.h + ", " + r.s + "%, " + r.v + "%, " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$b2c7d62665b7ee26 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$he
    }));
}, $498ba2dab0ae91e7$var$ge = {
    defaultColor: {
        h: 0,
        s: 0,
        v: 0
    },
    toHsva: function(e) {
        return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: 1
        };
    },
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return {
            h: r.h,
            s: r.s,
            v: r.v
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$580e7249020ee39f = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$ge
    }));
}, $498ba2dab0ae91e7$var$be = {
    defaultColor: "hsv(0, 0%, 0%)",
    toHsva: $498ba2dab0ae91e7$var$j,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$A(e);
        return "hsv(" + r.h + ", " + r.s + "%, " + r.v + "%)";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$ef09412d0ef04fda = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$be
    }));
}, $498ba2dab0ae91e7$var$xe = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    },
    toHsva: $498ba2dab0ae91e7$var$L,
    fromHsva: $498ba2dab0ae91e7$var$I,
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$e9c07ef2be187cb1 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$xe
    }));
}, $498ba2dab0ae91e7$var$Ee = {
    defaultColor: "rgba(0, 0, 0, 1)",
    toHsva: $498ba2dab0ae91e7$var$z,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$I(e);
        return "rgba(" + r.r + ", " + r.g + ", " + r.b + ", " + r.a + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$be07dcc7abc11a36 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$re, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$Ee
    }));
}, $498ba2dab0ae91e7$var$Me = {
    defaultColor: {
        r: 0,
        g: 0,
        b: 0
    },
    toHsva: function(e) {
        return $498ba2dab0ae91e7$var$L({
            r: e.r,
            g: e.g,
            b: e.b,
            a: 1
        });
    },
    fromHsva: function(e) {
        var r;
        return {
            r: (r = $498ba2dab0ae91e7$var$I(e)).r,
            g: r.g,
            b: r.b
        };
    },
    equal: $498ba2dab0ae91e7$var$F
}, $498ba2dab0ae91e7$export$5ac2ba36722d4bd2 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$Me
    }));
}, $498ba2dab0ae91e7$var$we = {
    defaultColor: "rgb(0, 0, 0)",
    toHsva: $498ba2dab0ae91e7$var$B,
    fromHsva: function(e) {
        var r = $498ba2dab0ae91e7$var$I(e);
        return "rgb(" + r.r + ", " + r.g + ", " + r.b + ")";
    },
    equal: $498ba2dab0ae91e7$var$P
}, $498ba2dab0ae91e7$export$9d70f030bf44a214 = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$U, $498ba2dab0ae91e7$var$u({}, r, {
        colorModel: $498ba2dab0ae91e7$var$we
    }));
}, $498ba2dab0ae91e7$var$qe = /^#?([0-9A-F]{3,8})$/i, $498ba2dab0ae91e7$var$ke = function(r) {
    var t = r.color, l = void 0 === t ? "" : t, s = r.onChange, f = r.onBlur, v = r.escape, d = r.validate, h = r.format, m = r.process, g = $498ba2dab0ae91e7$var$c(r, [
        "color",
        "onChange",
        "onBlur",
        "escape",
        "validate",
        "format",
        "process"
    ]), p = (0, $acw62.useState)(function() {
        return v(l);
    }), b = p[0], _ = p[1], x = $498ba2dab0ae91e7$var$i(s), C = $498ba2dab0ae91e7$var$i(f), E = (0, $acw62.useCallback)(function(e) {
        var r = v(e.target.value);
        _(r), d(r) && x(m ? m(r) : r);
    }, [
        v,
        m,
        d,
        x
    ]), H = (0, $acw62.useCallback)(function(e) {
        d(e.target.value) || _(v(l)), C(e);
    }, [
        l,
        v,
        d,
        C
    ]);
    return (0, $acw62.useEffect)(function() {
        _(v(l));
    }, [
        l,
        v
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $498ba2dab0ae91e7$var$u({}, g, {
        value: h ? h(b) : b,
        spellCheck: "false",
        onChange: E,
        onBlur: H
    }));
}, $498ba2dab0ae91e7$var$Ie = function(e) {
    return "#" + e;
}, $498ba2dab0ae91e7$export$9219d762117624b6 = function(r) {
    var t = r.prefixed, n = r.alpha, o = $498ba2dab0ae91e7$var$c(r, [
        "prefixed",
        "alpha"
    ]), l = (0, $acw62.useCallback)(function(e) {
        return e.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
    }, [
        n
    ]), i = (0, $acw62.useCallback)(function(e) {
        return function(e, r) {
            var t = $498ba2dab0ae91e7$var$qe.exec(e), n = t ? t[1].length : 0;
            return 3 === n || 6 === n || !!r && 4 === n || !!r && 8 === n;
        }(e, n);
    }, [
        n
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($498ba2dab0ae91e7$var$ke, $498ba2dab0ae91e7$var$u({}, o, {
        escape: l,
        format: t ? $498ba2dab0ae91e7$var$Ie : void 0,
        process: $498ba2dab0ae91e7$var$Ie,
        validate: i
    }));
};



var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $aa071d7e9cad3e5f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M228,67.24a39.77,39.77,0,0,0-12.51-28.52C199.91,24,174.71,24.5,159.29,39.93L142.48,56.84a28,28,0,0,0-35.64,3.29l-9,9a20,20,0,0,0-.73,27.49L48.9,144.84A43.76,43.76,0,0,0,37,185.28l-7.5,17.19a17.66,17.66,0,0,0,3.71,19.65,19.9,19.9,0,0,0,22.15,4.19l16.31-7.13a43.88,43.88,0,0,0,39.45-12.09l48.24-48.26a20,20,0,0,0,27.47-.73l9-9a28.06,28.06,0,0,0,3.26-35.72l17.23-17.33A39.69,39.69,0,0,0,228,67.24ZM94.15,190.11a20,20,0,0,1-20,5,11.93,11.93,0,0,0-8.32.47L57,199.38,60.69,191a12,12,0,0,0,.37-8.64,19.92,19.92,0,0,1,4.81-20.55l48.2-48.22,28.28,28.3Zm105.14-111-25.37,25.52a12,12,0,0,0,0,16.95l4.88,4.89a4,4,0,0,1,0,5.66l-6.14,6.15-55-55.05,6.14-6.14a4,4,0,0,1,5.65,0L134.35,82a12,12,0,0,0,8.49,3.51h0A12,12,0,0,0,151.34,82l24.94-25.08c6.3-6.3,16.48-6.63,22.71-.74a16,16,0,0,1,.3,23Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M207.8,87.6l-25.37,25.53,4.89,4.88a16,16,0,0,1,0,22.64l-9,9a8,8,0,0,1-11.32,0l-60.68-60.7a8,8,0,0,1,0-11.32l9-9a16,16,0,0,1,22.63,0l4.88,4.89,25-25.11c10.79-10.79,28.37-11.45,39.45-1A28,28,0,0,1,207.8,87.6Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,67.3a35.79,35.79,0,0,0-11.26-25.66c-14-13.28-36.72-12.78-50.62,1.13L142.8,62.2a24,24,0,0,0-33.14.77l-9,9a16,16,0,0,0,0,22.64l2,2.06-51,51a39.75,39.75,0,0,0-10.53,38l-8,18.41A13.68,13.68,0,0,0,36,219.3a15.92,15.92,0,0,0,17.71,3.35L71.23,215a39.89,39.89,0,0,0,37.06-10.75l51-51,2.06,2.06a16,16,0,0,0,22.62,0l9-9a24,24,0,0,0,.74-33.18l19.75-19.87A35.75,35.75,0,0,0,224,67.3ZM97,193a24,24,0,0,1-24,6,8,8,0,0,0-5.55.31l-18.1,7.91L57,189.41a8,8,0,0,0,.25-5.75A23.88,23.88,0,0,1,63,159l51-51,33.94,34ZM202.13,82l-25.37,25.52a8,8,0,0,0,0,11.3l4.89,4.89a8,8,0,0,1,0,11.32l-9,9L112,83.26l9-9a8,8,0,0,1,11.31,0l4.89,4.89a8,8,0,0,0,5.65,2.34h0a8,8,0,0,0,5.66-2.36l24.94-25.09c7.81-7.82,20.5-8.18,28.29-.81a20,20,0,0,1,.39,28.7Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,67.3a35.79,35.79,0,0,0-11.26-25.66c-14-13.28-36.72-12.78-50.62,1.13L138.8,66.2a24,24,0,0,0-33.14.77l-5,5a16,16,0,0,0,0,22.64l2,2.06-51,51a39.75,39.75,0,0,0-10.53,38l-8,18.41A13.68,13.68,0,0,0,36,219.3a15.92,15.92,0,0,0,17.71,3.35L71.23,215a39.89,39.89,0,0,0,37.06-10.75l51-51,2.06,2.06a16,16,0,0,0,22.62,0l5-5a24,24,0,0,0,.74-33.18l23.75-23.87A35.75,35.75,0,0,0,224,67.3ZM97,193a24,24,0,0,1-24,6,8,8,0,0,0-5.55.31l-18.1,7.91L57,189.41a8,8,0,0,0,.25-5.75A23.88,23.88,0,0,1,63,159l51-51,33.94,34Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M222,67.34a33.81,33.81,0,0,0-10.64-24.25C198.12,30.56,176.68,31,163.54,44.18L142.82,65l-.63-.63a22,22,0,0,0-31.11,0l-9,9a14,14,0,0,0,0,19.81l3.47,3.47L53.14,149.1a37.79,37.79,0,0,0-9.84,36.73l-8.31,19a11.68,11.68,0,0,0,2.46,13A13.91,13.91,0,0,0,47.32,222,14.15,14.15,0,0,0,53,220.82L71,212.92a37.92,37.92,0,0,0,35.84-10.07l52.44-52.46,3.47,3.48a14,14,0,0,0,19.8,0l9-9a22,22,0,0,0,0-31.12l-.66-.66L212,91.85A33.76,33.76,0,0,0,222,67.34Zm-123.61,127a26,26,0,0,1-26,6.47,6,6,0,0,0-4.16.24l-20,8.75a2,2,0,0,1-2.09-.31l9.12-20.9a5.94,5.94,0,0,0,.19-4.31,25.88,25.88,0,0,1,6.26-26.72l52.44-52.45,36.76,36.78Zm105.16-111L178.17,108.9a6,6,0,0,0,0,8.47l4.88,4.89a10,10,0,0,1,0,14.15l-9,9a2,2,0,0,1-2.82,0l-60.69-60.7a2,2,0,0,1,0-2.83l9-9a10,10,0,0,1,14.14,0l4.89,4.89a6,6,0,0,0,4.24,1.75h0a6,6,0,0,0,4.25-1.77L172,52.66c8.58-8.58,22.52-9,31.08-.85a22,22,0,0,1,.44,31.57Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,67.3a35.79,35.79,0,0,0-11.26-25.66c-14-13.28-36.72-12.78-50.62,1.13L142.8,62.2a24,24,0,0,0-33.14.77l-9,9a16,16,0,0,0,0,22.64l2,2.06-51,51a39.75,39.75,0,0,0-10.53,38l-8,18.41A13.68,13.68,0,0,0,36,219.3a15.92,15.92,0,0,0,17.71,3.35L71.23,215a39.89,39.89,0,0,0,37.06-10.75l51-51,2.06,2.06a16,16,0,0,0,22.62,0l9-9a24,24,0,0,0,.74-33.18l19.75-19.87A35.75,35.75,0,0,0,224,67.3ZM97,193a24,24,0,0,1-24,6,8,8,0,0,0-5.55.31l-18.1,7.91L57,189.41a8,8,0,0,0,.25-5.75A23.88,23.88,0,0,1,63,159l51-51,33.94,34ZM202.13,82l-25.37,25.52a8,8,0,0,0,0,11.3l4.89,4.89a8,8,0,0,1,0,11.32l-9,9L112,83.26l9-9a8,8,0,0,1,11.31,0l4.89,4.89a8,8,0,0,0,11.33,0l24.94-25.09c7.81-7.82,20.5-8.18,28.29-.81a20,20,0,0,1,.39,28.7Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M220,67.37a31.82,31.82,0,0,0-10-22.82c-12.46-11.8-32.66-11.33-45,1.05L142.82,67.86l-2-2a20,20,0,0,0-28.28,0l-9,9a12,12,0,0,0,0,17l4.89,4.89L54.55,150.52A35.81,35.81,0,0,0,45.42,186l-8.6,19.7a9.7,9.7,0,0,0,2,10.79A12,12,0,0,0,52.15,219l18.72-8.18a35.9,35.9,0,0,0,34.59-9.37l53.86-53.87,4.88,4.89a12,12,0,0,0,17,0l9-9a20,20,0,0,0,0-28.3l-2.06-2.06,22.55-22.69A31.75,31.75,0,0,0,220,67.37ZM99.81,195.78a28,28,0,0,1-28,7,4,4,0,0,0-2.78.15l-20,8.75a4,4,0,0,1-4.43-.84,1.73,1.73,0,0,1-.36-1.93l9.19-21.06a4,4,0,0,0,.12-2.88,27.87,27.87,0,0,1,6.74-28.77l53.85-53.87,39.6,39.61Zm79.78-85.47a4,4,0,0,0,0,5.65l4.89,4.89a12,12,0,0,1,0,17l-9,9a4,4,0,0,1-5.66,0L109.18,86.1a4,4,0,0,1,0-5.66l9-9a12,12,0,0,1,17,0L140,76.36a4,4,0,0,0,2.83,1.17h0a4,4,0,0,0,2.83-1.18l25-25.1c9.33-9.34,24.52-9.73,33.87-.89A24,24,0,0,1,205,84.79Z"
        }))
    ]
]);


const $a619c6b3c5c6519c$export$6f6fd7ecca10251 = $acw62.forwardRef((r, p)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: p,
        ...r,
        weights: (0, $aa071d7e9cad3e5f$export$2e2bcd8739ae039)
    }));
$a619c6b3c5c6519c$export$6f6fd7ecca10251.displayName = "EyedropperIcon";
const $a619c6b3c5c6519c$export$a8c18874b9331404 = $a619c6b3c5c6519c$export$6f6fd7ecca10251;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $2f22c29e91f0c11c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M216,56V200a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V56A16,16,0,0,1,56,40H200A16,16,0,0,1,216,56Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM181.66,170.34a8,8,0,0,1-11.32,11.32L128,139.31,85.66,181.66a8,8,0,0,1-11.32-11.32L116.69,128,74.34,85.66A8,8,0,0,1,85.66,74.34L128,116.69l42.34-42.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M204.24,195.76a6,6,0,1,1-8.48,8.48L128,136.49,60.24,204.24a6,6,0,0,1-8.48-8.48L119.51,128,51.76,60.24a6,6,0,0,1,8.48-8.48L128,119.51l67.76-67.75a6,6,0,0,1,8.48,8.48L136.49,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M202.83,197.17a4,4,0,0,1-5.66,5.66L128,133.66,58.83,202.83a4,4,0,0,1-5.66-5.66L122.34,128,53.17,58.83a4,4,0,0,1,5.66-5.66L128,122.34l69.17-69.17a4,4,0,1,1,5.66,5.66L133.66,128Z"
        }))
    ]
]);


const $627b50019e718aa3$export$5e658a8851ae9322 = $acw62.forwardRef((r, t)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: t,
        ...r,
        weights: (0, $2f22c29e91f0c11c$export$2e2bcd8739ae039)
    }));
$627b50019e718aa3$export$5e658a8851ae9322.displayName = "XIcon";
const $627b50019e718aa3$export$78acf4525d8a74c4 = $627b50019e718aa3$export$5e658a8851ae9322;



var $lmFrL = parcelRequire("lmFrL");

const $568ef2cc8320c42a$var$HEX_RE = /^#?[0-9a-fA-F]{6}$/;
function $568ef2cc8320c42a$var$normalizeHex(input) {
    if (!input) return null;
    const s = input.trim();
    if (!$568ef2cc8320c42a$var$HEX_RE.test(s)) return null;
    return (s.startsWith("#") ? s : `#${s}`).toLowerCase();
}
// `onChange(hex)` fires for every commit (picker drag, hex input commit,
// eyedropper click). The eyedropper session is owned internally — when
// active, the editor stays open, hover repaints the preview swatch, and
// click commits via onChange. Toggling the picker off, pressing Escape,
// or unmounting all clean up the App-level eyedropper state.
function $568ef2cc8320c42a$var$ColorEditor({ value: value, onChange: onChange, onClose: onClose }) {
    const { available: available, beginEyedropper: beginEyedropper, endEyedropper: endEyedropper } = (0, $7caa007c47a491c5$export$968d3a33c108f1d4)();
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(value);
    const [picking, setPicking] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setDraft(value);
    }, [
        value
    ]);
    // Cleanup: if the editor unmounts (popover closes) while an eyedropper
    // session is live, end it so a stray click on Marc doesn't fire into a
    // ghost handler.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        return ()=>{
            if (picking) endEyedropper();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const commitHex = (raw)=>{
        const next = $568ef2cc8320c42a$var$normalizeHex(raw);
        if (next) onChange(next);
    };
    const startPicking = ()=>{
        setPicking(true);
        setPreview(null);
        beginEyedropper({
            onPreview: (hex)=>setPreview(hex),
            onPick: (hex)=>onChange(hex),
            onCancel: ()=>{
                setPicking(false);
                setPreview(null);
            }
        });
    };
    const stopPicking = ()=>{
        endEyedropper();
        setPicking(false);
        setPreview(null);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($568ef2cc8320c42a$var$Wrap, {
        children: [
            onClose && /*#__PURE__*/ (0, $ayMG0.jsx)($568ef2cc8320c42a$var$CloseButton, {
                type: "button",
                onClick: onClose,
                "aria-label": "Close",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $627b50019e718aa3$export$78acf4525d8a74c4), {
                    size: 14,
                    weight: "bold"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $498ba2dab0ae91e7$export$a3bc3c32746e9f3a), {
                color: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($568ef2cc8320c42a$var$HexInput, {
                type: "text",
                value: draft,
                onChange: (e)=>setDraft(e.target.value),
                onBlur: (e)=>commitHex(e.target.value),
                onKeyDown: (e)=>{
                    if (e.key === "Enter") {
                        e.preventDefault();
                        commitHex(e.currentTarget.value);
                    }
                },
                spellCheck: false,
                "aria-label": "Hex color"
            }),
            available && (picking ? /*#__PURE__*/ (0, $ayMG0.jsxs)($568ef2cc8320c42a$var$PickRow, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($568ef2cc8320c42a$var$PickButton, {
                        type: "button",
                        onClick: stopPicking,
                        $active: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $627b50019e718aa3$export$78acf4525d8a74c4), {
                                size: 14,
                                weight: "bold"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Stop picking"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($568ef2cc8320c42a$var$PreviewSwatch, {
                        $hex: preview ?? value,
                        $dim: !preview,
                        title: preview ? `Hovering ${preview}` : "Hover Marc to preview"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($568ef2cc8320c42a$var$PickButton, {
                type: "button",
                onClick: startPicking,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a619c6b3c5c6519c$export$a8c18874b9331404), {
                        size: 14,
                        weight: "fill"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Pick from Marc"
                    })
                ]
            }))
        ]
    });
}
const $568ef2cc8320c42a$var$Wrap = (0, $lmFrL.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 200px;

  .react-colorful {
    width: 100%;
    height: 160px;
  }
  .react-colorful__saturation {
    border-radius: 6px 6px 0 0;
  }
  .react-colorful__last-control {
    border-radius: 0 0 6px 6px;
  }

  /* Match both pointers visually — by default the hue thumb is smaller
     and blends into the rainbow strip, which reads as decoration rather
     than a draggable control. Same size + white ring for both makes the
     hue strip obviously interactive. */
  .react-colorful__pointer {
    width: 20px;
    height: 20px;
    border: 3px solid white;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.3),
      0 2px 4px rgba(0, 0, 0, 0.25);
  }
`;
const $568ef2cc8320c42a$var$HexInput = (0, $lmFrL.default).input`
  width: 100%;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  padding: 6px 8px;
  border: 1px solid var(--color-orange-300);
  border-radius: 6px;
  background: var(--color-orange-50, #fff8f1);
  color: var(--color-text);
  text-align: center;

  &:focus {
    outline: none;
    border-color: var(--color-orange-700);
  }
`;
const $568ef2cc8320c42a$var$PickRow = (0, $lmFrL.default).div`
  display: flex;
  gap: 6px;
  align-items: stretch;
`;
const $568ef2cc8320c42a$var$PickButton = (0, $lmFrL.default).button`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid
    ${(p)=>p.$active ? "var(--color-orange-500)" : "var(--color-orange-300)"};
  border-radius: 6px;
  background: ${(p)=>p.$active ? "var(--color-orange-300)" : "var(--color-orange-100)"};
  color: var(--color-text);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  cursor: pointer;

  &:hover {
    background: var(--color-orange-300);
    border-color: var(--color-orange-400);
  }
`;
const $568ef2cc8320c42a$var$PreviewSwatch = (0, $lmFrL.default).span`
  width: 30px;
  border-radius: 6px;
  border: 1px solid var(--color-orange-300);
  background: ${(p)=>p.$hex};
  opacity: ${(p)=>p.$dim ? 0.3 : 1};
  flex-shrink: 0;
`;
const $568ef2cc8320c42a$var$CloseButton = (0, $lmFrL.default).button`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--color-orange-100);
  border: 1px solid var(--color-orange-300);
  border-radius: 50%;
  color: var(--color-text-muted);
  cursor: pointer;
  z-index: 1;

  &:hover {
    background: var(--color-orange-300);
    color: var(--color-text);
  }
`;
var $568ef2cc8320c42a$export$2e2bcd8739ae039 = $568ef2cc8320c42a$var$ColorEditor;






var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $2IwC4 = parcelRequire("2IwC4");

var $htT6J = parcelRequire("htT6J");

var $jnK0n = parcelRequire("jnK0n");

var $g2NP0 = parcelRequire("g2NP0");

var $88UcQ = parcelRequire("88UcQ");

var $4yZYB = parcelRequire("4yZYB");

var $kNgwr = parcelRequire("kNgwr");

var $5nYva = parcelRequire("5nYva");

var $cTFdF = parcelRequire("cTFdF");

var $kFbxc = parcelRequire("kFbxc");

var $fg1c6 = parcelRequire("fg1c6");

var $hPyeV = parcelRequire("hPyeV");

var $6okVC = parcelRequire("6okVC");

var $9UeUh = parcelRequire("9UeUh");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $eeaeb48e23f662e7$var$DIALOG_NAME = "Dialog";
var [$eeaeb48e23f662e7$var$createDialogContext, $eeaeb48e23f662e7$export$cc702773b8ea3e41] = (0, $jnK0n.createContextScope)($eeaeb48e23f662e7$var$DIALOG_NAME);
var [$eeaeb48e23f662e7$var$DialogProvider, $eeaeb48e23f662e7$var$useDialogContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$DIALOG_NAME);
var $eeaeb48e23f662e7$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $acw62.useRef(null);
    const contentRef = $acw62.useRef(null);
    const [open, setOpen] = (0, $88UcQ.useControllableState)({
        prop: openProp,
        defaultProp: defaultOpen ?? false,
        onChange: onOpenChange,
        caller: $eeaeb48e23f662e7$var$DIALOG_NAME
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $g2NP0.useId)(),
        titleId: (0, $g2NP0.useId)(),
        descriptionId: (0, $g2NP0.useId)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $acw62.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eeaeb48e23f662e7$export$3ddf2d174ce01153.displayName = $eeaeb48e23f662e7$var$DIALOG_NAME;
var $eeaeb48e23f662e7$var$TRIGGER_NAME = "DialogTrigger";
var $eeaeb48e23f662e7$export$2e1e1122cf0cba88 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $htT6J.useComposedRefs)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eeaeb48e23f662e7$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, context.onOpenToggle)
    });
});
$eeaeb48e23f662e7$export$2e1e1122cf0cba88.displayName = $eeaeb48e23f662e7$var$TRIGGER_NAME;
var $eeaeb48e23f662e7$var$PORTAL_NAME = "DialogPortal";
var [$eeaeb48e23f662e7$var$PortalProvider, $eeaeb48e23f662e7$var$usePortalContext] = $eeaeb48e23f662e7$var$createDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eeaeb48e23f662e7$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $acw62.Children.map(children, (child)=>/* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $5nYva.Portal), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eeaeb48e23f662e7$export$dad7c95542bacce0.displayName = $eeaeb48e23f662e7$var$PORTAL_NAME;
var $eeaeb48e23f662e7$var$OVERLAY_NAME = "DialogOverlay";
var $eeaeb48e23f662e7$export$bd1d06c79be19e17 = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eeaeb48e23f662e7$export$bd1d06c79be19e17.displayName = $eeaeb48e23f662e7$var$OVERLAY_NAME;
var $eeaeb48e23f662e7$var$Slot = (0, $9UeUh.createSlot)("DialogOverlay.RemoveScroll");
var $eeaeb48e23f662e7$var$DialogOverlayImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $hPyeV.default), {
        as: $eeaeb48e23f662e7$var$Slot,
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).div, {
            "data-state": $eeaeb48e23f662e7$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eeaeb48e23f662e7$var$CONTENT_NAME = "DialogContent";
var $eeaeb48e23f662e7$export$b6d9565de1e068cf = $acw62.forwardRef((props, forwardedRef)=>{
    const portalContext = $eeaeb48e23f662e7$var$usePortalContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $cTFdF.Presence), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eeaeb48e23f662e7$export$b6d9565de1e068cf.displayName = $eeaeb48e23f662e7$var$CONTENT_NAME;
var $eeaeb48e23f662e7$var$DialogContentModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, context.contentRef, contentRef);
    $acw62.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $6okVC.hideOthers)(content);
    }, []);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $2IwC4.composeEventHandlers)(props.onCloseAutoFocus, (event)=>{
            event.preventDefault();
            context.triggerRef.current?.focus();
        }),
        onPointerDownOutside: (0, $2IwC4.composeEventHandlers)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $2IwC4.composeEventHandlers)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eeaeb48e23f662e7$var$DialogContentNonModal = $acw62.forwardRef((props, forwardedRef)=>{
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $acw62.useRef(false);
    const hasPointerDownOutsideRef = $acw62.useRef(false);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            props.onCloseAutoFocus?.(event);
            if (!event.defaultPrevented) {
                if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            props.onInteractOutside?.(event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = context.triggerRef.current?.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eeaeb48e23f662e7$var$DialogContentImpl = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $acw62.useRef(null);
    const composedRefs = (0, $htT6J.useComposedRefs)(forwardedRef, contentRef);
    (0, $fg1c6.useFocusGuards)();
    return /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kNgwr.FocusScope), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $4yZYB.DismissableLayer), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $eeaeb48e23f662e7$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($eeaeb48e23f662e7$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $eeaeb48e23f662e7$var$TITLE_NAME = "DialogTitle";
var $eeaeb48e23f662e7$export$16f7638e4a34b909 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$16f7638e4a34b909.displayName = $eeaeb48e23f662e7$var$TITLE_NAME;
var $eeaeb48e23f662e7$var$DESCRIPTION_NAME = "DialogDescription";
var $eeaeb48e23f662e7$export$94e94c2ec2c954d5 = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eeaeb48e23f662e7$export$94e94c2ec2c954d5.displayName = $eeaeb48e23f662e7$var$DESCRIPTION_NAME;
var $eeaeb48e23f662e7$var$CLOSE_NAME = "DialogClose";
var $eeaeb48e23f662e7$export$fba2fb7cd781b7ac = $acw62.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eeaeb48e23f662e7$var$useDialogContext($eeaeb48e23f662e7$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $kFbxc.Primitive).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $2IwC4.composeEventHandlers)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eeaeb48e23f662e7$export$fba2fb7cd781b7ac.displayName = $eeaeb48e23f662e7$var$CLOSE_NAME;
function $eeaeb48e23f662e7$var$getState(open) {
    return open ? "open" : "closed";
}
var $eeaeb48e23f662e7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$eeaeb48e23f662e7$export$69b62a49393917d6, $eeaeb48e23f662e7$var$useWarningContext] = (0, $jnK0n.createContext)($eeaeb48e23f662e7$var$TITLE_WARNING_NAME, {
    contentName: $eeaeb48e23f662e7$var$CONTENT_NAME,
    titleName: $eeaeb48e23f662e7$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $eeaeb48e23f662e7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $acw62.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $eeaeb48e23f662e7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eeaeb48e23f662e7$var$useWarningContext($eeaeb48e23f662e7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $acw62.useEffect(()=>{
        const describedById = contentRef.current?.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $eeaeb48e23f662e7$export$be92b6f5f03c0fe9 = $eeaeb48e23f662e7$export$3ddf2d174ce01153;
var $eeaeb48e23f662e7$export$41fb9f06171c75f4 = $eeaeb48e23f662e7$export$2e1e1122cf0cba88;
var $eeaeb48e23f662e7$export$602eac185826482c = $eeaeb48e23f662e7$export$dad7c95542bacce0;
var $eeaeb48e23f662e7$export$c6fdb837b070b4ff = $eeaeb48e23f662e7$export$bd1d06c79be19e17;
var $eeaeb48e23f662e7$export$7c6e2c02157bb7d2 = $eeaeb48e23f662e7$export$b6d9565de1e068cf;
var $eeaeb48e23f662e7$export$f99233281efd08a0 = $eeaeb48e23f662e7$export$16f7638e4a34b909;
var $eeaeb48e23f662e7$export$393edc798c47379d = $eeaeb48e23f662e7$export$94e94c2ec2c954d5;
var $eeaeb48e23f662e7$export$f39c2d165cd861fe = $eeaeb48e23f662e7$export$fba2fb7cd781b7ac;



var $lmFrL = parcelRequire("lmFrL");


var $7Yi7V = parcelRequire("7Yi7V");
// Shared modal shell. Wraps a Radix Dialog with our overlay + content
// chrome, the close-X in the corner, and the animations. Callers render
// their own body (title, content, footer) as children.
//
// Initial focus is suppressed via onOpenAutoFocus(preventDefault) — Radix
// otherwise lands focus on the close-X (it's the first focusable child),
// which is both ugly and a bad UX target. The focus trap stays active, so
// keyboard users still tab into the dialog naturally.
// `className` is forwarded to Content so callers can do
// `styled(Modal)\`...\`` and have the styles land on the actual modal
// box (e.g. EndScreenModal layering a graph-paper pattern over the
// chrome). Without this, styled-components' generated class would be
// dropped on the floor and the override silently no-ops.
function $25e2004465f0404a$var$Modal({ open: open, onOpenChange: onOpenChange, width: width = 600, topOnMobile: topOnMobile = false, bottomOnMobile: bottomOnMobile = false, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($eeaeb48e23f662e7$export$be92b6f5f03c0fe9, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($eeaeb48e23f662e7$export$602eac185826482c, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($25e2004465f0404a$var$Overlay, {}),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($25e2004465f0404a$var$Content, {
                    $width: width,
                    $topOnMobile: topOnMobile,
                    $bottomOnMobile: bottomOnMobile,
                    "aria-describedby": undefined,
                    onOpenAutoFocus: (e)=>e.preventDefault(),
                    className: className,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($25e2004465f0404a$var$CloseButton, {
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $627b50019e718aa3$export$78acf4525d8a74c4), {
                                size: 18,
                                weight: "bold"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($25e2004465f0404a$var$Body, {
                            children: children
                        })
                    ]
                })
            ]
        })
    });
}
const $25e2004465f0404a$var$fadeIn = (0, $lmFrL.keyframes)`
  from { opacity: 0; }
  to   { opacity: 1; }
`;
const $25e2004465f0404a$var$popIn = (0, $lmFrL.keyframes)`
  from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
  to   { opacity: 1; transform: translate(-50%, -50%) scale(1); }
`;
const $25e2004465f0404a$var$slideUp = (0, $lmFrL.keyframes)`
  from { opacity: 0; transform: translate(-50%, 20%); }
  to   { opacity: 1; transform: translate(-50%, 0); }
`;
const $25e2004465f0404a$var$Overlay = (0, $lmFrL.default)($eeaeb48e23f662e7$export$c6fdb837b070b4ff)`
  position: fixed;
  inset: 0;
  background: rgba(28, 25, 23, 0.65);
  z-index: 50;
  animation: ${$25e2004465f0404a$var$fadeIn} 160ms ease-out;
`;
// max-height: 90dvh (dynamic viewport) so on mobile the modal reclaims
// the room mobile browsers would otherwise hide under their address-bar
// chrome — 90vh undershoots there. Below the modal's own width prop,
// we go full-bleed: 100vw, taller, no rounded corners or border.
const $25e2004465f0404a$var$Content = (0, $lmFrL.default)($eeaeb48e23f662e7$export$7c6e2c02157bb7d2)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: min(100vw, ${(p)=>p.$width}px);
  max-height: 90dvh;
  background: var(--color-orange-100);
  border: 1px solid var(--color-orange-300);
  border-radius: 8px;
  box-shadow: var(--surface-box-shadow-strong);
  z-index: 51;
  animation: ${$25e2004465f0404a$var$popIn} 180ms ease-out;
  overflow: hidden;

  @media (max-width: ${(p)=>p.$width}px) {
    max-height: 96dvh;
    border-radius: 0;
    border: none;
    ${(p)=>p.$topOnMobile && `
        top: 0;
        transform: translateX(-50%);
        animation: none;
      `}
  }

  ${(p)=>p.$bottomOnMobile && (0, $lmFrL.css)`
      @media (max-width: ${0, $7Yi7V.MOBILE_BREAKPOINT}px) {
        top: auto;
        bottom: 0;
        transform: translateX(-50%);
        animation: ${$25e2004465f0404a$var$slideUp} 200ms ease-out;
        max-height: 80dvh;
        border-radius: 12px 12px 0 0;
        border-bottom: none;
      }
    `}
`;
// min-height: 0 lets a flex child shrink below its content size when
// max-height kicks in on Content; without it the body would grow past
// the cap and overflow-y would never trigger. scrollbar-gutter: stable
// reserves the gutter so reflowing in/out of scroll doesn't shift
// content horizontally. Padding clamps from 1.75rem on roomy modals
// down to 1rem on phone widths so the photos/copy aren't crowded by
// chrome at narrow widths.
const $25e2004465f0404a$var$Body = (0, $lmFrL.default).div`
  min-height: 0;
  overflow-y: auto;
  padding: clamp(1rem, 3vw, 1.75rem);
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--color-orange-300) transparent;
`;
const $25e2004465f0404a$var$CloseButton = (0, $lmFrL.default)($eeaeb48e23f662e7$export$f39c2d165cd861fe)`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: var(--color-text-muted);
  cursor: pointer;

  &:hover {
    background: var(--color-orange-200);
    color: var(--color-text);
  }

  &:focus-visible {
    outline: 2px solid var(--color-orange-700);
    outline-offset: 2px;
  }
`;
const $25e2004465f0404a$export$b26fae16ba5468aa = (0, $lmFrL.default)($eeaeb48e23f662e7$export$f99233281efd08a0)`
  font-family: "Fraunces", serif;
  font-size: clamp(2rem, 5vw, 2.5rem);
  font-weight: 600;
  letter-spacing: -0.01em;
  margin: 0 0 1rem;
  color: var(--color-text);
`;
var $25e2004465f0404a$export$2e2bcd8739ae039 = $25e2004465f0404a$var$Modal;








var $7Yi7V = parcelRequire("7Yi7V");
function $6a92625cafe25dfe$var$CreativePanel({ creative: creative, onChangeMarc: onChangeMarc, onSyndicate: onSyndicate }) {
    const { onionOpacity: onionOpacity, setOnionOpacity: setOnionOpacity, warmth: warmth, setWarmth: setWarmth, redshift: redshift, setRedshift: setRedshift, eggLights: eggLights, setEggLights: setEggLights } = creative;
    const { palette: palette, activeColorIndex: activeColorIndex, setPaletteSlot: setPaletteSlot } = (0, $e4LUm.usePalette)();
    const { active: eyedropperActive } = (0, $7caa007c47a491c5$export$968d3a33c108f1d4)();
    const isMobile = (0, $eb158f4d61a7e273$export$2e2bcd8739ae039)();
    const [openPopover, setOpenPopover] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const closeIfRequested = (open)=>{
        if (!open) setOpenPopover(null);
    };
    const activeHex = palette[activeColorIndex];
    const handleColorChange = (hex)=>setPaletteSlot?.(activeColorIndex, hex);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$StyledPanel, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$Stack, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$Columns, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$LeftCol, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$Header, {
                                children: "Make Your Marc"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$Field, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$RowLabel, {
                                        children: "Marc Opacity"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        value: onionOpacity,
                                        onValueChange: setOnionOpacity,
                                        ariaLabel: "Marc opacity"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$Field, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$RowLabel, {
                                        children: "Warmth"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                        min: 0,
                                        max: 100,
                                        value: warmth,
                                        onValueChange: setWarmth,
                                        ariaLabel: "Warmth"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$Field, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$RowLabel, {
                                        children: "Redshift"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                        min: 0,
                                        max: 100,
                                        value: redshift,
                                        onValueChange: setRedshift,
                                        ariaLabel: "Redshift"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($6a92625cafe25dfe$var$RightCol, {
                        children: [
                            isMobile ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                        type: "button",
                                        $active: openPopover === "lights",
                                        onClick: ()=>setOpenPopover((p)=>p === "lights" ? null : "lights"),
                                        title: "Edit the egg's lights",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d102ee67d39f7c9$export$3d88f82d313e52c), {
                                                size: 14,
                                                weight: "fill"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: "Edit Lights"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$2e2bcd8739ae039), {
                                        open: openPopover === "lights",
                                        onOpenChange: closeIfRequested,
                                        width: 420,
                                        bottomOnMobile: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $25e2004465f0404a$export$b26fae16ba5468aa), {
                                                children: "Edit Lights"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85900dfd3a8d68a9$export$2e2bcd8739ae039), {
                                                lights: Array.isArray(eggLights) ? eggLights : [],
                                                setLights: setEggLights
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                                open: openPopover === "lights",
                                onOpenChange: closeIfRequested,
                                side: "left",
                                align: "start",
                                trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                    type: "button",
                                    $active: openPopover === "lights",
                                    onClick: ()=>setOpenPopover((p)=>p === "lights" ? null : "lights"),
                                    title: "Edit the egg's lights",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d102ee67d39f7c9$export$3d88f82d313e52c), {
                                            size: 14,
                                            weight: "fill"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Edit Lights"
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $85900dfd3a8d68a9$export$2e2bcd8739ae039), {
                                    lights: Array.isArray(eggLights) ? eggLights : [],
                                    setLights: setEggLights
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                                open: openPopover === "color",
                                onOpenChange: closeIfRequested,
                                side: isMobile ? "top" : "left",
                                align: isMobile ? "end" : "start",
                                lockOpen: eyedropperActive,
                                trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                    type: "button",
                                    $active: openPopover === "color",
                                    onClick: ()=>setOpenPopover((p)=>p === "color" ? null : "color"),
                                    title: "Replace the active color",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6a92625cafe25dfe$var$Swatch, {
                                            $hex: activeHex,
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: "Edit Color"
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $568ef2cc8320c42a$export$2e2bcd8739ae039), {
                                    value: activeHex,
                                    onChange: handleColorChange,
                                    onClose: ()=>setOpenPopover(null)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                type: "button",
                                onClick: ()=>{
                                    setOpenPopover(null);
                                    onChangeMarc();
                                },
                                title: "Pick a different Marc",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fffcb848af99c7fe$export$e23b03e3f30df91f), {
                                        size: 14,
                                        weight: "bold"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Pivot Marcs"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                type: "button",
                                onClick: ()=>{
                                    setOpenPopover(null);
                                    onSyndicate?.();
                                },
                                title: "Submit your egg to the gallery and grab share images",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $358642fbc699ef49$export$ee62305a5b7a42eb), {
                                        size: 14,
                                        weight: "fill"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: "Syndicate Marc"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
const $6a92625cafe25dfe$var$StyledPanel = (0, $lmFrL.default)((0, $5507f8043745c309$export$2e2bcd8739ae039))`
  padding: 10px 14px 12px;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    padding: 6px 12px 8px;
  }
`;
const $6a92625cafe25dfe$var$Stack = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    gap: 4px;
  }
`;
const $6a92625cafe25dfe$var$Header = (0, $lmFrL.default).h3`
  margin: 0;
  font-family: "Fraunces", serif;
  font-size: 1.25rem;
  font-weight: 600;
  padding-bottom: 0.5rem;
  color: var(--color-orange-700);
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    font-size: 1.15rem;
    padding-bottom: 0.15rem;
  }

  // nroyalty: i think maybe we don't want this, not sure.
  /* &::after {
    content: "";
    flex: 1;
    height: 1px;
    transform: translateY(4px);
    background: var(--color-orange-300);
  } */
`;
const $6a92625cafe25dfe$var$Columns = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  flex: 1;
  min-height: 0;
`;
const $6a92625cafe25dfe$var$LeftCol = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
`;
const $6a92625cafe25dfe$var$RightCol = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 6px;
`;
const $6a92625cafe25dfe$var$Field = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    gap: 0px;
  }
`;
const $6a92625cafe25dfe$var$RowLabel = (0, $lmFrL.default).span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-muted);
  white-space: nowrap;
`;
const $6a92625cafe25dfe$var$Swatch = (0, $lmFrL.default).span`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: ${(p)=>p.$hex};
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.25);
`;
var $6a92625cafe25dfe$export$2e2bcd8739ae039 = $6a92625cafe25dfe$var$CreativePanel;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7Yi7V = parcelRequire("7Yi7V");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");


// Controlled modal so the landing button can drive open/close — Radix
// owns escape / overlay-click / focus trap; we own the chrome.
function $98525fc4a5f8b583$var$WhatModal({ open: open, onOpenChange: onOpenChange }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        width: 600,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$b26fae16ba5468aa), {
                children: [
                    "It's Time to ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$EggsTitle, {
                        children: "Build Eggs"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($98525fc4a5f8b583$var$Body, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Global institutions have dramatically underestimated demand for eggs that look like Marc Andreessen. This failure will reverberate through the rest of the decade and beyond, but it's not too late to roll up our sleeves and start fixing it."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "We have enemies. Our enemy is inertia. Our enemy is regulatory capture. Our enemy is that Googling",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$ModalStrong, {
                                children: ' "Marc Andreessen Egg"'
                            }),
                            " barely returns any results - a damning failure of the media that is as much a generational indictment as it is a call to action."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "If drawing eggs that look like Marc Andreessen were easy, we'd already be doing it. And doing it will take builders of all types: builders that use",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$ModalStrong, {
                                children: " Speedrun Mode"
                            }),
                            " to ship 3 eggs at maximum velocity, and builders that use",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$ModalStrong, {
                                children: " Creative Mode"
                            }),
                            " to painstakingly produce 1 egg of generational quality."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            "As you draw eggs, ask yourself:",
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                children: '"is this egg so good that I want to see it every time Marc posts on Twitter?"'
                            }),
                            " ",
                            "And when the answer is yes, you should contribute to the",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$ModalStrong, {
                                children: " Egg Gallery"
                            }),
                            " - a by-founders-for-founders global registry of the best that we all have to offer."
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$ModalStrong, {
                                children: "You're still early."
                            }),
                            " Ship the eggs. Save the world."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($98525fc4a5f8b583$var$Footer, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                    asChild: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
                        variant: "primary",
                        size: "medium",
                        children: "I'm Ready"
                    })
                })
            })
        ]
    });
}
const $98525fc4a5f8b583$var$ModalStrong = (0, $lmFrL.default).span`
  color: var(--color-orange-700);
`;
const $98525fc4a5f8b583$var$EggsTitle = (0, $lmFrL.default).span`
  color: var(--color-orange-700);
`;
const $98525fc4a5f8b583$var$Body = (0, $lmFrL.default).div`
  font-size: 1rem;
  line-height: 1.55;
  color: var(--color-text);

  p + p {
    margin-top: 1rem;
    text-wrap: pretty;
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: 700;
  }
`;
const $98525fc4a5f8b583$var$Footer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
`;
var $98525fc4a5f8b583$export$2e2bcd8739ae039 = $98525fc4a5f8b583$var$WhatModal;





var $lmFrL = parcelRequire("lmFrL");
const $1db35e3f87274d8a$var$Wrapper = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: 270px;
  grid-template-rows: repeat(3, 44px);
  align-items: stretch;
  justify-items: stretch;
  gap: 1rem;
  --pattern-color: rgba(0, 0, 0, 0.05);

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    grid-template-rows: repeat(3, 40px);
    gap: 0.5rem;
    /* align-items: center; */
    /* justify-content: center; */
    margin-top: 1.5rem;
  }
`;
const $1db35e3f87274d8a$var$SpeedrunButton = (0, $lmFrL.default)((0, $3d26c75613118b87$export$2e2bcd8739ae039))`
  --pattern-size: 2px;
  background-image: repeating-linear-gradient(
    45deg,
    var(--pattern-color),
    var(--pattern-color) var(--pattern-size),
    transparent var(--pattern-size),
    transparent 9px
  );
`;
const $1db35e3f87274d8a$var$CreativeButton = (0, $lmFrL.default)((0, $3d26c75613118b87$export$2e2bcd8739ae039))`
  /* background-color: var(--color-orange-50); */
  --pattern-size: 2px;
  --pattern-color: rgba(0, 0, 0, 0.05);
  background-image:
    radial-gradient(
      var(--pattern-color) var(--pattern-size),
      transparent var(--pattern-size)
    ),
    radial-gradient(
      var(--pattern-color) var(--pattern-size),
      transparent var(--pattern-size)
    );
  background-size: 20px 20px;
  background-position:
    0 0,
    10px 10px;
`;
const $1db35e3f87274d8a$var$SmallerButton = (0, $lmFrL.default)((0, $3d26c75613118b87$export$2e2bcd8739ae039))`
  background-color: var(--color-orange-100);
`;
const $1db35e3f87274d8a$var$Row = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: repeat(2, 130px);
  align-items: stretch;
  justify-items: stretch;
  justify-content: space-between;
`;
// Creative button opens the marc picker WITHOUT switching to creative
// mode — picking a marc from the modal is what transitions us. This
// avoids the brief no-marc-selected window in creative that used to
// remount the landing trace at full opacity behind the picker (read as
// an afterimage on top of the modal). It also makes dismissing the
// picker a non-event: you were always in landing, you stay in landing.
function $1db35e3f87274d8a$var$LandingUIPanel({ setMode: setMode, onCreativeClick: onCreativeClick }) {
    const [whatOpen, setWhatOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5507f8043745c309$export$2e2bcd8739ae039), {
        style: {
            display: "grid",
            placeItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($1db35e3f87274d8a$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1db35e3f87274d8a$var$CreativeButton, {
                        size: "large",
                        onClick: onCreativeClick,
                        children: "Creative Mode"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1db35e3f87274d8a$var$SpeedrunButton, {
                        size: "large",
                        onClick: ()=>setMode((0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN),
                        children: "Speedrun Mode"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($1db35e3f87274d8a$var$Row, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1db35e3f87274d8a$var$SmallerButton, {
                                size: "large",
                                onClick: ()=>{
                                    window.location.href = "/gallery";
                                },
                                children: "Egg Gallery"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($1db35e3f87274d8a$var$SmallerButton, {
                                size: "large",
                                onClick: ()=>setWhatOpen(true),
                                children: "Manifesto"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $98525fc4a5f8b583$export$2e2bcd8739ae039), {
                open: whatOpen,
                onOpenChange: setWhatOpen
            })
        ]
    });
}
var $1db35e3f87274d8a$export$2e2bcd8739ae039 = $1db35e3f87274d8a$var$LandingUIPanel;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

const $d3dbfb4747e670e5$var$KNOBS = [
    {
        key: "largeMassFraction",
        label: "mass fraction (large)",
        min: 0.05,
        max: 0.95,
        step: 0.01,
        format: (v)=>v.toFixed(2)
    },
    {
        key: "smallMassFraction",
        label: "mass fraction (small)",
        min: 0.02,
        max: 0.8,
        step: 0.01,
        format: (v)=>v.toFixed(2)
    },
    {
        key: "searchRadiusScale",
        label: "search radius \xd7",
        min: 0.1,
        max: 3,
        step: 0.05,
        format: (v)=>v.toFixed(2)
    },
    {
        key: "smallMaxOverdrawRatio",
        label: "max overdraw \xd7 (small)",
        min: 2,
        max: 50,
        step: 0.5,
        format: (v)=>v.toFixed(1)
    },
    {
        key: "largeMaxOverdrawRatio",
        label: "max overdraw \xd7 (large)",
        min: 1.2,
        max: 10,
        step: 0.1,
        format: (v)=>v.toFixed(1)
    },
    {
        key: "distanceSoftener",
        label: "distance softener (px)",
        min: 20,
        max: 500,
        step: 5,
        format: (v)=>String(Math.round(v))
    },
    {
        key: "detectionFillMs",
        label: "bar fill rate \xb7 fill (ms)",
        min: 50,
        max: 1500,
        step: 25,
        format: (v)=>String(Math.round(v))
    },
    {
        key: "detectionStrokeMs",
        label: "bar fill rate \xb7 stroke (ms)",
        min: 200,
        max: 3000,
        step: 50,
        format: (v)=>String(Math.round(v))
    }
];
function $d3dbfb4747e670e5$var$DebugScoringPanel({ overrides: overrides, onChange: onChange, shown: shown, maskOverlay: maskOverlay, onToggleMask: onToggleMask, marcId: marcId }) {
    const reset = ()=>onChange((0, $c1e9a979fb38f5e6$export$6de33833799c3d24));
    const dirty = $d3dbfb4747e670e5$var$KNOBS.some((k)=>overrides[k.key] !== (0, $c1e9a979fb38f5e6$export$6de33833799c3d24)[k.key]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Wrap, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "scoring knobs"
                    }),
                    marcId && /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$MarcId, {
                        children: [
                            "marc ",
                            marcId
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Reset, {
                        onClick: reset,
                        disabled: !dirty,
                        children: "reset"
                    })
                ]
            }),
            $d3dbfb4747e670e5$var$KNOBS.map((k)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Row, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$RowHeader, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                    children: k.label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Value, {
                                    children: k.format(overrides[k.key])
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            type: "range",
                            min: k.min,
                            max: k.max,
                            step: k.step,
                            value: overrides[k.key],
                            onChange: (e)=>onChange({
                                    ...overrides,
                                    [k.key]: Number(e.target.value)
                                })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Default, {
                            children: [
                                "default ",
                                k.format((0, $c1e9a979fb38f5e6$export$6de33833799c3d24)[k.key])
                            ]
                        })
                    ]
                }, k.key)),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$ShownSection, {
                shown: shown,
                maskOverlay: maskOverlay,
                onToggleMask: onToggleMask
            })
        ]
    });
}
// Live debug readout for the currently-graded region. Shows the math
// behind whatever the bar is doing right now, plus per-subregion
// breakdown for any-of groups (so e.g. "the small shirt sliver got
// 200 hits, the big half got 6K" reads at a glance).
// Show the breakdown when there's anything interesting to break down:
// multiple subregions, or any single sub that uses spread split.
function $d3dbfb4747e670e5$var$shouldShowSubBreakdown(subRegions) {
    if (!subRegions) return false;
    if (subRegions.length > 1) return true;
    return subRegions.some((s)=>s.splitAxis);
}
function $d3dbfb4747e670e5$var$ShownSection({ shown: shown, maskOverlay: maskOverlay, onToggleMask: onToggleMask }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Shown, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "shown region"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Reset, {
                        onClick: onToggleMask,
                        children: maskOverlay ? "hide mask" : "show mask"
                    })
                ]
            }),
            !shown ? /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Empty, {
                children: "none"
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$StatRow, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                children: "label"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Value, {
                                children: [
                                    shown.label,
                                    " (",
                                    shown.mode,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$StatRow, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                children: "hits / required"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Value, {
                                children: [
                                    Math.round(shown.hits),
                                    " / ",
                                    shown.required
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$StatRow, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                children: "score"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Value, {
                                children: shown.score.toFixed(2)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$StatRow, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                children: "ref pixelCount"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Value, {
                                children: shown.pixelCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$StatRow, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$Label, {
                                children: "assignedSize"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$Value, {
                                children: [
                                    shown.assignedSize,
                                    " / ",
                                    shown.overdrawAllowed,
                                    shown.overdrawn ? " \u26A0" : ""
                                ]
                            })
                        ]
                    }),
                    shown.subRegions && $d3dbfb4747e670e5$var$shouldShowSubBreakdown(shown.subRegions) && /*#__PURE__*/ (0, $ayMG0.jsx)($d3dbfb4747e670e5$var$SubBreakdown, {
                        children: shown.subRegions.map((s)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$SubRowGroup, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$SubRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: s.id
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    s.pixelCount,
                                                    "px \xb7 ",
                                                    Math.round(s.hits),
                                                    " hits \xb7",
                                                    " ",
                                                    s.assignedSize,
                                                    " size"
                                                ]
                                            })
                                        ]
                                    }),
                                    s.splitAxis && s.halfHits && s.halfThresholds && /*#__PURE__*/ (0, $ayMG0.jsxs)($d3dbfb4747e670e5$var$SubRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                children: s.splitAxis === "x" ? "  l/r" : "  t/b"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    Math.round(s.halfHits[0]),
                                                    "/",
                                                    Math.round(s.halfHits[1]),
                                                    " ",
                                                    "of ",
                                                    Math.round(s.halfThresholds[0]),
                                                    "/",
                                                    Math.round(s.halfThresholds[1])
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, s.id))
                    })
                ]
            })
        ]
    });
}
const $d3dbfb4747e670e5$var$Wrap = (0, $lmFrL.default).div`
  position: fixed;
  top: 12px;
  right: 12px;
  z-index: 50;
  width: 220px;
  padding: 10px 12px;
  background: rgba(26, 26, 26, 0.88);
  color: #f6f5f1;
  border-radius: 8px;
  font-size: 11px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const $d3dbfb4747e670e5$var$Header = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 10px;
  opacity: 0.85;
`;
const $d3dbfb4747e670e5$var$Reset = (0, $lmFrL.default).button`
  background: transparent;
  color: inherit;
  border: 1px solid #666;
  border-radius: 4px;
  padding: 2px 8px;
  font: inherit;
  font-size: 10px;
  cursor: pointer;
  &:disabled {
    opacity: 0.3;
    cursor: default;
  }
  &:not(:disabled):hover {
    background: #333;
  }
`;
const $d3dbfb4747e670e5$var$Row = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  input[type="range"] {
    width: 100%;
  }
`;
const $d3dbfb4747e670e5$var$RowHeader = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
const $d3dbfb4747e670e5$var$Label = (0, $lmFrL.default).span`
  opacity: 0.85;
`;
const $d3dbfb4747e670e5$var$Value = (0, $lmFrL.default).span`
  font-variant-numeric: tabular-nums;
  font-weight: 700;
`;
const $d3dbfb4747e670e5$var$Default = (0, $lmFrL.default).span`
  font-size: 10px;
  opacity: 0.45;
`;
const $d3dbfb4747e670e5$var$Shown = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding-top: 8px;
`;
const $d3dbfb4747e670e5$var$StatRow = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
`;
const $d3dbfb4747e670e5$var$SubBreakdown = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 2px;
  padding-top: 4px;
  border-top: 1px dashed rgba(255, 255, 255, 0.12);
  font-size: 10px;
  opacity: 0.7;
  font-variant-numeric: tabular-nums;
`;
const $d3dbfb4747e670e5$var$SubRow = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;
const $d3dbfb4747e670e5$var$SubRowGroup = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
`;
const $d3dbfb4747e670e5$var$Empty = (0, $lmFrL.default).span`
  opacity: 0.45;
`;
const $d3dbfb4747e670e5$var$MarcId = (0, $lmFrL.default).span`
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--color-orange-300, #fdba74);
  font-size: 10px;
`;
var $d3dbfb4747e670e5$export$2e2bcd8739ae039 = $d3dbfb4747e670e5$var$DebugScoringPanel;





var $fOHsz = parcelRequire("fOHsz");


var $fOHsz = parcelRequire("fOHsz");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $cf251384926ed4c4$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M236,144a68.07,68.07,0,0,1-68,68H80a12,12,0,0,1,0-24h88a44,44,0,0,0,0-88H61l27.52,27.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,1,1,17,17L61,76H168A68.08,68.08,0,0,1,236,144Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M80,40v96L32,88Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M168,80H88V40a8,8,0,0,0-13.66-5.66l-48,48a8,8,0,0,0,0,11.32l48,48A8,8,0,0,0,88,136V96h80a48,48,0,0,1,0,96H80a8,8,0,0,0,0,16h88a64,64,0,0,0,0-128ZM72,116.69,43.31,88,72,59.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M232,144a64.07,64.07,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H88v40a8,8,0,0,1-13.66,5.66l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,88,40V80h80A64.07,64.07,0,0,1,232,144Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M230,144a62.07,62.07,0,0,1-62,62H80a6,6,0,0,1,0-12h88a50,50,0,0,0,0-100H46.49l37.75,37.76a6,6,0,1,1-8.48,8.48l-48-48a6,6,0,0,1,0-8.48l48-48a6,6,0,0,1,8.48,8.48L46.49,82H168A62.07,62.07,0,0,1,230,144Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M232,144a64.07,64.07,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H51.31l34.35,34.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,45.66L51.31,80H168A64.07,64.07,0,0,1,232,144Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M228,144a60.07,60.07,0,0,1-60,60H80a4,4,0,0,1,0-8h88a52,52,0,0,0,0-104H41.66l41.17,41.17a4,4,0,0,1-5.66,5.66l-48-48a4,4,0,0,1,0-5.66l48-48a4,4,0,0,1,5.66,5.66L41.66,84H168A60.07,60.07,0,0,1,228,144Z"
        }))
    ]
]);


const $dad4d9e310df876e$export$194c576697aa9bbc = $acw62.forwardRef((e, t)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: t,
        ...e,
        weights: (0, $cf251384926ed4c4$export$2e2bcd8739ae039)
    }));
$dad4d9e310df876e$export$194c576697aa9bbc.displayName = "ArrowUUpLeftIcon";
const $dad4d9e310df876e$export$61587597da16632a = $dad4d9e310df876e$export$194c576697aa9bbc;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $56a7f247496c78b0$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M167.51,127.51,195,100H88a44,44,0,0,0,0,88h88a12,12,0,0,1,0,24H88A68,68,0,0,1,88,76H195L167.51,48.49a12,12,0,1,1,17-17l48,48a12,12,0,0,1,0,17l-48,48a12,12,0,0,1-17-17Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,88l-48,48V40Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M172.94,143.39a8,8,0,0,0,8.72-1.73l48-48a8,8,0,0,0,0-11.32l-48-48A8,8,0,0,0,168,40V80H88a64,64,0,0,0,0,128h88a8,8,0,0,0,0-16H88a48,48,0,0,1,0-96h80v40A8,8,0,0,0,172.94,143.39ZM184,59.31,212.69,88,184,116.69Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8,8,0,0,1,13.66-5.66l48,48a8,8,0,0,1,0,11.32l-48,48A8,8,0,0,1,168,136Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M171.76,131.76,209.51,94H88a50,50,0,0,0,0,100h88a6,6,0,0,1,0,12H88A62,62,0,0,1,88,82H209.51L171.76,44.24a6,6,0,0,1,8.48-8.48l48,48a6,6,0,0,1,0,8.48l-48,48a6,6,0,0,1-8.48-8.48Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M170.34,130.34,204.69,96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80H204.69L170.34,45.66a8,8,0,0,1,11.32-11.32l48,48a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32-11.32Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M173.17,133.17,214.34,92H88a52,52,0,0,0,0,104h88a4,4,0,0,1,0,8H88A60,60,0,0,1,88,84H214.34L173.17,42.83a4,4,0,0,1,5.66-5.66l48,48a4,4,0,0,1,0,5.66l-48,48a4,4,0,0,1-5.66-5.66Z"
        }))
    ]
]);


const $f285fda8af7575e7$export$869097c664788ec2 = $acw62.forwardRef((t, e)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: e,
        ...t,
        weights: (0, $56a7f247496c78b0$export$2e2bcd8739ae039)
    }));
$f285fda8af7575e7$export$869097c664788ec2.displayName = "ArrowUUpRightIcon";
const $f285fda8af7575e7$export$a7eba9a04bceab86 = $f285fda8af7575e7$export$869097c664788ec2;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $9710e34a6590a17b$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M216,204H141l86.84-86.84a28,28,0,0,0,0-39.6L186.43,36.19a28,28,0,0,0-39.6,0L28.19,154.82a28,28,0,0,0,0,39.6l30.06,30.07A12,12,0,0,0,66.74,228H216a12,12,0,0,0,0-24ZM163.8,53.16a4,4,0,0,1,5.66,0l41.38,41.38a4,4,0,0,1,0,5.65L160,151l-47-47ZM71.71,204,45.16,177.45a4,4,0,0,1,0-5.65L96,121l47,47-36,36Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M160,168l-48,48H66.75L36.69,185.94a16,16,0,0,1,0-22.63L96,104Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M225,80.4,183.6,39a24,24,0,0,0-33.94,0L31,157.66a24,24,0,0,0,0,33.94l30.06,30.06A8,8,0,0,0,66.74,224H216a8,8,0,0,0,0-16h-84.7L225,114.34A24,24,0,0,0,225,80.4ZM108.68,208H70.05L42.33,180.28a8,8,0,0,1,0-11.31L96,115.31,148.69,168Zm105-105L160,156.69,107.31,104,161,50.34a8,8,0,0,1,11.32,0l41.38,41.38a8,8,0,0,1,0,11.31Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M225,80.4,183.6,39a24,24,0,0,0-33.94,0L31,157.66a24,24,0,0,0,0,33.94l30.06,30.06A8,8,0,0,0,66.74,224H216a8,8,0,0,0,0-16h-84.7L225,114.34A24,24,0,0,0,225,80.4ZM213.67,103,160,156.69,107.31,104,161,50.34a8,8,0,0,1,11.32,0l41.38,41.38a8,8,0,0,1,0,11.31Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M223.57,81.81,182.19,40.43a22,22,0,0,0-31.12,0L32.43,159.07a22,22,0,0,0,0,31.11L62.5,220.24A6,6,0,0,0,66.74,222H216a6,6,0,0,0,0-12H126.49l97.08-97.08A22,22,0,0,0,223.57,81.81ZM109.51,210H69.22l-28.3-28.3a10,10,0,0,1,0-14.15L96,112.48,151.52,168ZM215.08,104.44,160,159.51,104.48,104l55.08-55.07a10,10,0,0,1,14.14,0l41.38,41.37A10,10,0,0,1,215.08,104.44Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M225,80.4,183.6,39a24,24,0,0,0-33.94,0L31,157.66a24,24,0,0,0,0,33.94l30.06,30.06A8,8,0,0,0,66.74,224H216a8,8,0,0,0,0-16h-84.7L225,114.34A24,24,0,0,0,225,80.4ZM108.68,208H70.05L42.33,180.28a8,8,0,0,1,0-11.31L96,115.31,148.69,168Zm105-105L160,156.69,107.31,104,161,50.34a8,8,0,0,1,11.32,0l41.38,41.38a8,8,0,0,1,0,11.31Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M222.15,83.22,180.77,41.85a20,20,0,0,0-28.28,0L33.85,160.48a20,20,0,0,0,0,28.29l30.06,30.06A4,4,0,0,0,66.74,220H216a4,4,0,0,0,0-8H121.66L222.15,111.51A20,20,0,0,0,222.15,83.22ZM110.34,212H68.4L39.51,183.11a12,12,0,0,1,0-17L96,109.65,154.35,168ZM216.49,105.85,160,162.34,101.65,104l56.49-56.48a12,12,0,0,1,17,0l41.37,41.37A12,12,0,0,1,216.49,105.85Z"
        }))
    ]
]);


const $fabc15b223e6cf0b$export$b6c544816d254f36 = $acw62.forwardRef((o, a)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: a,
        ...o,
        weights: (0, $9710e34a6590a17b$export$2e2bcd8739ae039)
    }));
$fabc15b223e6cf0b$export$b6c544816d254f36.displayName = "EraserIcon";
const $fabc15b223e6cf0b$export$dd603c4f14fc685b = $fabc15b223e6cf0b$export$b6c544816d254f36;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $301dfd7b5d5d7336$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M236,32a12,12,0,0,0-12-12c-44.78,0-90,48.54-115.9,82a64,64,0,0,0-80,62c0,12-3.1,22.71-9.23,31.76A43,43,0,0,1,9.4,206.05a11.88,11.88,0,0,0-4.91,13.38A12.07,12.07,0,0,0,16.11,228h76A64,64,0,0,0,154,148C187.49,122.05,236,76.8,236,32ZM209.62,46.39c-4,12.92-13.15,27.49-26.92,42.91-3,3.39-6.16,6.7-9.35,9.89a104.31,104.31,0,0,0-16.5-16.51c3.19-3.19,6.49-6.32,9.88-9.35C182.15,59.55,196.71,50.43,209.62,46.39ZM92.07,204H42a80.17,80.17,0,0,0,10.14-40,40,40,0,1,1,40,40Zm38.18-91.32c3.12-3.93,6.55-8.09,10.23-12.35a80.52,80.52,0,0,1,15.23,15.24c-4.26,3.68-8.42,7.11-12.35,10.23A64.43,64.43,0,0,0,130.25,112.68Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,32c0,32.81-31.64,67.43-58.64,91.05A84.39,84.39,0,0,0,133,90.64C156.57,63.64,191.19,32,224,32Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M232,32a8,8,0,0,0-8-8c-44.08,0-89.31,49.71-114.43,82.63A60,60,0,0,0,32,164c0,30.88-19.54,44.73-20.47,45.37A8,8,0,0,0,16,224H92a60,60,0,0,0,57.37-77.57C182.3,121.31,232,76.08,232,32ZM92,208H34.63C41.38,198.41,48,183.92,48,164a44,44,0,1,1,44,44Zm32.42-94.45q5.14-6.66,10.09-12.55A76.23,76.23,0,0,1,155,121.49q-5.9,4.94-12.55,10.09A60.54,60.54,0,0,0,124.42,113.55Zm42.7-2.68a92.57,92.57,0,0,0-22-22c31.78-34.53,55.75-45,69.9-47.91C212.17,55.12,201.65,79.09,167.12,110.87Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M232,32a8,8,0,0,0-8-8c-44.08,0-89.31,49.71-114.43,82.63A60,60,0,0,0,32,164c0,30.88-19.54,44.73-20.47,45.37A8,8,0,0,0,16,224H92a60,60,0,0,0,57.37-77.57C182.3,121.31,232,76.08,232,32ZM124.42,113.55q5.14-6.66,10.09-12.55A76.23,76.23,0,0,1,155,121.49q-5.9,4.94-12.55,10.09A60.54,60.54,0,0,0,124.42,113.55Zm42.7-2.68a92.57,92.57,0,0,0-22-22c31.78-34.53,55.75-45,69.9-47.91C212.17,55.12,201.65,79.09,167.12,110.87Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,26c-20.8,0-44.11,11.41-69.3,33.9C136.62,76.06,121,94.9,110.3,109A58,58,0,0,0,34,164c0,32.07-20.43,46.39-21.35,47A6,6,0,0,0,16,222H92a58,58,0,0,0,55-76.3c14.08-10.67,32.92-26.32,49.08-44.4C218.59,76.11,230,52.8,230,32A6,6,0,0,0,224,26ZM92,210H30.65C37.92,200.85,46,185.78,46,164a46,46,0,1,1,46,46Zm29.49-95.91c3.6-4.67,7.88-10,12.71-15.69a78.17,78.17,0,0,1,23.4,23.4c-5.67,4.83-11,9.11-15.69,12.71A58.38,58.38,0,0,0,121.49,114.09Zm45.2-.3a90.24,90.24,0,0,0-24.48-24.48C163.05,66.46,191,42,217.56,38.44,214,65,189.54,93,166.69,113.79Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M232,32a8,8,0,0,0-8-8c-44.08,0-89.31,49.71-114.43,82.63A60,60,0,0,0,32,164c0,30.88-19.54,44.73-20.47,45.37A8,8,0,0,0,16,224H92a60,60,0,0,0,57.37-77.57C182.3,121.31,232,76.08,232,32ZM92,208H34.63C41.38,198.41,48,183.92,48,164a44,44,0,1,1,44,44Zm32.42-94.45q5.14-6.66,10.09-12.55A76.23,76.23,0,0,1,155,121.49q-5.9,4.94-12.55,10.09A60.54,60.54,0,0,0,124.42,113.55Zm42.7-2.68a92.57,92.57,0,0,0-22-22c31.78-34.53,55.75-45,69.9-47.91C212.17,55.12,201.65,79.09,167.12,110.87Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M224,28c-20.29,0-43.16,11.24-68,33.4-18.47,16.49-34.39,35.83-45,49.93A56,56,0,0,0,36,164c0,33.22-21.26,48-22.22,48.68A4,4,0,0,0,16,220H92a56,56,0,0,0,52.67-75c14.11-10.63,33.44-26.55,49.93-45C216.76,75.16,228,52.29,228,32A4,4,0,0,0,224,28ZM92,212H26.35C33.91,203.69,44,188.08,44,164a48,48,0,1,1,48,48Zm26.52-97.31c4.13-5.44,9.32-12,15.29-18.9a80.08,80.08,0,0,1,26.4,26.4c-6.94,6-13.46,11.16-18.9,15.29A56.32,56.32,0,0,0,118.52,114.69Zm47.77,2.14a88.17,88.17,0,0,0-27.12-27.12C161,65.43,191.26,38.63,219.82,36.18,217.37,64.74,190.57,95,166.29,116.83Z"
        }))
    ]
]);


const $bcfb5017307d0d93$export$4799ca36cb97dc90 = $acw62.forwardRef((t, a)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: a,
        ...t,
        weights: (0, $301dfd7b5d5d7336$export$2e2bcd8739ae039)
    }));
$bcfb5017307d0d93$export$4799ca36cb97dc90.displayName = "PaintBrushIcon";
const $bcfb5017307d0d93$export$145d90bf65d7f62b = $bcfb5017307d0d93$export$4799ca36cb97dc90;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $b550422f05524d7f$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M235.79,142.88a12,12,0,0,0,4.7-19.87L125,7.52a12,12,0,0,0-17,0L70.25,45.29,48.48,23.52a12,12,0,0,0-17,17L53.28,62.26,12.2,103.35a28,28,0,0,0,0,39.6l84.86,84.86a28,28,0,0,0,39.6,0L214.48,150Zm-31.58-14.77a12,12,0,0,0-4.7,2.9l-79.82,79.83a4,4,0,0,1-5.66,0L29.17,126a4,4,0,0,1,0-5.66L70.25,79.24l24.29,24.29a32,32,0,0,0,52.09,35.11h0a32,32,0,0,0-35.12-52.08L87.23,62.26,116.52,33l93.27,93.28Zm-85.87-17.75,0,0a8,8,0,1,1-.06.06ZM256,208a24,24,0,0,1-48,0c0-19.44,12.93-37.23,14.4-39.2a12,12,0,0,1,19.2,0C243.07,170.78,256,188.57,256,208Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M248,208a16,16,0,0,1-32,0c0-16,16-40,16-40S248,192,248,208Zm-16-76.52-24,8-79.83,79.83a16,16,0,0,1-22.63,0L20.69,134.46a16,16,0,0,1,0-22.63L116.52,16Zm-93.86-29.62a20,20,0,1,0,0,28.28A20,20,0,0,0,138.14,101.86Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M238.66,163.56a8,8,0,0,0-13.32,0C223.57,166.23,208,190.09,208,208a24,24,0,0,0,48,0C256,190.09,240.43,166.23,238.66,163.56ZM232,216a8,8,0,0,1-8-8c0-6.8,4-16.32,8-24.08,4,7.76,8,17.34,8,24.08A8,8,0,0,1,232,216Zm2.53-76.93a8,8,0,0,0,3.13-13.24L122.17,10.34a8,8,0,0,0-11.31,0L70.25,51,45.65,26.34A8,8,0,0,0,34.34,37.66l24.6,24.6L15,106.17a24,24,0,0,0,0,33.94L99.89,225a24,24,0,0,0,33.94,0l78.49-78.49Zm-32.19-5.24-79.83,79.83a8,8,0,0,1-11.31,0L26.34,128.8a8,8,0,0,1,0-11.31L70.25,73.57l29.12,29.12a28,28,0,1,0,11.31-11.32L81.57,62.26l35-34.95L217.19,128l-11.72,3.9A8.09,8.09,0,0,0,202.34,133.83Zm-86.83-26.31,0,0a13.26,13.26,0,1,1-.05.06S115.51,107.53,115.51,107.52Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M256,208a24,24,0,0,1-48,0c0-17.91,15.57-41.77,17.34-44.44a8,8,0,0,1,13.32,0C240.43,166.23,256,190.09,256,208ZM132.49,124.49a12,12,0,0,0-17-17l0,0s0,0,0,0a12,12,0,0,0,17,16.94ZM37.65,18.34A8,8,0,0,0,26.34,29.66l32.6,32.6L70.25,51ZM234.53,139.07a8,8,0,0,0,3.13-13.24L122.17,10.34a8,8,0,0,0-11.31,0L70.25,51l40.43,40.42a28,28,0,1,1-11.31,11.32L58.94,62.26,15,106.17a24,24,0,0,0,0,33.94L99.89,225a24,24,0,0,0,33.94,0l78.49-78.49Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M237,164.67a6,6,0,0,0-10,0c-.7,1-17,25.72-17,43.33a22,22,0,0,0,44,0C254,190.39,237.69,165.71,237,164.67ZM232,218a10,10,0,0,1-10-10c0-8.17,5.37-19.92,10-28.34,4.63,8.41,10,20.15,10,28.34A10,10,0,0,1,232,218Zm1.9-80.82a6,6,0,0,0,2.34-9.94L120.76,11.76a6,6,0,0,0-8.49,0l-42,42-26-26a6,6,0,0,0-8.49,8.48l26,26L16.44,107.59a22,22,0,0,0,0,31.11l84.86,84.86a22,22,0,0,0,31.11,0l78.83-78.83Zm-30.14-1.94-79.83,79.83a10,10,0,0,1-14.14,0L24.93,130.21a10,10,0,0,1,0-14.14L70.25,70.75l31.62,31.61a26,26,0,0,0,3.75,32,26,26,0,0,0,36.76,0h0a26,26,0,0,0-32-40.51L78.74,62.26l37.78-37.77L220.89,128.86l-14.79,4.93A6.07,6.07,0,0,0,203.76,135.24ZM114.1,106.11l0,0a14,14,0,1,1,0,19.82,13.91,13.91,0,0,1,0-19.82Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M234.53,139.07a8,8,0,0,0,3.13-13.24L122.17,10.34a8,8,0,0,0-11.31,0L70.25,51,45.65,26.34A8,8,0,0,0,34.34,37.66l24.6,24.6L15,106.17a24,24,0,0,0,0,33.94L99.89,225a24,24,0,0,0,33.94,0l78.49-78.49Zm-32.19-5.24-79.83,79.83a8,8,0,0,1-11.31,0L26.34,128.8a8,8,0,0,1,0-11.31L70.25,73.57l29.12,29.12a28,28,0,1,0,11.31-11.32L81.57,62.26l35-34.95L217.19,128l-11.72,3.9A8.09,8.09,0,0,0,202.34,133.83Zm-86.83-26.31,0,0a13.26,13.26,0,1,1-.05.06S115.51,107.53,115.51,107.52Zm123.15,56a8,8,0,0,0-13.32,0C223.57,166.23,208,190.09,208,208a24,24,0,0,0,48,0C256,190.09,240.43,166.23,238.66,163.56ZM232,216a8,8,0,0,1-8-8c0-6.8,4-16.32,8-24.08,4,7.76,8,17.34,8,24.08A8,8,0,0,1,232,216Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M235.33,165.78a4,4,0,0,0-6.66,0C228,166.8,212,191,212,208a20,20,0,0,0,40,0C252,191,236,166.8,235.33,165.78ZM232,220a12,12,0,0,1-12-12c0-10.25,7.49-24.64,12-32.37,4.51,7.73,12,22.1,12,32.37A12,12,0,0,1,232,220Zm3.89-87.6a4,4,0,0,0-1.06-3.74L119.34,13.17a4,4,0,0,0-5.65,0L70.25,56.6,42.82,29.17a4,4,0,0,0-5.65,5.66L64.6,62.26,17.86,109a20,20,0,0,0,0,28.29l84.85,84.85a20,20,0,0,0,28.29,0L210.16,143l23.1-7.7A4,4,0,0,0,235.89,132.4Zm-29.15,3.29a4.06,4.06,0,0,0-1.57,1l-79.83,79.82a12,12,0,0,1-17,0L23.51,131.63a12,12,0,0,1,0-17L70.25,67.92l34.2,34.2A24,24,0,0,0,141,133h0a24,24,0,0,0-30.86-36.51l-34.2-34.2,40.61-40.6L224.59,129.74Zm-94.05-31a0,0,0,0,0,0,0,16,16,0,1,1,0,22.64,16,16,0,0,1,0-22.64Z"
        }))
    ]
]);


const $a7b3808ac3150303$export$2f0cfbbf1070571b = $acw62.forwardRef((o, a)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: a,
        ...o,
        weights: (0, $b550422f05524d7f$export$2e2bcd8739ae039)
    }));
$a7b3808ac3150303$export$2f0cfbbf1070571b.displayName = "PaintBucketIcon";
const $a7b3808ac3150303$export$38a21d0b1a76c510 = $a7b3808ac3150303$export$2f0cfbbf1070571b;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $374082d405f0c49c$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M157.27,21.22a12,12,0,0,0-12.64,1.31L75.88,76H32A20,20,0,0,0,12,96v64a20,20,0,0,0,20,20H75.88l68.75,53.47A12,12,0,0,0,164,224V32A12,12,0,0,0,157.27,21.22ZM36,100H68v56H36Zm104,99.46L92,162.13V93.87l48-37.33ZM212,128a44,44,0,0,1-11,29.11,12,12,0,1,1-18-15.88,20,20,0,0,0,0-26.43,12,12,0,0,1,18-15.86A43.94,43.94,0,0,1,212,128Zm40,0a83.87,83.87,0,0,1-21.39,56,12,12,0,0,1-17.89-16,60,60,0,0,0,0-80,12,12,0,1,1,17.88-16A83.87,83.87,0,0,1,252,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M80,88v80H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M160,32.25V223.69a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.57-51A4,4,0,0,1,80,176.16V79.84a4,4,0,0,1,1.55-3.15l65.57-51a8,8,0,0,1,10,.16A8.27,8.27,0,0,1,160,32.25ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Zm126.77,20.84a8,8,0,0,0-.72,11.3,24,24,0,0,1,0,31.72,8,8,0,1,0,12,10.58,40,40,0,0,0,0-52.88A8,8,0,0,0,186.74,100.84Zm40.89-26.17a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M154.64,26.61a6,6,0,0,0-6.32.65L77.94,82H32A14,14,0,0,0,18,96v64a14,14,0,0,0,14,14H77.94l70.38,54.74A6,6,0,0,0,158,224V32A6,6,0,0,0,154.64,26.61ZM30,160V96a2,2,0,0,1,2-2H74v68H32A2,2,0,0,1,30,160Zm116,51.73L86,165.07V90.93l60-46.66Zm50.53-108.85a38,38,0,0,1,0,50.24,6,6,0,1,1-9-7.94,26,26,0,0,0,0-34.37,6,6,0,0,1,9-7.93ZM246,128a77.86,77.86,0,0,1-19.86,52,6,6,0,1,1-8.94-8,66,66,0,0,0,0-88,6,6,0,1,1,8.94-8A77.86,77.86,0,0,1,246,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M155.51,24.81a8,8,0,0,0-8.42.88L77.25,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V32A8,8,0,0,0,155.51,24.81ZM32,96H72v64H32ZM144,207.64,88,164.09V91.91l56-43.55Zm54-106.08a40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.58,24,24,0,0,0,0-31.72,8,8,0,0,1,12-10.58ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M153.76,28.41a4,4,0,0,0-4.22.43L78.63,84H32A12,12,0,0,0,20,96v64a12,12,0,0,0,12,12H78.63l70.91,55.16A4.07,4.07,0,0,0,152,228a3.92,3.92,0,0,0,1.76-.41A4,4,0,0,0,156,224V32A4,4,0,0,0,153.76,28.41ZM28,160V96a4,4,0,0,1,4-4H76v72H32A4,4,0,0,1,28,160Zm120,55.82L84,166V90l64-49.78Zm47-111.61a36,36,0,0,1,0,47.59,4,4,0,1,1-6-5.3,28,28,0,0,0,0-37,4,4,0,0,1,6-5.28ZM244,128a75.88,75.88,0,0,1-19.35,50.67,4,4,0,0,1-6-5.34,68,68,0,0,0,0-90.66,4,4,0,0,1,6-5.34A75.88,75.88,0,0,1,244,128Z"
        }))
    ]
]);


const $10175a158768899b$export$951b168b9ecc05fb = $acw62.forwardRef((r, a)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: a,
        ...r,
        weights: (0, $374082d405f0c49c$export$2e2bcd8739ae039)
    }));
$10175a158768899b$export$951b168b9ecc05fb.displayName = "SpeakerHighIcon";
const $10175a158768899b$export$72b5f9f618bcd07d = $10175a158768899b$export$951b168b9ecc05fb;


var $acw62 = parcelRequire("acw62");

var $eaLPw = parcelRequire("eaLPw");

var $acw62 = parcelRequire("acw62");
const $fa2d373f3601f00d$export$2e2bcd8739ae039 = /* @__PURE__ */ new Map([
    [
        "bold",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M56.88,31.93A12,12,0,1,0,39.12,48.07L64.51,76H32A20,20,0,0,0,12,96v64a20,20,0,0,0,20,20H75.88l68.75,53.47A12,12,0,0,0,164,224V185.44l35.12,38.63a12,12,0,0,0,17.76-16.14ZM36,100H68v56H36Zm104,99.46L92,162.13V106.24L140,159Zm-31-134a12,12,0,0,1,2.11-16.84l33.51-26.07A12,12,0,0,1,164,32V94.94a12,12,0,0,1-24,0V56.54l-14.15,11A12,12,0,0,1,109,65.44Zm74,49.35a12,12,0,0,1,18-15.85,44,44,0,0,1,5.55,50.21,12,12,0,0,1-21-11.55A19.67,19.67,0,0,0,188,128,20,20,0,0,0,183,114.79ZM252,128a84.18,84.18,0,0,1-19.11,53.35,12,12,0,1,1-18.53-15.25A60,60,0,0,0,212.73,88a12,12,0,1,1,17.88-16A83.87,83.87,0,0,1,252,128Z"
        }))
    ],
    [
        "duotone",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M80,88v80H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8Z",
            opacity: "0.2"
        }), /* @__PURE__ */ $acw62.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L73.55,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V175.09l42.08,46.29a8,8,0,1,0,11.84-10.76ZM32,96H72v64H32ZM144,207.64,88,164.09V95.89l56,61.6Zm42-63.77a24,24,0,0,0,0-31.72,8,8,0,1,1,12-10.57,40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.59Zm-80.16-76a8,8,0,0,1,1.4-11.23l39.85-31A8,8,0,0,1,160,32v74.83a8,8,0,0,1-16,0V48.36l-26.94,21A8,8,0,0,1,105.84,67.91ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "fill",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M213.92,210.62a8,8,0,1,1-11.84,10.76L160,175.09v48.6a8.29,8.29,0,0,1-3.91,7.18,8,8,0,0,1-9-.56l-65.55-51A4,4,0,0,1,80,176.18V87.09L42.08,45.38A8,8,0,1,1,53.92,34.62Zm-27.21-55.46a8,8,0,0,0,11.29-.7,40,40,0,0,0,0-52.88,8,8,0,1,0-12,10.57,24,24,0,0,1,0,31.72A8,8,0,0,0,186.71,155.16Zm40.92-80.49a8,8,0,1,0-11.92,10.66,64,64,0,0,1,0,85.34,8,8,0,1,0,11.92,10.66,80,80,0,0,0,0-106.66ZM153,119.87a4,4,0,0,0,7-2.7V32.25a8.27,8.27,0,0,0-2.88-6.4,8,8,0,0,0-10-.16L103.83,59.33a4,4,0,0,0-.5,5.85ZM60,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H60a4,4,0,0,0,4-4V84A4,4,0,0,0,60,80Z"
        }))
    ],
    [
        "light",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M52.44,36A6,6,0,0,0,43.56,44L78,81.94l-.08.06H32A14,14,0,0,0,18,96v64a14,14,0,0,0,14,14H77.94l70.38,54.74A6,6,0,0,0,158,224V169.92L203.56,220a6,6,0,0,0,8.88-8.08ZM30,160V96a2,2,0,0,1,2-2H74v68H32A2,2,0,0,1,30,160Zm116,51.73L86,165.07V90.93l.11-.08L146,156.72Zm41.5-66.53a26,26,0,0,0,0-34.37,6,6,0,1,1,9-7.93,38,38,0,0,1,0,50.24,6,6,0,0,1-9-7.94ZM107.41,66.68a6,6,0,0,1,1.06-8.42l39.85-31A6,6,0,0,1,158,32v74.83a6,6,0,0,1-12,0V44.27L115.83,67.73A6,6,0,0,1,107.41,66.68ZM246,128a77.86,77.86,0,0,1-19.86,52,6,6,0,1,1-8.94-8,66,66,0,0,0,0-88,6,6,0,1,1,8.94-8A77.86,77.86,0,0,1,246,128Z"
        }))
    ],
    [
        "regular",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M53.92,34.62A8,8,0,1,0,42.08,45.38L73.55,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.25l69.84,54.31A8,8,0,0,0,160,224V175.09l42.08,46.29a8,8,0,1,0,11.84-10.76ZM32,96H72v64H32ZM144,207.64,88,164.09V95.89l56,61.6Zm42-63.77a24,24,0,0,0,0-31.72,8,8,0,1,1,12-10.57,40,40,0,0,1,0,52.88,8,8,0,0,1-12-10.59Zm-80.16-76a8,8,0,0,1,1.4-11.23l39.85-31A8,8,0,0,1,160,32v74.83a8,8,0,0,1-16,0V48.36l-26.94,21A8,8,0,0,1,105.84,67.91ZM248,128a79.9,79.9,0,0,1-20.37,53.34,8,8,0,0,1-11.92-10.67,64,64,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67A79.83,79.83,0,0,1,248,128Z"
        }))
    ],
    [
        "thin",
        /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("path", {
            d: "M51,37.31A4,4,0,0,0,45,42.69L81,82.19,78.63,84H32A12,12,0,0,0,20,96v64a12,12,0,0,0,12,12H78.63l70.91,55.16A4.07,4.07,0,0,0,152,228a3.92,3.92,0,0,0,1.76-.41A4,4,0,0,0,156,224V164.75l49,53.94a4,4,0,1,0,5.92-5.38ZM28,160V96a4,4,0,0,1,4-4H76v72H32A4,4,0,0,1,28,160Zm120,55.82L84,166V90l2.35-1.83L148,156Zm41-69.3a28,28,0,0,0,0-37,4,4,0,1,1,6-5.29,36,36,0,0,1,0,47.59,4,4,0,1,1-6-5.29ZM109,65.45a4,4,0,0,1,.7-5.61l39.85-31A4,4,0,0,1,156,32v74.83a4,4,0,0,1-8,0V40.18l-33.39,26A4,4,0,0,1,109,65.45ZM244,128a75.88,75.88,0,0,1-19.35,50.67,4,4,0,0,1-6-5.34,68,68,0,0,0,0-90.66,4,4,0,0,1,6-5.34A75.88,75.88,0,0,1,244,128Z"
        }))
    ]
]);


const $46f049c3c71edcb6$export$e8087ce41a037429 = $acw62.forwardRef((o, r)=>/* @__PURE__ */ $acw62.createElement((0, $eaLPw.default), {
        ref: r,
        ...o,
        weights: (0, $fa2d373f3601f00d$export$2e2bcd8739ae039)
    }));
$46f049c3c71edcb6$export$e8087ce41a037429.displayName = "SpeakerSlashIcon";
const $46f049c3c71edcb6$export$7372de0dc9bbbd21 = $46f049c3c71edcb6$export$e8087ce41a037429;



var $7Yi7V = parcelRequire("7Yi7V");

var $e4LUm = parcelRequire("e4LUm");

var $4vfI7 = parcelRequire("4vfI7");


var $acw62 = parcelRequire("acw62");

function $4b82fe218372b69c$export$2e2bcd8739ae039() {
    const subscribe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((cb)=>(0, $cd49d00d6f1363b1$export$22ff19d9bef9b9a9)(cb), []);
    const muted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useSyncExternalStore(subscribe, (0, $cd49d00d6f1363b1$export$daf3ed797ed8a980), (0, $cd49d00d6f1363b1$export$daf3ed797ed8a980));
    return [
        muted,
        (0, $cd49d00d6f1363b1$export$a1680ba91cc9be33)
    ];
}



var $baa6D = parcelRequire("baa6D");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");

var $gDnUo = parcelRequire("gDnUo");


var $e4LUm = parcelRequire("e4LUm");

var $baa6D = parcelRequire("baa6D");


function $1b07297e5ead3e1c$var$ColorPalette() {
    const { palette: palette, activeColorIndex: activeColorIndex, setActiveColorIndex: setActiveColorIndex, setPaletteSlot: setPaletteSlot, colorLocked: colorLocked } = (0, $e4LUm.usePalette)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: palette.map((hex, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$Swatch, {
                index: i,
                hex: hex,
                active: i === activeColorIndex,
                locked: colorLocked,
                onSelect: colorLocked ? null : setActiveColorIndex,
                onEdit: colorLocked ? null : setPaletteSlot
            }, i))
    });
}
function $1b07297e5ead3e1c$export$e896a615f92a0856() {
    const { palette: palette, activeColorIndex: activeColorIndex, setActiveColorIndex: setActiveColorIndex, setPaletteSlot: setPaletteSlot, colorLocked: colorLocked } = (0, $e4LUm.usePalette)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const activeHex = palette[activeColorIndex];
    const handleSelect = (idx)=>{
        setActiveColorIndex(idx);
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: setOpen,
        side: "top",
        align: "end",
        sideOffset: 8,
        trigger: /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$CompactSwatch, {
            type: "button",
            $hex: activeHex,
            onClick: ()=>setOpen((o)=>!o),
            "aria-label": `Active color (${activeHex}) \xb7 tap to change`,
            title: `${activeHex} \xb7 tap to change`
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$Grid, {
            children: palette.map((hex, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$Swatch, {
                    index: i,
                    hex: hex,
                    active: i === activeColorIndex,
                    locked: colorLocked,
                    onSelect: colorLocked ? null : handleSelect,
                    onEdit: colorLocked ? null : setPaletteSlot
                }, i))
        })
    });
}
const $1b07297e5ead3e1c$var$Grid = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  grid-auto-rows: auto;
  gap: 4px;
  justify-items: center;
`;
// Mirrors the desktop "active swatch" look: chrome-active square pad
// behind a circular pigment swatch. Sized to match the toolbar's
// ToolButton — 40px on mobile (where this is actually rendered),
// 50px otherwise as a fallback if anyone reuses it on desktop.
const $1b07297e5ead3e1c$var$CompactSwatch = (0, $lmFrL.default).button.attrs({
    onMouseDown: (0, $baa6D.noFocusOnMouseDown)
})`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: var(--color-chrome-active);
  cursor: pointer;

  &::after {
    content: "";
    width: 80%;
    aspect-ratio: 1;
    border-radius: 50%;
    background: ${(p)=>p.$hex};
  }

  &:focus-visible {
    outline: 2px solid var(--color-chrome-active);
    outline-offset: 2px;
  }
`;
const $1b07297e5ead3e1c$var$OuterWrap = (0, $lmFrL.default).div`
  display: grid;
  place-items: center;
  width: 50px;
  aspect-ratio: 1;
  border-radius: 6px;
  background: ${(p)=>p.$active ? "var(--color-chrome-active)" : "transparent"};

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    width: 40px;
  }

  transition: background-color 120ms ease-out;

  &:hover:not(:disabled) {
    background: ${(p)=>p.$active ? "var(--color-chrome-active)" : "var(--color-chrome-hover)"};
  }
`;
function $1b07297e5ead3e1c$var$Swatch({ index: index, hex: hex, active: active, locked: locked, onSelect: onSelect, onEdit: onEdit }) {
    const [editorOpen, setEditorOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { active: eyedropperActive } = (0, $7caa007c47a491c5$export$968d3a33c108f1d4)();
    const openEditor = (event)=>{
        if (!onEdit) return;
        event.preventDefault();
        setEditorOpen(true);
    };
    const onLight = (0, $gDnUo.isLightColor)(hex);
    const title = locked ? `${index + 1} \xb7 ${hex} \xb7 color locked (speedrun)` : onEdit ? `${index + 1} \xb7 ${hex} \xb7 double-click or right-click to edit` : `${index + 1} \xb7 ${hex}`;
    const swatchEl = /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$OuterWrap, {
        $active: active,
        $locked: locked,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$SwatchWrap, {
            $hex: hex,
            $active: active,
            $locked: locked,
            $onLight: onLight,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$SwatchButton, {
                type: "button",
                onClick: onSelect ? ()=>onSelect(index) : undefined,
                onDoubleClick: openEditor,
                onContextMenu: onEdit ? openEditor : (e)=>e.preventDefault(),
                "aria-label": `Color ${index + 1} (${hex})`,
                title: title,
                disabled: locked && !active,
                $locked: locked,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($1b07297e5ead3e1c$var$Num, {
                    $onLight: onLight,
                    children: index + 1
                })
            })
        })
    });
    if (!onEdit) return swatchEl;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
        open: editorOpen,
        onOpenChange: setEditorOpen,
        side: "right",
        align: "center",
        lockOpen: eyedropperActive,
        trigger: swatchEl,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $568ef2cc8320c42a$export$2e2bcd8739ae039), {
            value: hex,
            onChange: (next)=>onEdit(index, next),
            onClose: ()=>setEditorOpen(false)
        })
    });
}
// Circular swatches (pigment), distinct from the square tool buttons.
//
// One indicator at any state — no stacked rings:
//   idle:     soft 2px inset shadow, gives every swatch a visible boundary
//             against the chrome regardless of fill
//   selected: no inset; the OuterWrap's chrome-active background ring does
//             the "this one's picked" job
const $1b07297e5ead3e1c$var$SwatchWrap = (0, $lmFrL.default).div`
  position: relative;
  width: 80%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: ${(p)=>p.$hex};
  cursor: ${(p)=>p.$locked && !p.$active ? "default" : "pointer"};
  /* Locked + inactive swatches dim out so the active one reads as the only
     interactive thing. The active swatch stays full-strength so the player
     can see what color is selected for the current target. */
  opacity: ${(p)=>p.$locked && !p.$active ? 0.35 : 1};
  box-shadow: ${(p)=>p.$active ? "none" : "inset 0 0 2px rgba(0, 0, 0, 0.3)"};
  z-index: ${(p)=>p.$active ? 1 : 0};
  transition: opacity 200ms ease-out;
`;
const $1b07297e5ead3e1c$var$SwatchButton = (0, $lmFrL.default).button.attrs({
    onMouseDown: (0, $baa6D.noFocusOnMouseDown)
})`
  appearance: none;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: ${(p)=>p.disabled ? "default" : "pointer"};
`;
// Centered inside the circle — the geometry of a round swatch doesn't give
// a corner to tuck the hint in. Tool buttons (square) keep their bottom-
// right hint; different shape, different placement.
// Hidden on coarse-pointer devices for the same reason as toolbar Hints.
const $1b07297e5ead3e1c$var$Num = (0, $lmFrL.default).span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: ${(p)=>p.$onLight ? "var(--color-text)" : "var(--color-selected-fg)"};
  opacity: 0.8;
  pointer-events: none;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;

  @media (pointer: coarse) {
    display: none;
  }
`;
var $1b07297e5ead3e1c$export$2e2bcd8739ae039 = $1b07297e5ead3e1c$var$ColorPalette;






const $205b7352174a90c0$var$ICON_SIZE = 22;
const $205b7352174a90c0$var$Group = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.125rem;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    flex-direction: row;
  }
`;
const $205b7352174a90c0$var$FullPaletteOnly = (0, $lmFrL.default).div`
  display: contents;

  @media (max-width: ${(0, $7Yi7V.COMPACT_PALETTE_BREAKPOINT)}px) {
    display: none;
  }
`;
const $205b7352174a90c0$var$CompactPaletteOnly = (0, $lmFrL.default).div`
  display: none;

  @media (max-width: ${(0, $7Yi7V.COMPACT_PALETTE_BREAKPOINT)}px) {
    display: contents;
  }
`;
function $205b7352174a90c0$var$DrawingToolbar({ onUndo: onUndo, onRedo: onRedo, canUndo: canUndo, canRedo: canRedo, disabled: disabled = false, visible: visible = true, showMute: showMute = false }) {
    const { tool: tool, setTool: setTool, penSize: penSize, eraserSize: eraserSize, setSize: setSize } = (0, $4vfI7.useTool)();
    const { colorLocked: colorLocked } = (0, $e4LUm.usePalette)();
    const [muted, setMuted] = (0, $4b82fe218372b69c$export$2e2bcd8739ae039)();
    const [openPopover, setOpenPopover] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Stagger pop-in for icon buttons each time the toolbar reveals. Double-rAF
    // primes "off" before flipping "on" so the animation re-triggers on every
    // false→true cycle, not just first mount.
    const [animateIn, setAnimateIn] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const wasVisibleRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!visible) {
            setAnimateIn(false);
            wasVisibleRef.current = false;
            return;
        }
        if (wasVisibleRef.current) return;
        wasVisibleRef.current = true;
        setAnimateIn(false);
        let id2 = 0;
        const id1 = requestAnimationFrame(()=>{
            id2 = requestAnimationFrame(()=>setAnimateIn(true));
        });
        return ()=>{
            cancelAnimationFrame(id1);
            cancelAnimationFrame(id2);
        };
    }, [
        visible
    ]);
    // Tracks whether the currently-open popover was opened via hotkey, so that
    // a hotkey open auto-focuses the slider thumb (arrow-key driveable) but a
    // click open keeps focus on the canvas. Cleared on any close.
    const [openedByHotkey, setOpenedByHotkey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Single-click selects (and closes any open popover). Double-click and
    // right-click open the tool's size popover — same model as ColorPalette,
    // where single = use, secondary = configure. Single-click on the already-
    // active tool is a no-op.
    //
    // `disabled` short-circuits all of these so the toolbar reads as inert
    // chrome in modes where the canvas isn't accepting input (currently:
    // landing). Hotkeys still register on window-level useKey but no-op
    // because cycleHotkey checks `disabled`.
    const selectTool = (next)=>{
        if (disabled) return;
        setTool(next);
        setOpenPopover(null);
        setOpenedByHotkey(false);
    };
    const openPopoverFor = (next)=>{
        if (disabled) return;
        setTool(next);
        setOpenPopover(next);
        setOpenedByHotkey(false);
    };
    const onContextMenuFor = (next)=>(e)=>{
            e.preventDefault();
            openPopoverFor(next);
        };
    // Radix only calls this with `false` (Escape, click-outside) since we drive
    // open via Anchor + caller state, not Trigger.
    const closeIfRequested = (open)=>{
        if (!open) {
            setOpenPopover(null);
            setOpenedByHotkey(false);
        }
    };
    // Hotkey cycle: first press selects the tool (closing any popover); a
    // second press of the same hotkey opens that tool's popover (focused);
    // a third press closes it. Tools without a popover (fill) just select.
    // Pressing a different tool's hotkey always switches and closes whatever
    // was open.
    const cycleHotkey = (next, hasPopover)=>()=>{
            if (disabled) return;
            if (tool !== next) {
                setTool(next);
                setOpenPopover(null);
                setOpenedByHotkey(false);
                return;
            }
            if (!hasPopover) return;
            if (openPopover === next) {
                setOpenPopover(null);
                setOpenedByHotkey(false);
            } else {
                setOpenPopover(next);
                setOpenedByHotkey(true);
            }
        };
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("q", cycleHotkey("pen", true));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("b", cycleHotkey("pen", true));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("w", cycleHotkey("fill", false));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("f", cycleHotkey("fill", false));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("e", cycleHotkey("eraser", true));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$Bar, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$Group, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "pen",
                        onOpenChange: closeIfRequested,
                        side: "right",
                        align: "start",
                        sideOffset: 4,
                        autoFocusOnOpen: openedByHotkey && openPopover === "pen",
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$ToolButton, {
                            type: "button",
                            $active: tool === "pen",
                            disabled: disabled,
                            $animateIn: animateIn,
                            $staggerIndex: 0,
                            onClick: ()=>selectTool("pen"),
                            onDoubleClick: ()=>openPopoverFor("pen"),
                            onContextMenu: onContextMenuFor("pen"),
                            title: "Pen (q) \xb7 double-click or right-click to set size",
                            "aria-label": "Pen",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcfb5017307d0d93$export$145d90bf65d7f62b), {
                                    size: $205b7352174a90c0$var$ICON_SIZE,
                                    weight: "fill"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Hint, {
                                    children: "q"
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$PopLabel, {
                                children: [
                                    "Pen \xb7 ",
                                    penSize,
                                    "px"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 2,
                                max: 60,
                                value: penSize,
                                onValueChange: (v)=>setSize(v),
                                ariaLabel: "Pen size"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$ToolButton, {
                        type: "button",
                        $active: tool === "fill",
                        disabled: disabled,
                        $animateIn: animateIn,
                        $staggerIndex: 1,
                        onClick: ()=>selectTool("fill"),
                        onContextMenu: (e)=>e.preventDefault(),
                        title: "Paint bucket (w)",
                        "aria-label": "Paint bucket",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7b3808ac3150303$export$38a21d0b1a76c510), {
                                size: $205b7352174a90c0$var$ICON_SIZE,
                                weight: "fill"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Hint, {
                                children: "w"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $0439259ca7ccea8d$export$2e2bcd8739ae039), {
                        open: openPopover === "eraser",
                        onOpenChange: closeIfRequested,
                        side: "right",
                        align: "start",
                        sideOffset: 4,
                        autoFocusOnOpen: openedByHotkey && openPopover === "eraser",
                        trigger: /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$ToolButton, {
                            type: "button",
                            $active: tool === "eraser",
                            disabled: disabled,
                            $animateIn: animateIn,
                            $staggerIndex: 2,
                            onClick: ()=>selectTool("eraser"),
                            onDoubleClick: ()=>openPopoverFor("eraser"),
                            onContextMenu: onContextMenuFor("eraser"),
                            title: "Eraser (e) \xb7 double-click or right-click to set size",
                            "aria-label": "Eraser",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fabc15b223e6cf0b$export$dd603c4f14fc685b), {
                                    size: $205b7352174a90c0$var$ICON_SIZE,
                                    weight: "fill"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Hint, {
                                    children: "e"
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$PopLabel, {
                                children: [
                                    "Eraser \xb7 ",
                                    eraserSize,
                                    "px"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ffaeb3a0df79d49$export$2e2bcd8739ae039), {
                                min: 4,
                                max: 80,
                                value: eraserSize,
                                onValueChange: (v)=>setSize(v),
                                ariaLabel: "Eraser size"
                            })
                        ]
                    })
                ]
            }),
            !colorLocked && /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$Group, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$FullPaletteOnly, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b07297e5ead3e1c$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$CompactPaletteOnly, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b07297e5ead3e1c$export$e896a615f92a0856), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$Group, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$ToolButton, {
                        type: "button",
                        onClick: onUndo,
                        disabled: disabled || !canUndo,
                        $animateIn: animateIn,
                        $staggerIndex: 3,
                        title: "Undo (z)",
                        "aria-label": "Undo",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dad4d9e310df876e$export$61587597da16632a), {
                                size: $205b7352174a90c0$var$ICON_SIZE
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Hint, {
                                children: "z"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($205b7352174a90c0$var$ToolButton, {
                        type: "button",
                        onClick: onRedo,
                        disabled: disabled || !canRedo,
                        $animateIn: animateIn,
                        $staggerIndex: 4,
                        title: "Redo (r or shift+z)",
                        "aria-label": "Redo",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f285fda8af7575e7$export$a7eba9a04bceab86), {
                                size: $205b7352174a90c0$var$ICON_SIZE
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Hint, {
                                children: "r"
                            })
                        ]
                    })
                ]
            }),
            showMute && /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$Group, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($205b7352174a90c0$var$ToolButton, {
                    type: "button",
                    onClick: ()=>setMuted(!muted),
                    $animateIn: animateIn,
                    $staggerIndex: 5,
                    title: muted ? "Unmute" : "Mute",
                    "aria-label": muted ? "Unmute" : "Mute",
                    "aria-pressed": muted,
                    children: muted ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $46f049c3c71edcb6$export$7372de0dc9bbbd21), {
                        size: $205b7352174a90c0$var$ICON_SIZE,
                        weight: "fill"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $10175a158768899b$export$72b5f9f618bcd07d), {
                        size: $205b7352174a90c0$var$ICON_SIZE,
                        weight: "fill"
                    })
                })
            })
        ]
    });
}
const $205b7352174a90c0$var$Bar = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem; // CR nroyalty: make sure that this works on small screens?
  padding: 12px 10px;
  background-color: var(--color-chrome);
  border-right: 1px solid var(--color-chrome-border);
  flex: 0 0 auto;
  overflow: visible;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    gap: 0.5rem;
    padding: 6px 10px 0;
    border-right: none;
    border-top: 1px solid var(--color-chrome-border);
  }
`;
const $205b7352174a90c0$var$popIn = (0, $lmFrL.keyframes)`
  0% {
    opacity: 0;
    transform: scale(0.4) rotate(-14deg);
  }
  60% {
    opacity: 1;
    transform: scale(1.12) rotate(4deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
`;
const $205b7352174a90c0$var$ToolButton = (0, $lmFrL.default).button.attrs({
    onMouseDown: (0, $baa6D.noFocusOnMouseDown)
})`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  opacity: 0.95;
  border-radius: 6px;
  background: ${(p)=>p.$active ? "var(--color-chrome-active)" : "transparent"};
  color: var(--color-chrome-fg);
  border: none;
  cursor: pointer;
  transition:
    background-color 120ms ease-out,
    color 120ms ease-out;

  &:hover:not(:disabled) {
    background: ${(p)=>p.$active ? "var(--color-chrome-active)" : "var(--color-chrome-hover)"};
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }

  ${(p)=>p.$animateIn && (0, $lmFrL.css)`
      animation: ${$205b7352174a90c0$var$popIn} 380ms ease-out both;
      animation-delay: calc(${p.$staggerIndex ?? 0} * 55ms + 220ms);
    `}

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    width: 40px;
    height: 40px;

    & > svg {
      width: 26px;
      height: 26px;
    }
  }
`;
// Hint inherits color from its ToolButton so it flips light when active.
// Hidden on coarse-pointer devices (phones, tablets) where there's no
// keyboard to press these hotkeys with — tooltip + aria-label still carry
// the info for hover/AT users.
const $205b7352174a90c0$var$Hint = (0, $lmFrL.default).span`
  position: absolute;
  bottom: 2px;
  right: 4px;
  font-size: 11px;
  font-weight: 700;
  color: inherit;
  pointer-events: none;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;

  @media (pointer: coarse) {
    display: none;
  }
`;
const $205b7352174a90c0$var$PopLabel = (0, $lmFrL.default).div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
`;
var $205b7352174a90c0$export$2e2bcd8739ae039 = $205b7352174a90c0$var$DrawingToolbar;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $hwQVN = parcelRequire("hwQVN");

var $7Yi7V = parcelRequire("7Yi7V");

var $gLxJv = parcelRequire("gLxJv");

var $4e3Nb = parcelRequire("4e3Nb");

var $3IUwO = parcelRequire("3IUwO");

var $4cvDM = parcelRequire("4cvDM");


var $fFWQJ = parcelRequire("fFWQJ");

const $764ce5e5a1823266$var$Modal = (0, $lmFrL.default)((0, $25e2004465f0404a$export$2e2bcd8739ae039))`
  background-image:
    linear-gradient(to right, var(--pattern-color) 1px, transparent 1px),
    linear-gradient(to bottom, var(--pattern-color) 1px, transparent 1px);
  background-size: var(--pattern-size) var(--pattern-size);
`;
// Round-complete recap.
//
// One row, all three drawings the same size. Each drawing wears a
// big circular marc-photo "tag" pinned to its upper-right corner —
// since the egg is always positioned toward the bottom of the
// frame in play, the upper-right of every drawing tile is mostly
// empty orange canvas-bg, which gives us plenty of room for a
// reference circle without obscuring the actual artwork.
//
// Sort order is by per-marc duration (fastest first). No
// click-to-promote — equal-sized tiles convey "all three are the
// recap" without needing a winner.
//
// Drawings render from `drawingSrc` (data URL captured at
// triggerShowcase). Strokes/palette/eggTransform/marcTransform/
// finishedAt/duration ride along in the same snapshot;
// marcTransform is kept around for a possible future rectangular-
// frame variant of the marc tag.
function $764ce5e5a1823266$var$EndScreenModal({ open: open, onOpenChange: onOpenChange, lineup: lineup, roundDrawings: roundDrawings, elapsedMs: elapsedMs, onSyndicate: onSyndicate }) {
    const orderedByDuration = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        return [
            ...lineup
        ].sort((a, b)=>{
            const da = roundDrawings[a]?.duration ?? Infinity;
            const db = roundDrawings[b]?.duration ?? Infinity;
            return da - db;
        });
    }, [
        lineup,
        roundDrawings
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$Modal, {
        open: open,
        onOpenChange: onOpenChange,
        width: 820,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($764ce5e5a1823266$var$Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($764ce5e5a1823266$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$Eyebrow, {
                            children: "Velocity established"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$b26fae16ba5468aa), {
                            children: [
                                "You shipped in: ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$Time, {
                                    children: $764ce5e5a1823266$var$formatElapsed(elapsedMs)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$Row, {
                    children: orderedByDuration.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$MarcSlot, {
                            marcId: id,
                            snapshot: roundDrawings[id],
                            onSyndicate: onSyndicate
                        }, id))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$Footer, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
                        variant: "primary",
                        size: "large",
                        onClick: ()=>onOpenChange(false),
                        children: "Keep Building"
                    })
                })
            ]
        })
    });
}
const $764ce5e5a1823266$var$Stack = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
// One slot = the framed drawing + its marc-photo tag in the upper
// right. The tag is sized as a fraction of the slot width
// (--marc-tag-size) so it scales with the column when the row
// wraps on narrow viewports.
function $764ce5e5a1823266$var$MarcSlot({ marcId: marcId, snapshot: snapshot, onSyndicate: onSyndicate }) {
    const hasDrawing = !!(snapshot?.strokes && snapshot?.palette);
    const canSyndicate = hasDrawing && !!onSyndicate;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($764ce5e5a1823266$var$SlotShell, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$DrawingFrame, {
                snapshot: snapshot
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$MarcCircle, {
                src: (0, $4e3Nb.marcImageUrl)(marcId),
                alt: "",
                draggable: false
            }),
            hasDrawing && /*#__PURE__*/ (0, $ayMG0.jsxs)($764ce5e5a1823266$var$SlotActions, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                        type: "button",
                        disabled: !canSyndicate,
                        onClick: ()=>onSyndicate?.(marcId, snapshot),
                        title: "Submit your egg to the gallery and grab share images",
                        style: {
                            minWidth: "128px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $358642fbc699ef49$export$ee62305a5b7a42eb), {
                                size: 14,
                                weight: "fill"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Syndicate"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                        type: "button",
                        style: {
                            minWidth: "128px"
                        },
                        onClick: ()=>(0, $gLxJv.downloadComposite)({
                                marcId: marcId,
                                eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
                                strokes: snapshot.strokes,
                                palette: snapshot.palette,
                                eggTransform: snapshot.eggTransform,
                                marcTransform: snapshot.marcTransform,
                                lights: snapshot.eggLights,
                                warmth: snapshot.eggWarmth,
                                redshift: snapshot.eggRedshift
                            }),
                        title: "Download a PNG of this Marc",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hwQVN.DownloadSimple), {
                                size: 14,
                                weight: "bold"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: "Download"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Gold-framed drawing tile. Same FRAME_OUTER virtual stage that the
// play surface and MarcPickerModal use — FitContainer scales it to
// whatever size the parent column gives it.
function $764ce5e5a1823266$var$DrawingFrame({ snapshot: snapshot }) {
    const transform = snapshot?.eggTransform;
    const drawingSrc = snapshot?.drawingSrc ?? null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$FrameStage, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fFWQJ.default), {
            width: (0, $7Yi7V.FRAME_OUTER_WIDTH),
            height: (0, $7Yi7V.FRAME_OUTER_HEIGHT),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($764ce5e5a1823266$var$FrameInterior, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$EggImg, {
                            src: (0, $4e3Nb.eggImageUrl)((0, $7Yi7V.DEFAULT_EGG_ID)),
                            alt: "",
                            draggable: false,
                            style: {
                                transform: (0, $3IUwO.eggTransformToCss)(transform)
                            }
                        }),
                        drawingSrc && /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$DrawingImg, {
                            src: drawingSrc,
                            alt: "",
                            draggable: false
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($764ce5e5a1823266$var$FrameOverlay, {
                    src: "/frame.png",
                    alt: "",
                    draggable: false
                })
            ]
        })
    });
}
function $764ce5e5a1823266$var$formatElapsed(ms) {
    const total = Math.max(0, ms ?? 0);
    const totalTenths = Math.floor(total / 100);
    const tenths = totalTenths % 10;
    const totalSeconds = Math.floor(totalTenths / 10);
    const seconds = totalSeconds % 60;
    const minutes = Math.floor(totalSeconds / 60);
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");
    return `${mm}:${ss}.${tenths}`;
}
const $764ce5e5a1823266$var$Header = (0, $lmFrL.default).div`
  text-align: center;
  margin-bottom: 1rem;

  & > h2 {
    line-height: 1.05;
  }
`;
const $764ce5e5a1823266$var$Eyebrow = (0, $lmFrL.default).div`
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--color-text-muted);
`;
const $764ce5e5a1823266$var$Time = (0, $lmFrL.default).span`
  /* font-family: "Fraunces", serif; */
  /* font-size: clamp(2.5rem, 6vw, 3.5rem); */
  /* font-weight: 600; */
  /* letter-spacing: -0.02em; */
  /* line-height: 1; */
  color: var(--color-orange-700);
  /* text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4),
    0 2px 0 var(--color-text); */
`;
// All three drawings, equal-width. minmax(200px, 1fr) wraps the
// row when the modal is too narrow (mobile / very small windows)
// instead of squeezing the columns past readability.
const $764ce5e5a1823266$var$Row = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 640px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`;
// SlotShell is the click target / position anchor for the marc
// circle. position: relative so MarcCircle's absolute positioning
// is relative to this slot, not the modal.
const $764ce5e5a1823266$var$SlotShell = (0, $lmFrL.default).div`
  position: relative;
  display: flex;
  flex-direction: column;
`;
const $764ce5e5a1823266$var$SlotActions = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.6rem;
`;
// Marc-photo tag — a much bigger circle than the previous flanker
// thumb, since it now lives in the empty upper portion of every
// drawing (the egg sits at the bottom of every play frame). Sized
// as a fraction of the slot width via container query units so it
// scales with the column when the row wraps.
//
// Slight upper/right overhang reads as a sticker pinned ON the
// frame rather than tucked inside it.
const $764ce5e5a1823266$var$MarcCircle = (0, $lmFrL.default).img`
  position: absolute;
  top: -25px;
  right: -10px;
  /* ~50% of the slot width — at modal width 820 with 3 columns
     each slot is ~250px, so the circle ends up ~125px. Bigger on
     wider viewports, smaller when the row wraps narrow. */
  width: 45%;
  aspect-ratio: 1;
  border-radius: 50%;
  object-fit: cover;
  background: var(--canvas-bg);
  border: 3px solid var(--color-orange-700);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  user-select: none;
  pointer-events: none;
  z-index: 2;
`;
// Drawing tile chrome (gold frame). Aspect-ratio matches the
// FRAME_OUTER PNG so FitContainer fills it 1:1.
const $764ce5e5a1823266$var$FrameStage = (0, $lmFrL.default).div`
  width: 100%;
  aspect-ratio: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)} / ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)};
  position: relative;
  filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.22));
`;
const $764ce5e5a1823266$var$FrameInterior = (0, $lmFrL.default).div`
  position: absolute;
  top: ${(0, $7Yi7V.FRAME_SLICE_TOP)}px;
  left: ${(0, $7Yi7V.FRAME_SLICE_LEFT)}px;
  width: ${(0, $7Yi7V.CANVAS_WIDTH)}px;
  height: ${(0, $7Yi7V.CANVAS_HEIGHT)}px;
  background: var(--canvas-bg);
  overflow: hidden;
`;
const $764ce5e5a1823266$var$FrameOverlay = (0, $lmFrL.default).img`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)}px;
  height: ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)}px;
  pointer-events: none;
  user-select: none;
`;
const $764ce5e5a1823266$var$EggImg = (0, $lmFrL.default).img`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: center center;
  user-select: none;
  pointer-events: none;
`;
const $764ce5e5a1823266$var$DrawingImg = (0, $lmFrL.default).img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;
`;
const $764ce5e5a1823266$var$Footer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
`;
var $764ce5e5a1823266$export$2e2bcd8739ae039 = $764ce5e5a1823266$var$EndScreenModal;





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");

var $4e3Nb = parcelRequire("4e3Nb");

var $3IUwO = parcelRequire("3IUwO");
// Auto-generated by scripts/gen-manifest.js. Do not edit by hand —
// re-run `npm run gen-manifest` after adding/removing references.
//
// Per-marc data needed to render a marc photo in the picker modal in
// the same pose as the easel + onion overlay: canvas-virtual dims plus
// the marc's displayBox / transform / naturalSize. Saves the picker
// from fetching every reference JSON on open (those carry full base64
// region masks and run hundreds of KB each).
const $556276f41489f5d5$export$6284c8d968c0583f = {
    "001": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -10.099714181496886,
                "ty": 105.82139197322951,
                "scale": 1.0293913074511956,
                "rot": 0
            },
            "naturalSize": {
                "width": 250,
                "height": 250
            }
        }
    },
    "002": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 190.13064133016627,
                "w": 792,
                "h": 637.7387173396675
            },
            "transform": {
                "tx": 18.209938017003964,
                "ty": 158.08462238849935,
                "scale": 1.275508366678405,
                "rot": -0.23025322353298983
            },
            "naturalSize": {
                "width": 421,
                "height": 339
            }
        }
    },
    "003": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 34.76501305483026,
                "w": 792,
                "h": 948.4699738903395
            },
            "transform": {
                "tx": 9.185672097391773,
                "ty": 42.09384944916758,
                "scale": 1.0285975820716986,
                "rot": 0
            },
            "naturalSize": {
                "width": 1149,
                "height": 1376
            }
        }
    },
    "004": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 104.08999999999997,
                "w": 792,
                "h": 809.82
            },
            "transform": {
                "tx": 24.065178400472035,
                "ty": 77.66360777741988,
                "scale": 1.0751987243813756,
                "rot": 0
            },
            "naturalSize": {
                "width": 400,
                "height": 409
            }
        }
    },
    "006": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -7.689256002737537,
                "ty": 107.5929933777718,
                "scale": 1.0225298010330004,
                "rot": 0
            },
            "naturalSize": {
                "width": 350,
                "height": 350
            }
        }
    },
    "007": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": 26.985163314663595,
                "ty": 90.30908144195823,
                "scale": 1.0829932864749525,
                "rot": -0.21020383656264788
            },
            "naturalSize": {
                "width": 200,
                "height": 200
            }
        }
    },
    "008": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -4.61230212042625,
                "ty": 97.69322522100144,
                "scale": 1.0727574527513921,
                "rot": 0
            },
            "naturalSize": {
                "width": 153,
                "height": 153
            }
        }
    },
    "009": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 118.95488721804514,
                "w": 792,
                "h": 780.0902255639097
            },
            "transform": {
                "tx": 7.675108337599106,
                "ty": 74.46623545613437,
                "scale": 1.142075501764111,
                "rot": 0
            },
            "naturalSize": {
                "width": 133,
                "height": 131
            }
        }
    },
    "010": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -0.7639739174753026,
                "ty": 125.9000720669022,
                "scale": 1,
                "rot": 0
            },
            "naturalSize": {
                "width": 460,
                "height": 460
            }
        }
    },
    "011": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -7.385081202261259,
                "ty": 86.53419381921645,
                "scale": 1.1022162577580488,
                "rot": 0
            },
            "naturalSize": {
                "width": 161,
                "height": 161
            }
        }
    },
    "012": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 106.01176470588234,
                "w": 792,
                "h": 805.9764705882353
            },
            "transform": {
                "tx": 4.378702360344559,
                "ty": 112.60126683677656,
                "scale": 1.0261143282463372,
                "rot": 0
            },
            "naturalSize": {
                "width": 1020,
                "height": 1038
            }
        }
    },
    "013": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": 19.870395686927083,
                "ty": 95.5250350146897,
                "scale": 1.0667967071952114,
                "rot": 0
            },
            "naturalSize": {
                "width": 340,
                "height": 340
            }
        }
    },
    "014": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -44.233820674769184,
                "ty": 22.09262510250433,
                "scale": 1.231976117945633,
                "rot": 0
            },
            "naturalSize": {
                "width": 440,
                "height": 440
            }
        }
    },
    "015": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 113,
                "w": 792,
                "h": 792
            },
            "transform": {
                "tx": -5.100233282404565,
                "ty": 118.77672266970191,
                "scale": 1,
                "rot": 0
            },
            "naturalSize": {
                "width": 220,
                "height": 220
            }
        }
    },
    "016": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 116.19490445859873,
                "w": 792,
                "h": 785.6101910828025
            },
            "transform": {
                "tx": 13.384633738294859,
                "ty": 106.13341506529716,
                "scale": 1.0347449045627557,
                "rot": -0.008361093920056621
            },
            "naturalSize": {
                "width": 2355,
                "height": 2336
            }
        }
    },
    "017": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 112.48638132295719,
                "w": 792,
                "h": 793.0272373540856
            },
            "transform": {
                "tx": 19.73348799984997,
                "ty": 93.4148906265753,
                "scale": 1.0678035637060619,
                "rot": 0
            },
            "naturalSize": {
                "width": 771,
                "height": 772
            }
        }
    },
    "018": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 100.68,
                "w": 792,
                "h": 816.64
            },
            "transform": {
                "tx": 15.112354734062322,
                "ty": 66.35420033142239,
                "scale": 1.1239423889470417,
                "rot": 0
            },
            "naturalSize": {
                "width": 900,
                "height": 928
            }
        }
    },
    "019": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 52.674509803921524,
                "y": 0,
                "w": 686.650980392157,
                "h": 1018
            },
            "transform": {
                "tx": 2.317505271431031,
                "ty": 10.345510058993057,
                "scale": 1.154539184890988,
                "rot": -0.044358694248405106
            },
            "naturalSize": {
                "width": 172,
                "height": 255
            }
        }
    },
    "020": {
        "canvas": {
            "width": 792,
            "height": 1018
        },
        "marc": {
            "displayBox": {
                "x": 0,
                "y": 129.73239436619718,
                "w": 792,
                "h": 758.5352112676056
            },
            "transform": {
                "tx": 0.9549673968441283,
                "ty": 135.71147784040446,
                "scale": 1,
                "rot": 0
            },
            "naturalSize": {
                "width": 355,
                "height": 340
            }
        }
    }
};



var $fFWQJ = parcelRequire("fFWQJ");

// Marc gallery modal — opens at the start of creative mode and any time
// the user clicks "Change Marc." Each tile is a mini gold-framed portrait
// rendered at the canonical FRAME_OUTER × FRAME_OUTER_HEIGHT virtual
// stage and scaled to fit via FitContainer, mirroring DrawingArea's
// structure so the marc inside each tile sits in the exact pose it
// would in author/play mode (orange canvas-bg interior, marc photo
// positioned by marcTransform from the saved reference).
function $6510fc73fba60ab1$var$MarcPickerModal({ open: open, onOpenChange: onOpenChange, marcIds: marcIds, selectedId: selectedId, onPick: onPick }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        width: 920,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$b26fae16ba5468aa), {
                children: [
                    "Who do you want to ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$Accent, {
                        children: "draw today?"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$Grid, {
                children: marcIds.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$Tile, {
                        type: "button",
                        $active: id === selectedId,
                        onClick: ()=>onPick(id),
                        "aria-label": `Marc ${id}`,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$PortraitFrame, {
                            id: id
                        })
                    }, id))
            })
        ]
    });
}
// One framed marc. The FitContainer holds the canonical FRAME_OUTER
// virtual stage; inside, FrameInterior is the orange canvas-bg layer at
// canvas-virtual dims (positioned at the slice offsets so it sits
// exactly inside frame.png's transparent center), and FrameOverlay is
// the gold frame PNG painted on top. The marc photo is positioned in
// FrameInterior with marcTransformToCss(mult=1) — same call DrawingArea
// uses, since both render inside a FitContainer-scaled stage.
//
// If a marc isn't in MARC_PICKER_DATA (e.g. someone added a thumbnail
// without a committed reference yet) we render with no transform and
// let object-fit: contain do its best.
function $6510fc73fba60ab1$var$PortraitFrame({ id: id }) {
    const data = (0, $556276f41489f5d5$export$6284c8d968c0583f)[id];
    const transform = data?.marc.transform;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $fFWQJ.default), {
        width: (0, $7Yi7V.FRAME_OUTER_WIDTH),
        height: (0, $7Yi7V.FRAME_OUTER_HEIGHT),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$FrameInterior, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$MarcImg, {
                    src: (0, $4e3Nb.marcImageUrl)(id),
                    alt: "",
                    draggable: false,
                    style: {
                        transform: transform ? (0, $3IUwO.marcTransformToCss)(transform) : "translate(-50%, -50%)"
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($6510fc73fba60ab1$var$FrameOverlay, {
                src: "/frame.png",
                alt: "",
                draggable: false
            })
        ]
    });
}
const $6510fc73fba60ab1$var$Accent = (0, $lmFrL.default).span`
  color: var(--color-orange-700);
`;
// Column count is fluid — auto-fit gives 4 → 3 → 2 → 1 as the modal
// narrows, with the inner min(170px, 100%) preventing a single tile
// from overflowing on phone widths (without it, the floor would force
// a horizontal scrollbar inside the modal at sub-170px widths). The
// gap clamps so vertical breathing room shrinks proportionally on
// narrow screens.
const $6510fc73fba60ab1$var$Grid = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(170px, 100%), 1fr));
  gap: clamp(0.75rem, 2vw, 1.5rem) clamp(0.75rem, 2vw, 1.25rem);
  margin-top: 1.25rem;
`;
// The clickable wrapper around a portrait. We expose --frame-shadow as
// a CSS var on Tile and read it from FrameOverlay's filter — that way
// hover/active swap the gold frame's drop-shadow without applying it to
// the orange interior (which would shadow as a rectangle past the
// frame edges). Default is a soft museum-hang shadow; hover deepens it,
// active layers in a warm orange-700 glow so the current marc reads
// against the already-warm gold frames.
const $6510fc73fba60ab1$var$Tile = (0, $lmFrL.default).button`
  --frame-shadow: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.22));

  position: relative;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 4px;
  aspect-ratio: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)} / ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)};
  transition: transform 140ms ease-out;

  ${(p)=>p.$active && `
      transform: translateY(-2px);
      --frame-shadow:
        drop-shadow(0 0 6px var(--color-orange-700))
        drop-shadow(0 10px 14px rgba(0, 0, 0, 0.3));
    `}

  &:hover {
    transform: translateY(-3px);
    --frame-shadow: drop-shadow(0 10px 14px rgba(0, 0, 0, 0.3));
  }

  &:focus-visible {
    outline: 2px solid var(--color-orange-700);
    outline-offset: 4px;
  }
`;
// Sized in canvas-virtual px and positioned at the gold frame's slice
// offsets — the same coordinate space DrawingArea's <Frame> uses. The
// FitContainer above scales it to display alongside FrameOverlay.
const $6510fc73fba60ab1$var$FrameInterior = (0, $lmFrL.default).div`
  position: absolute;
  top: ${(0, $7Yi7V.FRAME_SLICE_TOP)}px;
  left: ${(0, $7Yi7V.FRAME_SLICE_LEFT)}px;
  width: ${(0, $7Yi7V.CANVAS_WIDTH)}px;
  height: ${(0, $7Yi7V.CANVAS_HEIGHT)}px;
  background: var(--canvas-bg);
  overflow: hidden;
`;
// Same shape as OnionMarc.MarcImg — left:50%/top:50% with the centering
// translate baked into marcTransformToCss. width/height: 100% means the
// layout box equals FrameInterior; object-fit: contain preserves the
// natural photo aspect within it.
const $6510fc73fba60ab1$var$MarcImg = (0, $lmFrL.default).img`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: center center;
  user-select: none;
  pointer-events: none;
`;
// drop-shadow on an img with a transparent center casts shadow only
// from the gold portion's silhouette — the transparent middle doesn't
// throw a shadow over the marc photo behind it. Filter value comes
// from --frame-shadow on the Tile parent so hover/active can swap it.
// transition on filter is what makes the active glow + hover lift feel
// like the frame is responding rather than snapping.
const $6510fc73fba60ab1$var$FrameOverlay = (0, $lmFrL.default).img`
  position: absolute;
  top: 0;
  left: 0;
  width: ${(0, $7Yi7V.FRAME_OUTER_WIDTH)}px;
  height: ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)}px;
  pointer-events: none;
  user-select: none;
  filter: var(--frame-shadow);
  transition: filter 140ms ease-out;
`;
var $6510fc73fba60ab1$export$2e2bcd8739ae039 = $6510fc73fba60ab1$var$MarcPickerModal;





var $9RQES = parcelRequire("9RQES");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");

// Presentational. All state + state-machine logic lives in
// MarcEngine (per-marc) and SpeedrunEngine (round); this component
// just renders snapshots.
function $a0d5763e6f8dc01d$var$ScorePanel({ snapshot: snapshot, bindBar: bindBar, roundSnapshot: roundSnapshot, countIn: countIn }) {
    const { celebrating: celebrating, hasLabeled: hasLabeled, regions: regions } = snapshot;
    // Pre-round: timer hasn't started yet. Egg is flying in, reference
    // might still be loading, or the 3-2-1-GO sequence is rolling. We
    // dim the panel content and show "…" in the count-in slot until
    // the active numeral takes over. Gate on startedAt alone (not
    // total > 0) so the overlay covers the first render after mode
    // flips to SPEEDRUN — before the engine's start() effect runs.
    const beforeRoundStart = roundSnapshot?.startedAt == null;
    const numeral = countIn?.numeral ?? (beforeRoundStart ? "\u2026" : null);
    const showOverlay = numeral != null;
    // Dim while the overlay is fully on — exit fade lifts the dim so
    // the panel content swells back up as the numeral fades out.
    const dim = showOverlay && !countIn?.exiting;
    const barRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        bindBar(barRef.current);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a0d5763e6f8dc01d$var$StyledPanel, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$FlashOverlay, {
                $on: celebrating
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($a0d5763e6f8dc01d$var$Stack, {
                $dim: dim,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($a0d5763e6f8dc01d$var$TopLine, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Title, {
                                children: $a0d5763e6f8dc01d$var$roundLabel(roundSnapshot)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$RoundTimer, {
                                startedAt: roundSnapshot?.startedAt ?? null,
                                endedAt: roundSnapshot?.endedAt ?? null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Body, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$BodyContent, {
                            snapshot: snapshot,
                            barRef: barRef
                        })
                    }),
                    hasLabeled && /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Pips, {
                        children: regions.map((r)=>/*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Pip, {
                                $on: r.detected,
                                title: r.label
                            }, r.id))
                    })
                ]
            }),
            showOverlay && /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$CountInOverlay, {
                $exiting: countIn?.exiting ?? false,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$CountInNumeral, {
                    $waiting: countIn?.numeral == null,
                    children: numeral
                }, numeral)
            })
        ]
    });
}
const $a0d5763e6f8dc01d$var$StyledPanel = (0, $lmFrL.default)((0, $5507f8043745c309$export$2e2bcd8739ae039))`
  padding: 10px 16px 12px;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    padding: 6px 12px 8px;
  }
`;
// Count-up timer. Drives its own rAF loop and writes textContent
// directly to the DOM, so the panel doesn't re-render at 30fps. The
// round freezes the displayed time at endedAt - startedAt the moment
// SpeedrunEngine flips complete.
function $a0d5763e6f8dc01d$var$RoundTimer({ startedAt: startedAt, endedAt: endedAt }) {
    const elRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const el = elRef.current;
        if (!el) return;
        if (startedAt == null) {
            el.textContent = $a0d5763e6f8dc01d$var$formatElapsed(0);
            return;
        }
        if (endedAt != null) {
            el.textContent = $a0d5763e6f8dc01d$var$formatElapsed(endedAt - startedAt);
            return;
        }
        let raf = 0;
        const tick = ()=>{
            el.textContent = $a0d5763e6f8dc01d$var$formatElapsed(Date.now() - startedAt);
            raf = requestAnimationFrame(tick);
        };
        tick();
        return ()=>cancelAnimationFrame(raf);
    }, [
        startedAt,
        endedAt
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Time, {
        ref: elRef,
        children: $a0d5763e6f8dc01d$var$formatElapsed(0)
    });
}
// MM:SS.t — minutes : seconds . tenths. Tenths precision is enough at
// the speedrun pace (rounds run ~30-90s); milliseconds would jitter
// without adding signal.
function $a0d5763e6f8dc01d$var$formatElapsed(ms) {
    const total = Math.max(0, ms);
    const totalTenths = Math.floor(total / 100);
    const tenths = totalTenths % 10;
    const totalSeconds = Math.floor(totalTenths / 10);
    const seconds = totalSeconds % 60;
    const minutes = Math.floor(totalSeconds / 60);
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");
    return `${mm}:${ss}.${tenths}`;
}
// Top-line round counter. Pre-round (no lineup) reads as just "Marc".
function $a0d5763e6f8dc01d$var$roundLabel(roundSnapshot) {
    const total = roundSnapshot?.total ?? 0;
    if (total === 0) return "Marc";
    // currentIndex is 0-based mid-round; parks on the last index when the
    // round completes, so cap displayed N at total.
    const current = Math.min(roundSnapshot.currentIndex + 1, total);
    return `Marc ${current} of ${total}`;
}
// Three body states, dispatched in order:
//   1. empty   — reference not yet loaded (cache miss). Render nothing;
//                the count-in overlay covers the panel during this
//                window so an empty body never shows through.
//   2. done    — every region detected, marc complete
//   3. active  — drawing in progress (further branches inside)
function $a0d5763e6f8dc01d$var$BodyContent({ snapshot: snapshot, barRef: barRef }) {
    const { hasLabeled: hasLabeled, allDone: allDone, shownLabel: shownLabel } = snapshot;
    if (!hasLabeled) return null;
    // Mirror ActiveInstruction's outer shape (caption + TargetSlot + a
    // bar-shaped slot) so the panel doesn't shrink between the last
    // celebration and "marc complete." The bar slot is solid-filled
    // instead of striped — signal "done" without restarting the diagonal
    // scroll.
    if (allDone) return /*#__PURE__*/ (0, $ayMG0.jsxs)($a0d5763e6f8dc01d$var$Instruction, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$DrawThe, {
                children: "You drew"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$TargetSlot, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Target, {
                    children: "Marc!"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$ProgressTrack, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$DoneFill, {})
            })
        ]
    });
    if (!shownLabel) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$ActiveInstruction, {
        snapshot: snapshot,
        barRef: barRef
    });
}
// Active drawing UI: small caption + the rotating big label + progress
// bar. The big-label slot has its own three-way render — overdraw
// override, mid-celebration crossfade, settled — pulled out into
// TargetContent so each branch reads one-line.
function $a0d5763e6f8dc01d$var$ActiveInstruction({ snapshot: snapshot, barRef: barRef }) {
    const { shownOverdrawn: shownOverdrawn } = snapshot;
    const caption = shownOverdrawn ? "that's too much" : "Draw His";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($a0d5763e6f8dc01d$var$Instruction, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$DrawThe, {
                $alert: shownOverdrawn,
                children: caption
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$TargetSlot, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$TargetContent, {
                    snapshot: snapshot
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$ProgressTrack, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$ProgressFill, {
                    ref: barRef
                })
            })
        ]
    });
}
function $a0d5763e6f8dc01d$var$TargetContent({ snapshot: snapshot }) {
    const { shownOverdrawn: shownOverdrawn, celebrating: celebrating, shownLabel: shownLabel, incomingLabel: incomingLabel } = snapshot;
    if (shownOverdrawn) return /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Target, {
        $overdrawn: true,
        children: shownLabel
    }, "overdrawn");
    if (celebrating) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Target, {
                $exiting: true,
                children: shownLabel
            }, "exiting"),
            incomingLabel && /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Target, {
                $entering: true,
                children: incomingLabel
            }, "entering")
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a0d5763e6f8dc01d$var$Target, {
        children: shownLabel
    }, "settled");
}
const $a0d5763e6f8dc01d$var$Stack = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  height: 100%;
  /* gap: 0.5rem; */
  transition: opacity ${(0, $7Yi7V.COUNT_IN_EXIT_MS)}ms ease-out;
  opacity: ${(p)=>p.$dim ? 0.15 : 1};
`;
const $a0d5763e6f8dc01d$var$TopLine = (0, $lmFrL.default).div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;
`;
const $a0d5763e6f8dc01d$var$Time = (0, $lmFrL.default).div`
  /* font-size: 11px; */
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  /* color: var(--color-text-muted); */
`;
const $a0d5763e6f8dc01d$var$Title = (0, $lmFrL.default).div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
`;
const $a0d5763e6f8dc01d$var$Body = (0, $lmFrL.default).div`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: 0;
  padding: 1.25rem 0;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    padding: 0.5rem 0;
  }
`;
const $a0d5763e6f8dc01d$var$DrawThe = (0, $lmFrL.default).span`
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-text-muted);
  line-height: 1;

  ${(p)=>p.$alert && (0, $lmFrL.css)`
      color: var(--color-alert);
      /* font-size: 14px; */
      letter-spacing: 0.04em;
    `}
`;
const $a0d5763e6f8dc01d$var$Instruction = (0, $lmFrL.default).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* gap: 0.25rem; */
`;
// Stack two Targets in the same grid cell so the outgoing label can slide
// up and out while the incoming label slides up from below — no manual
// absolute positioning per label needed.
const $a0d5763e6f8dc01d$var$TargetSlot = (0, $lmFrL.default).div`
  display: grid;
  grid-template-areas: "stack";
  align-items: center;
  justify-items: center;
  overflow: hidden;
`;
const $a0d5763e6f8dc01d$var$slideUpOut = (0, $lmFrL.keyframes)`
  0% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(-110%); opacity: 0; }
`;
const $a0d5763e6f8dc01d$var$slideUpIn = (0, $lmFrL.keyframes)`
  0% { transform: translateY(110%); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;
const $a0d5763e6f8dc01d$var$fadeOut = (0, $lmFrL.keyframes)`
  from { opacity: 1; }
  to { opacity: 0; }
`;
const $a0d5763e6f8dc01d$var$fadeIn = (0, $lmFrL.keyframes)`
  from { opacity: 0; }
  to { opacity: 1; }
`;
const $a0d5763e6f8dc01d$var$Target = (0, $lmFrL.default).span`
  grid-area: stack;
  font-family: "Fraunces", serif;
  font-size: 3.25rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.1;
  text-transform: uppercase;
  color: var(--color-orange-500);
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4),
    0 2px 0 var(--color-text);

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    font-size: 2.4rem;
  }

  ${(p)=>p.$exiting && (0, $lmFrL.css)`
      animation: ${$a0d5763e6f8dc01d$var$slideUpOut} ${0, $7Yi7V.CELEBRATION_MS}ms ease-out forwards;
    `}
  ${(p)=>p.$entering && (0, $lmFrL.css)`
      animation: ${$a0d5763e6f8dc01d$var$slideUpIn} ${0, $7Yi7V.CELEBRATION_MS}ms ease-out forwards;
    `}

  ${(p)=>p.$overdrawn && (0, $lmFrL.css)`
      color: #ff6467;
    `}

  @media (prefers-reduced-motion: reduce) {
    ${(p)=>p.$exiting && (0, $lmFrL.css)`
        animation: ${$a0d5763e6f8dc01d$var$fadeOut} ${0, $7Yi7V.CELEBRATION_MS}ms ease-out forwards !important;
      `}
    ${(p)=>p.$entering && (0, $lmFrL.css)`
        animation: ${$a0d5763e6f8dc01d$var$fadeIn} ${0, $7Yi7V.CELEBRATION_MS}ms ease-out forwards !important;
      `}
  }
`;
const $a0d5763e6f8dc01d$var$ProgressTrack = (0, $lmFrL.default).div`
  width: 280px;
  height: 12px;
  border-radius: 2px;
  margin-top: 0.5rem;
  background: var(--color-orange-200);
  /* overflow: hidden; */
  position: relative;
  outline: 1px solid var(--color-text);

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    margin-top: 0.25rem;
    height: 10px;
  }
`;
const $a0d5763e6f8dc01d$var$progressFillAnimation = (0, $lmFrL.keyframes)`
  to {
    background-position: 24px 0;
  }
`;
const $a0d5763e6f8dc01d$var$ProgressFill = (0, $lmFrL.default).div`
  /* The fill spans the full track; the DetectionGate writes
     clip-path: inset(0 N% 0 0) directly to this element to reveal more
     of the bar as the displayed score rises. clip-path leaves the
     rotated stripe pseudo unscaled (a width / scaleX animation would
     shear the diagonal). */
  position: absolute;
  inset: 0;
  clip-path: inset(0 100% 0 0);
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200%;
    height: 500px;
    background:
      repeating-linear-gradient(
        90deg,
        var(--color-orange-400) 0 12px,
        rgba(255, 255, 255, 0.4) 12px 24px
      ),
      var(--color-orange-500);
    background-size: 24px 24px;
    transform: translate(-50%, -50%) rotate(45deg);
    animation: ${$a0d5763e6f8dc01d$var$progressFillAnimation} 2000ms linear infinite;
    will-change: background-position;
  }

  /* Overdraw: same striped fill but flipped to alert red. The gate
     forces the bar to full when overdrawn, so the player sees a
     conspicuous solid-red bar instead of orange — paired with the
     "you drew too much" title swap above. */
  &[data-overdrawn="1"]::before {
    background:
      repeating-linear-gradient(
        90deg,
        var(--color-alert-stripe) 0 12px,
        rgba(255, 255, 255, 0.4) 12px 24px
      ),
      var(--color-alert);
    /* background: var(--color-alert); */
    background-size: 24px 24px;
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      animation: none;
    }
  }

  /* Pause the diagonal scroll while the bar is climbing toward raw
     target — two simultaneous animations (clip-path reveal + stripe
     scroll) read as visual noise. Resume on stable / satisfied,
     signaling "you're holding at this level, keep going." Driven by a
     data attribute the gate writes alongside clip-path. */
  &[data-growing="1"]::before {
    animation-play-state: paused;
  }
`;
const $a0d5763e6f8dc01d$var$DoneFill = (0, $lmFrL.default).div`
  position: absolute;
  inset: 0;
  background: var(--color-orange-500);
`;
const $a0d5763e6f8dc01d$var$Pips = (0, $lmFrL.default).div`
  display: flex;
  justify-content: center;
  gap: 6px;
`;
const $a0d5763e6f8dc01d$var$Pip = (0, $lmFrL.default).span`
  opacity: 0.8;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${(p)=>p.$on ? "var(--color-orange-500)" : "var(--color-stone-300)"};
  border: 1px solid
    ${(p)=>p.$on ? "var(--color-orange-500)" : "var(--color-border)"};
`;
// Diagonal light sweep across the panel on commit. Sits above the
// content so the gradient washes over labels + bar; pointer-events:
// none so it can't block input. Self-clips with overflow: hidden +
// matching border-radius (the parent Panel's Interior is
// border-radius: 6px and doesn't clip its children).
const $a0d5763e6f8dc01d$var$flashSweep = (0, $lmFrL.keyframes)`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;
// 3-2-1-GO takeover. Sits over the dimmed Stack. The numeral itself
// scale/fades in per beat (key change → remount); the overlay container
// fades the whole thing out during the exit window when markStarted has
// already fired and the panel content is fading back to full opacity.
const $a0d5763e6f8dc01d$var$countInPop = (0, $lmFrL.keyframes)`
  0%   { transform: scale(0.55); opacity: 0; }
  60%  { transform: scale(1.08); opacity: 1; }
  100% { transform: scale(1);    opacity: 1; }
`;
const $a0d5763e6f8dc01d$var$CountInOverlay = (0, $lmFrL.default).div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 2;
  transition: opacity ${(0, $7Yi7V.COUNT_IN_EXIT_MS)}ms ease-out;
  opacity: ${(p)=>p.$exiting ? 0 : 1};
`;
const $a0d5763e6f8dc01d$var$CountInNumeral = (0, $lmFrL.default).span`
  font-family: "Fraunces", serif;
  font-size: 5rem;
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--color-orange-500);
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4),
    0 2px 0 var(--color-text);
  animation: ${$a0d5763e6f8dc01d$var$countInPop} 280ms cubic-bezier(0.34, 1.56, 0.64, 1) both;

  ${(p)=>p.$waiting && (0, $lmFrL.css)`
      /* Waiting placeholder ("…") reads as secondary chrome — same
         slot as the numerals, but lighter and smaller so it doesn't
         compete with the 3-2-1-GO that's about to land. */
      font-size: 3rem;
      font-weight: 500;
      color: var(--color-text-muted);
      text-shadow: none;
      letter-spacing: 0.1em;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const $a0d5763e6f8dc01d$var$FlashOverlay = (0, $lmFrL.default).div`
  position: absolute;
  inset: 0;
  border-radius: 6px;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      115deg,
      transparent 35%,
      rgba(255, 255, 255, 0.55) 50%,
      transparent 65%
    );
    transform: translateX(-100%);
    ${(p)=>p.$on && (0, $lmFrL.css)`
        animation: ${$a0d5763e6f8dc01d$var$flashSweep} ${0, $7Yi7V.CELEBRATION_MS}ms ease-out forwards;
      `}
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
    }
  }
`;
var $a0d5763e6f8dc01d$export$2e2bcd8739ae039 = $a0d5763e6f8dc01d$var$ScorePanel;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $lmFrL = parcelRequire("lmFrL");


function $3b1308561e2d0f8f$var$SyndicateModal({ open: open, onOpenChange: onOpenChange, onSubmit: onSubmit }) {
    const [initials, setInitials] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (open) {
            setInitials("");
            setSubmitting(false);
            setError(null);
        }
    }, [
        open
    ]);
    const valid = /^[A-Z]{2}$/.test(initials);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (!valid || submitting) return;
        setSubmitting(true);
        setError(null);
        const result = await onSubmit({
            initials: initials
        });
        if (result?.ok) return;
        setSubmitting(false);
        setError(result?.error || "Submission failed. Try again.");
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: onOpenChange,
        width: 500,
        topOnMobile: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $25e2004465f0404a$export$b26fae16ba5468aa), {
                children: [
                    "Hello ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3b1308561e2d0f8f$var$Cap, {
                        children: "Founder"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($3b1308561e2d0f8f$var$Body, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: "Initial your artwork. Senior partners will review your piece and potentially list it in the gallery."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($3b1308561e2d0f8f$var$Form, {
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b1308561e2d0f8f$var$Label, {
                                htmlFor: "initials",
                                children: "Your initials"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3b1308561e2d0f8f$var$Input, {
                                id: "initials",
                                value: initials,
                                onChange: (e)=>setInitials(e.target.value.toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2)),
                                maxLength: 2,
                                placeholder: "MA",
                                autoFocus: typeof window !== "undefined" && !window.matchMedia("(pointer: coarse)").matches,
                                autoComplete: "off",
                                "data-1p-ignore": true,
                                "data-lpignore": "true",
                                "data-form-type": "other",
                                disabled: submitting
                            }),
                            error && /*#__PURE__*/ (0, $ayMG0.jsx)($3b1308561e2d0f8f$var$ErrorText, {
                                children: error
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($3b1308561e2d0f8f$var$Footer, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($eeaeb48e23f662e7$export$f39c2d165cd861fe, {
                                        asChild: true,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
                                            type: "button",
                                            variant: "default",
                                            size: "medium",
                                            disabled: submitting,
                                            children: "Cancel"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3d26c75613118b87$export$2e2bcd8739ae039), {
                                        type: "submit",
                                        variant: "primary",
                                        size: "medium",
                                        disabled: !valid || submitting,
                                        children: submitting ? "Syndicating\u2026" : "Syndicate"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $3b1308561e2d0f8f$var$Cap = (0, $lmFrL.default).span`
  color: var(--color-orange-700);
`;
const $3b1308561e2d0f8f$var$Body = (0, $lmFrL.default).div`
  font-size: 1rem;
  line-height: 1.55;
  color: var(--color-text);

  p {
    margin: 0 0 1rem;
  }
`;
const $3b1308561e2d0f8f$var$Form = (0, $lmFrL.default).form`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
const $3b1308561e2d0f8f$var$Label = (0, $lmFrL.default).label`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-muted);
`;
const $3b1308561e2d0f8f$var$Input = (0, $lmFrL.default).input`
  font-family: "Fraunces", serif;
  font-size: 2.5rem;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  width: 100%;
  padding: 0.5rem;
  background: var(--color-orange-50, #fff8f1);
  border: 2px solid var(--color-orange-300);
  border-radius: 6px;
  color: var(--color-text);

  &:focus {
    outline: none;
    border-color: var(--color-orange-700);
  }
`;
const $3b1308561e2d0f8f$var$ErrorText = (0, $lmFrL.default).div`
  font-size: 0.875rem;
  color: var(--color-alert, #b00020);
`;
const $3b1308561e2d0f8f$var$Footer = (0, $lmFrL.default).div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
`;
var $3b1308561e2d0f8f$export$2e2bcd8739ae039 = $3b1308561e2d0f8f$var$SyndicateModal;




// Schema + builder helpers for the syndicate-submission RPC. Imported by
// both the worker validator (functions/_shared.js, functions/api/submit.js)
// and the client request builder (src/components/App/App.js) so the two
// sides share one source of truth for which keys are on the wire.
//
// To add a field: add it to the relevant key-list AND thread it through
// the matching builder. Both ends pick it up automatically — the
// validator allows it, the builder forwards it.
const $8642a65fcc91168a$export$a5b415ec25a96912 = [
    "marcId",
    "eggId",
    "initials",
    "source",
    "elapsedMs",
    "strokes",
    "palette",
    "overrides"
];
const $8642a65fcc91168a$export$328b5a5cb522ea = [
    "tool",
    "colorIndex",
    "color",
    "size",
    "points"
];
const $8642a65fcc91168a$export$6f708a679fd2c796 = [
    "tool",
    "colorIndex",
    "color",
    "bbox",
    "maskPng"
];
const $8642a65fcc91168a$export$97efe9494599e8b7 = [
    "x",
    "y",
    "w",
    "h"
];
const $8642a65fcc91168a$export$8f727dd2be764a45 = [
    "x",
    "y",
    "pressure"
];
const $8642a65fcc91168a$export$ca4ebca91f0bedee = [
    "eggTransform",
    "marcTransform",
    "eggLights",
    "warmth",
    "redshift"
];
const $8642a65fcc91168a$export$bab94bf147cdeaf1 = [
    "tx",
    "ty",
    "scale",
    "scaleX",
    "rotation"
];
const $8642a65fcc91168a$export$f1f5c4f5dbb67d04 = [
    "tx",
    "ty",
    "scale",
    "rot"
];
const $8642a65fcc91168a$export$79dd9ed2d5395523 = [
    "direction",
    "intensity",
    "shadow",
    "size"
];
const $8642a65fcc91168a$export$7a24a077d7a1fcef = [
    "x",
    "y",
    "z"
];
function $8642a65fcc91168a$var$pickKeys(src, keys) {
    const out = {};
    for (const k of keys)if (src[k] !== undefined) out[k] = src[k];
    return out;
}
function $8642a65fcc91168a$export$38efa97b7a6f5e3f(src) {
    return $8642a65fcc91168a$var$pickKeys(src, $8642a65fcc91168a$export$a5b415ec25a96912);
}
function $8642a65fcc91168a$export$1e1cf71100296aff(src) {
    return $8642a65fcc91168a$var$pickKeys(src, $8642a65fcc91168a$export$ca4ebca91f0bedee);
}



var $jCH6j = parcelRequire("jCH6j");

var $R3rkF = parcelRequire("R3rkF");
function $4d8b6aef94a206ca$var$App() {
    const [urlState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(()=>(0, $7921bdd52deb8db9$export$e97fefb967eddbb9)());
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(urlState.mode);
    const authorMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).AUTHOR;
    const speedrunMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN;
    const landingMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING;
    const creativeMode = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE;
    // Preload every marc's photo + reference JSON at app mount so the
    // browser cache is warm before the landing reel cycles, the speedrun
    // lineup advances, or creative-mode marcs are picked. Without this,
    // marc swaps mid-transition can hit the network and the photo
    // <img> renders the previous (cached) image while the new one
    // decodes — the cloudflare flicker. Fire-and-forget; failed fetches
    // just mean a per-marc cache miss later, which the load-aware photo
    // gate still handles.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        for (const id of (0, $558b48ff778d5bc1$export$abd6720e30c85521)){
            const img = new Image();
            img.src = (0, $4e3Nb.marcImageUrl)(id);
            (0, $7vZux.preloadReference)(id);
        }
    }, []);
    // canvasRef is created here so useAuthoring's `save` can read the live
    // drawing canvas; AppBody attaches the ref to the actual <canvas>.
    const canvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Egg silhouette in canvas-virtual coords — populated by useEggLighting
    // (in DrawingArea), consumed by useDrawing's flood fill so the egg's
    // boundary acts as a wall.
    const eggSilhouetteRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const authoring = (0, $30e7b6ad4a686810$export$2e2bcd8739ae039)({
        urlState: urlState,
        mode: mode,
        canvasRef: canvasRef
    });
    // Multi-marc round state. Only meaningful in speedrun mode; rolls a
    // fresh lineup each time speedrun activates and resets on exit.
    // ?marcs=001,003 pins the lineup for testing.
    const speedrun = (0, $e47285a9ce27f4b2$export$2e2bcd8739ae039)({
        active: speedrunMode,
        available: (0, $558b48ff778d5bc1$export$abd6720e30c85521),
        pinnedLineup: urlState.pinnedMarcs,
        roundSize: (0, $7Yi7V.MARCS_PER_ROUND)
    });
    // `lastDisplayMarcIdRef` is the "last non-null logicalMarcId we
    // were rendering." Declared here so useLandingCycle can read it as
    // `entryFromMarcId` BEFORE useDisplayedSurfaces (which mutates it
    // via effect) runs. Two consumers, one ref:
    //
    //   useLandingCycle    — reads on first activation to drive the
    //                        entry-from-other-mode transition (fade out
    //                        FROM marc → swap src → fade in NEW marc →
    //                        move egg). Without it, the photo snaps to
    //                        ids[0] on landing entry and the user sees
    //                        ids[0] fading 1→0 before the natural fade-
    //                        in. The cycle scopes the value to its own
    //                        first-activation render, so passing it
    //                        unconditionally is safe.
    //   useDisplayedSurfaces — uses it as the `effectiveMarcId` fallback
    //                          during transient null states (speedrun
    //                          pre-engine-start, creative pre-pick) and
    //                          keeps it in sync via effect.
    const lastDisplayMarcIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Landing-page reel. Cycles a separate marc pool (LANDING_MARC_IDS,
    // currently == AVAILABLE_MARC_IDS) with timed fade phases so the
    // page boots into a moving showcase instead of a static marc.
    const landing = (0, $c4b469c0eb5e80de$export$2e2bcd8739ae039)({
        ids: (0, $68890285b5e31cfc$export$1e0018afdce14cd3),
        active: landingMode,
        entryFromMarcId: lastDisplayMarcIdRef.current
    });
    // Creative mode session state. Picker modal opens on entry; the
    // user's choice flows into effectiveMarcId via useDisplayedSurfaces.
    // Warmth/redshift/lights are reseeded to per-marc author values
    // inside useDisplayedSurfaces when the marc's reference loads.
    const creative = (0, $3699cbcb67a7e0a1$export$2e2bcd8739ae039)({
        active: creativeMode
    });
    // Single source of truth for "what marc is showing on each surface."
    // Owns every marcId derivation: logicalMarcId selector,
    // effectiveMarcId, the three useReferenceJson fetches, displayedMarcId,
    // displayedMarcTransform, eggDisplay (with tween), the creative
    // cross-fade dampening, and the creative reseed effects. App's
    // PaletteProvider + drawingAuthoring + the speedrun count-in effect
    // pull what they need from here; AppBody receives the whole bag as a
    // single `surfaces` prop.
    const surfaces = (0, $6bed9cd88f4a851e$export$2e2bcd8739ae039)({
        urlState: urlState,
        mode: mode,
        authoring: authoring,
        speedrun: speedrun,
        landing: landing,
        creative: creative,
        lastDisplayMarcIdRef: lastDisplayMarcIdRef
    });
    // Speedrun start gate + 3-2-1-GO count-in. Defers markStarted (the
    // round timer) until the egg has actually arrived at the round's
    // first marc, then plays the count-in and fires markStarted at GO.
    // See useSpeedrunCountIn for the gate's race-fix details.
    const countIn = (0, $44735938ea086b83$export$2e2bcd8739ae039)({
        active: speedrunMode,
        currentMarcId: speedrun.snapshot.currentMarcId,
        eggReferenceLoadedForMarcId: surfaces.eggReferenceLoadedForMarcId,
        tween: surfaces.tween,
        markStarted: speedrun.markStarted,
        debug: urlState.debug
    });
    // Color is locked in modes where the player isn't picking colors —
    // speedrun (color follows the current target region) and landing
    // (palette would flicker per marc on the cycling reel). Creative
    // leaves it unlocked so the player can pick freely.
    const colorLocked = speedrunMode || landingMode;
    // Creative reuses DrawingArea's onion machinery (designed for
    // author mode) by feeding an authoring-shaped bag with just the
    // onion fields populated. Drag/transform setters are omitted —
    // the user can't reposition the marc onion in creative for now,
    // matching the "fewer, friendlier" toolset.
    const creativeAuthoringLike = creativeMode && creative.selectedMarcId ? {
        // The onion src lags via displayedMarcId so the photo stays
        // on the OLD marc through fade-out, snaps under cover of
        // opacity 0, and fades in as the NEW marc.
        marcOnionSrc: (0, $4e3Nb.marcImageUrl)(creative.displayedMarcId ?? creative.selectedMarcId),
        // No separate visibility toggle — the user's slider IS the
        // on/off switch, so visible = (user's) opacity > 0. We force
        // visible=true throughout the swap (even when creativeOnionOpacity
        // is 0) so the element stays mounted and CSS transition can
        // animate; otherwise OnionMarc unmounts at opacity 0 and the
        // fade-in has nothing to fade from.
        marcVisible: creative.onionOpacity > 0,
        marcOpacity: surfaces.creativeOnionOpacity,
        marcOpacityTransitionMs: surfaces.creativeOnionTransitionMs,
        marcTransformMode: false
    } : null;
    const drawingAuthoring = creativeMode ? creativeAuthoringLike : authoring;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4vfI7.ToolProvider), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4LUm.PaletteProvider), {
            palette: surfaces.eff.palette,
            setPaletteSlot: authorMode ? authoring.setPaletteSlot : creativeMode ? creative.setPaletteSlot : null,
            colorLocked: colorLocked,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$AppBody, {
                urlState: urlState,
                mode: mode,
                setMode: setMode,
                authoring: authoring,
                drawingAuthoring: drawingAuthoring,
                creative: creative,
                surfaces: surfaces,
                canvasRef: canvasRef,
                eggSilhouetteRef: eggSilhouetteRef,
                speedrun: speedrun,
                landing: landing,
                countIn: countIn
            })
        })
    });
}
function $4d8b6aef94a206ca$var$AppBody({ urlState: urlState, mode: mode, setMode: setMode, authoring: authoring, drawingAuthoring: drawingAuthoring, creative: creative, surfaces: surfaces, canvasRef: canvasRef, eggSilhouetteRef: eggSilhouetteRef, speedrun: speedrun, landing: landing, countIn: countIn }) {
    // Pull the surface bundle apart locally so the JSX + effects below
    // read naturally. `surfaces` is the single source of truth for marcId
    // resolution + reference fetches + per-surface lagged transforms;
    // see useDisplayedSurfaces for the full timing model.
    const { effectiveMarcId: effectiveMarcId, displayedMarcId: displayedMarcId, displayedMarcTransform: displayedMarcTransform, reference: reference, eff: eff, landingDrawing: landingDrawing, eggDisplay: eggDisplay, creativePhotoVisible: creativePhotoVisible, tween: tween } = surfaces;
    const eggTweening = tween.tweening;
    const { tool: tool, size: size } = (0, $4vfI7.useTool)();
    const { activeColorIndex: activeColorIndex, setActiveColorIndex: setActiveColorIndex, colorLocked: colorLocked } = (0, $e4LUm.usePalette)();
    // Scoring knobs are deliberately ephemeral — we're hunting for values to
    // bake into constants.js, so surviving a refresh would just confuse
    // "is this the default or am I still overriding?". The debug panel that
    // mutates them is gated on ?debug.
    const [scoreOverrides, setScoreOverrides] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState((0, $c1e9a979fb38f5e6$export$6de33833799c3d24));
    const drawing = (0, $b678971e312560c2$export$2e2bcd8739ae039)({
        canvasRef: canvasRef,
        tool: tool,
        palette: eff.palette,
        colorIndex: activeColorIndex,
        size: size,
        eggSilhouetteRef: eggSilhouetteRef,
        freezeStrokeColor: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE
    });
    // MarcEngine owns shownId / celebrating / target picker / auto-color /
    // auto-pen-on-celebration-end for the current marc. `active` gates the
    // engine on speedrun mode so committed flags don't carry over between
    // mode switches; the engine also resets on marcId change so flags
    // don't bleed across marcs in a round.
    // DrawingArea reads snapshot.celebrating to disable canvas input
    // during the celebration window — otherwise the auto-color-switch can
    // land mid-stroke and the player draws the next region's color onto
    // the previous one.
    const marcEngine = (0, $f02e9dd8be437860$export$2e2bcd8739ae039)({
        active: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN,
        marcId: effectiveMarcId,
        strokes: drawing.strokes,
        palette: eff.palette,
        reference: reference,
        scoreOverrides: scoreOverrides,
        lastTool: drawing.lastTool,
        lastActionAt: drawing.lastActionAt
    });
    // Marc-completion showcase + end-screen-recap data. Fires after
    // EACH marc completes (not just at round end) — the inter-marc
    // punchline beat. See useShowcase for the full timing model.
    //
    // onMarcCaptured fires per marc the moment the showcase trigger
    // captures it — same beat as the recap snapshot. Used to record
    // the drawing into the local "Mine" log so the gallery's Mine tab
    // sees every speedrun entry, syndicated or not. The localId is
    // stashed so a later syndicate from the end-screen attaches to
    // the same entry instead of creating a duplicate.
    const roundLocalIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const handleMarcCaptured = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((marcId, snap)=>{
        if (!snap.strokes?.length || !snap.palette) return;
        roundLocalIdsRef.current[marcId] = (0, $R3rkF.recordDrawing)({
            marcId: marcId,
            eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
            source: "speedrun",
            elapsedMs: snap.duration,
            strokes: snap.strokes,
            palette: snap.palette
        });
    }, []);
    const { showcasing: showcasing, showcaseMarc: showcaseMarc, roundDrawings: roundDrawings, triggerShowcase: triggerShowcase, debugEndScreenOpen: debugEndScreenOpen, triggerDebugEndScreen: triggerDebugEndScreen } = (0, $c47171705eb25d33$export$2e2bcd8739ae039)({
        active: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN,
        allDone: marcEngine.snapshot.allDone,
        advanceMarc: speedrun.advanceMarc,
        effectiveMarcId: effectiveMarcId,
        eff: eff,
        strokes: drawing.strokes,
        canvasRef: canvasRef,
        speedrunLineup: speedrun.snapshot.lineup,
        speedrunStartedAt: speedrun.snapshot.startedAt,
        onMarcCaptured: handleMarcCaptured
    });
    // Wipe the canvas on marc change — including round entry (null →
    // first marc) and round exit (last marc → null) for speedrun, plus
    // every "Change Marc" action in creative. Idempotent on an empty
    // canvas, so the no-op cases are free.
    const currentMarcId = speedrun.snapshot.currentMarcId;
    const creativeSelectedMarcId = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE ? creative.selectedMarcId : null;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        drawing.clear();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentMarcId,
        creativeSelectedMarcId
    ]);
    // Debug-only: ←/→ in speedrun mode swap the current marc with the
    // prev/next from the manifest. Lets us land on a specific marc to
    // tune scoring without re-rolling. Bare arrow keys (no modifiers).
    const debugCycleEnabled = urlState.debug && mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN;
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("ArrowLeft", ()=>{
        if (debugCycleEnabled) speedrun.cycleMarc(-1);
    });
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("ArrowRight", ()=>{
        if (debugCycleEnabled) speedrun.cycleMarc(1);
    });
    // Debug-only: `r` toggles the easel between the marc photo and the
    // saved reference trace (reference.json's drawing.image). Lets us
    // eyeball "how big I drew his neck" against the canonical version
    // while tuning scoring. Off by default; resets every time the
    // current marc changes so you don't carry the override into a fresh
    // marc unintentionally.
    const [showReferenceDrawing, setShowReferenceDrawing] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Bare `r` is redo; shift+r is the debug-only easel toggle.
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)({
        key: "r",
        shift: true
    }, ()=>{
        if (urlState.debug && mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN) setShowReferenceDrawing((v)=>!v);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowReferenceDrawing(false);
    }, [
        effectiveMarcId
    ]);
    // Debug-only: `v` (for "victory") fakes a marc completion in speedrun.
    // Blits the saved reference trace onto the canvas (so the showcase
    // animation has a "perfect player" drawing underneath the marc overlay
    // for alignment iteration) and fires triggerShowcase, which runs the
    // same setShowcasing → timer → advanceMarc chain as a real allDone.
    // The blit gets wiped automatically when advanceMarc fires the
    // currentMarcId-keyed drawing.clear() effect. `showcasing` gates the
    // early-return so the blit doesn't stack onto an in-flight showcase
    // (triggerShowcase self-guards against re-entry too).
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("v", async ()=>{
        if (!urlState.debug || mode !== (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN) return;
        if (!reference?.drawing?.image) return;
        if (showcasing) return;
        const canvas = canvasRef.current;
        if (!canvas) return;
        const img = new Image();
        img.src = reference.drawing.image;
        try {
            await img.decode();
        } catch  {
            return;
        }
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        triggerShowcase();
    });
    // Debug-only: `n` (for "next round complete") fakes a round
    // completion and pops the end-screen modal. Picks 3 random marcs,
    // fetches their references, and builds the recap from each
    // reference.drawing.image so we can iterate on the modal without
    // grinding through real rounds. Strokes/palette aren't populated
    // (no real play happened); the modal renders from drawingSrc only.
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("n", async ()=>{
        if (!urlState.debug || mode !== (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN) return;
        const ids = [
            ...(0, $558b48ff778d5bc1$export$abd6720e30c85521)
        ].sort(()=>Math.random() - 0.5).slice(0, 3);
        const fakes = {};
        for (const id of ids)try {
            const r = await fetch((0, $4e3Nb.referenceUrl)(id));
            if (!r.ok) continue;
            const ref = await r.json();
            if (!ref?.drawing?.image) continue;
            fakes[id] = {
                drawingSrc: ref.drawing.image,
                eggTransform: ref.egg?.transform ?? null,
                marcTransform: ref.marc?.transform ?? null
            };
        } catch  {
        // Skip this id; the modal handles missing tiles gracefully.
        }
        if (Object.keys(fakes).length === 0) return;
        triggerDebugEndScreen(fakes);
    });
    // Right-click / mobile-button "save the marc you just made" menu.
    // anchorPos is null when closed, {x, y} (viewport-fixed) when opened
    // by a right-click on the drawing area. Mobile button bypasses the
    // menu and downloads directly.
    const [actionMenuPos, setActionMenuPos] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const compositeOpts = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            marcId: effectiveMarcId,
            eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
            strokes: drawing.strokes,
            palette: eff.palette,
            eggTransform: eggDisplay.eggTransform,
            marcTransform: eff.marcTransform,
            lights: eggDisplay.eggLights,
            warmth: eggDisplay.eggWarmth,
            redshift: eggDisplay.eggRedshift
        }), [
        effectiveMarcId,
        drawing.strokes,
        eff.palette,
        eff.marcTransform,
        eggDisplay.eggTransform,
        eggDisplay.eggLights,
        eggDisplay.eggWarmth,
        eggDisplay.eggRedshift
    ]);
    const actionMenuEnabled = mode !== (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING && !!effectiveMarcId;
    const handleDrawingContextMenu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((e)=>{
        if (!actionMenuEnabled) return;
        e.preventDefault();
        setActionMenuPos({
            x: e.clientX,
            y: e.clientY
        });
    }, [
        actionMenuEnabled
    ]);
    // Debug-only: `g` (for "guide") overlays the current target region's
    // mask + dilated search bbox onto the canvas. Shows where the
    // reference region actually lives, so we can tell whether the
    // player's drawing falls inside the search area or just slightly
    // outside it (which gives zero credit).
    const [showMaskOverlay, setShowMaskOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("g", ()=>{
        if (urlState.debug && mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN) setShowMaskOverlay((v)=>!v);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setShowMaskOverlay(false);
    }, [
        effectiveMarcId
    ]);
    // Build the debug overlay payload from the marcEngine snapshot's
    // `shown` (which carries searchBbox per subregion) joined with the
    // raw reference regions (which carry the mask data). Memoized so
    // the array identity is stable across renders that don't change
    // shown/reference, keeping DrawingArea's render quiet.
    const debugRegions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!showMaskOverlay) return null;
        const shown = marcEngine.snapshot.shown;
        if (!shown || !reference) return null;
        const refById = new Map(reference.drawing.regions.map((r)=>[
                r.id,
                r
            ]));
        return shown.subRegions.map((s)=>{
            const ref = refById.get(s.id);
            return {
                id: s.id,
                mask: ref?.mask ?? null,
                bbox: ref?.bbox ?? null,
                searchBbox: s.searchBbox
            };
        });
    }, [
        showMaskOverlay,
        marcEngine.snapshot.shown,
        reference
    ]);
    // Tool hotkeys (q/b/w/f/e) live in DrawingToolbar so the same keypress
    // can drive both setTool and the popover-cycle (select → open → close).
    // Number-key palette switching is suppressed when colorLocked (speedrun);
    // see PaletteProvider's note. Hooks must be unconditional, so we gate
    // inside the handler.
    const pickColor = (i)=>{
        if (colorLocked) return;
        setActiveColorIndex(i);
    };
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("1", ()=>pickColor(0));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("2", ()=>pickColor(1));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("3", ()=>pickColor(2));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("4", ()=>pickColor(3));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("5", ()=>pickColor(4));
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("6", ()=>pickColor(5));
    // Bare z, ⌘z, ctrl-z all undo; shift variants redo. `r` is also redo —
    // the hint chip on the redo button (⇧z renders awkwardly in the corner).
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)({
        key: "z",
        shift: false
    }, ()=>drawing.undo(), {
        preventDefault: true
    });
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)({
        key: "z",
        shift: true
    }, ()=>drawing.redo(), {
        preventDefault: true
    });
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("r", ()=>drawing.redo(), {
        preventDefault: true
    });
    // Eyedropper: a live sample-from-marc-photo gesture invoked from the
    // Edit Color popover. The popover stays open during a session — hover
    // over the marc photo fires onPreview (so the editor can paint a
    // hover swatch), click fires onPick (commit). Session ends on
    // endEyedropper() (toggle off via the editor) or Escape (fires the
    // registered onCancel so the editor can reset its own UI state).
    const eyedropperRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const [eyedropperActive, setEyedropperActive] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const beginEyedropper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((handlers)=>{
        eyedropperRef.current = handlers;
        setEyedropperActive(true);
    }, []);
    const endEyedropper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        eyedropperRef.current = null;
        setEyedropperActive(false);
    }, []);
    const handlePickPixel = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((hex)=>{
        eyedropperRef.current?.onPick?.(hex);
    }, []);
    const handlePreviewPixel = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((hex)=>{
        eyedropperRef.current?.onPreview?.(hex);
    }, []);
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("Escape", ()=>{
        const handlers = eyedropperRef.current;
        if (!handlers) return;
        eyedropperRef.current = null;
        setEyedropperActive(false);
        handlers.onCancel?.();
    });
    const UI_PANELS = {
        [(0, $7921bdd52deb8db9$export$240b20df485e8ed6).AUTHOR]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d41632e1035022ac$export$2e2bcd8739ae039), {
            authoring: authoring,
            saveDisabled: !drawing.canUndo
        }),
        [(0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1db35e3f87274d8a$export$2e2bcd8739ae039), {
            setMode: setMode,
            onCreativeClick: creative.openPicker
        }),
        [(0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0d5763e6f8dc01d$export$2e2bcd8739ae039), {
            snapshot: marcEngine.snapshot,
            bindBar: marcEngine.bindBar,
            roundSnapshot: speedrun.snapshot,
            countIn: countIn
        }),
        [(0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a92625cafe25dfe$export$2e2bcd8739ae039), {
            creative: creative,
            onChangeMarc: creative.openPicker,
            onSyndicate: ()=>setSyndicateTarget({
                    marcId: effectiveMarcId,
                    eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
                    strokes: drawing.strokes,
                    palette: eff.palette,
                    source: "creative",
                    // Creative-mode tweaks ride along so the gallery renders
                    // the user's pose + lighting, not the canonical reference.
                    // Speedrun submissions skip this and inherit the reference.
                    overrides: (0, $8642a65fcc91168a$export$1e1cf71100296aff)({
                        eggTransform: eggDisplay.eggTransform,
                        marcTransform: eff.marcTransform,
                        eggLights: eggDisplay.eggLights,
                        warmth: eggDisplay.eggWarmth,
                        redshift: eggDisplay.eggRedshift
                    })
                })
        })
    };
    // Syndicate target staged on click — null outside the flow, populated
    // with the strokes/palette/marc to submit when the user clicks
    // syndicate (creative panel button or per-marc end-screen button).
    // SyndicateModal opens whenever this is non-null.
    const [syndicateTarget, setSyndicateTarget] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const handleSyndicateSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(async ({ initials: initials })=>{
        if (!syndicateTarget) return {
            ok: true
        };
        const wasSpeedrun = syndicateTarget.source === "speedrun";
        // Silent failure: any network/HTTP error is swallowed and the user
        // sees the same flow as success (modal closes). The local "Mine"
        // record only attaches when we have a real submission id.
        try {
            const res = await fetch("/api/submit", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify((0, $8642a65fcc91168a$export$38efa97b7a6f5e3f)({
                    marcId: syndicateTarget.marcId,
                    eggId: syndicateTarget.eggId,
                    initials: initials,
                    source: syndicateTarget.source,
                    elapsedMs: syndicateTarget.elapsedMs,
                    strokes: (0, $jCH6j.serializeStrokes)(syndicateTarget.strokes),
                    palette: syndicateTarget.palette,
                    overrides: syndicateTarget.overrides
                }))
            });
            const data = await res.json().catch(()=>({}));
            if (res.ok && data.id) {
                if (wasSpeedrun) {
                    const localId = roundLocalIdsRef.current[syndicateTarget.marcId];
                    if (localId) (0, $R3rkF.attachSubmission)(localId, {
                        id: data.id,
                        initials: initials
                    });
                } else {
                    const localId = (0, $R3rkF.recordDrawing)({
                        marcId: syndicateTarget.marcId,
                        eggId: syndicateTarget.eggId,
                        source: "creative",
                        strokes: syndicateTarget.strokes,
                        palette: syndicateTarget.palette,
                        overrides: syndicateTarget.overrides
                    });
                    (0, $R3rkF.attachSubmission)(localId, {
                        id: data.id,
                        initials: initials
                    });
                }
            }
        } catch  {}
        setSyndicateTarget(null);
        return {
            ok: true
        };
    }, [
        syndicateTarget
    ]);
    // Canvas input gate. `startedAt` is the canonical "speedrun is
    // running" signal — null through the entire pre-round window AND
    // through the first commit after mode flips to SPEEDRUN (before the
    // engine's effect runs `start()`). Scoping on `mode === SPEEDRUN`
    // (not `total > 0`) covers that first-commit window. Exit fade keeps
    // input enabled — markStarted has already fired, so the 200ms
    // fade-up is purely visual.
    const inputDisabled = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING || marcEngine.snapshot.celebrating || eggTweening || showcasing || mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN && speedrun.snapshot.startedAt == null && !countIn.exiting;
    // Easel photo visibility. In landing the cycle drives it; otherwise
    // the creative cross-fade dampening (or full opacity outside the
    // 'out' phase, derived in surfaces).
    const easelPhotoVisible = mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING ? landing.photoShown : creativePhotoVisible;
    // End-screen modal state. Real path opens when speedrun completes
    // AND the last marc's showcase has finished — the cross-fade plays
    // through before the modal pops, so the punchline lands first and
    // the recap follows. Debug path (`n` hotkey) forces it open with
    // fake roundDrawings; lineup + elapsedMs swap to the debug values
    // so the modal doesn't read "0:00" against fake data.
    const endScreenOpen = debugEndScreenOpen || mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN && speedrun.snapshot.complete && !showcasing;
    const endScreenLineup = debugEndScreenOpen ? Object.keys(roundDrawings) : speedrun.snapshot.lineup;
    const endScreenElapsedMs = debugEndScreenOpen ? 87654 // 01:27.6 — plausible-looking placeholder
     : speedrun.snapshot.startedAt != null && speedrun.snapshot.endedAt != null ? speedrun.snapshot.endedAt - speedrun.snapshot.startedAt : 0;
    const toolbarVisible = mode !== (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7caa007c47a491c5$export$1e92748507e26cde), {
        beginEyedropper: beginEyedropper,
        endEyedropper: endEyedropper,
        active: eyedropperActive,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$Page, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$LeftBleed, {
                    $visible: toolbarVisible
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$Layout, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$ToolbarBackdrop, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$ToolbarSlot, {
                            $visible: toolbarVisible,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $205b7352174a90c0$export$2e2bcd8739ae039), {
                                onUndo: drawing.undo,
                                onRedo: drawing.redo,
                                canUndo: drawing.canUndo,
                                canRedo: drawing.canRedo,
                                disabled: !toolbarVisible,
                                visible: toolbarVisible,
                                showMute: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$ContentArea, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$HeaderSlot, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$Title, {
                                        $clickable: mode !== (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING,
                                        onClick: ()=>{
                                            if (mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING) return;
                                            // Author mode is URL-gated, so going home means clearing
                                            // the URL params — otherwise a refresh would bounce back
                                            // into it.
                                            if (mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).AUTHOR) {
                                                window.location.assign("/");
                                                return;
                                            }
                                            setMode((0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING);
                                        },
                                        children: "Marc Andreessen Egg Game"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$DrawingSlot, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$FrameBox, {
                                            onContextMenu: handleDrawingContextMenu,
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fOHsz.default), {
                                                    eggSrc: (0, $4e3Nb.eggImageUrl)((0, $7Yi7V.DEFAULT_EGG_ID)),
                                                    eggTransform: eggDisplay.eggTransform,
                                                    eggLights: eggDisplay.eggLights,
                                                    eggWarmth: eggDisplay.eggWarmth,
                                                    eggRedshift: eggDisplay.eggRedshift,
                                                    marcTransform: displayedMarcTransform,
                                                    canvasRef: canvasRef,
                                                    handlers: drawing.canvasHandlers,
                                                    align: "center",
                                                    authoring: drawingAuthoring,
                                                    eggSilhouetteRef: eggSilhouetteRef,
                                                    inputDisabled: inputDisabled,
                                                    debugRegions: debugRegions,
                                                    landingDrawing: landingDrawing,
                                                    showcaseMarc: showcaseMarc
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$MobileReferenceCard, {
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RQES.default), {
                                                        withEasel: false,
                                                        marcId: displayedMarcId,
                                                        marcTransform: displayedMarcTransform,
                                                        referenceDrawingSrc: reference?.drawing?.image ?? null,
                                                        showReferenceDrawing: showReferenceDrawing,
                                                        photoVisible: easelPhotoVisible,
                                                        photoLoadGate: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING,
                                                        showcasing: showcasing,
                                                        eyedropperActive: eyedropperActive,
                                                        onPickPixel: handlePickPixel,
                                                        onPreviewPixel: handlePreviewPixel
                                                    })
                                                })
                                            ]
                                        }),
                                        mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE && actionMenuEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$MobileDownloadAction, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4cvDM.default), {
                                                type: "button",
                                                onClick: ()=>(0, $gLxJv.downloadComposite)(compositeOpts),
                                                title: "Download a PNG of this Marc",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hwQVN.DownloadSimple), {
                                                        size: 14,
                                                        weight: "bold"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Download"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$EaselSlot, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9RQES.default), {
                                        marcId: displayedMarcId,
                                        marcTransform: displayedMarcTransform,
                                        referenceDrawingSrc: reference?.drawing?.image ?? null,
                                        showReferenceDrawing: showReferenceDrawing,
                                        photoVisible: easelPhotoVisible,
                                        photoLoadGate: mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING,
                                        showcasing: showcasing,
                                        eyedropperActive: eyedropperActive,
                                        onPickPixel: handlePickPixel,
                                        onPreviewPixel: handlePreviewPixel
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$PanelSlot, {
                                    children: UI_PANELS[mode]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$Footer, {
                            $toolbarVisible: toolbarVisible,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        "a website by",
                                        " ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: "https://eieio.games",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            style: {
                                                textDecoration: "underline",
                                                textDecorationStyle: "dotted"
                                            },
                                            children: "nolen (eieio)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($4d8b6aef94a206ca$var$Socials, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$SocialLink, {
                                            href: "https://bsky.app/profile/itseieio.bsky.social",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": "eieio on Bluesky",
                                            title: "eieio on Bluesky",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$BlueskyIcon, {
                                                size: 14
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$SocialLink, {
                                            href: "https://x.com/itseieio",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": "eieio on Twitter",
                                            title: "eieio on Twitter",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($4d8b6aef94a206ca$var$TwitterIcon, {
                                                size: 14
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                urlState.debug && mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).SPEEDRUN && reference && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3dbfb4747e670e5$export$2e2bcd8739ae039), {
                    overrides: scoreOverrides,
                    onChange: setScoreOverrides,
                    shown: marcEngine.snapshot.shown,
                    maskOverlay: showMaskOverlay,
                    onToggleMask: ()=>setShowMaskOverlay((v)=>!v),
                    marcId: effectiveMarcId
                }),
                (mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING || mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6510fc73fba60ab1$export$2e2bcd8739ae039), {
                    open: creative.pickerOpen,
                    onOpenChange: (o)=>{
                        if (o) {
                            creative.openPicker();
                            return;
                        }
                        creative.closePicker();
                    },
                    marcIds: (0, $558b48ff778d5bc1$export$abd6720e30c85521),
                    selectedId: creative.selectedMarcId,
                    onPick: (id)=>{
                        creative.pickMarc(id, displayedMarcId);
                        if (mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING) setMode((0, $7921bdd52deb8db9$export$240b20df485e8ed6).CREATIVE);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $764ce5e5a1823266$export$2e2bcd8739ae039), {
                    open: endScreenOpen,
                    onOpenChange: (next)=>{
                        if (next) return;
                        setMode((0, $7921bdd52deb8db9$export$240b20df485e8ed6).LANDING);
                    },
                    lineup: endScreenLineup,
                    roundDrawings: roundDrawings,
                    elapsedMs: endScreenElapsedMs,
                    onSyndicate: (marcId, snapshot)=>setSyndicateTarget({
                            marcId: marcId,
                            eggId: (0, $7Yi7V.DEFAULT_EGG_ID),
                            strokes: snapshot.strokes,
                            palette: snapshot.palette,
                            source: "speedrun",
                            elapsedMs: snapshot.duration
                        })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3b1308561e2d0f8f$export$2e2bcd8739ae039), {
                    open: syndicateTarget != null,
                    onOpenChange: (next)=>{
                        if (!next) setSyndicateTarget(null);
                    },
                    onSubmit: handleSyndicateSubmit
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5Ykzn.default), {
                    open: actionMenuPos != null && actionMenuEnabled,
                    onOpenChange: (next)=>{
                        if (!next) setActionMenuPos(null);
                    },
                    anchorPos: actionMenuPos,
                    onDownload: ()=>(0, $gLxJv.downloadComposite)(compositeOpts),
                    onCopy: ()=>(0, $gLxJv.copyCompositeToClipboard)(compositeOpts),
                    canCopy: (0, $gLxJv.canCopyImageToClipboard)()
                })
            ]
        })
    });
}
// On tablet, ContentArea uses `display: contents` so its children
// flatten into Layout's grid — that's how the panel spans toolbar-
// right-edge to viewport-edge while the toolbar stays full-height.
const $4d8b6aef94a206ca$var$LAYOUT_MAX_WIDTH = 1600;
const $4d8b6aef94a206ca$var$TOOLBAR_TRANSITION_MS = 350;
const $4d8b6aef94a206ca$var$Page = (0, $lmFrL.default).div`
  min-height: 100vh;
  min-height: 100svh;
  // Clips the toolbar's slide-off transform so it doesn't extend Page
  // bounds and trigger scroll. Layout itself is locked to 100svh.
  overflow: hidden;
`;
// Chrome strip on viewports wider than Layout. Renders inside React so
// it can fade in/out alongside the toolbar's slide animation.
const $4d8b6aef94a206ca$var$LeftBleed = (0, $lmFrL.default).div`
  position: fixed;
  left: 0;
  top: 0;
  width: max(0px, calc(50vw - ${$4d8b6aef94a206ca$var$LAYOUT_MAX_WIDTH / 2}px));
  height: 100%;
  background-color: var(--color-chrome);
  pointer-events: none;
  z-index: 0;
  opacity: ${(p)=>p.$visible ? 1 : 0};
  transition: opacity ${$4d8b6aef94a206ca$var$TOOLBAR_TRANSITION_MS}ms ease;
`;
// Cream backdrop revealed when the toolbar slides off — only meaningful
// on tablet (col1 row3 under the panel) and mobile (toolbar's own
// track). On desktop the area behind the toolbar is graph paper, no
// backdrop needed.
const $4d8b6aef94a206ca$var$ToolbarBackdrop = (0, $lmFrL.default).div`
  display: none;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    display: block;
    grid-row: 3;
    grid-column: 1;
    background-color: var(--color-orange-100);
    border-top: 1px solid var(--color-orange-300);
  }

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    grid-area: toolbar;
    border-top: none;
  }
`;
const $4d8b6aef94a206ca$var$Layout = (0, $lmFrL.default).main`
  width: 100%;
  max-width: ${$4d8b6aef94a206ca$var$LAYOUT_MAX_WIDTH}px;
  margin: 0 auto;
  min-height: 100vh;
  min-height: 100svh;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) auto;
  grid-template-areas:
    "toolbar content"
    "toolbar footer";
  padding-right: 10px;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    grid-template-columns: auto minmax(0, 1.3fr) minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr) auto auto;
    grid-template-areas:
      "toolbar header  header"
      "toolbar drawing easel"
      "toolbar panel   panel"
      "toolbar footer  footer";
    padding-right: 0;
  }

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(0, 1fr) auto auto;
    grid-template-areas:
      "content"
      "toolbar"
      "footer";
    padding-right: 0;
  }
`;
const $4d8b6aef94a206ca$var$ToolbarSlot = (0, $lmFrL.default).div`
  grid-area: toolbar;
  display: flex;
  align-items: stretch;
  min-height: 0;
  min-width: 0;
  position: relative;
  z-index: 1;
  transform: translateX(${(p)=>p.$visible ? "0" : "-100%"});
  opacity: ${(p)=>p.$visible ? 1 : 0};
  pointer-events: ${(p)=>p.$visible ? "auto" : "none"};
  transition:
    transform ${$4d8b6aef94a206ca$var$TOOLBAR_TRANSITION_MS}ms ease,
    opacity ${$4d8b6aef94a206ca$var$TOOLBAR_TRANSITION_MS}ms ease;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    transform: translateY(${(p)=>p.$visible ? "0" : "100%"});
  }
`;
const $4d8b6aef94a206ca$var$ContentArea = (0, $lmFrL.default).div`
  grid-area: content;
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  grid-template-columns: minmax(440px, 1.1fr) minmax(400px, 1fr);
  grid-template-areas:
    "header  header"
    "drawing easel"
    "drawing panel";
  padding: 0 1.25rem;
  max-height: 1200px;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    display: contents;
  }

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr) auto;
    grid-template-areas:
      "header"
      "drawing"
      "panel";
    padding: 0;
    max-height: none;
  }
`;
const $4d8b6aef94a206ca$var$Socials = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
const $4d8b6aef94a206ca$var$SocialLink = (0, $lmFrL.default).a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-muted);
  transition: color 120ms ease-out;
  transform: translateY(1px);

  &:hover {
    color: var(--color-text);
  }

  &:focus-visible {
    outline: 2px solid var(--color-text);
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
// Bluesky butterfly. Phosphor doesn't ship one.
function $4d8b6aef94a206ca$var$BlueskyIcon({ size: size = 16 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364-3.911.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z"
        })
    });
}
// Pre-X Twitter bird (deliberate — preferring the legacy logo).
function $4d8b6aef94a206ca$var$TwitterIcon({ size: size = 16 }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: size,
        height: size,
        style: {
            transform: "scale(1.3)"
        },
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
        })
    });
}
const $4d8b6aef94a206ca$var$Footer = (0, $lmFrL.default).footer`
  grid-area: footer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0 12px 12px;
  font-size: 0.75rem;
  color: var(--color-text-muted);
  letter-spacing: 0.01em;
  transition: background-color 200ms ease-out;
  transition-delay: 100ms;

  a {
    color: inherit;
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 0.2em;
    font-weight: 700;

    &:hover {
      color: var(--color-text);
      text-decoration-thickness: 2px;
    }
  }

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    background-color: var(--color-orange-100);
    padding: 8px 12px;
  }

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    /* border-top: 1px solid var(--color-orange-300); */
    padding: 2px 12px 6px;
    background-color: ${(p)=>p.$toolbarVisible ? "var(--color-orange-200)" : "var(--color-orange-100)"};
  }
`;
const $4d8b6aef94a206ca$var$HeaderSlot = (0, $lmFrL.default).header`
  grid-area: header;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem 1rem;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    padding-bottom: 3.5rem;
  }
`;
const $4d8b6aef94a206ca$var$Title = (0, $lmFrL.default).h1`
  /* Lower clamp floor lets narrow phones use a smaller title — the
     reference card sits high in the drawing area and a 40px title
     gives it less room to overlap. */
  font-size: clamp(2.2rem, 5.2vw, 5rem);
  line-height: 1;
  padding-bottom: 0.5rem;
  padding-top: 0.25rem;
  font-weight: 600;
  font-family: "Fraunces", serif;
  text-wrap: balance;
  text-align: center;
  letter-spacing: -0.01em;
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.5),
    0 2px 6px rgba(80, 45, 20, 0.18);

  ${(p)=>p.$clickable && (0, $lmFrL.css)`
      cursor: pointer;
      &:hover {
        text-decoration: underline;
        text-decoration-thickness: 4px;
      }
    `}
`;
const $4d8b6aef94a206ca$var$DrawingSlot = (0, $lmFrL.default).div`
  grid-area: drawing;
  position: relative;
  min-width: 0;
  min-height: 0;
  padding: 16px 1rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  container-type: size;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    padding: 8px 8px 1.5rem;
  }
`;
// Mobile-only download button under the drawing frame. Hidden on
// desktop — desktop users get the right-click menu, which also offers
// clipboard copy. Mobile gets a single direct-download affordance
// since clipboard support is patchy on phones.
const $4d8b6aef94a206ca$var$MobileDownloadAction = (0, $lmFrL.default).div`
  display: none;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
  }
`;
// Cap the frame's display width on mobile so the reference card's
// straddle has horizontal room (otherwise the card clips off the right
// edge on tall+narrow phones). Trades drawing area for card breathing.
// Tied to the card knobs: with REF_CARD_FRACTION × |X_SHIFT_FRAC| of
// frame width sticking out past the right edge, frame_max ≈
// 1 / (1 + 2 × that overhang) keeps the card inside the viewport.
const $4d8b6aef94a206ca$var$FRAME_MAX_W_FRAC_MOBILE = 0.85;
// Sized to the frame's actual aspect-fitted display bounds so
// MobileReferenceCard can position relative to the frame instead of
// the slot. container-type: size makes its descendants' cq* units
// resolve against this box (= the frame's display size).
const $4d8b6aef94a206ca$var$FrameBox = (0, $lmFrL.default).div`
  position: relative;
  width: min(
    100cqw,
    calc(100cqh * ${(0, $7Yi7V.FRAME_OUTER_WIDTH)} / ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)})
  );
  height: min(
    100cqh,
    calc(100cqw * ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)} / ${(0, $7Yi7V.FRAME_OUTER_WIDTH)})
  );
  display: flex;
  container-type: size;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    width: min(
      ${$4d8b6aef94a206ca$var$FRAME_MAX_W_FRAC_MOBILE * 100}cqw,
      calc(100cqh * ${(0, $7Yi7V.FRAME_OUTER_WIDTH)} / ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)})
    );
    height: min(
      100cqh,
      calc(
        ${$4d8b6aef94a206ca$var$FRAME_MAX_W_FRAC_MOBILE * 100}cqw * ${(0, $7Yi7V.FRAME_OUTER_HEIGHT)} /
          ${(0, $7Yi7V.FRAME_OUTER_WIDTH)}
      )
    );
  }
`;
// container-type: size feeds ReferencePhoto's Stage cqw/cqh sizing.
const $4d8b6aef94a206ca$var$EaselSlot = (0, $lmFrL.default).div`
  grid-area: easel;
  min-width: min-content;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  container-type: size;
  container-name: easel-area;
  width: 100%;
  padding-bottom: 1rem;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    display: none;
  }
`;
const $4d8b6aef94a206ca$var$PanelSlot = (0, $lmFrL.default).div`
  grid-area: panel;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-bottom: 1rem;

  @media (max-width: ${(0, $7Yi7V.TABLET_BREAKPOINT)}px) {
    padding: 0;
  }
`;
// ── Reference-card placement knobs (mobile only) ──
// Size as a fraction of the gold frame's display dimensions.
const $4d8b6aef94a206ca$var$REF_CARD_FRACTION = 0.38;
// Anchor point inside the frame: 100%/50% = right edge, vertical mid.
const $4d8b6aef94a206ca$var$REF_CARD_X = "90%";
const $4d8b6aef94a206ca$var$REF_CARD_Y = "13%";
// Translate past the anchor (-50%/-50% = card centered on the anchor,
// straddling the frame's right edge half-in / half-out).
const $4d8b6aef94a206ca$var$REF_CARD_X_SHIFT = "-50%";
const $4d8b6aef94a206ca$var$REF_CARD_Y_SHIFT = "-50%";
const $4d8b6aef94a206ca$var$MobileReferenceCard = (0, $lmFrL.default).div`
  display: none;

  @media (max-width: ${(0, $7Yi7V.MOBILE_BREAKPOINT)}px) {
    display: block;
    position: absolute;
    /* Largest aspect-preserving rectangle that fits within
       (fraction × frame-width) × (fraction × frame-height) — so the
       card shrinks with both axes of the frame, not just the
       viewport. cq* units resolve against FrameBox via its
       container-type. */
    width: min(
      ${$4d8b6aef94a206ca$var$REF_CARD_FRACTION * 100}cqw,
      calc(${$4d8b6aef94a206ca$var$REF_CARD_FRACTION * 100}cqh * ${(0, $7Yi7V.CANVAS_WIDTH)} / ${(0, $7Yi7V.CANVAS_HEIGHT)})
    );
    height: min(
      ${$4d8b6aef94a206ca$var$REF_CARD_FRACTION * 100}cqh,
      calc(${$4d8b6aef94a206ca$var$REF_CARD_FRACTION * 100}cqw * ${(0, $7Yi7V.CANVAS_HEIGHT)} / ${(0, $7Yi7V.CANVAS_WIDTH)})
    );
    left: ${$4d8b6aef94a206ca$var$REF_CARD_X};
    top: ${$4d8b6aef94a206ca$var$REF_CARD_Y};
    transform: translate(${$4d8b6aef94a206ca$var$REF_CARD_X_SHIFT}, ${$4d8b6aef94a206ca$var$REF_CARD_Y_SHIFT});
    container-type: size;
    z-index: 5;
    pointer-events: none;
  }
`;
var $4d8b6aef94a206ca$export$2e2bcd8739ae039 = $4d8b6aef94a206ca$var$App;





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");

var $7Yi7V = parcelRequire("7Yi7V");


var $4e3Nb = parcelRequire("4e3Nb");

var $baa6D = parcelRequire("baa6D");

var $3IUwO = parcelRequire("3IUwO");



var $fFWQJ = parcelRequire("fFWQJ");
const $f0b7b36e0ef67d33$var$DEFAULT_ALL_OF_SET = new Set((0, $7Yi7V.DEFAULT_ALL_OF_LABELS).map((s)=>s.toLowerCase()));
function $f0b7b36e0ef67d33$var$defaultGroupMode(labelKey) {
    return $f0b7b36e0ef67d33$var$DEFAULT_ALL_OF_SET.has(labelKey) ? "all" : "any";
}
// Seed labels + deletions to match a committed reference.json snapshot:
// labels come directly from committed regions; a region missing from the
// committed set (because it was deleted last session) is marked deleted.
// Group modes pulled from the committed `labelGroups` dict (only entries
// that diverge from the default-list need to be kept).
function $f0b7b36e0ef67d33$var$seedFromCommitted(committed, unlabeled, setLabels, setDeletedIds, setGroupModes) {
    const committedById = new Map((committed.drawing?.regions ?? []).map((r)=>[
            r.id,
            r
        ]));
    const nextLabels = {};
    const nextDeleted = [];
    for (const r of unlabeled.drawing.regions){
        const c = committedById.get(r.id);
        if (!c) nextDeleted.push(r.id);
        else if ((c.label ?? "").trim().length > 0) nextLabels[r.id] = c.label;
    }
    setLabels(nextLabels);
    setDeletedIds(nextDeleted);
    setGroupModes(committed.labelGroups ?? {});
}
function $f0b7b36e0ef67d33$var$LabelApp({ marcId: marcId }) {
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    // Committed reference (reference.json) — used to seed labels + deletions
    // on first load and to support a "reset to committed" button. Null if the
    // file doesn't exist yet (fresh marcId with no labels ever committed).
    const [committed, setCommitted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [labels, setLabels] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(`egg-game:v1:marc:${marcId}:labels`, {});
    const [deletedIds, setDeletedIds] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(`egg-game:v1:marc:${marcId}:deletedRegions`, []);
    // Per-label "all" / "any" overrides. Empty by default — labels not in
    // this dict resolve via `defaultGroupMode` (eyes/eyebrows/pupils → all,
    // everything else → any).
    const [groupModes, setGroupModes] = (0, $6b137a2b7afbc892$export$2e2bcd8739ae039)(`egg-game:v1:marc:${marcId}:groupModes`, {});
    const [selectedId, setSelectedId] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [showAll, setShowAll] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    // Whether this label session arrived via author-mode handoff. When true,
    // region IDs come from a fresh trace and don't correspond to whatever's
    // in the committed file — so we wipe pre-existing labels/deletions and
    // disable the "Reset to committed" button (which would mis-apply old
    // labels to new IDs).
    const [fromHandoff, setFromHandoff] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const seededRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    const canvasRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const maskCache = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({});
    const labelInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        let cancelled = false;
        // Two sources of truth:
        //
        //   1. sessionStorage handoff — author mode just saved and navigated
        //      here, the unlabeled JSON is in memory.
        //   2. referenceUrl(marcId) on disk — the committed file. Used as the
        //      committed-labels source (for seeding) when a handoff is
        //      present, OR as the working copy itself when there's no
        //      handoff (e.g. you reloaded the label tab to keep editing).
        //
        // There's no separate reference-unlabeled.json on disk anymore — the
        // handoff is the only intermediate artifact.
        const handoffJson = (0, $54c1c6fbbb01e713$export$fa7ee5447c2e5120)(marcId);
        const committedRefPromise = (0, $baa6D.fetchOptionalJson)((0, $4e3Nb.referenceUrl)(marcId));
        let unlabeledPromise;
        if (handoffJson) {
            // Fresh trace from author mode. Region IDs are positional ("biggest
            // region in this trace = r-001"), so previously-saved labels and
            // deletions can't be trusted to mean the same thing on the new
            // trace — wipe them and start clean. seededRef → true so the seed
            // effect below short-circuits.
            setFromHandoff(true);
            setLabels({});
            setDeletedIds([]);
            setGroupModes({});
            seededRef.current = true;
            try {
                unlabeledPromise = Promise.resolve(JSON.parse(handoffJson));
            } catch (err) {
                unlabeledPromise = Promise.reject(new Error(`handoff JSON: ${err.message}`));
            }
        } else // No handoff → continue editing the committed file in place.
        unlabeledPromise = committedRefPromise.then((ref)=>{
            if (!ref) throw new Error(`No ${(0, $4e3Nb.referenceFilename)(marcId)} on disk and no author handoff. Author the marc first.`);
            return ref;
        });
        Promise.all([
            unlabeledPromise,
            committedRefPromise
        ]).then(([unlabeled, committedRef])=>{
            if (cancelled) return;
            setReference(unlabeled);
            setCommitted(committedRef);
        }).catch((err)=>{
            if (cancelled) return;
            setLoadError(err.message);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        marcId
    ]);
    // Seed labels + deletions from the committed reference.json on first
    // mount, but only if localStorage is empty. A returning session with
    // in-progress edits keeps those edits; the "Reset to committed" button
    // below lets you force-reseed.
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (seededRef.current) return;
        if (!reference) return;
        seededRef.current = true;
        const hasLocalLabels = Object.values(labels).some((v)=>(v ?? "").trim().length > 0);
        const hasLocalDeletions = deletedIds.length > 0;
        if (hasLocalLabels || hasLocalDeletions) return;
        if (!committed) return;
        $f0b7b36e0ef67d33$var$seedFromCommitted(committed, reference, setLabels, setDeletedIds, setGroupModes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        reference,
        committed
    ]);
    const resetToCommitted = ()=>{
        if (!committed) {
            window.alert("No reference.json found to reset from.");
            return;
        }
        if (!window.confirm("Reset labels and deletions to what's in the committed reference.json?")) return;
        $f0b7b36e0ef67d33$var$seedFromCommitted(committed, reference, setLabels, setDeletedIds, setGroupModes);
    };
    const visibleRegions = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (!reference) return [];
        const deleted = new Set(deletedIds);
        return reference.drawing.regions.filter((r)=>!deleted.has(r.id));
    }, [
        reference,
        deletedIds
    ]);
    // Default select the first region once regions are available
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (selectedId == null && visibleRegions.length > 0) setSelectedId(visibleRegions[0].id);
    }, [
        visibleRegions,
        selectedId
    ]);
    // Preload mask images
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!reference) return;
        reference.drawing.regions.forEach((r)=>{
            if (maskCache.current[r.id]) return;
            const img = new Image();
            img.onload = ()=>{
                maskCache.current[r.id] = img;
                // Force redraw when each mask finishes loading
                drawCanvas();
            };
            img.src = r.mask;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        reference
    ]);
    const drawCanvas = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        const canvas = canvasRef.current;
        if (!canvas || !reference) return;
        const ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const toDraw = showAll ? visibleRegions : visibleRegions.filter((r)=>r.id === selectedId);
        for (const r of toDraw){
            const maskImg = maskCache.current[r.id];
            if (!maskImg) continue;
            const { x: x, y: y, w: w, h: h } = r.bbox;
            const off = document.createElement("canvas");
            off.width = w;
            off.height = h;
            const octx = off.getContext("2d");
            octx.drawImage(maskImg, 0, 0);
            octx.globalCompositeOperation = "source-in";
            octx.fillStyle = r.color;
            octx.fillRect(0, 0, w, h);
            ctx.drawImage(off, x, y);
        }
    }, [
        reference,
        visibleRegions,
        selectedId,
        showAll
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        drawCanvas();
    }, [
        drawCanvas
    ]);
    const selectedRegion = visibleRegions.find((r)=>r.id === selectedId) || null;
    const selectedIndex = visibleRegions.findIndex((r)=>r.id === selectedId);
    const advance = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((dir)=>{
        if (visibleRegions.length === 0) return;
        const i = Math.max(0, selectedIndex);
        const next = (i + dir + visibleRegions.length) % visibleRegions.length;
        setSelectedId(visibleRegions[next].id);
    }, [
        visibleRegions,
        selectedIndex
    ]);
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("ArrowDown", ()=>advance(1), {
        preventDefault: true
    });
    (0, $8c77a2f882a1085d$export$2e2bcd8739ae039)("ArrowUp", ()=>advance(-1), {
        preventDefault: true
    });
    const handleLabelChange = (value)=>{
        if (!selectedRegion) return;
        setLabels((prev)=>({
                ...prev,
                [selectedRegion.id]: value
            }));
    };
    const handleDelete = ()=>{
        if (!selectedRegion) return;
        const ok = window.confirm(`Delete region ${selectedRegion.id} (${selectedRegion.pixelCount} px)?`);
        if (!ok) return;
        setDeletedIds((prev)=>[
                ...prev,
                selectedRegion.id
            ]);
        // Move selection to next available
        const idx = visibleRegions.findIndex((r)=>r.id === selectedRegion.id);
        const nextList = visibleRegions.filter((r)=>r.id !== selectedRegion.id);
        if (nextList.length === 0) setSelectedId(null);
        else setSelectedId(nextList[Math.min(idx, nextList.length - 1)].id);
    };
    const handleUndelete = ()=>{
        setDeletedIds([]);
    };
    const handleClearLabels = ()=>{
        if (!window.confirm("Clear all labels?")) return;
        setLabels({});
    };
    // Plural labels = labels assigned to ≥2 visible regions. These are the
    // groups that get an explicit all/any toggle in the sidebar (singletons
    // can't have a group mode that matters).
    const pluralGroups = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        const counts = new Map();
        visibleRegions.forEach((r)=>{
            const key = (labels[r.id] ?? "").trim().toLowerCase();
            if (!key) return;
            counts.set(key, (counts.get(key) ?? 0) + 1);
        });
        return Array.from(counts.entries()).filter(([_, n])=>n >= 2).map(([key, count])=>({
                key: key,
                count: count,
                mode: groupModes[key] ?? $f0b7b36e0ef67d33$var$defaultGroupMode(key)
            })).sort((a, b)=>a.key.localeCompare(b.key));
    }, [
        visibleRegions,
        labels,
        groupModes
    ]);
    const setGroupMode = (key, mode)=>{
        setGroupModes((prev)=>({
                ...prev,
                [key]: mode
            }));
    };
    const handleExport = ()=>{
        if (!reference) return;
        const regions = reference.drawing.regions.filter((r)=>!deletedIds.includes(r.id)).map((r)=>({
                ...r,
                label: labels[r.id] ?? r.label ?? ""
            }));
        // Bake the resolved mode for every plural label so consumers don't have
        // to re-implement the default-list. Singletons are omitted (mode is
        // irrelevant for them) to keep the file small.
        const labelGroups = {};
        pluralGroups.forEach((g)=>{
            labelGroups[g.key] = g.mode;
        });
        const out = {
            ...reference,
            drawing: {
                ...reference.drawing,
                regions: regions
            },
            labelGroups: labelGroups
        };
        const json = JSON.stringify(out, null, 2);
        const blob = new Blob([
            json
        ], {
            type: "application/json"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = (0, $4e3Nb.referenceFilename)(marcId);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };
    const labeledCount = visibleRegions.filter((r)=>(labels[r.id] ?? "").trim().length > 0).length;
    if (loadError) return /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Main, {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$ErrorBox, {
            children: [
                "Failed to load reference: ",
                loadError
            ]
        })
    });
    if (!reference) return /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Main, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$LoadingBox, {
            children: "Loading reference\u2026"
        })
    });
    const eggTransform = reference.egg.transform ?? (0, $7Yi7V.DEFAULT_EGG_TRANSFORM);
    const marcTransform = reference.marc?.transform;
    const marcStyle = marcTransform ? {
        transform: `translate(-50%, -50%) translate(${marcTransform.tx}px, ${marcTransform.ty}px) rotate(${marcTransform.rot}deg) scale(${marcTransform.scale})`
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Main, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Title, {
                        children: "Marc Andreessen Egg Game"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Badge, {
                        children: [
                            "label \xb7 marc ",
                            marcId
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$HeaderStatus, {
                        children: [
                            labeledCount,
                            " / ",
                            visibleRegions.length,
                            " labeled",
                            deletedIds.length > 0 && ` \xb7 ${deletedIds.length} deleted`
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Body, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Panes, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Pane, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fFWQJ.default), {
                                    width: (0, $7Yi7V.CANVAS_WIDTH),
                                    height: (0, $7Yi7V.CANVAS_HEIGHT),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Frame, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$EggImg, {
                                                src: (0, $4e3Nb.eggImageUrl)(reference.egg.id),
                                                alt: "",
                                                draggable: false,
                                                style: {
                                                    transform: (0, $3IUwO.eggTransformToCss)(eggTransform)
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RegionCanvas, {
                                                ref: canvasRef,
                                                width: (0, $7Yi7V.CANVAS_WIDTH),
                                                height: (0, $7Yi7V.CANVAS_HEIGHT)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Pane, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fFWQJ.default), {
                                    width: (0, $7Yi7V.CANVAS_WIDTH),
                                    height: (0, $7Yi7V.CANVAS_HEIGHT),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RefFrame, {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RefImg, {
                                            src: (0, $4e3Nb.marcImageUrl)(marcId),
                                            alt: "",
                                            draggable: false,
                                            style: marcStyle,
                                            $transformed: !!reference.marc?.transform
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Sidebar, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$SidebarHeader, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$ShowAllRow, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "checkbox",
                                                checked: showAll,
                                                onChange: (e)=>setShowAll(e.target.checked)
                                            }),
                                            " ",
                                            "Show all regions"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RegionList, {
                                children: visibleRegions.map((r)=>{
                                    const label = labels[r.id] ?? "";
                                    const isSelected = r.id === selectedId;
                                    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$RegionRow, {
                                        $selected: isSelected,
                                        onClick: ()=>setSelectedId(r.id),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Swatch, {
                                                style: {
                                                    background: r.color
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RegionId, {
                                                children: r.id
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$RegionPx, {
                                                children: [
                                                    r.pixelCount,
                                                    "px"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$RegionLabel, {
                                                $empty: !label.trim(),
                                                children: label.trim() || "unlabeled"
                                            })
                                        ]
                                    }, r.id);
                                })
                            }),
                            pluralGroups.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Groups, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$GroupsHeader, {
                                        children: "Region groups"
                                    }),
                                    pluralGroups.map((g)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$GroupRow, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$GroupName, {
                                                    children: [
                                                        g.key,
                                                        " ",
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$GroupCount, {
                                                            children: [
                                                                "\xd7",
                                                                g.count
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$GroupToggle, {
                                                    role: "group",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$GroupToggleButton, {
                                                            type: "button",
                                                            $active: g.mode === "all",
                                                            onClick: ()=>setGroupMode(g.key, "all"),
                                                            title: "All subregions must be drawn individually",
                                                            children: "all"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$GroupToggleButton, {
                                                            type: "button",
                                                            $active: g.mode === "any",
                                                            onClick: ()=>setGroupMode(g.key, "any"),
                                                            title: "Hits pool across subregions; one well-drawn subregion clears the group",
                                                            children: "any"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, g.key))
                                ]
                            }),
                            selectedRegion && /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Editor, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$EditorHeader, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Swatch, {
                                                style: {
                                                    background: selectedRegion.color
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: selectedRegion.id
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                children: [
                                                    selectedRegion.pixelCount,
                                                    "px \xb7 color slot",
                                                    " ",
                                                    selectedRegion.colorIndex + 1
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$LabelInput, {
                                        ref: labelInputRef,
                                        type: "text",
                                        placeholder: "Label (e.g. left eye)",
                                        value: labels[selectedRegion.id] ?? "",
                                        onChange: (e)=>handleLabelChange(e.target.value),
                                        onKeyDown: (e)=>{
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                advance(1);
                                            }
                                        },
                                        autoFocus: true
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$Suggestions, {
                                        children: (0, $7Yi7V.CANONICAL_LABELS).map((s)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$SuggestChip, {
                                                type: "button",
                                                onClick: ()=>{
                                                    handleLabelChange(s);
                                                    advance(1);
                                                },
                                                children: s
                                            }, s))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$EditorActions, {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$DangerButton, {
                                            type: "button",
                                            onClick: handleDelete,
                                            children: "Delete region"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Footer, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$FooterButton, {
                                        type: "button",
                                        onClick: handleExport,
                                        children: [
                                            "Export ",
                                            (0, $4e3Nb.referenceFilename)(marcId)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$FooterRow, {
                                        children: [
                                            deletedIds.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$MiniButton, {
                                                type: "button",
                                                onClick: handleUndelete,
                                                children: [
                                                    "Restore ",
                                                    deletedIds.length,
                                                    " deleted"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$MiniButton, {
                                                type: "button",
                                                onClick: handleClearLabels,
                                                children: "Clear labels"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($f0b7b36e0ef67d33$var$MiniButton, {
                                                type: "button",
                                                onClick: resetToCommitted,
                                                disabled: !committed || fromHandoff,
                                                title: fromHandoff ? "New trace from author mode \u2014 region IDs don't correspond to the committed file's regions, so a reset would mis-apply old labels" : committed ? "Replace current labels/deletions with what's in the committed reference" : "No committed reference on disk to reset from",
                                                children: "Reset to committed"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($f0b7b36e0ef67d33$var$Hint, {
                                        children: [
                                            "\u2191/\u2193 navigate \xb7 Enter = next \xb7 click a chip to label & advance",
                                            committed ? " \xb7 editing on top of committed reference.json" : " \xb7 no committed reference.json yet"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $f0b7b36e0ef67d33$var$Main = (0, $lmFrL.default).main`
  height: 100vh;
  height: 100svh;
  display: flex;
  flex-direction: column;
  background: #f6f5f1;
  color: #1a1a1a;
  overflow: hidden;
`;
const $f0b7b36e0ef67d33$var$Header = (0, $lmFrL.default).header`
  display: flex;
  align-items: baseline;
  gap: 16px;
  padding: 14px 24px;
  border-bottom: 1px solid #e4e2dc;
`;
const $f0b7b36e0ef67d33$var$Title = (0, $lmFrL.default).h1`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
`;
const $f0b7b36e0ef67d33$var$Badge = (0, $lmFrL.default).span`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #2d5fa0;
`;
const $f0b7b36e0ef67d33$var$HeaderStatus = (0, $lmFrL.default).span`
  font-size: 13px;
  color: #555;
  margin-left: auto;
  font-variant-numeric: tabular-nums;
`;
const $f0b7b36e0ef67d33$var$Body = (0, $lmFrL.default).div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 0;
  min-height: 0;
`;
const $f0b7b36e0ef67d33$var$Panes = (0, $lmFrL.default).div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  gap: 24px;
  padding: 24px;
  min-height: 0;
  overflow: hidden;
`;
const $f0b7b36e0ef67d33$var$Pane = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $f0b7b36e0ef67d33$var$Frame = (0, $lmFrL.default).div`
  position: absolute;
  inset: 0;
  background: #ff8904;
  border-radius: 4px;
  overflow: hidden;
`;
const $f0b7b36e0ef67d33$var$EggImg = (0, $lmFrL.default).img`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform-origin: center center;
  user-select: none;
  pointer-events: none;
  filter: brightness(0.8);
`;
const $f0b7b36e0ef67d33$var$RegionCanvas = (0, $lmFrL.default).canvas`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
const $f0b7b36e0ef67d33$var$RefFrame = (0, $lmFrL.default).div`
  position: absolute;
  inset: 0;
  background: #eceae4;
  border-radius: 4px;
  overflow: hidden;
`;
const $f0b7b36e0ef67d33$var$RefImg = (0, $lmFrL.default).img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  ${(p)=>p.$transformed ? `
    position: absolute;
    left: 50%;
    top: 50%;
    transform-origin: center center;
  ` : `display: block;`}
`;
const $f0b7b36e0ef67d33$var$Sidebar = (0, $lmFrL.default).aside`
  border-left: 1px solid #e4e2dc;
  background: #fbfaf7;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
const $f0b7b36e0ef67d33$var$SidebarHeader = (0, $lmFrL.default).div`
  padding: 12px 16px;
  border-bottom: 1px solid #e4e2dc;
`;
const $f0b7b36e0ef67d33$var$ShowAllRow = (0, $lmFrL.default).div`
  font-size: 13px;
  label {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
`;
const $f0b7b36e0ef67d33$var$RegionList = (0, $lmFrL.default).div`
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 6px 0;
`;
const $f0b7b36e0ef67d33$var$RegionRow = (0, $lmFrL.default).button`
  width: 100%;
  display: grid;
  grid-template-columns: 18px 60px 60px 1fr;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border: none;
  background: ${(p)=>p.$selected ? "#e8e3d3" : "transparent"};
  cursor: pointer;
  text-align: left;
  font-size: 13px;

  &:hover {
    background: ${(p)=>p.$selected ? "#e8e3d3" : "#f0ede4"};
  }
`;
const $f0b7b36e0ef67d33$var$Swatch = (0, $lmFrL.default).div`
  width: 18px;
  height: 18px;
  border-radius: 3px;
  border: 1px solid #d0ccc2;
`;
const $f0b7b36e0ef67d33$var$RegionId = (0, $lmFrL.default).span`
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  color: #555;
`;
const $f0b7b36e0ef67d33$var$RegionPx = (0, $lmFrL.default).span`
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  color: #888;
  text-align: right;
`;
const $f0b7b36e0ef67d33$var$RegionLabel = (0, $lmFrL.default).span`
  color: ${(p)=>p.$empty ? "#aaa" : "#1a1a1a"};
  font-style: ${(p)=>p.$empty ? "italic" : "normal"};
  font-weight: ${(p)=>p.$empty ? "400" : "600"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $f0b7b36e0ef67d33$var$Groups = (0, $lmFrL.default).div`
  border-top: 1px solid #e4e2dc;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const $f0b7b36e0ef67d33$var$GroupsHeader = (0, $lmFrL.default).div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #888;
`;
const $f0b7b36e0ef67d33$var$GroupRow = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 13px;
`;
const $f0b7b36e0ef67d33$var$GroupName = (0, $lmFrL.default).span`
  font-weight: 600;
`;
const $f0b7b36e0ef67d33$var$GroupCount = (0, $lmFrL.default).span`
  color: #888;
  font-weight: 400;
  font-variant-numeric: tabular-nums;
  margin-left: 2px;
`;
const $f0b7b36e0ef67d33$var$GroupToggle = (0, $lmFrL.default).div`
  display: inline-flex;
  border: 1px solid #d0ccc2;
  border-radius: 4px;
  overflow: hidden;
`;
const $f0b7b36e0ef67d33$var$GroupToggleButton = (0, $lmFrL.default).button`
  font-size: 11px;
  padding: 3px 10px;
  border: none;
  background: ${(p)=>p.$active ? "#2d5fa0" : "#fff"};
  color: ${(p)=>p.$active ? "#fff" : "#333"};
  cursor: pointer;
  font-weight: ${(p)=>p.$active ? 700 : 500};
  & + & {
    border-left: 1px solid #d0ccc2;
  }
  &:hover {
    background: ${(p)=>p.$active ? "#26528d" : "#ece9e0"};
  }
`;
const $f0b7b36e0ef67d33$var$Editor = (0, $lmFrL.default).div`
  border-top: 1px solid #e4e2dc;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $f0b7b36e0ef67d33$var$EditorHeader = (0, $lmFrL.default).div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #555;
`;
const $f0b7b36e0ef67d33$var$LabelInput = (0, $lmFrL.default).input`
  padding: 8px 10px;
  border: 1px solid #d0ccc2;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  &:focus {
    outline: 2px solid #2d5fa0;
    outline-offset: -1px;
  }
`;
const $f0b7b36e0ef67d33$var$Suggestions = (0, $lmFrL.default).div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
const $f0b7b36e0ef67d33$var$SuggestChip = (0, $lmFrL.default).button`
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 99px;
  border: 1px solid #d0ccc2;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #ece9e0;
  }
`;
const $f0b7b36e0ef67d33$var$EditorActions = (0, $lmFrL.default).div`
  display: flex;
  gap: 6px;
`;
const $f0b7b36e0ef67d33$var$DangerButton = (0, $lmFrL.default).button`
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid #c44;
  background: #fff;
  color: #c44;
  cursor: pointer;
  font-weight: 600;
  &:hover {
    background: #fbe9e9;
  }
`;
const $f0b7b36e0ef67d33$var$Footer = (0, $lmFrL.default).div`
  border-top: 1px solid #e4e2dc;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $f0b7b36e0ef67d33$var$FooterButton = (0, $lmFrL.default).button`
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #2d5fa0;
  background: #2d5fa0;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    background: #26528d;
  }
`;
const $f0b7b36e0ef67d33$var$FooterRow = (0, $lmFrL.default).div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;
const $f0b7b36e0ef67d33$var$MiniButton = (0, $lmFrL.default).button`
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #d0ccc2;
  background: #fff;
  cursor: pointer;
  &:hover {
    background: #ece9e0;
  }
`;
const $f0b7b36e0ef67d33$var$Hint = (0, $lmFrL.default).div`
  font-size: 11px;
  color: #888;
`;
const $f0b7b36e0ef67d33$var$LoadingBox = (0, $lmFrL.default).div`
  padding: 40px;
  text-align: center;
  color: #555;
`;
const $f0b7b36e0ef67d33$var$ErrorBox = (0, $lmFrL.default).div`
  padding: 40px;
  color: #c44;
  code {
    background: #fbe9e9;
    padding: 2px 4px;
    border-radius: 2px;
  }
`;
var $f0b7b36e0ef67d33$export$2e2bcd8739ae039 = $f0b7b36e0ef67d33$var$LabelApp;




const $35da740d59af89ba$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($aRPiL))).createRoot(document.getElementById('root'));
const $35da740d59af89ba$var$urlState = (0, $7921bdd52deb8db9$export$e97fefb967eddbb9)();
// LabelApp is a fully separate app shell (different providers, no drawing
// canvas), so it dispatches at the root rather than living as a mode inside
// <App />.
$35da740d59af89ba$var$root.render($35da740d59af89ba$var$urlState.mode === (0, $7921bdd52deb8db9$export$240b20df485e8ed6).LABEL ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0b7b36e0ef67d33$export$2e2bcd8739ae039), {
    marcId: $35da740d59af89ba$var$urlState.marcId
}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d8b6aef94a206ca$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=public.2dc258e5.js.map
